;; Generated by dev/generate_meta_ui_studio_data.clj — do not edit by hand.
;; Regenerate with: devbox run generate-meta-ui-studio-data
;;
;; A committed mirror of dsl/contexts/ui.edn's :levels :meta-ui — every
;; version's :rules, exactly as the server-side interpreter (ui.interpret/
;; meta-ui) reads them. graph-ui.web.studio (Phase B, no bus connection)
;; renders every widget kind straight from this data, so the studio can
;; never drift from the DSL — see the generator script's own docstring.

(ns graph-ui.web.generated-meta-ui)

(def meta-ui-versions
  {:latest "v2.1",
 :mantine
 {:package "@mantine/core",
  :version "8.3.18",
  :extract "dsl/generated/mantine-extract.edn",
  :target-version "v2.0-SNAPSHOT",
  :kind-aliases
  {"Tabs" :tab-set,
   "Textarea" :text-area,
   "Collapse" :collapsible,
   "Code" :code-block,
   "ActionIcon" :icon-button},
  :type-mapping
  {"MantineSize | (string & {})"
   [:or [:enum :xs :sm :md :lg :xl] [:re "^\\d+(\\.\\d+)?(ch|%)$"]],
   "FloatingPosition"
   [:enum
    :top
    :right
    :bottom
    :left
    :top-start
    :top-end
    :right-start
    :right-end
    :bottom-start
    :bottom-end
    :left-start
    :left-end],
   "Width<string | number>" [:or :string :int :double],
   "MantineSpacing"
   [:or [:enum :xs :sm :md :lg :xl] [:re "^\\d+(\\.\\d+)?(ch|%)$"]],
   "MantineSize"
   [:or [:enum :xs :sm :md :lg :xl] [:re "^\\d+(\\.\\d+)?(ch|%)$"]],
   "AlignItems" :string,
   "MantineColor" [:or :keyword :string],
   "string | number" [:or :string :int :double],
   "ZIndex" [:or :string :int :double],
   "PointerEvents" :string,
   "MantineGradient"
   [:map
    [:from :string]
    [:to :string]
    [:deg {:optional true} :int :double]],
   "DefaultMantineColor" [:or :keyword :string],
   "JustifyContent" :string,
   "MantineShadow" [:or [:enum :xs :sm :md :lg :xl]],
   "FloatingStrategy" [:enum :absolute :fixed],
   "number | MantineSize | (string & {})"
   [:or [:enum :xs :sm :md :lg :xl] [:re "^\\d+(\\.\\d+)?(ch|%)$"]],
   "ArrowPosition" [:enum :center :side],
   "string[]" [:vector :string],
   "MantineRadius"
   [:or [:enum :xs :sm :md :lg :xl] [:re "^\\d+(\\.\\d+)?(ch|%)$"]]},
  :unmappable-types
  #{"ForwardedRef<HTMLDivElement>"
    "OptionsFilter"
    "MantineLoaderComponent"
    "PopoverWidth"
    "any"
    "ComboboxData"
    "any[]"
    "PopoverMiddlewares"
    "PaginationIcon"
    "HTMLElement"
    "ComboboxStringData"}},
 :box-ownership
 {:needs
  {:inline
   {:means "A definite width. A column with a maximum measure."},
   :block {:means "A definite height. Anything that scrolls down."},
   :both {:means "A definite width and a definite height."}},
  :self-flex
  {:inline
   {:means
    "The adapter fills the width without the description asking."},
   :block
   {:means
    "The adapter fills the height without the description asking."},
   :both {:means "The adapter fills both axes."}},
  :axes
  {:inline {:means "The axis text runs along. The width."},
   :block {:means "The axis lines stack along. The height."}},
  :checks
  [{:check :box-from-declared,
    :status :gated,
    :means
    "Every kind of a version that adopts this vocabulary declares\n               :box-from, and the value is one of the four."}
   {:check :needs-declared,
    :status :gated,
    :means
    "A kind whose :box-from is :parent declares :needs. No other kind\n               declares it."}
   {:check :self-flex-declared,
    :status :gated,
    :means
    "Only a :box-from :parent kind declares :self-flex, and the value\n               is one of the three axes."}
   {:check :box-to-children-declared,
    :status :gated,
    :means
    "A kind whose :children is :any declares :box-to-children. No\n               other kind declares it."}
   {:check :parent-has-a-box,
    :status :ratchet,
    :means
    "In a description, a node whose :box-from is :parent gets every\n               axis its :needs slot names. :known-unbounded below is the\n               baseline. devbox run box-ownership fails on anything else."}
   {:check :island-root-definite,
    :status :gated,
    :means
    "The root node of an island description is definite. The corpus\n               is clean, so this one is a gate with no baseline."}],
  :known-unbounded
  [{:node "code-view",
    :kind :code-view,
    :missing [:block],
    :files ["reader-ui.edn"],
    :drawn-in "dsl/instances/reader/reader-ui.edn",
    :why
    "A :code-view scrolls down by itself, and it sits inside the page's\n            own vertical :scroll-area. The first reader writes this inline\n            rather than through dsl/alatus/reading-area.edn, so the repair that\n            fixed the shared block does not reach it. The node carries no\n            :import-id, so the report names it by its kind.",
    :fix
    "reader-v2 replaces this island. The repair is the cut-over, not an\n            edit to a description that is on its way out."}],
  :means
  "Where a widget's box comes from, and what box it gives to a child. Two\n     slots on every kind of a version that adopts this vocabulary. v2.1-SNAPSHOT\n     is the first.",
  :refinements
  [{:kind :scroll-area,
    :prop :scrollbars,
    :is :x,
    :then "the node needs :inline instead of :block",
    :why
    "It scrolls sideways, so the width is the axis that must be bounded."}
   {:kind :group,
    :prop :align,
    :is :stretch,
    :then "the row gives :definite on the block axis",
    :why
    "Mantine's Group centres its children. :align :stretch makes each\n             child as tall as the row, which crew-editor found in a screenshot\n             on 2026-09-01."}
   {:kind :stack,
    :prop :align,
    :is-not :stretch,
    :then "the column gives :content on the inline axis",
    :why
    "A column stretches its children to the full width by default. Any\n             other :align makes each child as wide as its own content."}
   {:kind :scroll-area,
    :prop :flex,
    :is 0,
    :then "the node needs no axis from its parent on the block axis",
    :why
    "A short list (PR #74, 2026-09-26). The renderer gives a :scroll-area\n             with :flex 0 its own maximum height, the short limit of\n             dsl/design/sidebar-section.edn in rows (widgets.cljs\n             short-list-max-height). It is as tall as its content up to that\n             limit, and it scrolls past it, so its bound is its own. Until this\n             entry the report called ten such lists unbounded, and devbox run\n             check was red from 2026-09-26."}],
  :box-to-children
  {:block-flow
   {:gives {:inline :definite, :block :content},
    :means
    "Normal flow. A child fills the width and is as tall as its own\n              content. This is what a plain element does, and it is the answer\n              for most kinds."},
   :flex-column
   {:gives {:inline :definite, :block :flex},
    :means
    "A flex column. A child fills the width. A child that carries the\n              :flex slot also gets a definite height."},
   :flex-row
   {:gives {:inline :flex, :block :content},
    :means
    "A flex row. A child that carries the :flex slot gets a definite\n              width. Height follows the content, because the row centres its\n              children."},
   :flex-both
   {:gives {:inline :flex, :block :flex},
    :means
    "A flex container whose direction is stated per node, so a child\n              that carries the :flex slot may get either axis."},
   :definite
   {:gives {:inline :definite, :block :definite},
    :means "Every child gets a measured box on both axes."},
   :content
   {:gives {:inline :content, :block :content},
    :means "A child gets no box from here on either axis."}},
  :definite-when
  ["The island frame on the canvas gives a definite box on both axes. The person owns it."
   "A node whose :box-from is :props or :viewport is definite."
   "A node whose :box-from is :parent or :content is definite on an axis only when its parent gives it that axis."
   "A parent gives an axis to a child when the parent is itself definite on that axis, AND one of the next two sentences is true."
   "The parent's arrangement gives :definite on that axis."
   "The parent's arrangement gives :flex on that axis, and the child carries the :flex slot OR its kind declares :self-flex for that axis."
   "A :box-from :parent node is satisfied when it gets every axis its :needs slot names."],
  :box-from
  {:content
   {:means
    "The box is as large as the children need. It is INDEFINITE, so a\n              child can not fill it."},
   :parent
   {:means
    "The widget has no size of its own. It fills the box above it. Its\n              :needs slot says on which axis that box must be definite."},
   :props {:means "The widget's own props state the box."},
   :viewport
   {:means
    "The browser window gives the box. The widget leaves the flow, so\n              the chain starts again at this node."}},
  :gaks-refs
  {:concept
   ["CONCEPT-graph-ui-v0-014-01-the-levels-of-the-ui"
    "CONCEPT-graph-ui-v0-003-01-widget-tree"],
   :decision
   ["ADR-graph-ui-v0-013-01-one-layout-model"
    "ADR-graph-ui-v0-012-01-mantine-component-library"
    "ADR-graph-ui-v0-026-01-dockview-for-the-pattern-level"
    "ADR-graph-ui-v0-019-01-design-system-is-the-source"],
   :principle ["PRINCIPLE-ikc-v3-002-01-dsl-first"]}},
 :versions
 {"v1.0"
  {:status :released,
   :content-hash "d9e49c4e",
   :rules
   {:markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                  contain formatted text. :value is the markdown source. In the TUI it\n                  renders as plain text (no styled rendering); a web renderer renders\n                  it as HTML. A bound :markdown gets its :value from a data source.",
     :status :in-progress,
     :props [:map [:value {:optional true} :string]],
     :defaults {},
     :children :none},
    :tree
    {:description
     "A nested outline; each item is {:label string :children [item …]}\n                  rendered one per line, indented by depth. :items is optional: a\n                  bound :tree gets its outline from a source (the notes editor binds\n                  the page outline). The recursive sibling of :list.\n                  :on-fork is an optional command template (like :on-submit) dispatched\n                  when the user forks from the selected node (typically the 'f' key):\n                  $value substitutes the selected item's :entry-id.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:on-fork
       {:optional true}
       [:map [:command :keyword] [:with {:optional true} :map]]]],
     :defaults {},
     :children :none},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                  be a :box with a :title (used as the tab label). :active (default 0)\n                  is the index of the visible tab. The renderer draws a tab header line\n                  and shows only the active child's content below it.",
     :status :in-progress,
     :props [:map [:active {:optional true} :int]],
     :defaults {:active 0},
     :children :any},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n                  the toggle line; :collapsed (default false) controls initial state.\n                  When collapsed only the title line shows; when expanded the children\n                  stack below it. The renderer manages the collapsed state.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]],
     :defaults {:collapsed false},
     :children :any},
    :box
    {:description
     "A container that stacks its children vertically (default) or horizontally,\n      optionally titled and/or bordered. The composition primitive.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:layout {:optional true} [:enum :vertical :horizontal :split]]
      [:border {:optional true} :boolean]],
     :defaults {:layout :vertical},
     :children :any},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                  is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                  plain monospaced text; a web renderer may apply syntax highlighting.\n                  A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]],
     :defaults {},
     :children :none},
    :list
    {:description
     "A vertical list; each item is rendered on its own line.\n                  :items is optional: a bound :list gets its items from a source.",
     :status :in-progress,
     :props [:map [:items {:optional true} [:vector :string]]],
     :defaults {},
     :children :none},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer\n                  and, on Enter, dispatches this node's :on-submit command (see the\n                  :on-submit action below) — the input→command half of the UI-DSL.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]],
     :defaults {},
     :children :none},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a\n                  bound :text (see :bind) gets its value from a data source.",
     :status :in-progress,
     :props [:map [:value {:optional true} :string]],
     :defaults {},
     :children :none}}},
  "v1.2-SNAPSHOT"
  {:status :snapshot,
   :universal-slots
   {:layout-self
    {:description
     "How this child sizes and aligns itself INSIDE a flex parent (a :box\n        carrying :direction). Web renderer only — the TUI ignores it entirely\n        (documented no-op, same policy as :elevation, ADR-ikc-v3-047-01).\n        Maps directly onto CSS flex-grow / flex-shrink / flex-basis /\n        align-self, using named steps to stay inside the closed-schema\n        discipline (ADR-ikc-v3-041-01).",
     :shape
     [:map
      {:closed true}
      [:grow {:optional true} [:enum 0 1 2 3]]
      [:shrink {:optional true} [:enum 0 1]]
      [:basis
       {:optional true}
       [:enum :auto :zero :quarter :third :half :two-thirds :full]]
      [:align-self
       {:optional true}
       [:enum :auto :start :end :center :stretch]]]}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns the\n        edit buffer, seeded from :value (bindable). On Ctrl/Cmd+Enter it dispatches\n        :on-submit with $value = the buffer. :rows sets the initial height;\n        :auto-grow expands as the user types; :markdown toggles a live preview of\n        inline **bold**, *italic*, and `code`. :triggers is an optional vector of\n        trigger characters (e.g. [\"@\" \"/\" \"#\"]) carried as data for future chip\n        support; v1 renders them as plain text. :tone/:density/:state use the same\n        tokens as :text-area. Web renderer only — the TUI renders the buffer as\n        plain read-only text (ADR-047 parity policy).",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit\n                    buffer and, on Ctrl/Cmd+Enter or its Save button, dispatches this\n                    node's :on-submit with $value = the buffer — the editor half of the\n                    Foam markdown Edit view (ADR-ikc-v3-052-01). :value seeds the buffer\n                    (bindable). :rows is the initial visible height. In the TUI it\n                    renders as plain read-only text (edit is a web affordance).\n                    :draft-key (v1.2): a client draft channel to publish the live\n                    buffer to on every (debounced) change, so a live-preview widget\n                    (:island-view) can render what is being typed BEFORE it is\n                    submitted. Web-only, effectless without a subscriber; absent =\n                    the buffer stays local until :on-submit as before.\n                    :format (v1.2-SNAPSHOT): :edn (default) shows the buffer as-is;\n                    :indent converts the bound EDN value to a bracket-stripped\n                    indentation format for display, and converts back to EDN before\n                    publishing to the draft or submitting — the bracket-free authoring\n                    surface for deeply nested widget trees. The draft always carries\n                    EDN text so the live preview works regardless of which tab is active.\n                    :font-size (v1.2-SNAPSHOT): :xs/:sm/:md/:lg scales the editor's\n                    code font (web only, ignored by the TUI) — the Source (EDN)\n                    panel uses :sm so a whole widget tree fits without scrolling\n                    (George, 2026-07-22).",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:font-size {:optional true} [:enum :xs :sm :md :lg]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                    contain formatted text. :value is the markdown source. In the TUI it\n                    renders as plain text (no styled rendering); a web renderer renders\n                    it as HTML. A bound :markdown gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one — the\n        Studio preview pane. Renders the island the current session has selected /\n        is composing: its saved tree by default, or the description currently in the\n        editor buffer AS YOU TYPE (WYSIWYG), whichever the client draft holds, with\n        the saved tree as the fallback when the draft is empty or does not parse.\n        The preview attaches NOTHING — it reads via :ui/preview-context (no\n        presentation frame, no compose lock), so it can never steal or leak the lock\n        the composer holds. Inherently recursion-capable, so it carries a self-embed\n        guard: asked to preview the island it lives in, it shows a placeholder rather\n        than nest forever. Web-only; the TUI renders a labelled placeholder\n        (ADR-ikc-v3-047-01 lag policy) — a terminal cannot embed a second live render\n        surface.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :tree
    {:description
     "A nested outline; each item is {:label string :children [item …]}\n                    rendered one per line, indented by depth. :items is optional: a\n                    bound :tree gets its outline from a source (the notes editor binds\n                    the page outline). The recursive sibling of :list.\n                    :on-fork is an optional command template (like :on-submit) dispatched\n                    when the user forks from the selected node (typically the 'f' key):\n                    $value substitutes the selected item's :entry-id.\n                    :empty-label (v1.1): same as :list's.\n                    :direction (v1.1): :column (default) stacks items vertically as an\n                    indented outline; :row lays a FLAT item list out horizontally as a\n                    strip of clickable buttons — the daily-note nav bar. :row ignores\n                    nesting (a horizontal outline is meaningless); the TUI always renders\n                    :column (ADR-ikc-v3-048-01 TUI-lag).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:on-fork
       {:optional true}
       [:map [:command :keyword] [:with {:optional true} :map]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n        declares the header — a vector of {:label <string> :key <keyword|string>}\n        maps; each row's cell for a column is looked up by that column's :key.\n        :rows is the data — a vector of maps, bindable via :bind (a bound :table\n        fills its :rows from a source, like a bound :list fills :items). v1 is\n        display-only: the vault's markdown tables and any tabular source render as\n        a real grid instead of raw pipes; row selection/editing is a later\n        addition. :tone/:density tune the visual weight. In the TUI it renders as\n        plain text rows (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :button
    {:description
     "ADR-ikc-v3-047-01: a standalone clickable button — the first Meta-UI\n        widget kind whose WEB implementation is built on an actual industry\n        primitive (@radix-ui/react-slot) instead of hand-rolled Tailwind+\n        HTML, chosen over a full component framework specifically because\n        Radix ships behavior, not a competing visual design system. :label\n        is the button's text; :on-submit (the universal slot) is dispatched\n        on click — $session-id substitutes as usual, $value is not\n        meaningful for a plain button (no inherent value of its own) unless\n        a specific :on-submit template chooses to hardcode one. :disabled\n        blocks the click. TUI renders the label as plain text, read-only —\n        no dispatch (ADR-047 §Decision 3: TUI is not held to parity for\n        new interactive kinds going forward; same no-op precedent\n        :elevation/:outline already established, now a deliberate policy\n        rather than a one-off).",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]],
     :defaults {},
     :children :none},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                    be a :box with a :title (used as the tab label). :active (default 0)\n                    is the index of the visible tab. The renderer draws a tab header line\n                    and shows only the active child's content below it.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n                    the toggle line; :collapsed (default false) controls initial state.\n                    When collapsed only the title line shows; when expanded the children\n                    stack below it. The renderer manages the collapsed state.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false},
     :children :any},
    :box
    {:description
     "A container that stacks its children vertically (default) or horizontally,\n        optionally titled and/or bordered. The composition primitive.\n        v1.1 adds a real flexbox vocabulary (:direction/:wrap/:justify/:align/:gap,\n        ADR-ikc-v3-048-01): when :direction is present the flex model governs and\n        the legacy :layout enum is ignored; when :direction is absent behaviour is\n        byte-identical to before. Web renderer only — the TUI keeps its crude\n        :vertical/:horizontal/:split model and ignores the flex props.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:layout {:optional true} [:enum :vertical :horizontal :split]]
      [:border {:optional true} :boolean]
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:align {:optional true} [:enum :start :end :center :stretch]]
      [:gap {:optional true} [:enum :none :sm :md :lg]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation {:optional true} [:enum :flat :raised :overlay]]],
     :defaults {:layout :vertical},
     :children :any},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                    is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                    plain monospaced text; a web renderer may apply syntax highlighting.\n                    A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n                    (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n                    Exactly two children: the RESIZABLE/foldable pane and the FILLING\n                    pane. :fold-side picks which side the resizable one is on —\n                    :left (default) = child 1 is resizable and folds left; :right =\n                    child 2 is resizable and folds right (e.g. a right-hand property\n                    dock). The filling pane is always the other child. :pane-id is\n                    the localStorage key under which THIS pane's width + folded state\n                    are remembered (client view-state, not a frame — same as the\n                    theme overrides), so two split-panes never collide. :initial is\n                    the resizable pane's starting px width; :min is its floor. By\n                    default there is NO fixed max — the drag ceiling is computed live\n                    so the filling pane keeps room; :max sets an optional hard ceiling.\n                    :flex-min is the FILLING pane's floor (px): it never shrinks below\n                    it — when the window is too narrow for both panes the split scrolls\n                    horizontally instead of collapsing the filling pane to nothing\n                    (the 'last pane vanished' failure, fixed 2026-07-17). :collapsible\n                    shows the fold button. The web renderer is interactive (drag +\n                    fold); the TUI renders the two panes as a plain stack\n                    (ADR-ikc-v3-048-01 lag).",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true},
     :children :any},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session — every\n        bus command dispatched (with its round-trip ms) and the client-only UI\n        events that never reach the bus (island load, zoom-to-fit, widget select,\n        render), newest last. Purely a CLIENT-side observability surface for\n        dogfood debugging: like :island-view reads the draft, it reads a client\n        ring-buffer directly, never a bus :source — so it adds zero server load,\n        needs no :bind, and keeps showing history even while the thing it observes\n        is stuck (the 30-40s island-select cascade is exactly what it is for).\n        Web-only; the TUI renders a labelled placeholder (ADR-ikc-v3-047-01 lag\n        policy) — a scrolling live log has no terminal-render contract yet.\n        :slow-ms marks any dispatch at/above it as slow (tone shift), so a hot\n        handler stands out in the stream.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none},
    :list
    {:description
     "A vertical list; each item is rendered on its own line.\n                    :items is optional: a bound :list gets its items from a source.\n                    :empty-label (v1.1): shown in place of a silently-blank pane\n                    when :items resolves to an empty vector.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :outline
    {:description
     "ADR-ikc-v3-044-01: a flat, :order-sorted list of typed blocks, nested\n        VISUALLY by each item's :depth (never a real tree — the native\n        block-frame engine keeps every block a flat :child-of child of its\n        page). :items is optional: a bound :outline gets its list from a\n        source (:block-outline). Each item is\n        {:block-id uuid-str :block-type kw :content string :order number\n        :depth int :checked? bool :collapsed? bool} — a deeper item whose\n        ancestor has :collapsed? true is hidden by the renderer, not the\n        source. :actions (the universal slot, ui.interpret/entry-schema)\n        names the structural commands the renderer may dispatch per item —\n        the notes content pane wires :indent/:outdent/:toggle-done/\n        :toggle-collapse/:delete/:insert-after/:update-text (all real\n        :ui/* commands, PLAN-graph-ui-v0-005-01 Phase 1); $value's meaning\n        is per-action (row actions: the acted-on item's :block-id, matching\n        :tree's own $value convention; :update-text: the edited text,\n        matching :input's). :ui/split-block/:ui/join-blocks/:ui/move-block\n        are real dispatchable commands too but have no wired gesture yet in\n        v1 (a real, tracked gap — 'select' a block for focus is local\n        renderer state, never a bus dispatch). TUI renders read-only\n        (gutters/numbering only, no dispatch) — same documented no-op\n        precedent as :elevation; there is no live per-block editing outside\n        the web renderer in v1.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer\n                    and, on Enter, dispatches this node's :on-submit command (see the\n                    :on-submit action below) — the input→command half of the UI-DSL.\n                    :state (v1.1): a validation/enablement hint for the renderer —\n                    :invalid highlights the field, :disabled greys it out and blocks\n                    edits.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is a\n        vector of {:label <string> :command <keyword> :with <map, optional>\n        :tone <token, optional> :disabled <bool, optional>} maps, bindable via\n        :bind (a bound :menu fills its :items from a source). Clicking an item\n        dispatches that item's :command, filled the same way every :on-submit is\n        — $session-id substituted, plus any literal :with args. This is the\n        reusable menu BODY: Studio's action menus and the notes block\n        context-menu (opened on right-click, a later wiring) both compose it.\n        Distinct from :list (plain display strings) and :button (one action):\n        :menu is a grouped set of commands. Web-only interactive; the TUI renders\n        the item labels as plain read-only text (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n        :options is the list of choices — a vector of {:label <string>\n        :value <string>} maps, bindable via :bind (a bound :select fills its\n        :options from a source, exactly as a bound :list fills :items). :value\n        names the initially-selected option's :value. On change the renderer\n        dispatches this node's :on-submit (the universal slot) with\n        $value = the chosen option's :value (and $session-id as usual) — the\n        choose→command half of the UI-DSL, mirroring :input's Enter→command\n        seam. :placeholder shows as a disabled leading option when no :value\n        matches. Web-only interactive; the TUI renders the current value (or\n        placeholder) as plain read-only text (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a\n                    bound :text (see :bind) gets its value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:size {:optional true} [:enum :xs :sm :base :lg :xl]]
      [:weight {:optional true} [:enum :normal :medium :bold]]],
     :defaults {},
     :children :none}}},
  "v1.2"
  {:status :released,
   :content-hash "c228d945",
   :universal-slots
   {:layout-self
    {:description
     "How this child sizes and aligns itself INSIDE a flex parent (a :box\n        carrying :direction). Web renderer only — the TUI ignores it entirely\n        (documented no-op, same policy as :elevation, ADR-ikc-v3-047-01).\n        Maps directly onto CSS flex-grow / flex-shrink / flex-basis /\n        align-self, using named steps to stay inside the closed-schema\n        discipline (ADR-ikc-v3-041-01).",
     :shape
     [:map
      {:closed true}
      [:grow {:optional true} [:enum 0 1 2 3]]
      [:shrink {:optional true} [:enum 0 1]]
      [:basis
       {:optional true}
       [:enum :auto :zero :quarter :third :half :two-thirds :full]]
      [:align-self
       {:optional true}
       [:enum :auto :start :end :center :stretch]]]}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns the\n        edit buffer, seeded from :value (bindable). On Ctrl/Cmd+Enter it dispatches\n        :on-submit with $value = the buffer. :rows sets the initial height;\n        :auto-grow expands as the user types; :markdown toggles a live preview of\n        inline **bold**, *italic*, and `code`. :triggers is an optional vector of\n        trigger characters (e.g. [\"@\" \"/\" \"#\"]) carried as data for future chip\n        support; v1 renders them as plain text. :tone/:density/:state use the same\n        tokens as :text-area. Web renderer only — the TUI renders the buffer as\n        plain read-only text (ADR-047 parity policy).",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit\n                    buffer and, on Ctrl/Cmd+Enter or its Save button, dispatches this\n                    node's :on-submit with $value = the buffer — the editor half of the\n                    Foam markdown Edit view (ADR-ikc-v3-052-01). :value seeds the buffer\n                    (bindable). :rows is the initial visible height. In the TUI it\n                    renders as plain read-only text (edit is a web affordance).\n                    :draft-key (v1.2): a client draft channel to publish the live\n                    buffer to on every (debounced) change, so a live-preview widget\n                    (:island-view) can render what is being typed BEFORE it is\n                    submitted. Web-only, effectless without a subscriber; absent =\n                    the buffer stays local until :on-submit as before.\n                    :format (v1.2-SNAPSHOT): :edn (default) shows the buffer as-is;\n                    :indent converts the bound EDN value to a bracket-stripped\n                    indentation format for display, and converts back to EDN before\n                    publishing to the draft or submitting — the bracket-free authoring\n                    surface for deeply nested widget trees. The draft always carries\n                    EDN text so the live preview works regardless of which tab is active.\n                    :font-size (v1.2-SNAPSHOT): :xs/:sm/:md/:lg scales the editor's\n                    code font (web only, ignored by the TUI) — the Source (EDN)\n                    panel uses :sm so a whole widget tree fits without scrolling\n                    (George, 2026-07-22).",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:font-size {:optional true} [:enum :xs :sm :md :lg]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                    contain formatted text. :value is the markdown source. In the TUI it\n                    renders as plain text (no styled rendering); a web renderer renders\n                    it as HTML. A bound :markdown gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one — the\n        Studio preview pane. Renders the island the current session has selected /\n        is composing: its saved tree by default, or the description currently in the\n        editor buffer AS YOU TYPE (WYSIWYG), whichever the client draft holds, with\n        the saved tree as the fallback when the draft is empty or does not parse.\n        The preview attaches NOTHING — it reads via :ui/preview-context (no\n        presentation frame, no compose lock), so it can never steal or leak the lock\n        the composer holds. Inherently recursion-capable, so it carries a self-embed\n        guard: asked to preview the island it lives in, it shows a placeholder rather\n        than nest forever. Web-only; the TUI renders a labelled placeholder\n        (ADR-ikc-v3-047-01 lag policy) — a terminal cannot embed a second live render\n        surface.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :tree
    {:description
     "A nested outline; each item is {:label string :children [item …]}\n                    rendered one per line, indented by depth. :items is optional: a\n                    bound :tree gets its outline from a source (the notes editor binds\n                    the page outline). The recursive sibling of :list.\n                    :on-fork is an optional command template (like :on-submit) dispatched\n                    when the user forks from the selected node (typically the 'f' key):\n                    $value substitutes the selected item's :entry-id.\n                    :empty-label (v1.1): same as :list's.\n                    :direction (v1.1): :column (default) stacks items vertically as an\n                    indented outline; :row lays a FLAT item list out horizontally as a\n                    strip of clickable buttons — the daily-note nav bar. :row ignores\n                    nesting (a horizontal outline is meaningless); the TUI always renders\n                    :column (ADR-ikc-v3-048-01 TUI-lag).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:on-fork
       {:optional true}
       [:map [:command :keyword] [:with {:optional true} :map]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n        declares the header — a vector of {:label <string> :key <keyword|string>}\n        maps; each row's cell for a column is looked up by that column's :key.\n        :rows is the data — a vector of maps, bindable via :bind (a bound :table\n        fills its :rows from a source, like a bound :list fills :items). v1 is\n        display-only: the vault's markdown tables and any tabular source render as\n        a real grid instead of raw pipes; row selection/editing is a later\n        addition. :tone/:density tune the visual weight. In the TUI it renders as\n        plain text rows (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :button
    {:description
     "ADR-ikc-v3-047-01: a standalone clickable button — the first Meta-UI\n        widget kind whose WEB implementation is built on an actual industry\n        primitive (@radix-ui/react-slot) instead of hand-rolled Tailwind+\n        HTML, chosen over a full component framework specifically because\n        Radix ships behavior, not a competing visual design system. :label\n        is the button's text; :on-submit (the universal slot) is dispatched\n        on click — $session-id substitutes as usual, $value is not\n        meaningful for a plain button (no inherent value of its own) unless\n        a specific :on-submit template chooses to hardcode one. :disabled\n        blocks the click. TUI renders the label as plain text, read-only —\n        no dispatch (ADR-047 §Decision 3: TUI is not held to parity for\n        new interactive kinds going forward; same no-op precedent\n        :elevation/:outline already established, now a deliberate policy\n        rather than a one-off).",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]],
     :defaults {},
     :children :none},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                    be a :box with a :title (used as the tab label). :active (default 0)\n                    is the index of the visible tab. The renderer draws a tab header line\n                    and shows only the active child's content below it.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n                    the toggle line; :collapsed (default false) controls initial state.\n                    When collapsed only the title line shows; when expanded the children\n                    stack below it. The renderer manages the collapsed state.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false},
     :children :any},
    :box
    {:description
     "A container that stacks its children vertically (default) or horizontally,\n        optionally titled and/or bordered. The composition primitive.\n        v1.1 adds a real flexbox vocabulary (:direction/:wrap/:justify/:align/:gap,\n        ADR-ikc-v3-048-01): when :direction is present the flex model governs and\n        the legacy :layout enum is ignored; when :direction is absent behaviour is\n        byte-identical to before. Web renderer only — the TUI keeps its crude\n        :vertical/:horizontal/:split model and ignores the flex props.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:layout {:optional true} [:enum :vertical :horizontal :split]]
      [:border {:optional true} :boolean]
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:align {:optional true} [:enum :start :end :center :stretch]]
      [:gap {:optional true} [:enum :none :sm :md :lg]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation {:optional true} [:enum :flat :raised :overlay]]],
     :defaults {:layout :vertical},
     :children :any},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                    is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                    plain monospaced text; a web renderer may apply syntax highlighting.\n                    A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n                    (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n                    Exactly two children: the RESIZABLE/foldable pane and the FILLING\n                    pane. :fold-side picks which side the resizable one is on —\n                    :left (default) = child 1 is resizable and folds left; :right =\n                    child 2 is resizable and folds right (e.g. a right-hand property\n                    dock). The filling pane is always the other child. :pane-id is\n                    the localStorage key under which THIS pane's width + folded state\n                    are remembered (client view-state, not a frame — same as the\n                    theme overrides), so two split-panes never collide. :initial is\n                    the resizable pane's starting px width; :min is its floor. By\n                    default there is NO fixed max — the drag ceiling is computed live\n                    so the filling pane keeps room; :max sets an optional hard ceiling.\n                    :flex-min is the FILLING pane's floor (px): it never shrinks below\n                    it — when the window is too narrow for both panes the split scrolls\n                    horizontally instead of collapsing the filling pane to nothing\n                    (the 'last pane vanished' failure, fixed 2026-07-17). :collapsible\n                    shows the fold button. The web renderer is interactive (drag +\n                    fold); the TUI renders the two panes as a plain stack\n                    (ADR-ikc-v3-048-01 lag).",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true},
     :children :any},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session — every\n        bus command dispatched (with its round-trip ms) and the client-only UI\n        events that never reach the bus (island load, zoom-to-fit, widget select,\n        render), newest last. Purely a CLIENT-side observability surface for\n        dogfood debugging: like :island-view reads the draft, it reads a client\n        ring-buffer directly, never a bus :source — so it adds zero server load,\n        needs no :bind, and keeps showing history even while the thing it observes\n        is stuck (the 30-40s island-select cascade is exactly what it is for).\n        Web-only; the TUI renders a labelled placeholder (ADR-ikc-v3-047-01 lag\n        policy) — a scrolling live log has no terminal-render contract yet.\n        :slow-ms marks any dispatch at/above it as slow (tone shift), so a hot\n        handler stands out in the stream.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none},
    :list
    {:description
     "A vertical list; each item is rendered on its own line.\n                    :items is optional: a bound :list gets its items from a source.\n                    :empty-label (v1.1): shown in place of a silently-blank pane\n                    when :items resolves to an empty vector.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :outline
    {:description
     "ADR-ikc-v3-044-01: a flat, :order-sorted list of typed blocks, nested\n        VISUALLY by each item's :depth (never a real tree — the native\n        block-frame engine keeps every block a flat :child-of child of its\n        page). :items is optional: a bound :outline gets its list from a\n        source (:block-outline). Each item is\n        {:block-id uuid-str :block-type kw :content string :order number\n        :depth int :checked? bool :collapsed? bool} — a deeper item whose\n        ancestor has :collapsed? true is hidden by the renderer, not the\n        source. :actions (the universal slot, ui.interpret/entry-schema)\n        names the structural commands the renderer may dispatch per item —\n        the notes content pane wires :indent/:outdent/:toggle-done/\n        :toggle-collapse/:delete/:insert-after/:update-text (all real\n        :ui/* commands, PLAN-graph-ui-v0-005-01 Phase 1); $value's meaning\n        is per-action (row actions: the acted-on item's :block-id, matching\n        :tree's own $value convention; :update-text: the edited text,\n        matching :input's). :ui/split-block/:ui/join-blocks/:ui/move-block\n        are real dispatchable commands too but have no wired gesture yet in\n        v1 (a real, tracked gap — 'select' a block for focus is local\n        renderer state, never a bus dispatch). TUI renders read-only\n        (gutters/numbering only, no dispatch) — same documented no-op\n        precedent as :elevation; there is no live per-block editing outside\n        the web renderer in v1.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer\n                    and, on Enter, dispatches this node's :on-submit command (see the\n                    :on-submit action below) — the input→command half of the UI-DSL.\n                    :state (v1.1): a validation/enablement hint for the renderer —\n                    :invalid highlights the field, :disabled greys it out and blocks\n                    edits.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is a\n        vector of {:label <string> :command <keyword> :with <map, optional>\n        :tone <token, optional> :disabled <bool, optional>} maps, bindable via\n        :bind (a bound :menu fills its :items from a source). Clicking an item\n        dispatches that item's :command, filled the same way every :on-submit is\n        — $session-id substituted, plus any literal :with args. This is the\n        reusable menu BODY: Studio's action menus and the notes block\n        context-menu (opened on right-click, a later wiring) both compose it.\n        Distinct from :list (plain display strings) and :button (one action):\n        :menu is a grouped set of commands. Web-only interactive; the TUI renders\n        the item labels as plain read-only text (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n        :options is the list of choices — a vector of {:label <string>\n        :value <string>} maps, bindable via :bind (a bound :select fills its\n        :options from a source, exactly as a bound :list fills :items). :value\n        names the initially-selected option's :value. On change the renderer\n        dispatches this node's :on-submit (the universal slot) with\n        $value = the chosen option's :value (and $session-id as usual) — the\n        choose→command half of the UI-DSL, mirroring :input's Enter→command\n        seam. :placeholder shows as a disabled leading option when no :value\n        matches. Web-only interactive; the TUI renders the current value (or\n        placeholder) as plain read-only text (ADR-ikc-v3-047-01 §Decision 3).",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a\n                    bound :text (see :bind) gets its value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:size {:optional true} [:enum :xs :sm :base :lg :xl]]
      [:weight {:optional true} [:enum :normal :medium :bold]]],
     :defaults {},
     :children :none}}},
  "v2.0-SNAPSHOT"
  {:status :snapshot,
   :drops #{:layout-self},
   :universal-slots
   {:text-transform
    {:description
     "Text casing — Mantine's `tt`. :uppercase is SPEC-002's sidebar section\n     header (11px / 700 / uppercase / letter-spaced) and its kind badge; the\n     renderer pairs :uppercase with the target's letter-spacing, since the\n     two always travel together in the locked target and a separate\n     letter-spacing slot would be a prop with exactly one legal use.",
     :shape [:enum :none :uppercase]},
    :import-id
    {:description
     "This node's AUTHORED IDENTITY — stable across re-seeds, and the join\n     between a description FILE and the frames it becomes.\n\n     The platform's own mechanism, not a new one: `frames-lib.store/create-frame!`\n     treats :import-id as a stable identity — a frame already bearing one is\n     SYNCED IN PLACE, same :frame/id, rather than duplicated — and\n     `ui.frames/node->slots` already lifts it off a widget node. Seeding an\n     island twice therefore leaves every :widget-id byte-identical, which is\n     what makes a Penpot board, an op-spec or any stored reference survive a\n     re-seed (verified 2026-08-04 across two seeds of the reader).\n\n     Why it is authored rather than the uuid: a :widget-id is minted by whichever\n     database was running, so a file full of uuids names frames that a wiped\n     graph no longer has. \"reader/vault-search\" survives the wipe and says what\n     the node IS. The uuid remains the join key between the graph and Penpot;\n     this is the join key between the file and the graph.\n\n     Namespaced by island by convention (\"reader/…\", \"reader-v2/…\") so two\n     islands may both hold a `vault-search` without colliding in one graph.\n\n     DECLARED HERE BECAUSE THE ENTRY SCHEMA IS CLOSED. The seeder read this key\n     from day one and the validator rejected it as a disallowed key — the files\n     were stamped, the islands seeded, `validate-dsl` passed (it checks this\n     manifest, not the instances), and only the full suite caught it. A slot the\n     platform reads and the vocabulary does not declare is exactly the drift\n     DSL-First exists to make impossible.",
     :shape :string},
    :widget-component
    {:description
     "This node is an OCCURRENCE of a named definition rather than a widget in\n     its own right — ADR-ikc-v3-060-01 §5. The value names a definition in the\n     description's own :components map.\n\n        {:widget-component :reading-pane :section :main :size \"66ch\"}\n\n     Everything beside :widget-component is an OVERRIDE, merged over the\n     definition. Under ADR-graph-ui-v0-002-01 any property may be overridden and each\n     one is TOUCHED — the occurrence's own, no longer following the definition.\n     Verified against Penpot 2.17 on 2026-08-04, whose component copies behave\n     exactly this way.\n\n     WHY THIS EXISTS. A description is read far more often than it is written,\n     and reader-ui.edn is 863 lines nested nine deep — you cannot see the page.\n     Naming its parts lets the top of a file BE the page, six lines long, with\n     each part opening on its own. It is also what a Penpot component maps to,\n     one-for-one, so a board and a description can talk about the same thing\n     (§6).\n\n     EXPANDED AT SEED TIME, for now. The seeder inlines each occurrence before\n     creating frames, so the graph holds a plain widget tree and the renderers\n     need no new case. That means the graph does not yet KNOW a component exists\n     — ADR-060 §1's :widget-component frame type and §3's occurrence links are\n     not built, so a definition change does not propagate to live occurrences and\n     a round-trip cannot give components back. Stated plainly because the gap is\n     invisible from the file, which looks like it has components either way.",
     :shape :keyword},
    :font-size
    {:description
     "Type size — Mantine's `fz` style prop (universal there too, for the same\n     reason). Two scales in ONE enum, exactly as Mantine's own MantineFontSize\n     does: the :xs-:xl step scale, and :h1-:h6 for heading sizes. :h1 is what\n     makes an editable page title LOOK like a title (with :variant :unstyled\n     on :input — Sec21) instead of like a form control.\n\n     Distinct from a kind's own :size (:icon, :drawer, :container), which\n     means that KIND's own dimension, never type size.",
     :shape [:enum :xs :sm :md :lg :xl :h1 :h2 :h3 :h4 :h5 :h6]},
    :font-weight
    {:description
     "Font weight — Mantine's `fw`. Mantine types it to raw CSS fontWeight,\n     which would make it unvalidatable, so v2.0 closes it to three named\n     steps (Sec0's standing trade). Moved here from :text's own :props\n     (Sec19) — it was never a property of text specifically. v1.x's :text\n     keeps its own :weight forever; a released version's vocabulary never\n     changes (ADR-graph-ui-v0-004-01).",
     :shape [:enum :normal :medium :bold]},
    :section
    {:description
     "Which named PLACE in its parent this child fills.\n\n     Universal for the same reason :flex is: it is a statement a CHILD makes\n     about its place in its parent, not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being the navbar.\n\n     TWO FAMILIES OF VALUE, ONE IDEA. The first five are an :app-shell's page\n     regions — Mantine's AppShell.Header / .Navbar / .Aside / .Main / .Footer,\n     named rather than ordered (ADR-graph-ui-v0-001-01 §B). The rest are the\n     named child slots the generated kinds declare: a `Divider`'s label, an\n     `Alert`'s title and icon, a `TextInput`'s description and error. Mantine's\n     `leftSection` and `label` props are the same idea as its `AppShell.Navbar`\n     — a place a widget goes — so this vocabulary says it once. Inventing a\n     second mechanism for the second family is what ADR-graph-ui-v0-013-01 was\n     written to end.\n\n     WHY THE SECOND FAMILY IS HERE AT ALL (AC-graph-ui-v0-001-01 §C, 2026-08-05).\n     It was not, and the consequence was that 31 kinds declared named slots that\n     NO valid description could fill: the enum could not spell :label, so\n     graph-ui.web.mantine-generic/split-slots — correct code — was unreachable.\n     A browser found it; nothing else could, because both halves were\n     individually valid and only their conjunction was wrong.\n\n     A documented no-op where it means nothing — the same contract :flex sets\n     for the TUI. This enum stays CLOSED (ADR-ikc-v3-041-01): a name that is not\n     here is rejected, so a typo is still caught. dsl/scripts/validate.clj holds\n     it to the vocabulary — every :slots name any kind declares must appear\n     below, and a generator run that adds a new slot name fails the build until\n     it does. That check is what stops this list from drifting back out of step,\n     which is the failure it was written after.",
     :shape
     [:enum
      :aside
      :chevron
      :cite
      :description
      :error
      :footer
      :header
      :hide-label
      :icon
      :label
      :left-section
      :legend
      :main
      :navbar
      :nothing-found-message
      :off-label
      :placeholder
      :right-section
      :separator
      :show-label
      :thumb-children
      :thumb-icon
      :title
      :validation-error]},
    :flex
    {:description
     "How this child sizes itself inside a flex/grid parent — ADR-graph-ui-v0-013-01\n     Sec4: :layout-self's four-key map collapses to Mantine's own `flex` CSS\n     shorthand, one value. :layout-self {:grow 1 :basis :zero} becomes :flex 1.\n     :shrink/:basis/:align-self are DROPPED, not renamed (Sec4) — a child\n     needing its own cross-axis alignment is deferred until a concrete island\n     needs it (ADR-graph-ui-v0-013 Deferred). Web renderer only — the TUI ignores it\n     (documented no-op, ADR-graph-ui-v0-007-01). Distinct from the :flex WIDGET\n     KIND below (Mantine's Flex container) — this is the self-sizing PROP\n     every node may carry, mirroring Mantine's own dual use of `flex` as both\n     a Mantine component name and a Box style prop.",
     :shape [:enum 0 1 2 3]},
    :narrow
    {:description
     "What this node does when the window is narrower than --viewport-narrow.\n\n     :keep    no change — the default, and the whole vocabulary for a node that\n              fits a phone already.\n     :hide    the node is ABSENT below the breakpoint. For desktop-only chrome\n              whose content is reachable another way — the conversations roster\n              is a seven-column table beside a picker that lists the same\n              conversations, so the phone keeps the picker.\n     :scroll  the node scrolls sideways INSIDE its own box below the\n              breakpoint, so the PAGE does not. For a wide table whose columns\n              are the point.\n     :fold    a two-pane split hands the width to its filling pane and starts\n              its resizable pane folded, one tap from open. :split-pane only.\n     :stack   a two-pane split becomes one vertical column, the resizable pane\n              first. :split-pane only.\n\n     :hide is a real loss of content and is why this slot is not a boolean. A\n     description states which answer it takes, and a reader of the description\n     can see which one it chose.\n\n     TWO VALUES ARE HONOURED BY ONE KIND, which is this manifest's standing\n     contract rather than a wart: :backdrop says the same of the six kinds that\n     draw a box, and :flex says it of the TUI. A slot is a statement a node\n     makes about its place, and a split is the only node whose narrow answer is\n     about its own two panes. Spelling those two as a SECOND key would put\n     :narrow in the schema twice, which malli refuses outright\n     (:malli.core/duplicate-keys — the collision that named :font-size).\n\n     Honoured by the web renderer. The TUI ignores it, which is the contract\n     :flex and :backdrop already set (ADR-graph-ui-v0-007-01) — a terminal has\n     one width and no phone.",
     :shape [:enum :keep :hide :scroll :fold :stack]},
    :backdrop
    {:description
     "The declared surface token this node paints as its background — one of the\n     :surfaces group in dsl/instances/themes.edn. `:surface body` becomes\n     `background: var(--body)`, which is the whole translation.\n\n     COLOUR ONLY, and no stroke, radius or padding with it. Those are a CELL's\n     treatment (dsl/design/*.edn, ui/widgets cell-style) and a cell is drawn by a\n     component that owns its own grid. A node in a widget tree has no such owner,\n     so it gets the one property that needs none.\n\n     Honoured on the kinds that draw a box — :box :stack :group :container\n     :scroll-area :markdown. A documented no-op elsewhere, which is the contract\n     :flex and the typography slots above already set. The TUI ignores it, the\n     same way it ignores every surface token (ADR-graph-ui-v0-007-01).\n\n     :border and :border-2 are absent from the range on purpose. They are in the\n     :surfaces group because they are painted colours, and neither is a surface\n     anything sits on.",
     :shape
     [:enum :ground :panel :raised :card :field :body :gutter :hover]},
    :per-tile
    {:description
     "DRAW MY ONE CHILD ONCE PER TILE, each copy scoped to that tile's session\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01).\n\n     true or absent. The node keeps ONE child in the graph — the template — and\n     the renderer draws it once for each open tile of the island, in order. Copy\n     n resolves as if it carried `:session-of n`.\n\n     WHY THE FRAMES HOLD ONE COPY AND NOT SIX. A frame is identified by its\n     :import-id, and frames-lib.store upserts by it — so six copies of a pane\n     would collapse into one frame and the tree would be wrong. Six copies would\n     also quadruple the description of every island that draws a pane, for a\n     feature most of them never use.\n\n     WHY THE COUNT IS NOT HERE. George, 2026-08-22: \"the 6 tiles is not hard UI\n     - it is fluid config from 1, 2, 4 or 6 tiles in the grid\". The count is\n     data — the island's own tiles — so the declaration says \"per tile\" and\n     never says how many. :tile-columns says how they are laid out.\n\n     THE CONTENT IS THE SAME AS ANYWHERE ELSE, and that is the point. George:\n     \"a conversation has same content in the tile and in the reading pane of the\n     reader-v2 or if floating free in the infinite canvas.\" The template is the\n     same part the single pane draws, so there is one declaration of what a\n     conversation looks like and no copy to drift.\n\n     THE TUI DRAWS ONE COPY, the focused tile. A terminal has one pane\n     (ADR-ikc-v3-048-01 TUI-lag), and this is declared rather than discovered.",
     :shape :boolean,
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}},
    :session-of
    {:description
     "THIS SUBTREE ANSWERS FOR ANOTHER SESSION — the nth TILE of this pane\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01 phase 2).\n\n     An integer, counting from 0. The whole subtree resolves with `$session-id`\n     bound to that tile's session, so every bind inside it reads the tile's own\n     answer.\n\n     WHY IT EXISTS. George, 2026-08-21: \"Conversation pane can be reworked so\n     2, 4 or 6 conversations can be observed and participated at once, displayed\n     as tiles.\" Six tiles bind about 40 sources each. Without this slot, each\n     tile would need its own copy of every source: 240 declarations, and a sixth\n     copy of every source added later. With it, `:page-title` stays one source\n     and answers for the session it is asked about, which it always did.\n\n     A NODE WHOSE INDEX NAMES NO TILE IS NOT DRAWN, and it reads nothing. A grid\n     of six cells over a pane of two tiles shows two. The alternative is worse\n     than an empty cell: a cell that fell back to the TAB's session would show\n     the wrong item and say nothing.\n\n     TWO KINDS OF VALUE. An INTEGER names a position. The keyword `:focused`\n     names whichever tile has the focus, and the reading pane uses it: the pane\n     draws ONE column, and that column follows the focus.\n\n     WHY THE PANE DOES NOT YET DRAW SIX COLUMNS, said here because a reader will\n     ask. Every node in the column carries an `:import-id`, and a frame is\n     identified by it. Six copies would be six nodes with one identity, so\n     per-tile identity is its own step and phase 3 does it.\n\n     WHICH SESSION EACH INDEX HOLDS COMES FROM THE :tile-sessions SOURCE, not\n     from the description. The description is seeded once and the tiles change\n     while a person works, so a position is the only thing a description can\n     name. Both binding runtimes read that source and carry it in their\n     substitutions under `$tile-sessions`.",
     :shape [:or :int [:enum :focused]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns\n     the edit buffer, seeded from :value (bindable). It dispatches\n     :on-gesture's :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing\n     v1.x's :on-submit) with $value = the buffer.\n\n     ENTER SENDS. Shift+Enter inserts a newline, and Ctrl/Cmd+Enter still\n     sends. Until 2026-08-20 the ONLY way to send was Ctrl/Cmd+Enter, which\n     George reported as a box that does not send (\"The input field does not\n     send on Enter and there is no submit button\"). Two reasons Enter wins.\n     A prompt box is a chat box, and every chat box in the world sends on\n     Enter. And a phone keyboard has no Ctrl key at all, so the phone\n     surface of phase 6 had no way to send anything.\n\n     :rows sets the\n     initial height; :auto-grow expands as the user types; :markdown\n     toggles a live preview of inline **bold**, *italic*, and `code`.\n     :triggers is an optional vector of trigger characters (e.g. [\"@\" \"/\"\n     \"#\"]) carried as data for future chip support. Web renderer only —\n     the TUI renders the buffer as plain read-only text.\n\n     A PASTED IMAGE GOES WITH THE PROMPT (PLAN-ikc-v3-017-01 phase 11).\n     George, 2026-08-21: \"I often paste an image in the terminal — is it\n     supported in a tile?\" A paste that carries an image file dispatches\n     the :paste gesture, whose $value is the whole `data:` URL, and the image\n     never enters the buffer: the bytes are written once into the :attachments\n     vault, and the prompt carries the path. THE GESTURE AND NOT A DIRECT\n     DISPATCH, because a tile bakes its own session into every gesture it holds\n     (ADR-graph-ui-v0-023-01) — a paste that dispatched by itself attached the\n     image to the TAB'S session, and the tile showed nothing. A paste of TEXT is untouched, because the default is stopped only\n     when an image was found. NO PROP DECLARES THIS. A paste is what this\n     widget is for, in the same way that Enter sends.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :aspect-ratio
    {:description
     "Mantine `AspectRatio` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 1 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "AspectRatio"},
     :props
     [:map
      [:ratio
       {:optional true,
        :doc
        "Aspect ratio, for example, `16 / 9`, `4 / 3`, `1920 / 1080`"}
       [:or :int :double]]],
     :defaults {:ratio 1},
     :children :any},
    :fieldset
    {:description
     "Mantine `Fieldset` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 1 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Fieldset"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {},
     :slots [:legend],
     :children :slots},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit buffer\n     and, on Ctrl/Cmd+Enter or its Save button, dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the buffer — the editor half of the Foam markdown Edit\n     view (ADR-ikc-v3-052-01). :value seeds the buffer (bindable). :rows is\n     the initial visible height. In the TUI it renders as plain read-only\n     text. :draft-key: a client draft channel to publish the live buffer to\n     on every (debounced) change, so a live-preview widget (:island-view)\n     can render what is being typed BEFORE it is submitted. :format: :edn\n     (default) shows the buffer as-is; :indent converts the bound EDN value\n     to a bracket-stripped indentation format for display.\n\n     :font-size is NOT declared here under v2.0 — it is the UNIVERSAL SLOT\n     (ADR-graph-ui-v0-013-01 Sec19). v1.x declared it as this kind's own prop, which\n     was always a mislabelling: scaling the editor's code font is typography,\n     not a property of text areas specifically. Declaring both would be the\n     same key twice, which malli rejects outright (:malli.core/duplicate-keys)\n     — the check that found this. v1.x keeps its own :font-size forever.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                 contain formatted text. :value is the markdown source. In the TUI it\n                 renders as plain text (no styled rendering); a web renderer renders\n                 it as HTML. A bound :markdown gets its :value from a data source.\n\n                 SINCE 2026-08-14 IT CAN ALSO BE MARKED (F-platform-v0-011-01):\n                 :highlights is this page's highlights, and the marked text is\n                 washed in each one's colour. Selecting text offers four colour\n                 swatches and fires the :highlight gesture, whose $value is the\n                 whole selection map — the text, an advisory position, and the\n                 chosen colour — because a gesture carries one value and both\n                 capture modes must converge before the command\n                 (ADR-graph-ui-v0-017-01 §1-2).\n\n                 :value and :highlights are TWO bindings on one widget, which the\n                 per-prop :bind form has expressed since 2026-07-19; no new binding\n                 mechanism was needed for it.\n\n                 SINCE 2026-08-20 THE SELECTION CAN ALSO BOOKMARK\n                 (PLAN-ikc-v3-015-01 phase 3): the same popover offers a\n                 bookmark control beside the swatches, firing the :bookmark\n                 gesture with the same selection map, colour omitted. A\n                 description wires it only where the body is a conversation —\n                 the gesture resolves the selection to an entry id, and only a\n                 conversation has entries.\n\n                 A highlight map may carry :entry-id — the conversation storage\n                 form (ADR-ikc-v3-076-01 §3). The paint path is unchanged:\n                 offsets into the rendered source decide where a wash is drawn,\n                 whichever form stored it.\n\n                 AND ITS [[wikilinks]] CAN NAVIGATE (2026-08-18): :links is\n                 [{:target :page-id}] — every wikilink target in this body, each\n                 resolved on the SERVER by :page-content-links, bound with\n                 :link-bind rather than :bind because it is a second, independent\n                 binding beside :value.\n\n                 A target that names no page is still DRAWN, as a muted chip that\n                 does nothing. An unresolved wikilink is an invitation to create\n                 that page, not an error.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:links
       {:optional true}
       [:vector [:map [:target :string] [:page-id [:maybe :string]]]]]
      [:highlights
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:block-id {:optional true} :string]
         [:entry-id {:optional true} :string]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :input-base
    {:description
     "Mantine `InputBase` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 15 prop(s), 5 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "InputBase"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:multiline
       {:optional true,
        :doc
        "If set, the input can have multiple lines, for example when `component=\"textarea\"`"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-aria
       {:optional true,
        :doc
        "If set, `aria-` and other accessibility attributes are added to the input"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :with-aria true,
      :right-section-pointer-events "none",
      :multiline false,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :loader
    {:description
     "Mantine `Loader` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1 named\n  child slot(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Loader"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the loader. `Loader` has predefined `xs`-`xl` values. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Loader type, key of `loaders` prop"}
       [:or [:enum :bars :dots :oval] :string]]],
     :defaults {:size :md, :type :oval},
     :unmapped
     {"loaders"
      "Partial<Record<(string & {}) | \"bars\" | \"dots\" | \"oval\", MantineLoaderComponent>>"},
     :children :any},
    :unstyled-button
    {:description
     "Mantine `UnstyledButton` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 0 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "UnstyledButton"},
     :props [:map],
     :defaults {},
     :children :any},
    :loading-overlay
    {:description
     "Mantine `LoadingOverlay` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 2 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "LoadingOverlay"},
     :props
     [:map
      [:visible
       {:optional true,
        :doc "Determines whether the overlay should be visible"}
       :boolean]
      [:z-index
       {:optional true, :doc "Controls overlay `z-index`"}
       [:or :string :int :double]]],
     :defaults {:visible false, :z-index 400},
     :children :none},
    :space
    {:description
     "Mantine `Space` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 0 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Space"},
     :props [:map],
     :defaults {},
     :children :none},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one —\n     the Studio preview pane. Renders the island the current session has\n     selected / is composing: its saved tree by default, or the description\n     currently in the editor buffer AS YOU TYPE (WYSIWYG), whichever the\n     client draft holds, with the saved tree as the fallback. The preview\n     attaches NOTHING — it reads via :ui/preview-context, so it can never\n     steal or leak the lock the composer holds. Carries a self-embed guard.\n     Web-only; the TUI renders a labelled placeholder.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :tree
    {:description
     "A nested outline; each item is now a MAP with optional recursive\n     :children (ADR-graph-ui-v0-013-01 Sec17): {:label string :children [item ...]\n     :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean}. :items is optional: a\n     bound :tree gets its outline from a source. The recursive sibling of\n     :list. Recognises TWO :on-gesture keys (ADR-graph-ui-v0-013 Sec7-8): :submit\n     (click-to-navigate — the web renderer wires clicking any node to it) and\n     :fork (the explicit fork action, typically the 'f' key; declared but not\n     yet wired in the web renderer, same as v1.x's :on-fork always was).\n     $value substitutes the clicked/forked item's :entry-id either way.\n     :direction: :column (default) stacks items vertically as an indented\n     outline; :row lays a FLAT item list out horizontally as a strip of\n     clickable buttons (the daily-note nav bar) and ignores nesting. :value\n     (ADR-graph-ui-v0-013-01 Sec24): the clicked node's own click target — see\n     :list's :value note for why it was missing.\n\n     A CLICKED ROW ACKNOWLEDGES ITSELF, and it is not a prop. Added 2026-08-17,\n     because a click on a page row costs a dispatch plus one :ui/read for every\n     source the server says changed — measured at 337ms for a single frame read\n     against the live graph, so a click is a wait, and the row used to give back\n     nothing at all while it ran. The row now shows a turning ring at its trailing\n     edge from the moment of the click until this session stops waiting on the bus.\n     The ring is OUT OF FLOW — absolute at the row's right edge, so appearing costs\n     no layout and a row with an accessory does not have its count or its reference\n     text shoved left mid-click. In :direction :row the strip uses the Button's own\n     loading state for the same reason, which also disables the control so a second\n     click cannot queue a second dispatch behind the first.\n     Deliberately NOT declared as a prop: an island cannot ask for it, cannot turn\n     it off, and cannot bind it. It is not data about the outline — it is the state\n     of the client that is drawing the outline, and the value it reports is one no\n     bus source could serve, since reading a source is the very round trip being\n     waited on. It lives in graph-ui.web.busy, the reagent-atom pattern\n     graph-ui.web.activity and graph-ui.web.draft already use, and the TUI simply\n     has nothing to draw here. The matching WINDOW-level signal — a sweeping line\n     on the chrome bar once a wait passes 400ms — is in graph-ui.web.core for the\n     same reason a viewport-spanning bar is not an island widget: it is a fact\n     about the frame, not about anything on the canvas.",
     :status :in-progress,
     :props
     [:map
      [:row {:optional true} [:enum :line :card]]
      [:active-value {:optional true} [:maybe :string]]
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:children {:optional true} [:vector :any]]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :group
    {:description
     "Horizontal row — Mantine `Group` (ADR-graph-ui-v0-013-01 Sec0). :wrap is\n     boolean here (true -> CSS `wrap`, false -> `nowrap`), the same\n     convention v1.x's :box :wrap already used. :grow gives every child\n     `flex-grow: 1`.",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:wrap {:optional true} :boolean]
      [:grow {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n     declares the header — a vector of {:label <string> :key\n     <keyword|string>} maps; each row's cell for a column is looked up by\n     that column's :key. :rows is the data — a vector of maps, bindable via\n     :bind. Display-only: row selection/editing is a later addition.\n     :tone/:density tune the visual weight. In the TUI it renders as plain\n     text rows.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :file-input
    {:description
     "Mantine `FileInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 23 prop(s), 6 named\n  child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"component" "any",
      "defaultValue" "Multiple extends true ? File[] : File",
      "multiple" "Multiple",
      "value" "Multiple extends true ? File[] : File"},
     :slots
     [:description
      :error
      :label
      :left-section
      :placeholder
      :right-section],
     :defaults
     {:clearable false,
      :left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "FileInput"},
     :status :generated,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:name {:optional true, :doc "Input name attribute"} :string]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set, the input value cannot be changed"}
       :boolean]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :affix
    {:description
     "Mantine `Affix` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 3 prop(s), and 1\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Affix"},
     :props
     [:map
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]],
     :defaults {:within-portal true, :z-index 200},
     :unmapped {"position" "AffixPosition"},
     :children :any},
    :portal
    {:description
     "Mantine `Portal` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 2 prop(s), 1 named\n  child slot(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Portal"},
     :props
     [:map
      [:reuse-target-node
       {:optional true,
        :doc "If set, all portals are rendered in the same DOM node"}
       :boolean]],
     :defaults {:reuse-target-node true},
     :unmapped {"target" "string | HTMLElement"},
     :children :any},
    :tags-input
    {:description
     "A TAG EDITOR: the tags of the thing being read, each one removable, with a\n     field that completes from the vocabulary the graph already holds.\n\n     HAND-WRITTEN SINCE 2026-09-15, and the generated header it replaced says\n     exactly why it had to graduate: a generated kind has 'no data binding, no\n     edit buffer and no selection state of its own'. This kind needs all three.\n     :value is BOUND to the tags of the selected page and :suggestions to the tag\n     vocabulary, the field keeps a buffer while a person types, and the dropdown\n     keeps which row is active. graph-ui.web.widgets/widget-tags-input and an\n     explicit case in render.cljs are what those three cost.\n\n     THIRTY-THREE PROPS BECAME FIVE, and the ones that went were the library's,\n     not the product's. Mantine's TagsInput exposes its whole controlled-combobox\n     surface — :dropdown-opened, :search-value, :select-first-option-on-change\n     and twenty-five more. A description that set any of them would be reaching\n     past the contract into the component. What is declared here is the CONTRACT:\n     two bound props, one label, one posture, one size.\n\n     FOUR WAYS TO ADD AND THREE TO REMOVE, and each is the outliner idiom rather\n     than a choice made here. Enter, a comma and a loss of focus each add what is\n     typed. The cross on a tag removes it, and Backspace in an empty field\n     removes the last one.\n\n     THE SUGGESTIONS ARRIVE AS AN ORDINARY BIND, and the client narrows them per\n     keystroke. George decided that on 2026-08-20. The vocabulary is about 300\n     strings on this corpus, so one read beats a protocol that speaks on every\n     key.\n\n     A GESTURE CARRIES ONE TAG IN $value, never the whole list. The two commands\n     that write a :tags slot take one tag each (ADR-ikc-v3-080-01 decision 7), and\n     a widget that emitted the vector would make the handler compute a difference\n     to find out what a person did.\n\n     WHAT IT CANNOT DO, AND THE HELP PAGE SAYS SO. The editor writes the :tags\n     SLOT. An inline #hashtag lives in the text, and the file is the truth\n     (ADR-ikc-v3-052-01), so a cross on such a tag would promise a removal this\n     cannot perform. :tags/tags-of-frame reports which storage each tag came\n     from, and only a slot tag is offered a cross.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the tags as joined text and\n     dispatches nothing. A terminal has no dropdown, and a line of words is what\n     a reader of that surface needs.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true,
        :doc
        "The tags on the thing being read. BOUND, normally to\n                        :page-tag-list."}
       [:vector :string]]
      [:suggestions
       {:optional true,
        :doc
        "The known tag vocabulary, for completion. BOUND,\n                              normally to :tag-vocabulary. The client filters\n                              it."}
       [:vector :string]]
      [:placeholder
       {:optional true,
        :doc
        "What the empty field says. An empty tag editor is\n                              indistinguishable from a broken one without it."}
       :string]
      [:read-only
       {:optional true,
        :doc
        "Draw the tags and accept nothing. The TUI's posture,\n                            and a reading surface that must not be edited."}
       :boolean]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:size :sm},
     :gestures [:add :remove],
     :children :none},
    :radio
    {:description
     "Mantine `Radio` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s), 3 named\n  child slot(s), and 2 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Radio"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color, by default value depends on `theme.autoContrast`"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:label-position :right, :radius :xl, :size :sm},
     :slots [:description :error :label],
     :unmapped
     {"icon" "FC<RadioIconProps>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :slots},
    :transition
    {:description
     "Mantine `Transition` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s), 4\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Transition", :children :function},
     :props
     [:map
      [:duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]
      [:enter-delay
       {:optional true,
        :doc "Delay in ms before enter transition starts"}
       [:or :int :double]]
      [:exit-delay
       {:optional true,
        :doc "Delay in ms before exit transition starts"}
       [:or :int :double]]
      [:exit-duration
       {:optional true, :doc "Exit transition duration in ms"}
       [:or :int :double]]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the element is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:mounted
       {:optional true,
        :doc
        "Determines whether component should be mounted to the DOM"}
       :boolean]
      [:timing-function
       {:optional true, :doc "Transition timing function"}
       :string]
      [:transition
       {:optional true, :doc "Transition name or object"}
       [:or
        [:enum
         :scale
         :fade
         :fade-down
         :fade-up
         :fade-left
         :fade-right
         :skew-up
         :skew-down
         :rotate-right
         :rotate-left
         :slide-down
         :slide-up
         :slide-right
         :slide-left
         :scale-y
         :scale-x
         :pop
         :pop-top-left
         :pop-top-right
         :pop-bottom-left
         :pop-bottom-right]
        :string]]],
     :defaults {:duration 250, :exit-duration 250},
     :gestures [:enter :entered :exit :exited],
     :children :any},
    :button
    {:description
     "ADR-graph-ui-v0-007-01: a standalone clickable button, built on\n     @radix-ui/react-slot. :label is the button's text; :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit) is\n     dispatched on click — $session-id substitutes as usual, $value is not\n     meaningful for a plain button unless a specific template hardcodes\n     one. :disabled blocks the click. TUI renders the label as plain text,\n     read-only.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]],
     :defaults {},
     :children :none},
    :spoiler
    {:description
     "Mantine `Spoiler` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 5 prop(s), 2 named\n  child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :children :any,
     :unmapped {"controlRef" "ForwardedRef<HTMLButtonElement>"},
     :slots [:hide-label :show-label],
     :defaults {:max-height 100, :transition-duration 200},
     :mantine {:component "Spoiler"},
     :status :generated,
     :gestures [:expanded-change],
     :props
     [:map
      [:expanded
       {:optional true, :doc "Controlled expanded state value"}
       :boolean]
      [:initial-state
       {:optional true,
        :doc
        "Initial spoiler state, `true` to wrap content in spoiler, `false` to show content without spoiler, opened state is updated on mount"}
       :boolean]
      [:max-height
       {:optional true,
        :doc
        "Maximum height of the visible content, when this point is reached spoiler appears"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Spoiler reveal transition duration in ms, set 0 or null to turn off animation"}
       [:or :int :double]]]},
    :notification
    {:description
     "Mantine `Notification` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 5 prop(s), 3 named\n  child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Notification"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Controls notification line or icon color, key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:loading
       {:optional true,
        :doc
        "If set, the `Loader` component is displayed instead of the icon"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is visible"}
       :boolean]],
     :defaults {:with-close-button true},
     :gestures [:close],
     :slots [:icon :title],
     :children :any},
    :highlight
    {:description
     "Mantine `Highlight` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 10 prop(s), and 1\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Highlight"},
     :props
     [:map
      [:children
       {:optional true,
        :doc "String parts of which must be highlighted"}
       :string]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:highlight
       {:optional true,
        :doc
        "Substring or a list of substrings to highlight in `children`"}
       [:vector :any]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:span
       {:optional true, :doc "Shorthand for `component=\"span\"`"}
       :boolean]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]],
     :defaults
     {:highlight [], :inherit false, :inline false, :size :md},
     :unmapped {"color" "string | (string & {})"},
     :children :none},
    :mark
    {:description
     "Mantine `Mark` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 1 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Mark"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]],
     :defaults {},
     :children :any},
    :checkbox
    {:description
     "Mantine `Checkbox` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 10 prop(s), 3 named\n  child slot(s), and 2 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Checkbox"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input background color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color. By default, depends on `theme.autoContrast`."}
       [:or :keyword :string]]
      [:id {:optional true, :doc "Unique input id"} :string]
      [:indeterminate
       {:optional true,
        :doc
        "Indeterminate state of the checkbox. If set, `checked` prop is ignored."}
       :boolean]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:label-position :right, :size :sm},
     :slots [:description :error :label],
     :unmapped
     {"icon" "FC<{ indeterminate: boolean; className: string; }>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :slots},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                 be a :box with a :title (used as the tab label). :active (default 0)\n                 is the index of the visible tab. The renderer draws a tab header line\n                 and shows only the active child's content below it.\n\n                 THE WEB RENDERER DID NOT DO THAT UNTIL 2026-08-23, and this\n                 paragraph is why it now does. It mounted every panel, so a page\n                 click — which changes the bound value of all of them — rebuilt\n                 the lot: 798 DOM mutations for one click, 799 of 815 of them\n                 inside the Tabs component, measured on the running deployment.\n                 The TUI had drawn only the active child all along, so two\n                 renderers disagreed about one description and the words above\n                 were on the TUI's side (PLAN-ikc-v3-019-01 phase 4).\n\n                 ONE EXCEPTION, AND IT IS DERIVED RATHER THAN DECLARED. A child\n                 whose subtree holds a widget with an edit buffer — :input,\n                 :text-area, :outline — keeps its content drawn whichever tab is\n                 active. That buffer lives in the renderer, so unmounting it would\n                 throw away text a person typed and has not saved, with nothing\n                 saying so. The renderer reads it off the child's own subtree\n                 (graph-ui.web.widgets/holds-draft?), so no island declares it and\n                 none can forget it.\n\n                 DERIVED BECAUSE A DERIVED RULE CANNOT DRIFT, and for no other\n                 reason. An earlier draft of this paragraph also argued that a\n                 declared slot would be unavailable to an island pinned to a\n                 released vocabulary. George struck that on 2026-08-23: a version\n                 pin is not a reason to shape a design around it. If the right\n                 answer needs a slot, the slot is added and the island is moved.\n\n                 THE EXCEPTION IS A SYMPTOM AND IT HAS AN OWNER. An editor's\n                 unsaved text should not live in component state at all\n                 (PLAN-ikc-v3-018-01: drafts in browser storage, keyed by the\n                 thing being edited). When it does not, holds-draft? is deleted\n                 and a tab-set draws one child with no exception at all.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any},
    :pill
    {:description
     "Mantine `Pill` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Pill"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Adds disabled attribute, applies disabled styles"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls pill `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-remove-button
       {:optional true,
        :doc "Controls visibility of the remove button"}
       :boolean]],
     :defaults {:radius :xl, :size :sm, :with-remove-button false},
     :gestures [:remove],
     :children :any},
    :simple-grid
    {:description
     "Equal-width columns — Mantine `SimpleGrid` (ADR-graph-ui-v0-013-01 Sec0), the\n     common case :grid's :span bookkeeping would be overkill for.",
     :status :in-progress,
     :props
     [:map
      [:cols {:optional true} :int]
      [:spacing {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:vertical-spacing
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:cols 1},
     :children :any},
    :grid
    {:description
     "Real 2D proportional layout — CSS GRID (ADR-graph-ui-v0-013-01 Sec3).\n     :columns is the TOTAL (12 by default); each :grid-col child states\n     its :span of that total — '50-50' is two :grid-col children at :span 6.\n     :gutter is the gap between cells (a separate name from :gap elsewhere\n     in this vocabulary, because Mantine's Grid named it that and every\n     declaration here says :gutter). Children SHOULD be :grid-col.\n\n     EVERY CELL HAS A DEFINITE HEIGHT, and every row an equal share of the\n     grid. That is the whole reason this kind is CSS grid and not Mantine's\n     `Grid`, which is a wrapping flexbox: a flexbox row is as tall as its\n     content, so a :scroll-area in a cell grew instead of scrolling, and a\n     second row did not share the height with the first (2026-08-23).\n\n     :grow AND :offset ARE GONE, with the :auto and :content spans. A\n     wrapping flexbox could do those three and a grid cannot. Nothing\n     declared them, so a description that names one is now refused at\n     \"disallowed key\" instead of the renderer dropping it without a word.\n     The gate is the description validator that every island's own test\n     runs, and NOT validate-dsl, which checks this manifest and not the\n     instances.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} :int]
      [:gutter {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:columns 12},
     :children :any},
    :visually-hidden
    {:description
     "Mantine `VisuallyHidden` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 0 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "VisuallyHidden"},
     :props [:map],
     :defaults {},
     :children :any},
    :floating-indicator
    {:description
     "Mantine `FloatingIndicator` — GENERATED from @mantine/core's own\n  TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n  this kind says exactly what the library promises and no more. 4 prop(s),\n  and 2 prop(s) whose type carries no data contract (see :unmapped).\n  RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the component\n  named above straight from this declaration — the props here are the legal\n  ones, the gestures here are the wired ones, and nothing else reaches the\n  DOM. Generic is not finished: this kind has no data binding, no edit\n  buffer and no selection state of its own. A kind that needs one of those\n  graduates to a hand-written widget and an explicit case in render.cljs —\n  move it above the GENERATED marker and give it a description that explains\n  ITSELF.",
     :status :generated,
     :mantine {:component "FloatingIndicator"},
     :props
     [:map
      [:display-after-transition-end
       {:optional true,
        :doc
        "If set, the indicator is displayed after transition ends. Should be set if the component is used inside a container that has `transform: scale(n)` styles."}
       :boolean]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :string :int :double]]],
     :defaults {:transition-duration 150},
     :unmapped {"parent" "HTMLElement", "target" "HTMLElement"},
     :children :none},
    :popover
    {:description
     "Mantine `Popover` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 29 prop(s), 1 named\n  child slot(s), 7 gesture(s), and 4 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Popover"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:change
      :close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :children :any},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n     the toggle line; :collapsed (default false) controls initial state.\n     :count (ADR-graph-ui-v0-013-01 Sec17): an optional int shown beside the\n     title (the '12 pages' style header). :icon: an optional :icon name\n     leading the title. The expand/collapse chevron itself is not a prop —\n     every :collapsible has one, it is not a per-instance choice.\n\n     :hide-when-empty (F-platform-v0-014-01, 2026-08-18) — draw NOTHING, not an\n     empty heading, when every bound child inside is empty. Default false, which\n     is every existing section's behaviour.\n\n     WHY IT HAS TO BE A PROP. Emptiness is a RUNTIME fact, so it cannot be\n     settled where a section's existence is otherwise decided: ui.blocks drops a\n     collection that has no :source at EXPANSION time, which is a statement about\n     the declaration, not about today's data. A Pinned section has a source and is\n     usually empty, and ikc1 draws it only once something is pinned\n     (AthensSidebar.tsx: `{pinnedFrames.length > 0 && …}`).\n\n     AND WHY THIS DOES NOT CONTRADICT THE RIGHT GUTTER, which is drawn even when\n     empty on the stated rule that 'a column that comes and goes per row is not a\n     column' (dsl/design/block-row.edn). A sidebar section is not a column:\n     nothing aligns to it, and an empty one spends a heading plus its own vertical\n     space on every screen. Progressive disclosure applies\n     (CONCEPT-graph-ui-v0-008-01); column stability does not.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:count {:optional true} :int]
      [:icon {:optional true} :keyword]
      [:hide-when-empty {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false, :hide-when-empty false},
     :children :any},
    :ring-progress
    {:description
     "Mantine `RingProgress` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 6 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "RingProgress"},
     :props
     [:map
      [:root-color
       {:optional true,
        :doc
        "Color of the root section, key of theme.colors or CSS color value"}
       [:or :keyword :string]]
      [:round-caps
       {:optional true,
        :doc
        "Sets whether the edges of the progress circle are rounded"}
       :boolean]
      [:sections {:optional true, :doc "Ring sections"} [:vector :any]]
      [:size
       {:optional true, :doc "Width and height of the progress ring"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Ring thickness"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]],
     :defaults
     {:sections [], :size 120, :thickness 12, :transition-duration 0},
     :slots [:label],
     :children :slots},
    :segmented-control
    {:description
     "Mantine `SegmentedControl` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 15 prop(s), 1\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "SegmentedControl"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, changes color of indicator, by default color is based on current color scheme"}
       [:or :keyword :string]]
      [:data
       {:optional true,
        :doc "Data based on which controls are rendered"}
       [:vector :any]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Determines whether the component is disabled"}
       :boolean]
      [:full-width
       {:optional true,
        :doc
        "Determines whether the component should take 100% width of its parent"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "Name of the radio group, by default random name is generated"}
       :string]
      [:orientation
       {:optional true, :doc "Component orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set to `false`, prevents changing the value"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls `font-size`, `padding` and `height` properties"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc
        "Indicator `transition-duration` in ms, set `0` to turn off transitions"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "Indicator `transition-timing-function` property"}
       :string]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-items-borders
       {:optional true,
        :doc
        "Determines whether there should be borders between items"}
       :boolean]],
     :defaults
     {:data [],
      :full-width false,
      :orientation :horizontal,
      :size :sm,
      :transition-duration 200,
      :with-items-borders true},
     :gestures [:change],
     :children :none},
    :number-formatter
    {:description
     "Mantine `NumberFormatter` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 9 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "NumberFormatter"},
     :props
     [:map
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that are displayed after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true,
        :doc "Character used as a decimal separator, `'.'` by default"}
       :string]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, zeros are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:prefix
       {:optional true, :doc "Prefix added before the value"}
       :string]
      [:suffix
       {:optional true, :doc "Suffix added after the value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style"}
       [:enum :none :thousand :lakh :wan]]
      [:value
       {:optional true, :doc "Value to format"}
       [:or :string :int :double]]],
     :defaults
     {:allow-negative true,
      :fixed-decimal-scale false,
      :thousand-separator ","},
     :children :none},
    :multi-select
    {:description
     "Mantine `MultiSelect` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 37 prop(s), 6 named\n  child slot(s), 7 gesture(s), and 2 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData", "filter" "OptionsFilter"},
     :slots
     [:description
      :error
      :label
      :left-section
      :nothing-found-message
      :right-section],
     :defaults
     {:check-icon-position :left,
      :left-section-pointer-events "none",
      :hidden-input-values-divider ",",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :searchable false,
      :pointer false,
      :open-on-focus true,
      :with-check-icon true,
      :with-asterisk false,
      :with-aligned-labels false,
      :with-error-styles true,
      :required false,
      :hide-picked-options false},
     :mantine {:component "MultiSelect"},
     :status :generated,
     :gestures
     [:change
      :clear
      :dropdown-close
      :dropdown-open
      :option-submit
      :remove
      :search-change],
     :props
     [:map
      [:check-icon-position
       {:optional true,
        :doc "Position of the check icon relative to the option label"}
       [:enum :left :right]]
      [:chevron-color
       {:optional true, :doc "Controls color of the default chevron"}
       [:or :keyword :string]]
      [:clear-search-on-change
       {:optional true,
        :doc "Clear search value when item is selected"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section when the component has value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-search-value
       {:optional true, :doc "Default search value"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:vector :string]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:hidden-input-values-divider
       {:optional true,
        :doc
        "Divider used to separate values in the hidden input `value` attribute"}
       :string]
      [:hide-picked-options
       {:optional true,
        :doc
        "If set, picked options are removed from the options list"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:max-values
       {:optional true,
        :doc "Maximum number of values, no limit if not set"}
       [:or :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:search-value
       {:optional true, :doc "Controlled search value"}
       :string]
      [:searchable {:optional true, :doc "Allows searching"} :boolean]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:vector :string]]
      [:with-aligned-labels
       {:optional true,
        :doc "If set, unchecked labels are aligned with checked ones"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-check-icon
       {:optional true,
        :doc
        "If set, the check icon is displayed near the selected option label"}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :app-shell
    {:description
     "A PAGE — Mantine's `AppShell`, adopted whole (ADR-graph-ui-v0-001-01 §B).\n     Header / Navbar / Aside / Main / Footer, which is what a surface with a\n     navigation sidebar and a content area actually IS.\n\n     Adopted because the reader was hand-rolling one. `{:widget :split-pane\n     :initial 270 :min 180 :max 440}` wrapping a `:container` is a Navbar and a\n     Main expressed as flex arithmetic, with the sidebar's resize and collapse left\n     for the renderer to invent. Mantine ships that behaviour, including the\n     breakpoint at which the sidebar collapses — so 057-01's deferral of\n     responsiveness partly dissolves here rather than needing its own model.\n\n     SECTIONS ARE NAMED, NOT ORDERED. Children declare which section they are\n     via :section; there is no positional convention to remember and a\n     description that omits a section simply has none. That is the whole reason\n     this is a kind and not a :grid with agreed cells.\n\n     :mode is Mantine's own, and it is load-bearing HERE in a way it is not in a\n     plain web app. Mantine defaults to 'fixed', which positions every section\n     except Main against the VIEWPORT — correct for a page that owns the window,\n     wrong for an ikc3 island, which may be one pane of a canvas or embedded in\n     a tile. A fixed navbar would escape its island and land on the window. So\n     :mode defaults to :static here, and :fixed is the deliberate opt-in for a\n     surface that really does own the viewport. (The risk was named in the ADR\n     before this kind was declared; `mode` is Mantine's own answer to it, so\n     nothing had to be invented to resolve it.)\n\n     :navbar-width / :aside-width / :header-height / :footer-height take the\n     same open value :container's :size does — a token, a number, or a CSS\n     length — so a sidebar can be stated in ch or rem rather than pixels.\n     :navbar-breakpoint is the width below which the sidebar collapses; Mantine's\n     own token scale.\n\n     Gestures: none. An :app-shell arranges; it does not dispatch.",
     :status :in-progress,
     :props
     [:map
      [:mode {:optional true} [:enum :static :fixed]]
      [:padding {:optional true} [:enum :none :xs :sm :md :lg :xl]]
      [:navbar-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:aside-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:header-height {:optional true} :int]
      [:footer-height {:optional true} :int]
      [:navbar-breakpoint
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:mode :static, :padding :md},
     :slots [:aside :footer :header :main :navbar],
     :children :any},
    :close-button
    {:description
     "Mantine `CloseButton` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 2 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "CloseButton"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute, assigns disabled styles"}
       :boolean]
      [:icon-size
       {:optional true, :doc "`X` icon `width` and `height`"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :slots [:icon],
     :children :any},
    :grid-col
    {:description
     "One cell of a :grid parent (ADR-graph-ui-v0-013-01 Sec3). :span is this\n     child's share of the parent's :columns total — STATED, not emergent\n     from siblings. An int only: :auto and :content went with the flexbox\n     (see :grid), and so did :offset.",
     :status :in-progress,
     :props
     [:map
      [:span {:optional true} :int]
      [:order {:optional true} :int]],
     :defaults {},
     :children :any},
    :color-swatch
    {:description
     "Mantine `ColorSwatch` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ColorSwatch"},
     :props
     [:map
      [:color
       {:optional true, :doc "Valid CSS color to display"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the swatch, any valid CSS value, numbers are converted to rem."}
       [:or :string :int :double]]
      [:with-shadow
       {:optional true,
        :doc
        "Determines whether the swatch should have inner `box-shadow`"}
       :boolean]],
     :defaults {:radius 1000, :size 28, :with-shadow true},
     :children :any},
    :box
    {:description
     "A plain container with no layout opinion — ADR-graph-ui-v0-013-01 Sec0: v1.x's\n     :layout enum and flex props (:direction/:wrap/:justify/:align/:gap) are\n     DROPPED from :box itself (a prop-level change within a kind that still\n     exists, so no :drops entry is needed for it — only whole kind/slot names\n     require one). Arrangement lives on :stack/:group/:flex/:grid/\n     :simple-grid below; :box is for grouping + chrome only.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:border {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation
       {:optional true}
       [:enum :flat :raised :floating :overlay]]],
     :defaults {},
     :children :any},
    :paper
    {:description
     "Mantine `Paper` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 3 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Paper"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]],
     :defaults {},
     :children :any},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                 is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                 plain monospaced text; a web renderer may apply syntax highlighting.\n                 A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :native-select
    {:description
     "Mantine `NativeSelect` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 13 prop(s), 5 named\n  child slot(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "NativeSelect"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :unmapped {"data" "ComboboxData"},
     :children :slots},
    :kbd
    {:description
     "Mantine `Kbd` — GENERATED from @mantine/core's own TypeScript declarations\n  (PLAN-graph-ui-v0-009-01), not hand-written, so this kind says exactly\n  what the library promises and no more. 1 prop(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Kbd"},
     :props
     [:map
      [:size
       {:optional true, :doc "Controls `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :sm},
     :children :none},
    :burger
    {:description
     "Mantine `Burger` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 6 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Burger"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS value, by default `theme.white` in dark color scheme and `theme.black` in light"}
       [:or :keyword :string]]
      [:line-size
       {:optional true,
        :doc
        "Controls height of lines, by default calculated based on `size` prop"}
       [:or :string :int :double]]
      [:opened
       {:optional true,
        :doc
        "State of the burger, when `true` burger is transformed into X"}
       :boolean]
      [:size
       {:optional true,
        :doc
        "Controls burger `width` and `height`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc "`transition-duration` property value in ms"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "`transition-timing-function` property value"}
       :string]],
     :defaults
     {:opened false,
      :size :md,
      :transition-duration 300,
      :transition-timing-function "ease"},
     :children :none},
    :copy-button
    {:description
     "Mantine `CopyButton` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 2 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "CopyButton", :children :function},
     :props
     [:map
      [:timeout
       {:optional true, :doc "Copied status timeout in ms"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Value that is copied to the clipboard when the button is clicked"}
       :string]],
     :defaults {:timeout 1000},
     :children :any},
    :alert
    {:description
     "Mantine `Alert` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 5 prop(s), 2 named\n  child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Alert"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-button-label
       {:optional true, :doc "Close button `aria-label`"}
       :string]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-close-button
       {:optional true,
        :doc "Determines whether close button should be displayed"}
       :boolean]],
     :defaults {:with-close-button false},
     :gestures [:close],
     :slots [:icon :title],
     :children :slots},
    :voice
    {:description
     "THE SPOKEN SURFACE — speech to text for a prompt, text to speech for the\n     entries this session is reading. George walks the dog with the phone in one\n     hand and the headphones on, and the headphones are only audio transport\n     (the plan says so): everything that has to be built is here and in the\n     browser.\n\n     TWO CONTROLS, EACH ITS OWN BOOLEAN. :dictate shows the control that\n     listens. :read shows the control that speaks. A node may show one, the\n     other, or both, because they belong in different places — the prompt box\n     wants the microphone and the reading pane wants the reader.\n\n     THE RECOGNIZED TEXT IS NEVER SENT. It lands in the prompt box named by\n     :target, as if the reader had typed it, and the reader sends it. That is\n     the platform's standing rule that user input travels verbatim and a person\n     decides (ADR-ikc-v3-075-01 - the prompt box forwards the text VERBATIM).\n     Speech recognition is wrong often enough that auto-dispatch would be a\n     command nobody wrote. :target is the :import-id of the :prompt-area, not a\n     widget id, so it survives a re-seed like every other authored reference.\n\n     WHAT IS READ ALOUD is the bound value: the entries of the conversation this\n     session has selected, each with its :role, its :text, its :thinking and its\n     :harness? flag. A HARNESS BLOCK IS NEVER SPOKEN. The harness writes machine\n     messages with the role user (the harness fold, 2026-08-20), and reading one\n     aloud in a synthetic voice would be the same defect one layer out - the\n     record would lie in his ear instead of on his screen. THINKING IS NOT\n     SPOKEN unless :read-thinking is true: an answer is what a reader walking a\n     dog asked for. The thinking is longer than the answer.\n\n     :read-count is how many of the NEWEST entries the read control speaks. A\n     conversation is thousands of entries long and a reader who taps 'read'\n     wants what just arrived, so the control reads a tail and says on the\n     surface how many of how many it took. Three by default.\n\n     :language is a BCP-47 tag for both halves - recognition and speech. One\n     slot, because a reader who dictates in one language does not want the\n     answer read in another.\n\n     Gestures: NONE, and that is the point. A :voice dispatches no command. It\n     fills a prompt box and it drives the audio output, both of which are this\n     browser's own business.\n\n     WITHOUT A SECURE CONTEXT IT SAYS SO. The browser speech APIs are absent on\n     plain HTTP, so the controls cannot work until phase 5 puts the deployment\n     behind TLS. The widget then renders its controls DISABLED with the reason\n     and the remedy in words on the surface, and records the refusal on the\n     observability surface. A silent no-op is what\n     PRINCIPLE-ikc-v3-010-01 calls a defect, and a console line is a signal\n     nobody walking a dog can read.\n\n     Web renderer only. The TUI has no microphone and no loudspeaker, so it\n     renders nothing at all - the same documented no-op that :flex sets.",
     :status :in-progress,
     :props
     [:map
      [:dictate {:optional true} :boolean]
      [:read {:optional true} :boolean]
      [:target {:optional true} :string]
      [:language {:optional true} :string]
      [:read-thinking {:optional true} :boolean]
      [:read-count {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:language "en-US", :read-thinking false, :read-count 3},
     :children :none},
    :flex
    {:description
     "Explicit flex container, direction stated — Mantine `Flex`\n     (ADR-graph-ui-v0-013-01 Sec0). For when :stack (always vertical) / :group\n     (always horizontal) aren't enough. Distinct from the :flex UNIVERSAL\n     SLOT (this version's :universal-slots) — that is a CHILD's self-sizing\n     hint; this is a CONTAINER kind. Mantine overloads `flex` the same way (a\n     Mantine Flex component AND a Box style prop); v2.0 keeps that overlap rather\n     than inventing new names.",
     :status :in-progress,
     :props
     [:map
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:row-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:column-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :focus-trap
    {:description
     "Mantine `FocusTrap` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), and 2\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "FocusTrap"},
     :props
     [:map
      [:active
       {:optional true, :doc "If set to `false`, disables focus trap"}
       :boolean]
      [:ref-prop
       {:optional true, :doc "Prop that is used to access element ref"}
       :string]],
     :defaults {:ref-prop "ref"},
     :unmapped {"children" "any", "innerRef" "ForwardedRef<any>"},
     :children :none},
    :icon
    {:description
     "A line icon — ADR-graph-ui-v0-013-01 Sec11: @tabler/icons-react, closed to a\n     named set (not the library's full catalogue). :icon maps 1:1 to one\n     tabler React component in the renderer's own lookup table (widgets.cljs's\n     icon-components). Closed as a real [:enum ...] (not a bare :keyword,\n     which a prior draft of this rule wrongly claimed was already\n     validate-dsl-catchable — it was not, a keyword type check accepts any\n     keyword; fixed 2026-07-27 when Phase 2 needed 5 more names). Web-only;\n     TUI renders nothing (documented no-op, same precedent as\n     :elevation/:button). The 20 from Sec11's original set plus 5 added for\n     PLAN-graph-ui-v0-007-01 Phase 2's locked-target reader (the mockup's own\n     'outline view'/'theme config'/'theme selector'/'pin'/'copy' icons, none\n     of which are on a disabled/not-yet-built affordance, so they earn a real\n     name now rather than waiting).",
     :status :in-progress,
     :props
     [:map
      [:icon
       {:optional true}
       [:enum
        :search
        :chevron-down
        :chevron-right
        :chevron-up
        :chevron-left
        :tag
        :star
        :settings
        :close
        :plus
        :more
        :check
        :calendar
        :folder
        :file
        :link
        :trash
        :edit
        :menu
        :home
        :outline-view
        :theme-config
        :theme-selector
        :pin
        :copy]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :verse-rows
    {:description
     "A book's reading surface: one row per verse, each row carrying the\n     translation, the source text and the verse's notes as three aligned\n     cells. :items is the bound list, each item\n     {:verse-id string :text string :original string\n      :notes [{:head string :kind string}]}.\n\n     :show-source and :show-notes are the reader's, not the author's — the\n     second and third columns can be closed, which is what George asked for\n     when he said a reader may prefer the book without the Chinese. Closing a\n     column widens the ones that remain rather than leaving a gap.\n\n     A verse is ONE paragraph, so prose typography needs no markdown here: the\n     cell is styled text and reads the same. That is what lets the row exist\n     at all — a markdown document cannot be a table cell.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:empty-label {:optional true} :string]
      [:show-source {:optional true} :boolean]
      [:show-notes {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:show-source true, :show-notes true},
     :children :none},
    :color-picker
    {:description
     "Mantine `ColorPicker` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 12 prop(s), 3\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "ColorPicker"},
     :props
     [:map
      [:alpha-label
       {:optional true, :doc "Alpha slider `aria-label`"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:focusable
       {:optional true,
        :doc
        "If set, interactive elements (sliders thumbs and swatches) are focusable with keyboard"}
       :boolean]
      [:format
       {:optional true, :doc "Color format"}
       [:enum :hex :hexa :rgba :rgb :hsl :hsla]]
      [:full-width
       {:optional true,
        :doc "If set, the component takes 100% width of its container"}
       :boolean]
      [:hue-label
       {:optional true, :doc "Hue slider `aria-label`"}
       :string]
      [:saturation-label
       {:optional true, :doc "Saturation slider `aria-label`"}
       :string]
      [:size
       {:optional true,
        :doc "Controls size of hue, alpha and saturation sliders"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:swatches
       {:optional true,
        :doc
        "A list of colors used to display swatches list below the color picker"}
       [:vector :string]]
      [:swatches-per-row
       {:optional true, :doc "Number of swatches per row"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-picker
       {:optional true,
        :doc "Determines whether the color picker should be displayed"}
       :boolean]],
     :defaults
     {:focusable true,
      :format :hex,
      :full-width false,
      :size :md,
      :swatches-per-row 7,
      :with-picker true},
     :gestures [:change :change-end :color-swatch-click],
     :children :none},
    :drawer
    {:description
     "A slide-over — Mantine `Drawer`/`DrawerRoot` (ADR-graph-ui-v0-013-01 Sec15):\n     SPEC-002's '340px slide-over + scrim' is Drawer's own overlay, not\n     hand-rolled. Closing (Escape, scrim click, or the built-in close\n     button — all three are ModalBase's own affordances) fires\n     :on-gesture's :submit key with no $value, the same slot a plain\n     :button fires.",
     :status :in-progress,
     :props
     [:map
      [:opened {:optional true} :boolean]
      [:title {:optional true} :string]
      [:position {:optional true} [:enum :left :right :top :bottom]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:position :right},
     :children :any},
    :icon-button
    {:description
     "An icon button — Mantine `ActionIcon` (ADR-graph-ui-v0-013-01 Sec12). Also\n     covers SPEC-002's 'toggle button' row: a toggle is an icon-button with\n     :on set; mutual exclusion among several is the COMPOSING description's\n     concern (each button's :on-gesture clears its siblings), not a second\n     widget kind. :on is a renderer convention (ActionIcon has no native\n     'pressed' prop): true swaps Mantine's `variant` to :filled, false/absent\n     to :subtle. :tooltip wraps the button in Mantine's `Tooltip`. Fires\n     :on-gesture's :submit key on click, same as :button.",
     :status :in-progress,
     :props
     [:map
      [:icon {:optional true} :keyword]
      [:tooltip {:optional true} :string]
      [:on {:optional true} :boolean]
      [:disabled {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :modal
    {:description
     "Mantine `Modal` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 21 prop(s), 2 named\n  child slot(s), 3 gesture(s), and 2 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :children :any,
     :unmapped
     {"xOffset" "MarginLeft<string | number>",
      "yOffset" "MarginTop<string | number>"},
     :slots [:title],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :with-close-button true,
      :full-screen false,
      :with-overlay true,
      :centered false,
      :shadow :xl,
      :lock-scroll true},
     :mantine {:component "Modal"},
     :status :generated,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:centered
       {:optional true,
        :doc "If set, the modal is centered vertically"}
       :boolean]
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:full-screen
       {:optional true,
        :doc "If set, the modal takes the entire screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:stack-id
       {:optional true, :doc "Id of the modal in the `Modal.Stack`"}
       :string]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is rendered"}
       :boolean]
      [:with-overlay
       {:optional true, :doc "If set, the overlay is rendered"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :accordion
    {:description
     "Mantine `Accordion` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 11 prop(s), 1 named\n  child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"defaultValue" "AccordionValue<Multiple>",
      "multiple" "Multiple",
      "order" "AccordionHeadingOrder",
      "value" "AccordionValue<Multiple>"},
     :slots [:chevron],
     :defaults
     {:chevron-icon-size 16, :loop true, :transition-duration 200},
     :mantine {:component "Accordion"},
     :status :generated,
     :gestures [:change],
     :props
     [:map
      [:chevron-icon-size
       {:optional true,
        :doc
        "Size of the default chevron icon. Ignored when `chevron` prop is set."}
       [:or :string :int :double]]
      [:chevron-position
       {:optional true,
        :doc "Position of the chevron relative to the item label"}
       [:enum :left :right]]
      [:chevron-size
       {:optional true, :doc "Size of the chevron icon container"}
       [:or :string :int :double]]
      [:disable-chevron-rotation
       {:optional true, :doc "If set, chevron rotation is disabled"}
       :boolean]
      [:loop
       {:optional true,
        :doc
        "If set, arrow keys loop though items (first to last and last to first)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]]},
    :theme-icon
    {:description
     "Mantine `ThemeIcon` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 5 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ThemeIcon"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color."}
       [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc "Gradient data used when `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :children :any},
    :title
    {:description
     "Mantine `Title` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), and 2\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Title"},
     :props
     [:map
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which heading will be truncated"}
       [:or :int :double]]
      [:text-wrap
       {:optional true, :doc "Heading `text-wrap` CSS property"}
       [:enum :nowrap :wrap :balance :pretty :stable]]],
     :defaults {:text-wrap :wrap},
     :unmapped {"order" "TitleOrder", "size" "TitleSize"},
     :children :any},
    :skeleton
    {:description
     "Mantine `Skeleton` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 6 prop(s), and 2\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Skeleton"},
     :props
     [:map
      [:animate {:optional true, :doc "Enables animation"} :boolean]
      [:circle
       {:optional true,
        :doc
        "If set, Skeleton `width` and `border-radius` are equal to its `height`"}
       :boolean]
      [:visible
       {:optional true,
        :doc "Determines whether Skeleton overlay should be displayed"}
       :boolean]
      [:width
       {:optional true,
        :doc
        "Skeleton `width`, numbers are converted to rem, ignored when `circle` prop is set."}
       [:or :string :int :double]]],
     :defaults {:animate true, :circle false, :visible true},
     :unmapped
     {"height" "Height<string | number>",
      "radius" "BorderRadius<string | number>"},
     :children :any},
    :nav-link
    {:description
     "Mantine `NavLink` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 9 prop(s), 5 named\n  child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "NavLink"},
     :props
     [:map
      [:active
       {:optional true,
        :doc "Determines whether the link should have active styles"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:children-offset
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set collapsed links `padding-left`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS color to control active styles"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled nested items collapse initial state"}
       :boolean]
      [:disable-right-section-rotation
       {:optional true,
        :doc
        "If set, right section will not be rotated when collapse is opened"}
       :boolean]
      [:disabled
       {:optional true,
        :doc
        "If set, disabled styles will be added to the root element"}
       :boolean]
      [:no-wrap
       {:optional true,
        :doc
        "If set, label and description do not wrap to the next line"}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled nested items collapse state"}
       :boolean]],
     :defaults
     {:active false,
      :children-offset :lg,
      :disable-right-section-rotation false,
      :disabled false,
      :no-wrap false},
     :gestures [:change :click :key-down],
     :slots [:description :label :left-section :right-section],
     :children :any},
    :center
    {:description
     "Mantine `Center` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 1 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Center"},
     :props
     [:map
      [:inline
       {:optional true,
        :doc "If set, `inline-flex` is used instead of `flex`"}
       :boolean]],
     :defaults {},
     :children :any},
    :number-input
    {:description
     "Mantine `NumberInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 37 prop(s), 5 named\n  child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"handlersRef" "ForwardedRef<NumberInputHandlers>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :hide-controls false,
      :allow-decimal true,
      :allow-negative true,
      :type :text,
      :right-section-pointer-events "none",
      :value-is-numeric-string false,
      :decimal-separator ".",
      :size :sm,
      :allow-leading-zeros true,
      :fixed-decimal-scale false,
      :trim-leading-zeroes-on-blur true,
      :with-asterisk false,
      :start-value 0,
      :with-keyboard-events true,
      :step 1,
      :with-error-styles true,
      :required false},
     :mantine {:component "NumberInput"},
     :status :generated,
     :gestures [:change :value-change],
     :props
     [:map
      [:allow-decimal
       {:optional true, :doc "If set, decimal values are allowed"}
       :boolean]
      [:allow-leading-zeros
       {:optional true,
        :doc
        "Determines whether leading zeros are allowed. If set to `false`, leading zeros are removed when the input value becomes a valid number."}
       :boolean]
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:allowed-decimal-separators
       {:optional true,
        :doc
        "Characters which when pressed result in a decimal separator"}
       [:vector :string]]
      [:clamp-behavior
       {:optional true,
        :doc
        "Controls how value is clamped, `strict` – user is not allowed to enter values that are not in `[min, max]` range, `blur` – user is allowed to enter any values, but the value is clamped when the input loses focus (default behavior), `none` – lifts all restrictions, `[min, max]` range is applied only for controls and up/down keys"}
       [:enum :none :strict :blur]]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that can be entered after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true, :doc "Character used as a decimal separator"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :string :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, 0s are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:hide-controls
       {:optional true, :doc "If set, the up/down controls are hidden"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimum possible value"}
       [:or :int :double]]
      [:prefix
       {:optional true, :doc "Prefix added before the input value"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:start-value
       {:optional true,
        :doc
        "Value set to the input when increment/decrement buttons are clicked or up/down arrows pressed if the input is empty"}
       [:or :int :double]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with up/down controls and keyboard arrows"}
       [:or :int :double]]
      [:step-hold-delay
       {:optional true,
        :doc
        "Initial delay in milliseconds before stepping the value."}
       [:or :int :double]]
      [:suffix
       {:optional true, :doc "Suffix added after the input value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style."}
       [:enum :none :thousand :lakh :wan]]
      [:trim-leading-zeroes-on-blur
       {:optional true,
        :doc
        "If set, leading zeros are removed on blur. For example, `00100` -> `100`"}
       :boolean]
      [:type
       {:optional true, :doc "Controls input `type` attribute"}
       [:enum :text :tel :password]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :string :int :double]]
      [:value-is-numeric-string
       {:optional true,
        :doc
        "If value is passed as string representation of numbers (unformatted) and number is used in any format props like in prefix or suffix in numeric format and format prop in pattern format then this should be passed as `true`."}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-keyboard-events
       {:optional true,
        :doc
        "If set, up/down keyboard events increment/decrement value"}
       :boolean]]},
    :background-image
    {:description
     "Mantine `BackgroundImage` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 2 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "BackgroundImage"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src {:optional true, :doc "Image url"} :string]],
     :defaults {:radius 0},
     :children :none},
    :card
    {:description
     "Mantine `Card` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Card"},
     :props
     [:map
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the card"}
       :boolean]],
     :defaults {:padding :md},
     :children :any},
    :divider
    {:description
     "Mantine `Divider` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Divider"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default value depends on color scheme"}
       [:or :keyword :string]]
      [:label-position
       {:optional true, :doc "Controls label position"}
       [:enum :center :left :right]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:size
       {:optional true,
        :doc "Controls width/height (depends on orientation)"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults
     {:label-position :center, :orientation :horizontal, :size :xs},
     :slots [:label],
     :children :slots},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n     (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n     Exactly two children: the RESIZABLE/foldable pane and the FILLING\n     pane. :fold-side picks which side the resizable one is on — :left\n     (default) = child 1 is resizable and folds left; :right = child 2 is\n     resizable and folds right. :pane-id is the localStorage key under\n     which THIS pane's width + folded state are remembered. :initial is the\n     resizable pane's starting px width; :min is its floor; :max an\n     optional hard ceiling. :flex-min is the FILLING pane's floor (px).\n     :collapsible shows the fold button.\n\n     :narrow IS THE PHONE (2026-08-20, PLAN-ikc-v3-015-01 phase 6). It is the\n     UNIVERSAL slot of that name, not a prop of this kind — one word for one\n     idea (Rule 1.11), and a second key would have collided with the first in\n     malli's own schema, which is how :font-size came to be named that. This\n     kind honours two of its five values, and DEFAULTS to one of them. Below\n     --viewport-narrow a two-pane split does not fit: :initial 270 plus\n     :flex-min 280 plus the divider is 556px, and the pane's own\n     `overflow-x: auto` then makes the whole island scroll sideways. This\n     prop says which of the two things it does instead.\n\n       :fold   the resizable pane starts FOLDED and the filling pane takes\n               the width. Its fold control is still there, so the sidebar is one\n               tap away — the sidebar becomes a control, which is what a\n               sidebar is on a phone.\n       :stack  both panes as one vertical column, the resizable one first.\n               For a split whose two halves are both content (a source and\n               its preview), where hiding one loses the point.\n       :keep   the desktop split, sideways scroll included. Deliberate, and\n               sayable, for a surface nobody opens on a phone.\n\n     THE DEFAULT IS :fold, and that is a declaration, not an inference\n     (ADR-graph-ui-v0-011-01's own safety net: 'where the renderer can safely\n     default to filling, it should'). The failure mode of forgetting this\n     prop is a page that scrolls sideways under the reader's thumb, so the\n     safe answer is the one a description gets for free. A folded pane is\n     recoverable by one tap. A sideways-scrolled reading column is not\n     recoverable at all until the reader finds it.\n\n     The fold is NOT remembered across the breakpoint. :pane-id's stored\n     fold state is the reader's choice on a wide window, and a phone visit\n     must not overwrite it — so the narrow fold is computed, never stored.",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true,
      :narrow :fold},
     :children :any},
    :chip
    {:description
     "An interactive, selectable pill — Mantine `Chip` (ADR-graph-ui-v0-013-01\n     Sec14). Where :badge is a label with no behaviour, :chip reports its\n     own selected state — the ikc1 #tag filter needs a clickable tag that\n     toggles, which :badge cannot do. Fires :on-gesture's :submit key on\n     toggle, $value = the new selected state (true/false) — mirroring\n     :select's choose->command convention.",
     :status :in-progress,
     :props
     [:map
      [:label :string]
      [:selected {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :overlay
    {:description
     "Mantine `Overlay` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Overlay"},
     :props
     [:map
      [:background-opacity
       {:optional true,
        :doc
        "Overlay `background-color` opacity 0–1, ignored when `gradient` prop is set"}
       [:or :int :double]]
      [:blur
       {:optional true, :doc "Overlay background blur"}
       [:or :string :int :double]]
      [:center
       {:optional true, :doc "Centers content inside the overlay"}
       :boolean]
      [:color
       {:optional true, :doc "Overlay `background-color`"}
       [:or
        [:enum
         :gray
         :red
         :pink
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :transparent
         :white
         "-moz-initial"
         :inherit
         :initial
         :revert
         :revert-layer
         :unset
         :aliceblue
         :antiquewhite
         :aqua
         :aquamarine
         :azure
         :beige
         :bisque
         :black
         :blanchedalmond
         :blueviolet
         :brown
         :burlywood
         :cadetblue
         :chartreuse
         :chocolate
         :coral
         :cornflowerblue
         :cornsilk
         :crimson
         :darkblue
         :darkcyan
         :darkgoldenrod
         :darkgray
         :darkgreen
         :darkgrey
         :darkkhaki
         :darkmagenta
         :darkolivegreen
         :darkorange
         :darkorchid
         :darkred
         :darksalmon
         :darkseagreen
         :darkslateblue
         :darkslategray
         :darkslategrey
         :darkturquoise
         :darkviolet
         :deeppink
         :deepskyblue
         :dimgray
         :dimgrey
         :dodgerblue
         :firebrick
         :floralwhite
         :forestgreen
         :fuchsia
         :gainsboro
         :ghostwhite
         :gold
         :goldenrod
         :greenyellow
         :grey
         :honeydew
         :hotpink
         :indianred
         :ivory
         :khaki
         :lavender
         :lavenderblush
         :lawngreen
         :lemonchiffon
         :lightblue
         :lightcoral
         :lightcyan
         :lightgoldenrodyellow
         :lightgray
         :lightgreen
         :lightgrey
         :lightpink
         :lightsalmon
         :lightseagreen
         :lightskyblue
         :lightslategray
         :lightslategrey
         :lightsteelblue
         :lightyellow
         :limegreen
         :linen
         :magenta
         :maroon
         :mediumaquamarine
         :mediumblue
         :mediumorchid
         :mediumpurple
         :mediumseagreen
         :mediumslateblue
         :mediumspringgreen
         :mediumturquoise
         :mediumvioletred
         :midnightblue
         :mintcream
         :mistyrose
         :moccasin
         :navajowhite
         :navy
         :oldlace
         :olive
         :olivedrab
         :orangered
         :orchid
         :palegoldenrod
         :palegreen
         :paleturquoise
         :palevioletred
         :papayawhip
         :peachpuff
         :peru
         :plum
         :powderblue
         :purple
         :rebeccapurple
         :rosybrown
         :royalblue
         :saddlebrown
         :salmon
         :sandybrown
         :seagreen
         :seashell
         :sienna
         :silver
         :skyblue
         :slateblue
         :slategray
         :slategrey
         :snow
         :springgreen
         :steelblue
         :tan
         :thistle
         :tomato
         :turquoise
         :wheat
         :whitesmoke
         :yellowgreen
         :AccentColor
         :AccentColorText
         :ActiveText
         :ButtonBorder
         :ButtonFace
         :ButtonText
         :Canvas
         :CanvasText
         :Field
         :FieldText
         :GrayText
         :Highlight
         :HighlightText
         :LinkText
         :Mark
         :MarkText
         :SelectedItem
         :SelectedItemText
         :VisitedText
         :ActiveBorder
         :ActiveCaption
         :AppWorkspace
         :Background
         :ButtonHighlight
         :ButtonShadow
         :CaptionText
         :InactiveBorder
         :InactiveCaption
         :InactiveCaptionText
         :InfoBackground
         :InfoText
         :Menu
         :MenuText
         :Scrollbar
         :ThreeDDarkShadow
         :ThreeDFace
         :ThreeDHighlight
         :ThreeDLightShadow
         :ThreeDShadow
         :Window
         :WindowFrame
         :WindowText
         :currentColor]
        :string]]
      [:fixed
       {:optional true, :doc "Changes position to `fixed`"}
       :boolean]
      [:gradient
       {:optional true,
        :doc
        "Changes overlay to gradient. If set, `color` prop is ignored."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:z-index
       {:optional true, :doc "Overlay z-index"}
       [:or :string :int :double]]],
     :defaults
     {:background-opacity 0.6,
      :blur 0,
      :center false,
      :fixed false,
      :radius 0,
      :z-index 200},
     :children :any},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session —\n     every bus command dispatched (with its round-trip ms) and the\n     client-only UI events that never reach the bus, newest last. Purely a\n     CLIENT-side observability surface: reads a client ring-buffer directly,\n     never a bus :source. Web-only; the TUI renders a labelled placeholder.\n     :slow-ms marks any dispatch at/above it as slow (tone shift).",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none},
    :file-button
    {:description
     "Mantine `FileButton` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 6 prop(s), 1\n  gesture(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "FileButton", :children :function},
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:disabled
       {:optional true, :doc "Disables file picker"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:name {:optional true, :doc "Input name attribute"} :string]],
     :defaults {},
     :gestures [:change],
     :unmapped {"multiple" "Multiple"},
     :children :any},
    :list
    {:description
     "A vertical list; each item renders on its own line. :items is optional:\n     a bound :list gets its items from a source. An item is now a MAP\n     (ADR-graph-ui-v0-013-01 Sec17, legal because v2.0 is a major): {:label\n     string :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean} — covers the SPEC-002\n     'nav row' gap (icon + ellipsised text + trailing accessory, active/dim\n     states). {:label \"Foo\"} alone renders identically to a bare string\n     under v1.x, so the common case stays exactly as terse. :empty-label:\n     shown in place of a silently-blank pane when :items resolves to an\n     empty vector. :value (ADR-graph-ui-v0-013-01 Sec24): the item's click target,\n     substituted as $value into the dispatched command. It was MISSING from\n     this closed map while every source already returned it — invisible only\n     because BOUND items skip props validation, so a literal-authored item\n     carrying :value was rejected while the identical item from a source was\n     accepted. Declared now so model and code agree by agreeing, not because\n     one of them is never checked.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :scroll-area
    {:description
     "A scrolling viewport — Mantine `ScrollArea` (ADR-graph-ui-v0-013-01 Sec22).\n     This closes an AC-1 gap, not a styling one: WHAT SCROLLS was hardcoded\n     per widget in the renderer (:outline, :tree and :list each carried their\n     own overflow-y-auto), so no description could say 'this pane scrolls as\n     one document' — a capability reachable only through bespoke renderer\n     code, which is what AC-1 forbids.\n\n     It is also a known, still-open defect rather than a new observation:\n     graph_ui/web/render.cljs records (2026-07-14) that adding min-h-0 to the\n     SHARED root, to give descendants a bounded scroll box, collapsed the\n     content pane entirely against the real vault, was reverted, and left the\n     app unable to scroll long pages — with the fix explicitly deferred to\n     'the content pane's own flex chain'. Naming the scrolling box in the\n     description IS that fix: the renderer stops having to guess on a root it\n     shares with every island.\n\n     :type and :scrollbars are Mantine's own enums verbatim.\n     :scrollbarSize/:offsetScrollbars are not adopted — no consumer needs\n     them. A :scroll-area needs a bounded height to scroll WITHIN, so it\n     normally carries :flex 1 inside a :stack that has one.",
     :status :in-progress,
     :props
     [:map
      [:type
       {:optional true}
       [:enum :auto :always :scroll :hover :never]]
      [:scrollbars {:optional true} [:enum :x :y :xy :none]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:type :hover, :scrollbars :y},
     :children :any},
    :semi-circle-progress
    {:description
     "Mantine `SemiCircleProgress` — GENERATED from @mantine/core's own\n  TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n  this kind says exactly what the library promises and no more. 9 prop(s), 1\n  named child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic\n  drives the component named above straight from this declaration — the\n  props here are the legal ones, the gestures here are the wired ones, and\n  nothing else reaches the DOM. Generic is not finished: this kind has no\n  data binding, no edit buffer and no selection state of its own. A kind\n  that needs one of those graduates to a hand-written widget and an explicit\n  case in render.cljs — move it above the GENERATED marker and give it a\n  description that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine\n  declares no `children` for this component, so a child is admitted solely\n  to fill one of the named slots above, saying which with :section. A child\n  that names no slot is not body content here — there is no body to put it\n  in.",
     :status :generated,
     :mantine {:component "SemiCircleProgress"},
     :props
     [:map
      [:empty-segment-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default the value is determined based on the color scheme value"}
       [:or :keyword :string]]
      [:fill-direction
       {:optional true,
        :doc "Direction from which the circle is filled"}
       [:enum :right-to-left :left-to-right]]
      [:filled-segment-color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Label position relative to the circle center"}
       [:enum :center :bottom]]
      [:orientation
       {:optional true, :doc "Orientation of the circle"}
       [:enum :up :down]]
      [:size
       {:optional true, :doc "Diameter of the svg in px"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Circle thickness in px"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Progress value from `0` to `100`"}
       [:or :int :double]]],
     :defaults
     {:fill-direction :left-to-right,
      :label-position :bottom,
      :orientation :up,
      :size 200,
      :thickness 12,
      :transition-duration 0},
     :slots [:label],
     :children :slots},
    :pagination
    {:description
     "Mantine `Pagination` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 20 prop(s), 5\n  gesture(s), and 5 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "Pagination"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:boundaries
       {:optional true,
        :doc "Number of elements visible on the left/right edges"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc "Key of `theme.colors`, active item color"}
       [:or :keyword :string]]
      [:default-value
       {:optional true,
        :doc
        "Active page for uncontrolled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Disables all controls, applies disabled styles"}
       :boolean]
      [:gap
       {:optional true,
        :doc "Key of `theme.spacing`, gap between controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:hide-with-one-page
       {:optional true,
        :doc
        "If set, the pagination is hidden when only one page is available (`total={1}`)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:siblings
       {:optional true,
        :doc
        "Number of siblings displayed on the left/right side of the selected page"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "`height` and `min-width` of controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:total
       {:optional true,
        :doc "Total number of pages, must be an integer"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Active page for controlled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:with-controls
       {:optional true,
        :doc "If set, next/previous controls are displayed"}
       :boolean]
      [:with-edges
       {:optional true,
        :doc "If set, first/last controls are displayed"}
       :boolean]
      [:with-pages
       {:optional true,
        :doc "If set to `false`, pages controls are hidden"}
       :boolean]],
     :defaults
     {:boundaries 1,
      :gap 8,
      :hide-with-one-page false,
      :siblings 1,
      :size :md,
      :with-controls true,
      :with-edges false,
      :with-pages true},
     :gestures
     [:change :first-page :last-page :next-page :previous-page],
     :unmapped
     {"dotsIcon" "PaginationIcon",
      "firstIcon" "PaginationIcon",
      "lastIcon" "PaginationIcon",
      "nextIcon" "PaginationIcon",
      "previousIcon" "PaginationIcon"},
     :children :none},
    :color-input
    {:description
     "A swatch-picker input — Mantine `ColorInput` (ADR-graph-ui-v0-013-01\n     Sec16), the theme editor's field. :value is a CSS colour string (hex,\n     as the theme tokens already are — ADR-graph-ui-v0-009-01). Fires\n     :on-gesture's :submit key on change, $value = the picked colour — the\n     same input->command shape :input/:select already use.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :avatar
    {:description
     "Mantine `Avatar` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 9 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Avatar"},
     :props
     [:map
      [:allowed-initials-colors
       {:optional true,
        :doc
        "A list of colors that is used for autogenerated initials. By default, all default Mantine colors can be used except gray and dark."}
       [:vector :any]]
      [:alt
       {:optional true,
        :doc
        "Image `alt` attribute, also used as `title` attribute for placeholder"}
       :string]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or
        [:enum
         :dark
         :gray
         :red
         :pink
         :grape
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :initials]
        :string]]
      [:gradient
       {:optional true,
        :doc "Gradient configuration for `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:name
       {:optional true,
        :doc
        "Name of the user. When `src` is not set, used to display initials and to generate color when `color=\"initials\"` is set."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Width and height of the avatar, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src
       {:optional true,
        :doc
        "Image url, if the image cannot be loaded or `src={null}`, then placeholder is displayed instead"}
       :string]],
     :defaults {:color :gray, :radius "1000px", :size :md},
     :children :any},
    :text-input
    {:description
     "Mantine `TextInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 13 prop(s), 5 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "TextInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :highlight-list
    {:description
     "The document's highlights, listed beside it — ikc1's right gutter\n     (F-platform-v0-011-01, ADR-graph-ui-v0-017-01 §5). One row per highlight: a\n     dot in the highlight's own colour, the level badge when a level is set, the\n     marked text on ONE line (truncated, because a chunk-sized highlight is\n     paragraphs long and the gutter is a column), the note when there is one, and\n     an X that removes it, and — when the description wires a :link gesture — a\n     control that copies a wikilink to that mark, for pasting into a note.\n\n     THREE ACTS, AND NONE IS ANOTHER (2026-08-24). A row's click GOES to the\n     words. The link control COPIES a link. The X REMOVES it. George asked for\n     that split by name: \"without this click on bookmark to delete it, have some\n     more narrow way to delete it\".\n\n     NOT NAMED :highlight, which is taken — the generated Mantine `Highlight`\n     kind below marks substrings matching a search term and is unrelated. Two\n     things called highlight in one closed vocabulary would be a trap for every\n     later reader.\n\n     :items is the bound prop and its shape is :highlights/for-page's result\n     VERBATIM, whichever storage served it: a native page's highlights arrive as\n     block-relative and a vault page's as file-relative, and this widget cannot\n     tell, which is the point (ADR-ikc-v3-064-01 §3).\n\n     ORPHANED ROWS STAY LISTED, dimmed. A highlight whose text has been edited\n     away is a fact worth seeing — 'you marked this and it is gone' — and hiding\n     it would be the one behaviour that loses information silently\n     (CONCEPT-ikc-v3-008-01).\n\n     ONE GESTURE, :remove, $value = the row's :id. Creating a highlight is not a\n     gutter affordance: you make one by selecting text in the document, so there\n     is deliberately no empty-state gesture here and no :empty-reachable entry\n     below — a gutter with nothing in it is a document with nothing marked, and\n     the way out is in the document, not the gutter.\n\n     :title IS OPTIONAL AND MEANS A HEADER. Without one the column draws no\n     caption — which is what the reading area asks for, because the gutter sits\n     directly beside the text with each row level with the words it marks, and a\n     caption over that labels the self-evident. It captioned itself\n     unconditionally while it was a panel out at the pane's right edge; George\n     struck that panel through on 2026-08-16, saying the highlight in it\n     'belongs to the right gutter'. THE RIGHT GUTTER IS THIS, AND THERE IS ONLY\n     ONE — the per-row `2 hl` chip column that briefly sat between the text and\n     this one is gone (see the :outline kind).",
     :status :in-progress,
     :props
     [:map
      [:level-with-text {:optional true} :boolean]
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:block-id {:optional true} :string]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:title {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:chrome {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:chrome true},
     :children :none},
    :container
    {:description
     "A centred, max-width content column — Mantine `Container`\n     (ADR-graph-ui-v0-013-01 Sec20). SPEC-alatus-v0-002-01's locked target\n     centres its reading pane in a `max-width: 900px` column; nothing else in\n     v2.0 can say that, so a reading UI otherwise runs its prose edge-to-edge\n     on a wide monitor — a legibility defect, not a cosmetic one, in the\n     island whose whole purpose is reading.\n\n     :size is Mantine's own max-width scale: :xs 540 / :sm 720 / :md 960 /\n     :lg 1140 / :xl 1320 pixels, read from the shipped styles.css rather than\n     recalled. (Corrected 2026-07-28: this rule first said :md 768 / :lg 992,\n     which are Mantine's BREAKPOINT values, not its container sizes. The error\n     put the reading column at 1140px — wider than the target instead of nearer\n     it.) :fluid takes the parent's full width and ignores :size.\n\n     OPEN SINCE ADR-graph-ui-v0-001-01. :size also accepts a NUMBER (pixels) or any\n     CSS length string, which is Mantine's own documented contract — the size\n     prop accepts any valid CSS value or a number. It was closed to five tokens\n     by 057-01 Sec0, and that clamp is what this declaration used to confess to:\n     'the enum cannot express 900 exactly, which is the standing trade'.\n\n     The trade was worse than lossy. CONCEPT-graph-ui-v0-009-01 defines measure\n     as Bringhurst does — the length of a line counted in CHARACTERS — and a\n     measure in pixels is not a measure: change the type size and the line\n     length moves while :md does not. So a reading column says {:size \"66ch\"}\n     and means it, instead of naming the nearest breakpoint token and hoping.\n     The tokens remain valid and remain the ordinary case for non-prose widths.\n\n     The renderer lays a :container out as a flex COLUMN, so that a child\n     carrying :flex 1 fills it. Mantine's Container is a plain block element,\n     and a :flex 1 child inside a block parent silently falls back to its own\n     content height (measured: a 180px reading pane inside a 986px column). Mantine's :strategy ('block' | 'grid') is deliberately NOT\n     adopted: no consumer needs grid-centring, and an unused prop is a\n     promise the renderer has to keep.",
     :status :in-progress,
     :props
     [:map
      [:size
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:fluid {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:size :lg},
     :children :any},
    :indicator
    {:description
     "Mantine `Indicator` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 11 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Indicator"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:disabled
       {:optional true, :doc "If set, the indicator is hidden"}
       :boolean]
      [:inline
       {:optional true,
        :doc
        "Determines whether the indicator container should be an inline element"}
       :boolean]
      [:offset
       {:optional true,
        :doc
        "Indicator offset relative to the target element, usually used for elements with border-radius"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Indicator position relative to the target element"}
       [:enum
        :top-end
        :top-start
        :bottom-end
        :bottom-start
        :top-center
        :bottom-center
        :middle-center
        :middle-end
        :middle-start]]
      [:processing
       {:optional true,
        :doc "If set, the indicator has processing animation"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Indicator width and height"}
       [:or :string :int :double]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:z-index
       {:optional true, :doc "Indicator z-index"}
       [:or :string :int :double]]],
     :defaults
     {:inline false,
      :position :top-end,
      :processing false,
      :radius 100,
      :size 10,
      :z-index 200},
     :slots [:label],
     :children :slots},
    :stack
    {:description
     "Vertical stack — Mantine `Stack`, the common default arrangement\n     (ADR-graph-ui-v0-013-01 Sec0). :gap/:align/:justify keep Mantine's names;\n     values closed (Sec0).",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :outline
    {:description
     "ADR-graph-ui-v0-006-01: a flat, :order-sorted list of typed blocks, nested\n     VISUALLY by each item's :depth (never a real tree — the native\n     block-frame engine keeps every block a flat :child-of child of its\n     page). :items is optional: a bound :outline gets its list from a\n     source (:block-outline). Each item is {:block-id uuid-str :block-type\n     kw :content string :order number :depth int :checked? bool :collapsed?\n     bool}.\n\n     THERE IS NO :meta PROP. ADR-graph-ui-v0-013-01 Sec17 accepted one — a\n     trailing chip/badge gutter, third track in every row, captured from ikc1\n     by SPEC-alatus-v0-002-01 (`30px / 1fr / 132px`). Removed 2026-08-15,\n     George: \"What is this invented meta-gutter? The right gutter is the place\n     for meta information, no extra gutters.\" ikc3 has one margin beside the\n     document (F-platform-v0-011-01) that ikc1 did not, and meta about a block\n     belongs there; two gutters is two places to look for one kind of thing.\n     Nothing ever emitted :meta in production, so nothing is lost — the\n     reversal is recorded in that same ADR's Sec17. A deeper\n     item whose ancestor has :collapsed? true is hidden by the renderer, not\n     the source. Dispatches :on-gesture's named keys (ADR-graph-ui-v0-013 Sec7-8,\n     replacing v1.x's :actions): :indent/:outdent/:toggle-done/\n     :toggle-collapse/:delete/:insert-after/:update-text/:insert-first.\n     $value's meaning is still per gesture key (row actions: the acted-on\n     item's :block-id; :update-text: the edited text) but documented once, on\n     :on-gesture itself, not re-derived here.\n\n     :insert-first is the EMPTY state's gesture, and the only one that fires\n     when there are no items. Every other gesture acts on a row, so a page with\n     no blocks could not be given one: :insert-after needs a block to insert\n     after, and the empty state rendered as inert text. A note editor that\n     cannot accept its first character is not an editor, and the gap was\n     invisible until a wiped graph produced an empty page (2026-08-03). It\n     carries no $value — the target page is the session's selected one, which\n     the handler resolves, because the empty state has no row to name it.\n\n     :row-menu declares WHICH of the gestures above a row offers, in what order,\n     and how each is labelled. One list, rendered twice: as the hover strip on a\n     row and as the right-click context menu over it. Before this the strip was\n     four buttons hand-written in widgets.cljs, so adding an action cost three\n     edits in three languages — a command in this manifest, a gesture in the\n     description, and a button in ClojureScript. The gestures were declared; only\n     their PRESENTATION was not (2026-08-03).\n\n     Each entry is {:gesture <a key of this node's :on-gesture> :label <string>\n     :icon <string, optional> :tone <token, optional> :divider-before <bool,\n     optional>} — deliberately the same :label/:gesture/:tone shape v2.0's :menu\n     items use, so the two read alike. :row-menu is not a :menu widget, though:\n     a menu over a ROW must act on THAT row, and :menu's items have no notion of\n     which row they are over. The outline's gestures already carry the row id\n     through $value, so the same list renders as both the hover strip and the\n     right-click menu without any selected-block state to feed it. validate-dsl fails an entry naming a gesture the node does not\n     wire — a menu item that dispatches nothing looks identical to one that\n     works until it is clicked.\n\n     Omitting :row-menu means NO row affordances, which is a real choice for a\n     read-only outline rather than a reason to fall back to a built-in default:\n     a hidden default is how the hardcoded strip survived unnoticed.\n\n     :slash-menu declares the commands a row offers when its text begins with\n     '/' — the outliner idiom where typing turns a block into a to-do, a\n     separator, or a date without leaving the keyboard. Same shape as :row-menu\n     with one addition: :trigger is what you type after the slash, and what the\n     list filters on as you keep typing.\n\n     Each entry is {:trigger <string> :gesture <a key of :on-gesture>\n     :label <string> :icon <string, optional>}. validate-dsl fails an entry\n     naming a gesture the node does not wire, and fails two entries sharing a\n     :trigger — an ambiguous trigger picks one silently, and which one depends\n     on map ordering nobody declared.\n\n     The gesture's own template carries whatever the command needs (/todo and\n     /--- are both :ui/set-block-type with different literal :block-type args),\n     so a new slash command is usually a gesture plus a line here, and no\n     renderer change at all.\n\n     TUI renders read-only (gutters/numbering only, no dispatch).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:highlights {:optional true} [:vector [:map-of :keyword :any]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]]]]
      [:slash-menu
       {:optional true}
       [:vector
        [:map
         [:trigger :string]
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]]]]],
     :defaults {},
     :children :none},
    :typography
    {:description
     "Mantine `Typography` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 0 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Typography"},
     :props [:map],
     :defaults {},
     :children :any},
    :angle-slider
    {:description
     "Mantine `AngleSlider` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 10 prop(s), 4\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "AngleSlider"},
     :props
     [:map
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `data-disabled` attribute, disables interactions"}
       :boolean]
      [:marks
       {:optional true, :doc "Array of marks displayed on the slider"}
       [:vector :any]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:restrict-to-marks
       {:optional true,
        :doc
        "If set, the selection is allowed only from the given marks array"}
       :boolean]
      [:size
       {:optional true, :doc "Slider size in px"}
       [:or :int :double]]
      [:step
       {:optional true, :doc "Step between values"}
       [:or :int :double]]
      [:thumb-size
       {:optional true,
        :doc
        "Size of the thumb in px. Calculated based on the `size` value by default."}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]
      [:with-label
       {:optional true,
        :doc "If set, the label is displayed inside the slider"}
       :boolean]],
     :defaults {:restrict-to-marks false, :step 1, :with-label true},
     :gestures [:change :change-end :scrub-end :scrub-start],
     :children :none},
    :dialog
    {:description
     "Mantine `Dialog` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 10 prop(s), 1 named\n  child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Dialog"},
     :props
     [:map
      [:keep-mounted
       {:optional true,
        :doc
        "If set, dialog is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:opened {:optional true, :doc "Opened state"} :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls `width` of the dialog"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is displayed"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]],
     :defaults
     {:size :md,
      :with-close-button true,
      :within-portal true,
      :z-index 200},
     :gestures [:close],
     :unmapped {"position" "AffixPosition"},
     :children :any},
    :pills-input
    {:description
     "Mantine `PillsInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 13 prop(s), 5 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "PillsInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :combobox
    {:description
     "Mantine `Combobox` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 26 prop(s), 1 named\n  child slot(s), 7 gesture(s), and 6 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Combobox"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "Determines whether the `Combobox` value can be changed"}
       :boolean]
      [:reset-selection-on-option-hover
       {:optional true,
        :doc
        "Determines whether selection should be reset when option is hovered"}
       :boolean]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true,
        :doc "Controls items `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:reset-selection-on-option-hover false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :floating-strategy :absolute,
      :arrow-offset 5,
      :size :sm,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :option-submit
      :position-change],
     :unmapped
     {"dropdownPadding" "Padding<string | number>",
      "middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "store" "ComboboxStore",
      "width" "PopoverWidth"},
     :children :any},
    :image
    {:description
     "Mantine `Image` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 4 prop(s), 1\n  gesture(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "Image"},
     :props
     [:map
      [:fallback-src
       {:optional true,
        :doc
        "Image url used as a fallback if the image cannot be loaded"}
       :string]
      [:fit
       {:optional true, :doc "Controls `object-fit` style"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :fill
        :none
        :contain
        :cover
        :scale-down]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:fit :cover, :radius 0},
     :gestures [:error],
     :unmapped {"src" "any"},
     :children :none},
    :autocomplete
    {:description
     "Mantine `Autocomplete` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 27 prop(s), 5 named\n  child slot(s), 5 gesture(s), and 3 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"data" "ComboboxStringData",
      "filter" "OptionsFilter",
      "renderOption" "RenderAutocompleteOption"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :auto-select-on-blur false,
      :open-on-focus true,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "Autocomplete"},
     :status :generated,
     :gestures
     [:change :clear :dropdown-close :dropdown-open :option-submit],
     :props
     [:map
      [:auto-select-on-blur
       {:optional true,
        :doc
        "If set, the highlighted option is selected when the input loses focus"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed when the component has a value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-value
       {:optional true,
        :doc "Default value for uncontrolled component"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :hover-card
    {:description
     "Mantine `HoverCard` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 32 prop(s), 1 named\n  child slot(s), 6 gesture(s), and 4 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "HoverCard"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:initially-opened
       {:optional true, :doc "Initial opened state"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:variant {:optional true} :string]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :children :any},
    :anchor
    {:description
     "Mantine `Anchor` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Anchor"},
     :props
     [:map
      [:color {:optional true} [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]
      [:underline
       {:optional true,
        :doc
        "Defines when `text-decoration: underline` styles are applied."}
       [:enum :always :hover :not-hover :never]]],
     :defaults {:inherit false, :inline false, :size :md},
     :children :any},
    :stepper
    {:description
     "Mantine `Stepper` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 14 prop(s), 1 named\n  child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "Stepper"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active step"}
       [:or :int :double]]
      [:allow-next-steps-select
       {:optional true, :doc "If set, next steps can be selected"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls colors of active and progress steps"}
       [:or :keyword :string]]
      [:completed-icon
       {:optional true,
        :doc
        "Step icon displayed when step is completed, check icon by default"}
       :boolean]
      [:content-padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `padding-top` of the content"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:icon
       {:optional true,
        :doc "Step icon, default value is `step index + 1`"}
       :boolean]
      [:icon-position
       {:optional true, :doc "Icon position relative to the step body"}
       [:enum :left :right]]
      [:icon-size
       {:optional true,
        :doc
        "Controls size of the step icon, by default icon size is inferred from `size` prop"}
       [:or :string :int :double]]
      [:orientation
       {:optional true, :doc "Stepper orientation"}
       [:enum :horizontal :vertical]]
      [:progress-icon
       {:optional true,
        :doc
        "Step icon displayed when step is in progress, default value is `step index + 1`"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set steps border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls size of various Stepper elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:wrap
       {:optional true,
        :doc
        "Determines whether steps should wrap to the next line if no space is available"}
       :boolean]],
     :defaults
     {:allow-next-steps-select true,
      :icon-position :left,
      :orientation :horizontal,
      :radius :xl,
      :wrap true},
     :gestures [:step-click],
     :children :any},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer and,\n     on Enter, dispatches :on-gesture's :submit key (ADR-graph-ui-v0-013-01\n     Sec7-8, replacing v1.x's :on-submit). :leading-icon (ADR-graph-ui-v0-013 Sec17): an\n     optional :icon name shown at the input's leading edge — Mantine's\n     `leftSection`, the search field's magnifying glass. :state: a\n     validation/enablement hint — :invalid highlights the field, :disabled\n     greys it out and blocks edits. :variant (ADR-graph-ui-v0-013-01 Sec21):\n     Mantine's own InputVariant enum verbatim ('default' | 'filled' |\n     'unstyled'). :unstyled drops the field chrome, so an editable page title\n     paired with the universal :size :h1 reads as a HEADING rather than as a\n     form control — the locked target's 27px editable h1, expressed entirely\n     in Mantine's vocabulary rather than an ikc3 invention.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:leading-icon {:optional true} :keyword]
      [:variant {:optional true} [:enum :default :filled :unstyled]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :timeline
    {:description
     "Mantine `Timeline` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s), 1 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Timeline"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active element"}
       [:or :int :double]]
      [:align
       {:optional true,
        :doc "Position of content relative to the bullet"}
       [:enum :left :right]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:bullet-size
       {:optional true, :doc "Size of the bullet"}
       [:or :string :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to control active item colors"}
       [:or :keyword :string]]
      [:line-width
       {:optional true, :doc "Control width of the line"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:reverse-active
       {:optional true,
        :doc
        "If set, the active items direction is reversed without reversing items order"}
       :boolean]],
     :defaults
     {:align :left,
      :bullet-size 20,
      :radius :xl,
      :reverse-active false},
     :children :any},
    :password-input
    {:description
     "Mantine `PasswordInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 15 prop(s), 5 named\n  child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"visibilityToggleIcon" "FC<{ reveal: boolean; }>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "PasswordInput"},
     :status :generated,
     :gestures [:visibility-change],
     :props
     [:map
      [:default-visible
       {:optional true,
        :doc "If set, the input value is visible by default"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:visible
       {:optional true,
        :doc "If set, the input value is visible visible"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :progress
    {:description
     "Mantine `Progress` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 9 prop(s). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Progress"},
     :props
     [:map
      [:animated
       {:optional true,
        :doc
        "If set, the sections stripes are animated, `striped` prop is ignored"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS value"}
       [:or :keyword :string]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls track height"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:striped
       {:optional true, :doc "If set, the section has stripes"}
       :boolean]
      [:transition-duration
       {:optional true,
        :doc
        "Controls sections width transition duration, value is specified in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Value of the progress"}
       [:or :int :double]]],
     :defaults
     {:animated false,
      :orientation :horizontal,
      :size :md,
      :striped false,
      :transition-duration 100},
     :children :none},
    :badge
    {:description
     "A static label pill — Mantine `Badge` (ADR-graph-ui-v0-013-01 Sec13). Also\n     covers the 'status LED' row: :label absent + :circle true + a small\n     implicit size IS a state-coloured dot, deliberately not a seventh\n     kind. Non-interactive — no :on-gesture.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:circle {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :table-of-contents
    {:description
     "Mantine `TableOfContents` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 8 prop(s), and 1\n  prop(s) whose type carries no data contract (see :unmapped). RENDERED\n  GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n  straight from this declaration — the props here are the legal ones, the\n  gestures here are the wired ones, and nothing else reaches the DOM.\n  Generic is not finished: this kind has no data binding, no edit buffer and\n  no selection state of its own. A kind that needs one of those graduates to\n  a hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "TableOfContents"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:depth-offset
       {:optional true,
        :doc
        "Controls padding on the left side of control, multiplied by (`depth` - `minDepthToOffset`), `20px` by default"}
       [:or :string :int :double]]
      [:initial-data
       {:optional true,
        :doc
        "Data used to render content until actual values are retrieved from the DOM"}
       [:vector :any]]
      [:min-depth-to-offset
       {:optional true,
        :doc
        "Minimum `depth` value that requires offset, `1` by default"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls font-size and padding of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :unmapped {"scrollSpyOptions" "UseScrollSpyOptions"},
     :children :none},
    :breadcrumbs
    {:description
     "Mantine `Breadcrumbs` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 1 prop(s), 2 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n  child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Breadcrumbs"},
     :props
     [:map
      [:separator-margin
       {:optional true,
        :doc "Controls spacing between separator and breadcrumb"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:separator-margin :xs},
     :slots [:separator],
     :children :any},
    :pin-input
    {:description
     "Mantine `PinInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 22 prop(s), 2\n  gesture(s), and 1 prop(s) whose type carries no data contract (see\n  :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "PinInput"},
     :props
     [:map
      [:aria-label
       {:optional true, :doc "`aria-label` attribute"}
       :string]
      [:auto-focus
       {:optional true,
        :doc
        "If set, the first input is focused when component is mounted"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true, :doc "Adds disabled attribute to all inputs"}
       :boolean]
      [:error
       {:optional true,
        :doc
        "Sets `aria-invalid` attribute and applies error styles to all inputs"}
       :boolean]
      [:form
       {:optional true, :doc "Hidden input `form` attribute"}
       :string]
      [:gap
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `gap` between inputs, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:id
       {:optional true,
        :doc "Base id used to generate unique ids for inputs"}
       :string]
      [:input-mode
       {:optional true,
        :doc
        "`inputmode` attribute, inferred from the `type` prop if not specified"}
       [:enum :search :text :none :tel :email :url :numeric :decimal]]
      [:input-type
       {:optional true,
        :doc
        "Inputs `type` attribute, inferred from the `type` prop if not specified"}
       [:or
        [:enum
         :number
         :button
         :search
         :time
         :image
         :text
         :hidden
         :color
         :radio
         :checkbox
         :tel
         :password
         :date
         :datetime-local
         :email
         :file
         :month
         :range
         :reset
         :submit
         :url
         :week]
        :string]]
      [:length
       {:optional true, :doc "Number of inputs"}
       [:or :int :double]]
      [:manage-focus
       {:optional true,
        :doc
        "Determines whether focus should be moved automatically to the next input once filled"}
       :boolean]
      [:mask
       {:optional true, :doc "Changes input type to `\"password\"`"}
       :boolean]
      [:name
       {:optional true, :doc "Hidden input `name` attribute"}
       :string]
      [:one-time-code
       {:optional true,
        :doc
        "Determines whether `autocomplete=\"one-time-code\"` attribute should be set on all inputs"}
       :boolean]
      [:placeholder
       {:optional true, :doc "Inputs placeholder"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true, :doc "If set, the user cannot edit the value"}
       :boolean]
      [:size
       {:optional true, :doc "Controls inputs `width` and `height`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Determines which values can be entered"}
       [:or [:enum :number :alphanumeric] :string]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]],
     :defaults
     {:mask false,
      :one-time-code true,
      :placeholder "○",
      :type :alphanumeric,
      :size :sm,
      :manage-focus true,
      :gap :md,
      :length 4,
      :auto-focus false},
     :gestures [:change :complete],
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :none},
    :code-view
    {:description
     "A whole source FILE, shown the way an editor shows one: syntax colour, line\n     numbers, code folding, and the corpus ids and handler symbols inside the\n     text rendered as links that navigate to the frames they name. Read-only.\n     :value is the file body and :language the grammar to colour it with, both\n     normally bound to a source rather than written in the description. The TUI\n     renders it as plain monospaced text, as it does every code widget here.\n\n     Distinct from :code-block, which is a snippet inside a document and needs\n     only colour.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:line-numbers {:optional true} :boolean]
      [:folding {:optional true} :boolean]
      [:links
       {:optional true}
       [:vector [:map [:text :string] [:frame-id :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:line-numbers true, :folding true},
     :children :none},
    :json-input
    {:description
     "Mantine `JsonInput` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 20 prop(s), 6 named\n  child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "JsonInput"},
     :props
     [:map
      [:autosize
       {:optional true,
        :doc
        "If set, enables textarea height growing with its content"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:format-on-blur
       {:optional true,
        :doc
        "Determines whether the value should be formatted on blur"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max-rows
       {:optional true,
        :doc
        "Maximum rows for autosize textarea to grow, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:min-rows
       {:optional true,
        :doc
        "Minimum rows of autosize textarea, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:resize
       {:optional true, :doc "Controls `resize` CSS property"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :inline
        :none
        :block
        :horizontal
        :vertical
        :both]]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:autosize false,
      :left-section-pointer-events "none",
      :format-on-blur false,
      :right-section-pointer-events "none",
      :resize :none,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :gestures [:change],
     :slots
     [:description
      :error
      :label
      :left-section
      :right-section
      :validation-error],
     :children :slots},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is\n     a vector of {:label <string> :gesture <keyword> :tone <token,\n     optional> :disabled <bool, optional>} maps (ADR-graph-ui-v0-013-01 Sec9,\n     replacing v1.x's per-item :command/:with): :gesture names a key in\n     this SAME node's :on-gesture map, where the actual command template\n     lives, authored once alongside every other gesture the node carries.\n     Clicking an item dispatches its named :on-gesture entry — $session-id\n     substituted, plus whatever :with that entry's template carries.\n     Distinct from :list (plain display) and :button (one action): :menu is\n     a grouped set of commands. Web-only interactive; the TUI renders the\n     item labels as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:gesture {:optional true} :keyword]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:disabled {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :tooltip
    {:description
     "Mantine `Tooltip` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 26 prop(s), 2 named\n  child slot(s), 1 gesture(s), and 5 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :children :any,
     :unmapped
     {"events" "{ hover: boolean; focus: boolean; touch: boolean; }",
      "middlewares" "TooltipMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "target" "string | HTMLElement | RefObject<HTMLElement>"},
     :slots [:label],
     :defaults
     {:arrow-offset 5,
      :arrow-radius 0,
      :arrow-size 4,
      :close-delay 0,
      :floating-strategy :absolute,
      :with-arrow false},
     :mantine {:component "Tooltip"},
     :status :generated,
     :gestures [:position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position relative to the tooltip"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls tooltip background, by default set based on current color scheme"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled tooltip initial opened state"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, tooltip element will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:inline
       {:optional true,
        :doc "Must be set if the tooltip target is an inline element"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the tooltip is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:multiline
       {:optional true,
        :doc
        "Determines whether content should be wrapped on to the next line, `false` by default"}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:opened
       {:optional true, :doc "Controlled opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc
        "Tooltip position relative to target element (`Tooltip` component) or mouse (`Tooltip.Floating` component)"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:ref-prop
       {:optional true,
        :doc
        "Key of the prop that can be used to access element ref, `ref` by default"}
       :string]
      [:with-arrow
       {:optional true, :doc "If set, the tooltip has an arrow"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether tooltip should be rendered within `Portal`, `true` by default"}
       :boolean]
      [:z-index
       {:optional true, :doc "Tooltip z-index, `300` by default"}
       [:or :string :int :double]]]},
    :blockquote
    {:description
     "Mantine `Blockquote` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 3 prop(s), 2 named\n  child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n  the component named above straight from this declaration — the props here\n  are the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n  `children` for this component, so a child is admitted solely to fill one\n  of the named slots above, saying which with :section. A child that names\n  no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Blockquote"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:icon-size
       {:optional true,
        :doc
        "Controls icon `width` and `height`, numbers are converted to rem"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:icon-size 40},
     :slots [:cite :icon],
     :children :slots},
    :modal-base
    {:description
     "Mantine `ModalBase` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 14 prop(s), 1 named\n  child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF. TAKES\n  CHILDREN: Mantine declares `children`, so a child that names no slot is\n  ordinary body content.",
     :status :generated,
     :mantine {:component "ModalBase"},
     :props
     [:map
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:unstyled {:optional true} :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :shadow :xl,
      :lock-scroll true},
     :gestures [:close :enter-transition-end :exit-transition-end],
     :children :any},
    :switch
    {:description
     "Mantine `Switch` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 7 prop(s), 5 named\n  child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label :off-label :thumb-icon],
     :defaults
     {:label-position :right, :radius :xl, :with-thumb-indicator true},
     :mantine {:component "Switch"},
     :status :generated,
     :gestures [:label],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:id
       {:optional true,
        :doc
        "Id used to bind input and label, if not passed, unique id will be generated instead"}
       :string]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-thumb-indicator
       {:optional true,
        :doc "If set, the indicator will be displayed inside thumb"}
       :boolean]]},
    :rating
    {:description
     "Mantine `Rating` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 9 prop(s), 2\n  gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n  component named above straight from this declaration — the props here are\n  the legal ones, the gestures here are the wired ones, and nothing else\n  reaches the DOM. Generic is not finished: this kind has no data binding,\n  no edit buffer and no selection state of its own. A kind that needs one of\n  those graduates to a hand-written widget and an explicit case in\n  render.cljs — move it above the GENERATED marker and give it a description\n  that explains ITSELF.",
     :status :generated,
     :mantine {:component "Rating"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any CSS color value"}
       [:or :keyword :string]]
      [:count
       {:optional true, :doc "Number of controls"}
       [:or :int :double]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:fractions
       {:optional true,
        :doc "Number of fractions each item can be divided into"}
       [:or :int :double]]
      [:highlight-selected-only
       {:optional true,
        :doc
        "If set, only the selected symbol changes to full symbol when selected"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "`name` attribute passed down to all inputs. By default, `name` is generated randomly."}
       :string]
      [:read-only
       {:optional true,
        :doc "If set, the user cannot interact with the component"}
       :boolean]
      [:size
       {:optional true, :doc "Controls component size"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]],
     :defaults
     {:color :yellow,
      :count 5,
      :fractions 1,
      :highlight-selected-only false,
      :read-only false,
      :size :sm},
     :gestures [:change :hover],
     :children :none},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n     :options is the list of choices — a vector of {:label <string> :value\n     <string>} maps, bindable via :bind. :value names the initially-selected\n     option's :value. On change the renderer dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the chosen option's :value — mirroring :input's\n     Enter->command seam. :placeholder shows as a disabled leading option\n     when no :value matches. Web-only interactive; the TUI renders the\n     current value (or placeholder) as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :slider
    {:description
     "Mantine `Slider` — GENERATED from @mantine/core's own TypeScript\n  declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n  says exactly what the library promises and no more. 19 prop(s), 1 named\n  child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n  contract (see :unmapped). RENDERED GENERICALLY:\n  graph-ui.web.mantine-generic drives the component named above straight\n  from this declaration — the props here are the legal ones, the gestures\n  here are the wired ones, and nothing else reaches the DOM. Generic is not\n  finished: this kind has no data binding, no edit buffer and no selection\n  state of its own. A kind that needs one of those graduates to a\n  hand-written widget and an explicit case in render.cljs — move it above\n  the GENERATED marker and give it a description that explains ITSELF.\n  CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n  component, so a child is admitted solely to fill one of the named slots\n  above, saying which with :section. A child that names no slot is not body\n  content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"domain" "[number, number]"},
     :slots [:thumb-children],
     :defaults
     {:show-label-on-hover true,
      :min 0,
      :restrict-to-marks false,
      :radius :xl,
      :size :md,
      :max 100,
      :label-always-on false,
      :step 1,
      :inverted false},
     :mantine {:component "Slider"},
     :status :generated,
     :gestures [:change :change-end],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls color of track and thumb"}
       [:or :keyword :string]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled {:optional true, :doc "Disables slider"} :boolean]
      [:inverted
       {:optional true,
        :doc
        "Determines whether track value representation should be inverted"}
       :boolean]
      [:label-always-on
       {:optional true,
        :doc
        "Determines whether the label should be visible when the slider is not being dragged or hovered"}
       :boolean]
      [:marks
       {:optional true, :doc "Marks displayed on the track"}
       [:vector :any]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimal possible value"}
       [:or :int :double]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:precision
       {:optional true,
        :doc "Number of significant digits after the decimal point"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:restrict-to-marks
       {:optional true,
        :doc
        "Determines whether the selection should be only allowed from the given marks array"}
       :boolean]
      [:show-label-on-hover
       {:optional true,
        :doc
        "Determines whether the label should be displayed when the slider is hovered"}
       :boolean]
      [:size
       {:optional true, :doc "Controls size of the track"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with thumb drag and arrows"}
       [:or :int :double]]
      [:thumb-label
       {:optional true, :doc "Thumb `aria-label`"}
       :string]
      [:thumb-size
       {:optional true,
        :doc
        "Thumb `width` and `height`, by default value is computed based on `size` prop"}
       [:or :string :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]]},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a bound :text\n     (see :bind) gets its value from a data source. Type size, weight and\n     casing are NOT declared here: they are the :font-size/:font-weight/\n     :text-transform UNIVERSAL SLOTS as of ADR-graph-ui-v0-013-01 Sec19, because\n     they were never properties of text specifically (v1.x's own :size/:weight\n     stay on v1.x's :text forever, unchanged).\n     :empty-label (Sec23): what to show when the bound value resolves to an\n     empty string — the locked target's 'Add tags…' on a page with no tags.\n     Same slot name and same meaning :list/:tree/:outline already carry, so a\n     resolved-empty binding reads as EMPTY rather than as a broken pane. Not\n     :placeholder: that name already means 'hint text in an editable field'\n     on :input, and one name with two senses is how vocabulary rots.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none}}},
  "v2.0"
  {:status :released,
   :content-hash "f71c7a88",
   :drops #{:layout-self},
   :universal-slots
   {:text-transform
    {:description
     "Text casing — Mantine's `tt`. :uppercase is SPEC-002's sidebar section\n     header (11px / 700 / uppercase / letter-spaced) and its kind badge; the\n     renderer pairs :uppercase with the target's letter-spacing, since the\n     two always travel together in the locked target and a separate\n     letter-spacing slot would be a prop with exactly one legal use.",
     :shape [:enum :none :uppercase]},
    :import-id
    {:description
     "This node's AUTHORED IDENTITY — stable across re-seeds, and the join\n     between a description FILE and the frames it becomes.\n\n     The platform's own mechanism, not a new one: `frames-lib.store/create-frame!`\n     treats :import-id as a stable identity — a frame already bearing one is\n     SYNCED IN PLACE, same :frame/id, rather than duplicated — and\n     `ui.frames/node->slots` already lifts it off a widget node. Seeding an\n     island twice therefore leaves every :widget-id byte-identical, which is\n     what makes a Penpot board, an op-spec or any stored reference survive a\n     re-seed (verified 2026-08-04 across two seeds of the reader).\n\n     Why it is authored rather than the uuid: a :widget-id is minted by whichever\n     database was running, so a file full of uuids names frames that a wiped\n     graph no longer has. \"reader/vault-search\" survives the wipe and says what\n     the node IS. The uuid remains the join key between the graph and Penpot;\n     this is the join key between the file and the graph.\n\n     Namespaced by island by convention (\"reader/…\", \"reader-v2/…\") so two\n     islands may both hold a `vault-search` without colliding in one graph.\n\n     DECLARED HERE BECAUSE THE ENTRY SCHEMA IS CLOSED. The seeder read this key\n     from day one and the validator rejected it as a disallowed key — the files\n     were stamped, the islands seeded, `validate-dsl` passed (it checks this\n     manifest, not the instances), and only the full suite caught it. A slot the\n     platform reads and the vocabulary does not declare is exactly the drift\n     DSL-First exists to make impossible.",
     :shape :string},
    :widget-component
    {:description
     "This node is an OCCURRENCE of a named definition rather than a widget in\n     its own right — ADR-ikc-v3-060-01 §5. The value names a definition in the\n     description's own :components map.\n\n        {:widget-component :reading-pane :section :main :size \"66ch\"}\n\n     Everything beside :widget-component is an OVERRIDE, merged over the\n     definition. Under ADR-graph-ui-v0-002-01 any property may be overridden and each\n     one is TOUCHED — the occurrence's own, no longer following the definition.\n     Verified against Penpot 2.17 on 2026-08-04, whose component copies behave\n     exactly this way.\n\n     WHY THIS EXISTS. A description is read far more often than it is written,\n     and reader-ui.edn is 863 lines nested nine deep — you cannot see the page.\n     Naming its parts lets the top of a file BE the page, six lines long, with\n     each part opening on its own. It is also what a Penpot component maps to,\n     one-for-one, so a board and a description can talk about the same thing\n     (§6).\n\n     EXPANDED AT SEED TIME, for now. The seeder inlines each occurrence before\n     creating frames, so the graph holds a plain widget tree and the renderers\n     need no new case. That means the graph does not yet KNOW a component exists\n     — ADR-060 §1's :widget-component frame type and §3's occurrence links are\n     not built, so a definition change does not propagate to live occurrences and\n     a round-trip cannot give components back. Stated plainly because the gap is\n     invisible from the file, which looks like it has components either way.",
     :shape :keyword},
    :font-size
    {:description
     "Type size — Mantine's `fz` style prop (universal there too, for the same\n     reason). Two scales in ONE enum, exactly as Mantine's own MantineFontSize\n     does: the :xs-:xl step scale, and :h1-:h6 for heading sizes. :h1 is what\n     makes an editable page title LOOK like a title (with :variant :unstyled\n     on :input — Sec21) instead of like a form control.\n\n     Distinct from a kind's own :size (:icon, :drawer, :container), which\n     means that KIND's own dimension, never type size.",
     :shape [:enum :xs :sm :md :lg :xl :h1 :h2 :h3 :h4 :h5 :h6]},
    :font-weight
    {:description
     "Font weight — Mantine's `fw`. Mantine types it to raw CSS fontWeight,\n     which would make it unvalidatable, so v2.0 closes it to three named\n     steps (Sec0's standing trade). Moved here from :text's own :props\n     (Sec19) — it was never a property of text specifically. v1.x's :text\n     keeps its own :weight forever; a released version's vocabulary never\n     changes (ADR-graph-ui-v0-004-01).",
     :shape [:enum :normal :medium :bold]},
    :section
    {:description
     "Which named PLACE in its parent this child fills.\n\n     Universal for the same reason :flex is: it is a statement a CHILD makes\n     about its place in its parent, not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being the navbar.\n\n     TWO FAMILIES OF VALUE, ONE IDEA. The first five are an :app-shell's page\n     regions — Mantine's AppShell.Header / .Navbar / .Aside / .Main / .Footer,\n     named rather than ordered (ADR-graph-ui-v0-001-01 §B). The rest are the\n     named child slots the generated kinds declare: a `Divider`'s label, an\n     `Alert`'s title and icon, a `TextInput`'s description and error. Mantine's\n     `leftSection` and `label` props are the same idea as its `AppShell.Navbar`\n     — a place a widget goes — so this vocabulary says it once. Inventing a\n     second mechanism for the second family is what ADR-graph-ui-v0-013-01 was\n     written to end.\n\n     WHY THE SECOND FAMILY IS HERE AT ALL (AC-graph-ui-v0-001-01 §C, 2026-08-05).\n     It was not, and the consequence was that 31 kinds declared named slots that\n     NO valid description could fill: the enum could not spell :label, so\n     graph-ui.web.mantine-generic/split-slots — correct code — was unreachable.\n     A browser found it; nothing else could, because both halves were\n     individually valid and only their conjunction was wrong.\n\n     A documented no-op where it means nothing — the same contract :flex sets\n     for the TUI. This enum stays CLOSED (ADR-ikc-v3-041-01): a name that is not\n     here is rejected, so a typo is still caught. dsl/scripts/validate.clj holds\n     it to the vocabulary — every :slots name any kind declares must appear\n     below, and a generator run that adds a new slot name fails the build until\n     it does. That check is what stops this list from drifting back out of step,\n     which is the failure it was written after.",
     :shape
     [:enum
      :aside
      :chevron
      :cite
      :description
      :error
      :footer
      :header
      :hide-label
      :icon
      :label
      :left-section
      :legend
      :main
      :navbar
      :nothing-found-message
      :off-label
      :placeholder
      :right-section
      :separator
      :show-label
      :thumb-children
      :thumb-icon
      :title
      :validation-error]},
    :flex
    {:description
     "How this child sizes itself inside a flex/grid parent — ADR-graph-ui-v0-013-01\n     Sec4: :layout-self's four-key map collapses to Mantine's own `flex` CSS\n     shorthand, one value. :layout-self {:grow 1 :basis :zero} becomes :flex 1.\n     :shrink/:basis/:align-self are DROPPED, not renamed (Sec4) — a child\n     needing its own cross-axis alignment is deferred until a concrete island\n     needs it (ADR-graph-ui-v0-013 Deferred). Web renderer only — the TUI ignores it\n     (documented no-op, ADR-graph-ui-v0-007-01). Distinct from the :flex WIDGET\n     KIND below (Mantine's Flex container) — this is the self-sizing PROP\n     every node may carry, mirroring Mantine's own dual use of `flex` as both\n     a Mantine component name and a Box style prop.",
     :shape [:enum 0 1 2 3]},
    :narrow
    {:description
     "What this node does when the window is narrower than --viewport-narrow.\n\n     :keep    no change — the default, and the whole vocabulary for a node that\n              fits a phone already.\n     :hide    the node is ABSENT below the breakpoint. For desktop-only chrome\n              whose content is reachable another way — the conversations roster\n              is a seven-column table beside a picker that lists the same\n              conversations, so the phone keeps the picker.\n     :scroll  the node scrolls sideways INSIDE its own box below the\n              breakpoint, so the PAGE does not. For a wide table whose columns\n              are the point.\n     :fold    a two-pane split hands the width to its filling pane and starts\n              its resizable pane folded, one tap from open. :split-pane only.\n     :stack   a two-pane split becomes one vertical column, the resizable pane\n              first. :split-pane only.\n\n     :hide is a real loss of content and is why this slot is not a boolean. A\n     description states which answer it takes, and a reader of the description\n     can see which one it chose.\n\n     TWO VALUES ARE HONOURED BY ONE KIND, which is this manifest's standing\n     contract rather than a wart: :backdrop says the same of the six kinds that\n     draw a box, and :flex says it of the TUI. A slot is a statement a node\n     makes about its place, and a split is the only node whose narrow answer is\n     about its own two panes. Spelling those two as a SECOND key would put\n     :narrow in the schema twice, which malli refuses outright\n     (:malli.core/duplicate-keys — the collision that named :font-size).\n\n     Honoured by the web renderer. The TUI ignores it, which is the contract\n     :flex and :backdrop already set (ADR-graph-ui-v0-007-01) — a terminal has\n     one width and no phone.",
     :shape [:enum :keep :hide :scroll :fold :stack]},
    :backdrop
    {:description
     "The declared surface token this node paints as its background — one of the\n     :surfaces group in dsl/instances/themes.edn. `:surface body` becomes\n     `background: var(--body)`, which is the whole translation.\n\n     COLOUR ONLY, and no stroke, radius or padding with it. Those are a CELL's\n     treatment (dsl/design/*.edn, ui/widgets cell-style) and a cell is drawn by a\n     component that owns its own grid. A node in a widget tree has no such owner,\n     so it gets the one property that needs none.\n\n     Honoured on the kinds that draw a box — :box :stack :group :container\n     :scroll-area :markdown. A documented no-op elsewhere, which is the contract\n     :flex and the typography slots above already set. The TUI ignores it, the\n     same way it ignores every surface token (ADR-graph-ui-v0-007-01).\n\n     :border and :border-2 are absent from the range on purpose. They are in the\n     :surfaces group because they are painted colours, and neither is a surface\n     anything sits on.",
     :shape
     [:enum :ground :panel :raised :card :field :body :gutter :hover]},
    :per-tile
    {:description
     "DRAW MY ONE CHILD ONCE PER TILE, each copy scoped to that tile's session\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01).\n\n     true or absent. The node keeps ONE child in the graph — the template — and\n     the renderer draws it once for each open tile of the island, in order. Copy\n     n resolves as if it carried `:session-of n`.\n\n     WHY THE FRAMES HOLD ONE COPY AND NOT SIX. A frame is identified by its\n     :import-id, and frames-lib.store upserts by it — so six copies of a pane\n     would collapse into one frame and the tree would be wrong. Six copies would\n     also quadruple the description of every island that draws a pane, for a\n     feature most of them never use.\n\n     WHY THE COUNT IS NOT HERE. George, 2026-08-22: \"the 6 tiles is not hard UI\n     - it is fluid config from 1, 2, 4 or 6 tiles in the grid\". The count is\n     data — the island's own tiles — so the declaration says \"per tile\" and\n     never says how many. :tile-columns says how they are laid out.\n\n     THE CONTENT IS THE SAME AS ANYWHERE ELSE, and that is the point. George:\n     \"a conversation has same content in the tile and in the reading pane of the\n     reader-v2 or if floating free in the infinite canvas.\" The template is the\n     same part the single pane draws, so there is one declaration of what a\n     conversation looks like and no copy to drift.\n\n     THE TUI DRAWS ONE COPY, the focused tile. A terminal has one pane\n     (ADR-ikc-v3-048-01 TUI-lag), and this is declared rather than discovered.",
     :shape :boolean,
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}},
    :session-of
    {:description
     "THIS SUBTREE ANSWERS FOR ANOTHER SESSION — the nth TILE of this pane\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01 phase 2).\n\n     An integer, counting from 0. The whole subtree resolves with `$session-id`\n     bound to that tile's session, so every bind inside it reads the tile's own\n     answer.\n\n     WHY IT EXISTS. George, 2026-08-21: \"Conversation pane can be reworked so\n     2, 4 or 6 conversations can be observed and participated at once, displayed\n     as tiles.\" Six tiles bind about 40 sources each. Without this slot, each\n     tile would need its own copy of every source: 240 declarations, and a sixth\n     copy of every source added later. With it, `:page-title` stays one source\n     and answers for the session it is asked about, which it always did.\n\n     A NODE WHOSE INDEX NAMES NO TILE IS NOT DRAWN, and it reads nothing. A grid\n     of six cells over a pane of two tiles shows two. The alternative is worse\n     than an empty cell: a cell that fell back to the TAB's session would show\n     the wrong item and say nothing.\n\n     TWO KINDS OF VALUE. An INTEGER names a position. The keyword `:focused`\n     names whichever tile has the focus, and the reading pane uses it: the pane\n     draws ONE column, and that column follows the focus.\n\n     WHY THE PANE DOES NOT YET DRAW SIX COLUMNS, said here because a reader will\n     ask. Every node in the column carries an `:import-id`, and a frame is\n     identified by it. Six copies would be six nodes with one identity, so\n     per-tile identity is its own step and phase 3 does it.\n\n     WHICH SESSION EACH INDEX HOLDS COMES FROM THE :tile-sessions SOURCE, not\n     from the description. The description is seeded once and the tiles change\n     while a person works, so a position is the only thing a description can\n     name. Both binding runtimes read that source and carry it in their\n     substitutions under `$tile-sessions`.",
     :shape [:or :int [:enum :focused]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns\n     the edit buffer, seeded from :value (bindable). It dispatches\n     :on-gesture's :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing\n     v1.x's :on-submit) with $value = the buffer.\n\n     ENTER SENDS. Shift+Enter inserts a newline, and Ctrl/Cmd+Enter still\n     sends. Until 2026-08-20 the ONLY way to send was Ctrl/Cmd+Enter, which\n     George reported as a box that does not send (\"The input field does not\n     send on Enter and there is no submit button\"). Two reasons Enter wins.\n     A prompt box is a chat box, and every chat box in the world sends on\n     Enter. And a phone keyboard has no Ctrl key at all, so the phone\n     surface of phase 6 had no way to send anything.\n\n     :rows sets the\n     initial height; :auto-grow expands as the user types; :markdown\n     toggles a live preview of inline **bold**, *italic*, and `code`.\n     :triggers is an optional vector of trigger characters (e.g. [\"@\" \"/\"\n     \"#\"]) carried as data for future chip support. Web renderer only —\n     the TUI renders the buffer as plain read-only text.\n\n     A PASTED IMAGE GOES WITH THE PROMPT (PLAN-ikc-v3-017-01 phase 11).\n     George, 2026-08-21: \"I often paste an image in the terminal — is it\n     supported in a tile?\" A paste that carries an image file dispatches\n     the :paste gesture, whose $value is the whole `data:` URL, and the image\n     never enters the buffer: the bytes are written once into the :attachments\n     vault, and the prompt carries the path. THE GESTURE AND NOT A DIRECT\n     DISPATCH, because a tile bakes its own session into every gesture it holds\n     (ADR-graph-ui-v0-023-01) — a paste that dispatched by itself attached the\n     image to the TAB'S session, and the tile showed nothing. A paste of TEXT is untouched, because the default is stopped only\n     when an image was found. NO PROP DECLARES THIS. A paste is what this\n     widget is for, in the same way that Enter sends.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :aspect-ratio
    {:description
     "Mantine `AspectRatio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "AspectRatio"},
     :props
     [:map
      [:ratio
       {:optional true,
        :doc
        "Aspect ratio, for example, `16 / 9`, `4 / 3`, `1920 / 1080`"}
       [:or :int :double]]],
     :defaults {:ratio 1},
     :children :any},
    :fieldset
    {:description
     "Mantine `Fieldset` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Fieldset"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {},
     :slots [:legend],
     :children :slots},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit buffer\n     and, on Ctrl/Cmd+Enter or its Save button, dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the buffer — the editor half of the Foam markdown Edit\n     view (ADR-ikc-v3-052-01). :value seeds the buffer (bindable). :rows is\n     the initial visible height. In the TUI it renders as plain read-only\n     text. :draft-key: a client draft channel to publish the live buffer to\n     on every (debounced) change, so a live-preview widget (:island-view)\n     can render what is being typed BEFORE it is submitted. :format: :edn\n     (default) shows the buffer as-is; :indent converts the bound EDN value\n     to a bracket-stripped indentation format for display.\n\n     :font-size is NOT declared here under v2.0 — it is the UNIVERSAL SLOT\n     (ADR-graph-ui-v0-013-01 Sec19). v1.x declared it as this kind's own prop, which\n     was always a mislabelling: scaling the editor's code font is typography,\n     not a property of text areas specifically. Declaring both would be the\n     same key twice, which malli rejects outright (:malli.core/duplicate-keys)\n     — the check that found this. v1.x keeps its own :font-size forever.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                 contain formatted text. :value is the markdown source. In the TUI it\n                 renders as plain text (no styled rendering); a web renderer renders\n                 it as HTML. A bound :markdown gets its :value from a data source.\n\n                 SINCE 2026-08-14 IT CAN ALSO BE MARKED (F-platform-v0-011-01):\n                 :highlights is this page's highlights, and the marked text is\n                 washed in each one's colour. Selecting text offers four colour\n                 swatches and fires the :highlight gesture, whose $value is the\n                 whole selection map — the text, an advisory position, and the\n                 chosen colour — because a gesture carries one value and both\n                 capture modes must converge before the command\n                 (ADR-graph-ui-v0-017-01 §1-2).\n\n                 :value and :highlights are TWO bindings on one widget, which the\n                 per-prop :bind form has expressed since 2026-07-19; no new binding\n                 mechanism was needed for it.\n\n                 SINCE 2026-08-20 THE SELECTION CAN ALSO BOOKMARK\n                 (PLAN-ikc-v3-015-01 phase 3): the same popover offers a\n                 bookmark control beside the swatches, firing the :bookmark\n                 gesture with the same selection map, colour omitted. A\n                 description wires it only where the body is a conversation —\n                 the gesture resolves the selection to an entry id, and only a\n                 conversation has entries.\n\n                 A highlight map may carry :entry-id — the conversation storage\n                 form (ADR-ikc-v3-076-01 §3). The paint path is unchanged:\n                 offsets into the rendered source decide where a wash is drawn,\n                 whichever form stored it.\n\n                 AND ITS [[wikilinks]] CAN NAVIGATE (2026-08-18): :links is\n                 [{:target :page-id}] — every wikilink target in this body, each\n                 resolved on the SERVER by :page-content-links, bound with\n                 :link-bind rather than :bind because it is a second, independent\n                 binding beside :value.\n\n                 A target that names no page is still DRAWN, as a muted chip that\n                 does nothing. An unresolved wikilink is an invitation to create\n                 that page, not an error.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:links
       {:optional true}
       [:vector [:map [:target :string] [:page-id [:maybe :string]]]]]
      [:highlights
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:block-id {:optional true} :string]
         [:entry-id {:optional true} :string]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :input-base
    {:description
     "Mantine `InputBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "InputBase"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:multiline
       {:optional true,
        :doc
        "If set, the input can have multiple lines, for example when `component=\"textarea\"`"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-aria
       {:optional true,
        :doc
        "If set, `aria-` and other accessibility attributes are added to the input"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :with-aria true,
      :right-section-pointer-events "none",
      :multiline false,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :loader
    {:description
     "Mantine `Loader` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Loader"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the loader. `Loader` has predefined `xs`-`xl` values. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Loader type, key of `loaders` prop"}
       [:or [:enum :bars :dots :oval] :string]]],
     :defaults {:size :md, :type :oval},
     :unmapped
     {"loaders"
      "Partial<Record<(string & {}) | \"bars\" | \"dots\" | \"oval\", MantineLoaderComponent>>"},
     :children :any},
    :unstyled-button
    {:description
     "Mantine `UnstyledButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "UnstyledButton"},
     :props [:map],
     :defaults {},
     :children :any},
    :loading-overlay
    {:description
     "Mantine `LoadingOverlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "LoadingOverlay"},
     :props
     [:map
      [:visible
       {:optional true,
        :doc "Determines whether the overlay should be visible"}
       :boolean]
      [:z-index
       {:optional true, :doc "Controls overlay `z-index`"}
       [:or :string :int :double]]],
     :defaults {:visible false, :z-index 400},
     :children :none},
    :space
    {:description
     "Mantine `Space` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Space"},
     :props [:map],
     :defaults {},
     :children :none},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one —\n     the Studio preview pane. Renders the island the current session has\n     selected / is composing: its saved tree by default, or the description\n     currently in the editor buffer AS YOU TYPE (WYSIWYG), whichever the\n     client draft holds, with the saved tree as the fallback. The preview\n     attaches NOTHING — it reads via :ui/preview-context, so it can never\n     steal or leak the lock the composer holds. Carries a self-embed guard.\n     Web-only; the TUI renders a labelled placeholder.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :tree
    {:description
     "A nested outline; each item is now a MAP with optional recursive\n     :children (ADR-graph-ui-v0-013-01 Sec17): {:label string :children [item ...]\n     :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean}. :items is optional: a\n     bound :tree gets its outline from a source. The recursive sibling of\n     :list. Recognises TWO :on-gesture keys (ADR-graph-ui-v0-013 Sec7-8): :submit\n     (click-to-navigate — the web renderer wires clicking any node to it) and\n     :fork (the explicit fork action, typically the 'f' key; declared but not\n     yet wired in the web renderer, same as v1.x's :on-fork always was).\n     $value substitutes the clicked/forked item's :entry-id either way.\n     :direction: :column (default) stacks items vertically as an indented\n     outline; :row lays a FLAT item list out horizontally as a strip of\n     clickable buttons (the daily-note nav bar) and ignores nesting. :value\n     (ADR-graph-ui-v0-013-01 Sec24): the clicked node's own click target — see\n     :list's :value note for why it was missing.\n\n     A CLICKED ROW ACKNOWLEDGES ITSELF, and it is not a prop. Added 2026-08-17,\n     because a click on a page row costs a dispatch plus one :ui/read for every\n     source the server says changed — measured at 337ms for a single frame read\n     against the live graph, so a click is a wait, and the row used to give back\n     nothing at all while it ran. The row now shows a turning ring at its trailing\n     edge from the moment of the click until this session stops waiting on the bus.\n     The ring is OUT OF FLOW — absolute at the row's right edge, so appearing costs\n     no layout and a row with an accessory does not have its count or its reference\n     text shoved left mid-click. In :direction :row the strip uses the Button's own\n     loading state for the same reason, which also disables the control so a second\n     click cannot queue a second dispatch behind the first.\n     Deliberately NOT declared as a prop: an island cannot ask for it, cannot turn\n     it off, and cannot bind it. It is not data about the outline — it is the state\n     of the client that is drawing the outline, and the value it reports is one no\n     bus source could serve, since reading a source is the very round trip being\n     waited on. It lives in graph-ui.web.busy, the reagent-atom pattern\n     graph-ui.web.activity and graph-ui.web.draft already use, and the TUI simply\n     has nothing to draw here. The matching WINDOW-level signal — a sweeping line\n     on the chrome bar once a wait passes 400ms — is in graph-ui.web.core for the\n     same reason a viewport-spanning bar is not an island widget: it is a fact\n     about the frame, not about anything on the canvas.",
     :status :in-progress,
     :props
     [:map
      [:row {:optional true} [:enum :line :card]]
      [:active-value {:optional true} [:maybe :string]]
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:children {:optional true} [:vector :any]]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :group
    {:description
     "Horizontal row — Mantine `Group` (ADR-graph-ui-v0-013-01 Sec0). :wrap is\n     boolean here (true -> CSS `wrap`, false -> `nowrap`), the same\n     convention v1.x's :box :wrap already used. :grow gives every child\n     `flex-grow: 1`.",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:wrap {:optional true} :boolean]
      [:grow {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n     declares the header — a vector of {:label <string> :key\n     <keyword|string>} maps; each row's cell for a column is looked up by\n     that column's :key. :rows is the data — a vector of maps, bindable via\n     :bind. Display-only: row selection/editing is a later addition.\n     :tone/:density tune the visual weight. In the TUI it renders as plain\n     text rows.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :file-input
    {:description
     "Mantine `FileInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 23 prop(s), 6 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"component" "any",
      "defaultValue" "Multiple extends true ? File[] : File",
      "multiple" "Multiple",
      "value" "Multiple extends true ? File[] : File"},
     :slots
     [:description
      :error
      :label
      :left-section
      :placeholder
      :right-section],
     :defaults
     {:clearable false,
      :left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "FileInput"},
     :status :generated,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:name {:optional true, :doc "Input name attribute"} :string]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set, the input value cannot be changed"}
       :boolean]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :affix
    {:description
     "Mantine `Affix` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Affix"},
     :props
     [:map
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]],
     :defaults {:within-portal true, :z-index 200},
     :unmapped {"position" "AffixPosition"},
     :children :any},
    :portal
    {:description
     "Mantine `Portal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Portal"},
     :props
     [:map
      [:reuse-target-node
       {:optional true,
        :doc "If set, all portals are rendered in the same DOM node"}
       :boolean]],
     :defaults {:reuse-target-node true},
     :unmapped {"target" "string | HTMLElement"},
     :children :any},
    :tags-input
    {:description
     "Mantine `TagsInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 33 prop(s), 5 named\n     child slot(s), 8 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxStringData", "filter" "OptionsFilter"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :accept-value-on-blur true,
      :hidden-input-values-divider ",",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :allow-duplicates false,
      :pointer false,
      :open-on-focus true,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "TagsInput"},
     :status :generated,
     :gestures
     [:change
      :clear
      :dropdown-close
      :dropdown-open
      :duplicate
      :option-submit
      :remove
      :search-change],
     :props
     [:map
      [:accept-value-on-blur
       {:optional true,
        :doc
        "If set, the value typed in by the user but not submitted is accepted when the input is blurred"}
       :boolean]
      [:allow-duplicates
       {:optional true, :doc "If set, duplicate tags are allowed"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section when the component has value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-search-value
       {:optional true, :doc "Default search value"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:vector :string]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:hidden-input-values-divider
       {:optional true,
        :doc
        "Divider used to separate values in the hidden input `value` attribute"}
       :string]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:max-tags
       {:optional true, :doc "Maximum number of tags"}
       [:or :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:search-value
       {:optional true, :doc "Controlled search value"}
       :string]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:split-chars
       {:optional true,
        :doc
        "Characters that should trigger tags split, `[',']` by default"}
       [:vector :string]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:vector :string]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :radio
    {:description
     "Mantine `Radio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Radio"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color, by default value depends on `theme.autoContrast`"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:label-position :right, :radius :xl, :size :sm},
     :slots [:description :error :label],
     :unmapped
     {"icon" "FC<RadioIconProps>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :slots},
    :transition
    {:description
     "Mantine `Transition` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Transition", :children :function},
     :props
     [:map
      [:duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]
      [:enter-delay
       {:optional true,
        :doc "Delay in ms before enter transition starts"}
       [:or :int :double]]
      [:exit-delay
       {:optional true,
        :doc "Delay in ms before exit transition starts"}
       [:or :int :double]]
      [:exit-duration
       {:optional true, :doc "Exit transition duration in ms"}
       [:or :int :double]]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the element is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:mounted
       {:optional true,
        :doc
        "Determines whether component should be mounted to the DOM"}
       :boolean]
      [:timing-function
       {:optional true, :doc "Transition timing function"}
       :string]
      [:transition
       {:optional true, :doc "Transition name or object"}
       [:or
        [:enum
         :scale
         :fade
         :fade-down
         :fade-up
         :fade-left
         :fade-right
         :skew-up
         :skew-down
         :rotate-right
         :rotate-left
         :slide-down
         :slide-up
         :slide-right
         :slide-left
         :scale-y
         :scale-x
         :pop
         :pop-top-left
         :pop-top-right
         :pop-bottom-left
         :pop-bottom-right]
        :string]]],
     :defaults {:duration 250, :exit-duration 250},
     :gestures [:enter :entered :exit :exited],
     :children :any},
    :button
    {:description
     "ADR-graph-ui-v0-007-01: a standalone clickable button, built on\n     @radix-ui/react-slot. :label is the button's text; :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit) is\n     dispatched on click — $session-id substitutes as usual, $value is not\n     meaningful for a plain button unless a specific template hardcodes\n     one. :disabled blocks the click. TUI renders the label as plain text,\n     read-only.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]],
     :defaults {},
     :children :none},
    :spoiler
    {:description
     "Mantine `Spoiler` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"controlRef" "ForwardedRef<HTMLButtonElement>"},
     :slots [:hide-label :show-label],
     :defaults {:max-height 100, :transition-duration 200},
     :mantine {:component "Spoiler"},
     :status :generated,
     :gestures [:expanded-change],
     :props
     [:map
      [:expanded
       {:optional true, :doc "Controlled expanded state value"}
       :boolean]
      [:initial-state
       {:optional true,
        :doc
        "Initial spoiler state, `true` to wrap content in spoiler, `false` to show content without spoiler, opened state is updated on mount"}
       :boolean]
      [:max-height
       {:optional true,
        :doc
        "Maximum height of the visible content, when this point is reached spoiler appears"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Spoiler reveal transition duration in ms, set 0 or null to turn off animation"}
       [:or :int :double]]]},
    :notification
    {:description
     "Mantine `Notification` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 3 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Notification"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Controls notification line or icon color, key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:loading
       {:optional true,
        :doc
        "If set, the `Loader` component is displayed instead of the icon"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is visible"}
       :boolean]],
     :defaults {:with-close-button true},
     :gestures [:close],
     :slots [:icon :title],
     :children :any},
    :highlight
    {:description
     "Mantine `Highlight` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Highlight"},
     :props
     [:map
      [:children
       {:optional true,
        :doc "String parts of which must be highlighted"}
       :string]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:highlight
       {:optional true,
        :doc
        "Substring or a list of substrings to highlight in `children`"}
       [:vector :any]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:span
       {:optional true, :doc "Shorthand for `component=\"span\"`"}
       :boolean]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]],
     :defaults
     {:highlight [], :inherit false, :inline false, :size :md},
     :unmapped {"color" "string | (string & {})"},
     :children :none},
    :mark
    {:description
     "Mantine `Mark` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Mark"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]],
     :defaults {},
     :children :any},
    :checkbox
    {:description
     "Mantine `Checkbox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Checkbox"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input background color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color. By default, depends on `theme.autoContrast`."}
       [:or :keyword :string]]
      [:id {:optional true, :doc "Unique input id"} :string]
      [:indeterminate
       {:optional true,
        :doc
        "Indeterminate state of the checkbox. If set, `checked` prop is ignored."}
       :boolean]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:label-position :right, :size :sm},
     :slots [:description :error :label],
     :unmapped
     {"icon" "FC<{ indeterminate: boolean; className: string; }>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :slots},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                 be a :box with a :title (used as the tab label). :active (default 0)\n                 is the index of the visible tab. The renderer draws a tab header line\n                 and shows only the active child's content below it.\n\n                 THE WEB RENDERER DID NOT DO THAT UNTIL 2026-08-23, and this\n                 paragraph is why it now does. It mounted every panel, so a page\n                 click — which changes the bound value of all of them — rebuilt\n                 the lot: 798 DOM mutations for one click, 799 of 815 of them\n                 inside the Tabs component, measured on the running deployment.\n                 The TUI had drawn only the active child all along, so two\n                 renderers disagreed about one description and the words above\n                 were on the TUI's side (PLAN-ikc-v3-019-01 phase 4).\n\n                 ONE EXCEPTION, AND IT IS DERIVED RATHER THAN DECLARED. A child\n                 whose subtree holds a widget with an edit buffer — :input,\n                 :text-area, :outline — keeps its content drawn whichever tab is\n                 active. That buffer lives in the renderer, so unmounting it would\n                 throw away text a person typed and has not saved, with nothing\n                 saying so. The renderer reads it off the child's own subtree\n                 (graph-ui.web.widgets/holds-draft?), so no island declares it and\n                 none can forget it.\n\n                 DERIVED BECAUSE A DERIVED RULE CANNOT DRIFT, and for no other\n                 reason. An earlier draft of this paragraph also argued that a\n                 declared slot would be unavailable to an island pinned to a\n                 released vocabulary. George struck that on 2026-08-23: a version\n                 pin is not a reason to shape a design around it. If the right\n                 answer needs a slot, the slot is added and the island is moved.\n\n                 THE EXCEPTION IS A SYMPTOM AND IT HAS AN OWNER. An editor's\n                 unsaved text should not live in component state at all\n                 (PLAN-ikc-v3-018-01: drafts in browser storage, keyed by the\n                 thing being edited). When it does not, holds-draft? is deleted\n                 and a tab-set draws one child with no exception at all.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any},
    :pill
    {:description
     "Mantine `Pill` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Pill"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Adds disabled attribute, applies disabled styles"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls pill `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-remove-button
       {:optional true,
        :doc "Controls visibility of the remove button"}
       :boolean]],
     :defaults {:radius :xl, :size :sm, :with-remove-button false},
     :gestures [:remove],
     :children :any},
    :simple-grid
    {:description
     "Equal-width columns — Mantine `SimpleGrid` (ADR-graph-ui-v0-013-01 Sec0), the\n     common case :grid's :span bookkeeping would be overkill for.",
     :status :in-progress,
     :props
     [:map
      [:cols {:optional true} :int]
      [:spacing {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:vertical-spacing
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:cols 1},
     :children :any},
    :grid
    {:description
     "Real 2D proportional layout — CSS GRID (ADR-graph-ui-v0-013-01 Sec3).\n     :columns is the TOTAL (12 by default); each :grid-col child states\n     its :span of that total — '50-50' is two :grid-col children at :span 6.\n     :gutter is the gap between cells (a separate name from :gap elsewhere\n     in this vocabulary, because Mantine's Grid named it that and every\n     declaration here says :gutter). Children SHOULD be :grid-col.\n\n     EVERY CELL HAS A DEFINITE HEIGHT, and every row an equal share of the\n     grid. That is the whole reason this kind is CSS grid and not Mantine's\n     `Grid`, which is a wrapping flexbox: a flexbox row is as tall as its\n     content, so a :scroll-area in a cell grew instead of scrolling, and a\n     second row did not share the height with the first (2026-08-23).\n\n     :grow AND :offset ARE GONE, with the :auto and :content spans. A\n     wrapping flexbox could do those three and a grid cannot. Nothing\n     declared them, so a description that names one is now refused at\n     \"disallowed key\" instead of the renderer dropping it without a word.\n     The gate is the description validator that every island's own test\n     runs, and NOT validate-dsl, which checks this manifest and not the\n     instances.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} :int]
      [:gutter {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:columns 12},
     :children :any},
    :visually-hidden
    {:description
     "Mantine `VisuallyHidden` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "VisuallyHidden"},
     :props [:map],
     :defaults {},
     :children :any},
    :floating-indicator
    {:description
     "Mantine `FloatingIndicator` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 4 prop(s),\n     and 2 prop(s) whose type carries no data contract (see :unmapped).\n     RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the component\n     named above straight from this declaration — the props here are the legal\n     ones, the gestures here are the wired ones, and nothing else reaches the\n     DOM. Generic is not finished: this kind has no data binding, no edit\n     buffer and no selection state of its own. A kind that needs one of those\n     graduates to a hand-written widget and an explicit case in render.cljs —\n     move it above the GENERATED marker and give it a description that explains\n     ITSELF.",
     :status :generated,
     :mantine {:component "FloatingIndicator"},
     :props
     [:map
      [:display-after-transition-end
       {:optional true,
        :doc
        "If set, the indicator is displayed after transition ends. Should be set if the component is used inside a container that has `transform: scale(n)` styles."}
       :boolean]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :string :int :double]]],
     :defaults {:transition-duration 150},
     :unmapped {"parent" "HTMLElement", "target" "HTMLElement"},
     :children :none},
    :popover
    {:description
     "Mantine `Popover` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 29 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Popover"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:change
      :close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :children :any},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n     the toggle line; :collapsed (default false) controls initial state.\n     :count (ADR-graph-ui-v0-013-01 Sec17): an optional int shown beside the\n     title (the '12 pages' style header). :icon: an optional :icon name\n     leading the title. The expand/collapse chevron itself is not a prop —\n     every :collapsible has one, it is not a per-instance choice.\n\n     :hide-when-empty (F-platform-v0-014-01, 2026-08-18) — draw NOTHING, not an\n     empty heading, when every bound child inside is empty. Default false, which\n     is every existing section's behaviour.\n\n     WHY IT HAS TO BE A PROP. Emptiness is a RUNTIME fact, so it cannot be\n     settled where a section's existence is otherwise decided: ui.blocks drops a\n     collection that has no :source at EXPANSION time, which is a statement about\n     the declaration, not about today's data. A Pinned section has a source and is\n     usually empty, and ikc1 draws it only once something is pinned\n     (AthensSidebar.tsx: `{pinnedFrames.length > 0 && …}`).\n\n     AND WHY THIS DOES NOT CONTRADICT THE RIGHT GUTTER, which is drawn even when\n     empty on the stated rule that 'a column that comes and goes per row is not a\n     column' (dsl/design/block-row.edn). A sidebar section is not a column:\n     nothing aligns to it, and an empty one spends a heading plus its own vertical\n     space on every screen. Progressive disclosure applies\n     (CONCEPT-graph-ui-v0-008-01); column stability does not.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:count {:optional true} :int]
      [:icon {:optional true} :keyword]
      [:hide-when-empty {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false, :hide-when-empty false},
     :children :any},
    :ring-progress
    {:description
     "Mantine `RingProgress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "RingProgress"},
     :props
     [:map
      [:root-color
       {:optional true,
        :doc
        "Color of the root section, key of theme.colors or CSS color value"}
       [:or :keyword :string]]
      [:round-caps
       {:optional true,
        :doc
        "Sets whether the edges of the progress circle are rounded"}
       :boolean]
      [:sections {:optional true, :doc "Ring sections"} [:vector :any]]
      [:size
       {:optional true, :doc "Width and height of the progress ring"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Ring thickness"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]],
     :defaults
     {:sections [], :size 120, :thickness 12, :transition-duration 0},
     :slots [:label],
     :children :slots},
    :segmented-control
    {:description
     "Mantine `SegmentedControl` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "SegmentedControl"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, changes color of indicator, by default color is based on current color scheme"}
       [:or :keyword :string]]
      [:data
       {:optional true,
        :doc "Data based on which controls are rendered"}
       [:vector :any]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Determines whether the component is disabled"}
       :boolean]
      [:full-width
       {:optional true,
        :doc
        "Determines whether the component should take 100% width of its parent"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "Name of the radio group, by default random name is generated"}
       :string]
      [:orientation
       {:optional true, :doc "Component orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set to `false`, prevents changing the value"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls `font-size`, `padding` and `height` properties"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc
        "Indicator `transition-duration` in ms, set `0` to turn off transitions"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "Indicator `transition-timing-function` property"}
       :string]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-items-borders
       {:optional true,
        :doc
        "Determines whether there should be borders between items"}
       :boolean]],
     :defaults
     {:data [],
      :full-width false,
      :orientation :horizontal,
      :size :sm,
      :transition-duration 200,
      :with-items-borders true},
     :gestures [:change],
     :children :none},
    :number-formatter
    {:description
     "Mantine `NumberFormatter` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "NumberFormatter"},
     :props
     [:map
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that are displayed after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true,
        :doc "Character used as a decimal separator, `'.'` by default"}
       :string]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, zeros are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:prefix
       {:optional true, :doc "Prefix added before the value"}
       :string]
      [:suffix
       {:optional true, :doc "Suffix added after the value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style"}
       [:enum :none :thousand :lakh :wan]]
      [:value
       {:optional true, :doc "Value to format"}
       [:or :string :int :double]]],
     :defaults
     {:allow-negative true,
      :fixed-decimal-scale false,
      :thousand-separator ","},
     :children :none},
    :multi-select
    {:description
     "Mantine `MultiSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 6 named\n     child slot(s), 7 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData", "filter" "OptionsFilter"},
     :slots
     [:description
      :error
      :label
      :left-section
      :nothing-found-message
      :right-section],
     :defaults
     {:check-icon-position :left,
      :left-section-pointer-events "none",
      :hidden-input-values-divider ",",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :searchable false,
      :pointer false,
      :open-on-focus true,
      :with-check-icon true,
      :with-asterisk false,
      :with-aligned-labels false,
      :with-error-styles true,
      :required false,
      :hide-picked-options false},
     :mantine {:component "MultiSelect"},
     :status :generated,
     :gestures
     [:change
      :clear
      :dropdown-close
      :dropdown-open
      :option-submit
      :remove
      :search-change],
     :props
     [:map
      [:check-icon-position
       {:optional true,
        :doc "Position of the check icon relative to the option label"}
       [:enum :left :right]]
      [:chevron-color
       {:optional true, :doc "Controls color of the default chevron"}
       [:or :keyword :string]]
      [:clear-search-on-change
       {:optional true,
        :doc "Clear search value when item is selected"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section when the component has value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-search-value
       {:optional true, :doc "Default search value"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:vector :string]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:hidden-input-values-divider
       {:optional true,
        :doc
        "Divider used to separate values in the hidden input `value` attribute"}
       :string]
      [:hide-picked-options
       {:optional true,
        :doc
        "If set, picked options are removed from the options list"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:max-values
       {:optional true,
        :doc "Maximum number of values, no limit if not set"}
       [:or :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:search-value
       {:optional true, :doc "Controlled search value"}
       :string]
      [:searchable {:optional true, :doc "Allows searching"} :boolean]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:vector :string]]
      [:with-aligned-labels
       {:optional true,
        :doc "If set, unchecked labels are aligned with checked ones"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-check-icon
       {:optional true,
        :doc
        "If set, the check icon is displayed near the selected option label"}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :app-shell
    {:description
     "A PAGE — Mantine's `AppShell`, adopted whole (ADR-graph-ui-v0-001-01 §B).\n     Header / Navbar / Aside / Main / Footer, which is what a surface with a\n     navigation sidebar and a content area actually IS.\n\n     Adopted because the reader was hand-rolling one. `{:widget :split-pane\n     :initial 270 :min 180 :max 440}` wrapping a `:container` is a Navbar and a\n     Main expressed as flex arithmetic, with the sidebar's resize and collapse left\n     for the renderer to invent. Mantine ships that behaviour, including the\n     breakpoint at which the sidebar collapses — so 057-01's deferral of\n     responsiveness partly dissolves here rather than needing its own model.\n\n     SECTIONS ARE NAMED, NOT ORDERED. Children declare which section they are\n     via :section; there is no positional convention to remember and a\n     description that omits a section simply has none. That is the whole reason\n     this is a kind and not a :grid with agreed cells.\n\n     :mode is Mantine's own, and it is load-bearing HERE in a way it is not in a\n     plain web app. Mantine defaults to 'fixed', which positions every section\n     except Main against the VIEWPORT — correct for a page that owns the window,\n     wrong for an ikc3 island, which may be one pane of a canvas or embedded in\n     a tile. A fixed navbar would escape its island and land on the window. So\n     :mode defaults to :static here, and :fixed is the deliberate opt-in for a\n     surface that really does own the viewport. (The risk was named in the ADR\n     before this kind was declared; `mode` is Mantine's own answer to it, so\n     nothing had to be invented to resolve it.)\n\n     :navbar-width / :aside-width / :header-height / :footer-height take the\n     same open value :container's :size does — a token, a number, or a CSS\n     length — so a sidebar can be stated in ch or rem rather than pixels.\n     :navbar-breakpoint is the width below which the sidebar collapses; Mantine's\n     own token scale.\n\n     Gestures: none. An :app-shell arranges; it does not dispatch.",
     :status :in-progress,
     :props
     [:map
      [:mode {:optional true} [:enum :static :fixed]]
      [:padding {:optional true} [:enum :none :xs :sm :md :lg :xl]]
      [:navbar-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:aside-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:header-height {:optional true} :int]
      [:footer-height {:optional true} :int]
      [:navbar-breakpoint
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:mode :static, :padding :md},
     :slots [:aside :footer :header :main :navbar],
     :children :any},
    :close-button
    {:description
     "Mantine `CloseButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "CloseButton"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute, assigns disabled styles"}
       :boolean]
      [:icon-size
       {:optional true, :doc "`X` icon `width` and `height`"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :slots [:icon],
     :children :any},
    :grid-col
    {:description
     "One cell of a :grid parent (ADR-graph-ui-v0-013-01 Sec3). :span is this\n     child's share of the parent's :columns total — STATED, not emergent\n     from siblings. An int only: :auto and :content went with the flexbox\n     (see :grid), and so did :offset.",
     :status :in-progress,
     :props
     [:map
      [:span {:optional true} :int]
      [:order {:optional true} :int]],
     :defaults {},
     :children :any},
    :color-swatch
    {:description
     "Mantine `ColorSwatch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ColorSwatch"},
     :props
     [:map
      [:color
       {:optional true, :doc "Valid CSS color to display"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the swatch, any valid CSS value, numbers are converted to rem."}
       [:or :string :int :double]]
      [:with-shadow
       {:optional true,
        :doc
        "Determines whether the swatch should have inner `box-shadow`"}
       :boolean]],
     :defaults {:radius 1000, :size 28, :with-shadow true},
     :children :any},
    :box
    {:description
     "A plain container with no layout opinion — ADR-graph-ui-v0-013-01 Sec0: v1.x's\n     :layout enum and flex props (:direction/:wrap/:justify/:align/:gap) are\n     DROPPED from :box itself (a prop-level change within a kind that still\n     exists, so no :drops entry is needed for it — only whole kind/slot names\n     require one). Arrangement lives on :stack/:group/:flex/:grid/\n     :simple-grid below; :box is for grouping + chrome only.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:border {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation
       {:optional true}
       [:enum :flat :raised :floating :overlay]]],
     :defaults {},
     :children :any},
    :paper
    {:description
     "Mantine `Paper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Paper"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]],
     :defaults {},
     :children :any},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                 is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                 plain monospaced text; a web renderer may apply syntax highlighting.\n                 A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :native-select
    {:description
     "Mantine `NativeSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "NativeSelect"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :unmapped {"data" "ComboboxData"},
     :children :slots},
    :kbd
    {:description
     "Mantine `Kbd` — GENERATED from @mantine/core's own TypeScript declarations\n     (PLAN-graph-ui-v0-009-01), not hand-written, so this kind says exactly\n     what the library promises and no more. 1 prop(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Kbd"},
     :props
     [:map
      [:size
       {:optional true, :doc "Controls `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :sm},
     :children :none},
    :burger
    {:description
     "Mantine `Burger` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Burger"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS value, by default `theme.white` in dark color scheme and `theme.black` in light"}
       [:or :keyword :string]]
      [:line-size
       {:optional true,
        :doc
        "Controls height of lines, by default calculated based on `size` prop"}
       [:or :string :int :double]]
      [:opened
       {:optional true,
        :doc
        "State of the burger, when `true` burger is transformed into X"}
       :boolean]
      [:size
       {:optional true,
        :doc
        "Controls burger `width` and `height`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc "`transition-duration` property value in ms"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "`transition-timing-function` property value"}
       :string]],
     :defaults
     {:opened false,
      :size :md,
      :transition-duration 300,
      :transition-timing-function "ease"},
     :children :none},
    :copy-button
    {:description
     "Mantine `CopyButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "CopyButton", :children :function},
     :props
     [:map
      [:timeout
       {:optional true, :doc "Copied status timeout in ms"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Value that is copied to the clipboard when the button is clicked"}
       :string]],
     :defaults {:timeout 1000},
     :children :any},
    :alert
    {:description
     "Mantine `Alert` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Alert"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-button-label
       {:optional true, :doc "Close button `aria-label`"}
       :string]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-close-button
       {:optional true,
        :doc "Determines whether close button should be displayed"}
       :boolean]],
     :defaults {:with-close-button false},
     :gestures [:close],
     :slots [:icon :title],
     :children :slots},
    :voice
    {:description
     "THE SPOKEN SURFACE — speech to text for a prompt, text to speech for the\n     entries this session is reading. George walks the dog with the phone in one\n     hand and the headphones on, and the headphones are only audio transport\n     (the plan says so): everything that has to be built is here and in the\n     browser.\n\n     TWO CONTROLS, EACH ITS OWN BOOLEAN. :dictate shows the control that\n     listens. :read shows the control that speaks. A node may show one, the\n     other, or both, because they belong in different places — the prompt box\n     wants the microphone and the reading pane wants the reader.\n\n     THE RECOGNIZED TEXT IS NEVER SENT. It lands in the prompt box named by\n     :target, as if the reader had typed it, and the reader sends it. That is\n     the platform's standing rule that user input travels verbatim and a person\n     decides (ADR-ikc-v3-075-01 - the prompt box forwards the text VERBATIM).\n     Speech recognition is wrong often enough that auto-dispatch would be a\n     command nobody wrote. :target is the :import-id of the :prompt-area, not a\n     widget id, so it survives a re-seed like every other authored reference.\n\n     WHAT IS READ ALOUD is the bound value: the entries of the conversation this\n     session has selected, each with its :role, its :text, its :thinking and its\n     :harness? flag. A HARNESS BLOCK IS NEVER SPOKEN. The harness writes machine\n     messages with the role user (the harness fold, 2026-08-20), and reading one\n     aloud in a synthetic voice would be the same defect one layer out - the\n     record would lie in his ear instead of on his screen. THINKING IS NOT\n     SPOKEN unless :read-thinking is true: an answer is what a reader walking a\n     dog asked for. The thinking is longer than the answer.\n\n     :read-count is how many of the NEWEST entries the read control speaks. A\n     conversation is thousands of entries long and a reader who taps 'read'\n     wants what just arrived, so the control reads a tail and says on the\n     surface how many of how many it took. Three by default.\n\n     :language is a BCP-47 tag for both halves - recognition and speech. One\n     slot, because a reader who dictates in one language does not want the\n     answer read in another.\n\n     Gestures: NONE, and that is the point. A :voice dispatches no command. It\n     fills a prompt box and it drives the audio output, both of which are this\n     browser's own business.\n\n     WITHOUT A SECURE CONTEXT IT SAYS SO. The browser speech APIs are absent on\n     plain HTTP, so the controls cannot work until phase 5 puts the deployment\n     behind TLS. The widget then renders its controls DISABLED with the reason\n     and the remedy in words on the surface, and records the refusal on the\n     observability surface. A silent no-op is what\n     PRINCIPLE-ikc-v3-010-01 calls a defect, and a console line is a signal\n     nobody walking a dog can read.\n\n     Web renderer only. The TUI has no microphone and no loudspeaker, so it\n     renders nothing at all - the same documented no-op that :flex sets.",
     :status :in-progress,
     :props
     [:map
      [:dictate {:optional true} :boolean]
      [:read {:optional true} :boolean]
      [:target {:optional true} :string]
      [:language {:optional true} :string]
      [:read-thinking {:optional true} :boolean]
      [:read-count {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:language "en-US", :read-thinking false, :read-count 3},
     :children :none},
    :flex
    {:description
     "Explicit flex container, direction stated — Mantine `Flex`\n     (ADR-graph-ui-v0-013-01 Sec0). For when :stack (always vertical) / :group\n     (always horizontal) aren't enough. Distinct from the :flex UNIVERSAL\n     SLOT (this version's :universal-slots) — that is a CHILD's self-sizing\n     hint; this is a CONTAINER kind. Mantine overloads `flex` the same way (a\n     Mantine Flex component AND a Box style prop); v2.0 keeps that overlap rather\n     than inventing new names.",
     :status :in-progress,
     :props
     [:map
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:row-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:column-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :focus-trap
    {:description
     "Mantine `FocusTrap` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "FocusTrap"},
     :props
     [:map
      [:active
       {:optional true, :doc "If set to `false`, disables focus trap"}
       :boolean]
      [:ref-prop
       {:optional true, :doc "Prop that is used to access element ref"}
       :string]],
     :defaults {:ref-prop "ref"},
     :unmapped {"children" "any", "innerRef" "ForwardedRef<any>"},
     :children :none},
    :icon
    {:description
     "A line icon — ADR-graph-ui-v0-013-01 Sec11: @tabler/icons-react, closed to a\n     named set (not the library's full catalogue). :icon maps 1:1 to one\n     tabler React component in the renderer's own lookup table (widgets.cljs's\n     icon-components). Closed as a real [:enum ...] (not a bare :keyword,\n     which a prior draft of this rule wrongly claimed was already\n     validate-dsl-catchable — it was not, a keyword type check accepts any\n     keyword; fixed 2026-07-27 when Phase 2 needed 5 more names). Web-only;\n     TUI renders nothing (documented no-op, same precedent as\n     :elevation/:button). The 20 from Sec11's original set plus 5 added for\n     PLAN-graph-ui-v0-007-01 Phase 2's locked-target reader (the mockup's own\n     'outline view'/'theme config'/'theme selector'/'pin'/'copy' icons, none\n     of which are on a disabled/not-yet-built affordance, so they earn a real\n     name now rather than waiting).",
     :status :in-progress,
     :props
     [:map
      [:icon
       {:optional true}
       [:enum
        :search
        :chevron-down
        :chevron-right
        :chevron-up
        :chevron-left
        :tag
        :star
        :settings
        :close
        :plus
        :more
        :check
        :calendar
        :folder
        :file
        :link
        :trash
        :edit
        :menu
        :home
        :outline-view
        :theme-config
        :theme-selector
        :pin
        :copy]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :verse-rows
    {:description
     "A book's reading surface: one row per verse, each row carrying the\n     translation, the source text and the verse's notes as three aligned\n     cells. :items is the bound list, each item\n     {:verse-id string :text string :original string\n      :notes [{:head string :kind string}]}.\n\n     :show-source and :show-notes are the reader's, not the author's — the\n     second and third columns can be closed, which is what George asked for\n     when he said a reader may prefer the book without the Chinese. Closing a\n     column widens the ones that remain rather than leaving a gap.\n\n     A verse is ONE paragraph, so prose typography needs no markdown here: the\n     cell is styled text and reads the same. That is what lets the row exist\n     at all — a markdown document cannot be a table cell.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:empty-label {:optional true} :string]
      [:show-source {:optional true} :boolean]
      [:show-notes {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:show-source true, :show-notes true},
     :children :none},
    :color-picker
    {:description
     "Mantine `ColorPicker` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 12 prop(s), 3\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "ColorPicker"},
     :props
     [:map
      [:alpha-label
       {:optional true, :doc "Alpha slider `aria-label`"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:focusable
       {:optional true,
        :doc
        "If set, interactive elements (sliders thumbs and swatches) are focusable with keyboard"}
       :boolean]
      [:format
       {:optional true, :doc "Color format"}
       [:enum :hex :hexa :rgba :rgb :hsl :hsla]]
      [:full-width
       {:optional true,
        :doc "If set, the component takes 100% width of its container"}
       :boolean]
      [:hue-label
       {:optional true, :doc "Hue slider `aria-label`"}
       :string]
      [:saturation-label
       {:optional true, :doc "Saturation slider `aria-label`"}
       :string]
      [:size
       {:optional true,
        :doc "Controls size of hue, alpha and saturation sliders"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:swatches
       {:optional true,
        :doc
        "A list of colors used to display swatches list below the color picker"}
       [:vector :string]]
      [:swatches-per-row
       {:optional true, :doc "Number of swatches per row"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-picker
       {:optional true,
        :doc "Determines whether the color picker should be displayed"}
       :boolean]],
     :defaults
     {:focusable true,
      :format :hex,
      :full-width false,
      :size :md,
      :swatches-per-row 7,
      :with-picker true},
     :gestures [:change :change-end :color-swatch-click],
     :children :none},
    :drawer
    {:description
     "A slide-over — Mantine `Drawer`/`DrawerRoot` (ADR-graph-ui-v0-013-01 Sec15):\n     SPEC-002's '340px slide-over + scrim' is Drawer's own overlay, not\n     hand-rolled. Closing (Escape, scrim click, or the built-in close\n     button — all three are ModalBase's own affordances) fires\n     :on-gesture's :submit key with no $value, the same slot a plain\n     :button fires.",
     :status :in-progress,
     :props
     [:map
      [:opened {:optional true} :boolean]
      [:title {:optional true} :string]
      [:position {:optional true} [:enum :left :right :top :bottom]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:position :right},
     :children :any},
    :icon-button
    {:description
     "An icon button — Mantine `ActionIcon` (ADR-graph-ui-v0-013-01 Sec12). Also\n     covers SPEC-002's 'toggle button' row: a toggle is an icon-button with\n     :on set; mutual exclusion among several is the COMPOSING description's\n     concern (each button's :on-gesture clears its siblings), not a second\n     widget kind. :on is a renderer convention (ActionIcon has no native\n     'pressed' prop): true swaps Mantine's `variant` to :filled, false/absent\n     to :subtle. :tooltip wraps the button in Mantine's `Tooltip`. Fires\n     :on-gesture's :submit key on click, same as :button.",
     :status :in-progress,
     :props
     [:map
      [:icon {:optional true} :keyword]
      [:tooltip {:optional true} :string]
      [:on {:optional true} :boolean]
      [:disabled {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :modal
    {:description
     "Mantine `Modal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 21 prop(s), 2 named\n     child slot(s), 3 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"xOffset" "MarginLeft<string | number>",
      "yOffset" "MarginTop<string | number>"},
     :slots [:title],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :with-close-button true,
      :full-screen false,
      :with-overlay true,
      :centered false,
      :shadow :xl,
      :lock-scroll true},
     :mantine {:component "Modal"},
     :status :generated,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:centered
       {:optional true,
        :doc "If set, the modal is centered vertically"}
       :boolean]
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:full-screen
       {:optional true,
        :doc "If set, the modal takes the entire screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:stack-id
       {:optional true, :doc "Id of the modal in the `Modal.Stack`"}
       :string]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is rendered"}
       :boolean]
      [:with-overlay
       {:optional true, :doc "If set, the overlay is rendered"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :accordion
    {:description
     "Mantine `Accordion` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"defaultValue" "AccordionValue<Multiple>",
      "multiple" "Multiple",
      "order" "AccordionHeadingOrder",
      "value" "AccordionValue<Multiple>"},
     :slots [:chevron],
     :defaults
     {:chevron-icon-size 16, :loop true, :transition-duration 200},
     :mantine {:component "Accordion"},
     :status :generated,
     :gestures [:change],
     :props
     [:map
      [:chevron-icon-size
       {:optional true,
        :doc
        "Size of the default chevron icon. Ignored when `chevron` prop is set."}
       [:or :string :int :double]]
      [:chevron-position
       {:optional true,
        :doc "Position of the chevron relative to the item label"}
       [:enum :left :right]]
      [:chevron-size
       {:optional true, :doc "Size of the chevron icon container"}
       [:or :string :int :double]]
      [:disable-chevron-rotation
       {:optional true, :doc "If set, chevron rotation is disabled"}
       :boolean]
      [:loop
       {:optional true,
        :doc
        "If set, arrow keys loop though items (first to last and last to first)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]]},
    :theme-icon
    {:description
     "Mantine `ThemeIcon` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ThemeIcon"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color."}
       [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc "Gradient data used when `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :children :any},
    :title
    {:description
     "Mantine `Title` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Title"},
     :props
     [:map
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which heading will be truncated"}
       [:or :int :double]]
      [:text-wrap
       {:optional true, :doc "Heading `text-wrap` CSS property"}
       [:enum :nowrap :wrap :balance :pretty :stable]]],
     :defaults {:text-wrap :wrap},
     :unmapped {"order" "TitleOrder", "size" "TitleSize"},
     :children :any},
    :skeleton
    {:description
     "Mantine `Skeleton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Skeleton"},
     :props
     [:map
      [:animate {:optional true, :doc "Enables animation"} :boolean]
      [:circle
       {:optional true,
        :doc
        "If set, Skeleton `width` and `border-radius` are equal to its `height`"}
       :boolean]
      [:visible
       {:optional true,
        :doc "Determines whether Skeleton overlay should be displayed"}
       :boolean]
      [:width
       {:optional true,
        :doc
        "Skeleton `width`, numbers are converted to rem, ignored when `circle` prop is set."}
       [:or :string :int :double]]],
     :defaults {:animate true, :circle false, :visible true},
     :unmapped
     {"height" "Height<string | number>",
      "radius" "BorderRadius<string | number>"},
     :children :any},
    :nav-link
    {:description
     "Mantine `NavLink` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 5 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "NavLink"},
     :props
     [:map
      [:active
       {:optional true,
        :doc "Determines whether the link should have active styles"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:children-offset
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set collapsed links `padding-left`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS color to control active styles"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled nested items collapse initial state"}
       :boolean]
      [:disable-right-section-rotation
       {:optional true,
        :doc
        "If set, right section will not be rotated when collapse is opened"}
       :boolean]
      [:disabled
       {:optional true,
        :doc
        "If set, disabled styles will be added to the root element"}
       :boolean]
      [:no-wrap
       {:optional true,
        :doc
        "If set, label and description do not wrap to the next line"}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled nested items collapse state"}
       :boolean]],
     :defaults
     {:active false,
      :children-offset :lg,
      :disable-right-section-rotation false,
      :disabled false,
      :no-wrap false},
     :gestures [:change :click :key-down],
     :slots [:description :label :left-section :right-section],
     :children :any},
    :center
    {:description
     "Mantine `Center` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Center"},
     :props
     [:map
      [:inline
       {:optional true,
        :doc "If set, `inline-flex` is used instead of `flex`"}
       :boolean]],
     :defaults {},
     :children :any},
    :number-input
    {:description
     "Mantine `NumberInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 5 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"handlersRef" "ForwardedRef<NumberInputHandlers>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :hide-controls false,
      :allow-decimal true,
      :allow-negative true,
      :type :text,
      :right-section-pointer-events "none",
      :value-is-numeric-string false,
      :decimal-separator ".",
      :size :sm,
      :allow-leading-zeros true,
      :fixed-decimal-scale false,
      :trim-leading-zeroes-on-blur true,
      :with-asterisk false,
      :start-value 0,
      :with-keyboard-events true,
      :step 1,
      :with-error-styles true,
      :required false},
     :mantine {:component "NumberInput"},
     :status :generated,
     :gestures [:change :value-change],
     :props
     [:map
      [:allow-decimal
       {:optional true, :doc "If set, decimal values are allowed"}
       :boolean]
      [:allow-leading-zeros
       {:optional true,
        :doc
        "Determines whether leading zeros are allowed. If set to `false`, leading zeros are removed when the input value becomes a valid number."}
       :boolean]
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:allowed-decimal-separators
       {:optional true,
        :doc
        "Characters which when pressed result in a decimal separator"}
       [:vector :string]]
      [:clamp-behavior
       {:optional true,
        :doc
        "Controls how value is clamped, `strict` – user is not allowed to enter values that are not in `[min, max]` range, `blur` – user is allowed to enter any values, but the value is clamped when the input loses focus (default behavior), `none` – lifts all restrictions, `[min, max]` range is applied only for controls and up/down keys"}
       [:enum :none :strict :blur]]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that can be entered after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true, :doc "Character used as a decimal separator"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :string :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, 0s are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:hide-controls
       {:optional true, :doc "If set, the up/down controls are hidden"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimum possible value"}
       [:or :int :double]]
      [:prefix
       {:optional true, :doc "Prefix added before the input value"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:start-value
       {:optional true,
        :doc
        "Value set to the input when increment/decrement buttons are clicked or up/down arrows pressed if the input is empty"}
       [:or :int :double]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with up/down controls and keyboard arrows"}
       [:or :int :double]]
      [:step-hold-delay
       {:optional true,
        :doc
        "Initial delay in milliseconds before stepping the value."}
       [:or :int :double]]
      [:suffix
       {:optional true, :doc "Suffix added after the input value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style."}
       [:enum :none :thousand :lakh :wan]]
      [:trim-leading-zeroes-on-blur
       {:optional true,
        :doc
        "If set, leading zeros are removed on blur. For example, `00100` -> `100`"}
       :boolean]
      [:type
       {:optional true, :doc "Controls input `type` attribute"}
       [:enum :text :tel :password]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :string :int :double]]
      [:value-is-numeric-string
       {:optional true,
        :doc
        "If value is passed as string representation of numbers (unformatted) and number is used in any format props like in prefix or suffix in numeric format and format prop in pattern format then this should be passed as `true`."}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-keyboard-events
       {:optional true,
        :doc
        "If set, up/down keyboard events increment/decrement value"}
       :boolean]]},
    :background-image
    {:description
     "Mantine `BackgroundImage` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "BackgroundImage"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src {:optional true, :doc "Image url"} :string]],
     :defaults {:radius 0},
     :children :none},
    :card
    {:description
     "Mantine `Card` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Card"},
     :props
     [:map
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the card"}
       :boolean]],
     :defaults {:padding :md},
     :children :any},
    :divider
    {:description
     "Mantine `Divider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Divider"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default value depends on color scheme"}
       [:or :keyword :string]]
      [:label-position
       {:optional true, :doc "Controls label position"}
       [:enum :center :left :right]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:size
       {:optional true,
        :doc "Controls width/height (depends on orientation)"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults
     {:label-position :center, :orientation :horizontal, :size :xs},
     :slots [:label],
     :children :slots},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n     (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n     Exactly two children: the RESIZABLE/foldable pane and the FILLING\n     pane. :fold-side picks which side the resizable one is on — :left\n     (default) = child 1 is resizable and folds left; :right = child 2 is\n     resizable and folds right. :pane-id is the localStorage key under\n     which THIS pane's width + folded state are remembered. :initial is the\n     resizable pane's starting px width; :min is its floor; :max an\n     optional hard ceiling. :flex-min is the FILLING pane's floor (px).\n     :collapsible shows the fold button.\n\n     :narrow IS THE PHONE (2026-08-20, PLAN-ikc-v3-015-01 phase 6). It is the\n     UNIVERSAL slot of that name, not a prop of this kind — one word for one\n     idea (Rule 1.11), and a second key would have collided with the first in\n     malli's own schema, which is how :font-size came to be named that. This\n     kind honours two of its five values, and DEFAULTS to one of them. Below\n     --viewport-narrow a two-pane split does not fit: :initial 270 plus\n     :flex-min 280 plus the divider is 556px, and the pane's own\n     `overflow-x: auto` then makes the whole island scroll sideways. This\n     prop says which of the two things it does instead.\n\n       :fold   the resizable pane starts FOLDED and the filling pane takes\n               the width. Its fold control is still there, so the sidebar is one\n               tap away — the sidebar becomes a control, which is what a\n               sidebar is on a phone.\n       :stack  both panes as one vertical column, the resizable one first.\n               For a split whose two halves are both content (a source and\n               its preview), where hiding one loses the point.\n       :keep   the desktop split, sideways scroll included. Deliberate, and\n               sayable, for a surface nobody opens on a phone.\n\n     THE DEFAULT IS :fold, and that is a declaration, not an inference\n     (ADR-graph-ui-v0-011-01's own safety net: 'where the renderer can safely\n     default to filling, it should'). The failure mode of forgetting this\n     prop is a page that scrolls sideways under the reader's thumb, so the\n     safe answer is the one a description gets for free. A folded pane is\n     recoverable by one tap. A sideways-scrolled reading column is not\n     recoverable at all until the reader finds it.\n\n     The fold is NOT remembered across the breakpoint. :pane-id's stored\n     fold state is the reader's choice on a wide window, and a phone visit\n     must not overwrite it — so the narrow fold is computed, never stored.",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true,
      :narrow :fold},
     :children :any},
    :chip
    {:description
     "An interactive, selectable pill — Mantine `Chip` (ADR-graph-ui-v0-013-01\n     Sec14). Where :badge is a label with no behaviour, :chip reports its\n     own selected state — the ikc1 #tag filter needs a clickable tag that\n     toggles, which :badge cannot do. Fires :on-gesture's :submit key on\n     toggle, $value = the new selected state (true/false) — mirroring\n     :select's choose->command convention.",
     :status :in-progress,
     :props
     [:map
      [:label :string]
      [:selected {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :overlay
    {:description
     "Mantine `Overlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Overlay"},
     :props
     [:map
      [:background-opacity
       {:optional true,
        :doc
        "Overlay `background-color` opacity 0–1, ignored when `gradient` prop is set"}
       [:or :int :double]]
      [:blur
       {:optional true, :doc "Overlay background blur"}
       [:or :string :int :double]]
      [:center
       {:optional true, :doc "Centers content inside the overlay"}
       :boolean]
      [:color
       {:optional true, :doc "Overlay `background-color`"}
       [:or
        [:enum
         :gray
         :red
         :pink
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :transparent
         :white
         "-moz-initial"
         :inherit
         :initial
         :revert
         :revert-layer
         :unset
         :aliceblue
         :antiquewhite
         :aqua
         :aquamarine
         :azure
         :beige
         :bisque
         :black
         :blanchedalmond
         :blueviolet
         :brown
         :burlywood
         :cadetblue
         :chartreuse
         :chocolate
         :coral
         :cornflowerblue
         :cornsilk
         :crimson
         :darkblue
         :darkcyan
         :darkgoldenrod
         :darkgray
         :darkgreen
         :darkgrey
         :darkkhaki
         :darkmagenta
         :darkolivegreen
         :darkorange
         :darkorchid
         :darkred
         :darksalmon
         :darkseagreen
         :darkslateblue
         :darkslategray
         :darkslategrey
         :darkturquoise
         :darkviolet
         :deeppink
         :deepskyblue
         :dimgray
         :dimgrey
         :dodgerblue
         :firebrick
         :floralwhite
         :forestgreen
         :fuchsia
         :gainsboro
         :ghostwhite
         :gold
         :goldenrod
         :greenyellow
         :grey
         :honeydew
         :hotpink
         :indianred
         :ivory
         :khaki
         :lavender
         :lavenderblush
         :lawngreen
         :lemonchiffon
         :lightblue
         :lightcoral
         :lightcyan
         :lightgoldenrodyellow
         :lightgray
         :lightgreen
         :lightgrey
         :lightpink
         :lightsalmon
         :lightseagreen
         :lightskyblue
         :lightslategray
         :lightslategrey
         :lightsteelblue
         :lightyellow
         :limegreen
         :linen
         :magenta
         :maroon
         :mediumaquamarine
         :mediumblue
         :mediumorchid
         :mediumpurple
         :mediumseagreen
         :mediumslateblue
         :mediumspringgreen
         :mediumturquoise
         :mediumvioletred
         :midnightblue
         :mintcream
         :mistyrose
         :moccasin
         :navajowhite
         :navy
         :oldlace
         :olive
         :olivedrab
         :orangered
         :orchid
         :palegoldenrod
         :palegreen
         :paleturquoise
         :palevioletred
         :papayawhip
         :peachpuff
         :peru
         :plum
         :powderblue
         :purple
         :rebeccapurple
         :rosybrown
         :royalblue
         :saddlebrown
         :salmon
         :sandybrown
         :seagreen
         :seashell
         :sienna
         :silver
         :skyblue
         :slateblue
         :slategray
         :slategrey
         :snow
         :springgreen
         :steelblue
         :tan
         :thistle
         :tomato
         :turquoise
         :wheat
         :whitesmoke
         :yellowgreen
         :AccentColor
         :AccentColorText
         :ActiveText
         :ButtonBorder
         :ButtonFace
         :ButtonText
         :Canvas
         :CanvasText
         :Field
         :FieldText
         :GrayText
         :Highlight
         :HighlightText
         :LinkText
         :Mark
         :MarkText
         :SelectedItem
         :SelectedItemText
         :VisitedText
         :ActiveBorder
         :ActiveCaption
         :AppWorkspace
         :Background
         :ButtonHighlight
         :ButtonShadow
         :CaptionText
         :InactiveBorder
         :InactiveCaption
         :InactiveCaptionText
         :InfoBackground
         :InfoText
         :Menu
         :MenuText
         :Scrollbar
         :ThreeDDarkShadow
         :ThreeDFace
         :ThreeDHighlight
         :ThreeDLightShadow
         :ThreeDShadow
         :Window
         :WindowFrame
         :WindowText
         :currentColor]
        :string]]
      [:fixed
       {:optional true, :doc "Changes position to `fixed`"}
       :boolean]
      [:gradient
       {:optional true,
        :doc
        "Changes overlay to gradient. If set, `color` prop is ignored."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:z-index
       {:optional true, :doc "Overlay z-index"}
       [:or :string :int :double]]],
     :defaults
     {:background-opacity 0.6,
      :blur 0,
      :center false,
      :fixed false,
      :radius 0,
      :z-index 200},
     :children :any},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session —\n     every bus command dispatched (with its round-trip ms) and the\n     client-only UI events that never reach the bus, newest last. Purely a\n     CLIENT-side observability surface: reads a client ring-buffer directly,\n     never a bus :source. Web-only; the TUI renders a labelled placeholder.\n     :slow-ms marks any dispatch at/above it as slow (tone shift).",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none},
    :file-button
    {:description
     "Mantine `FileButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "FileButton", :children :function},
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:disabled
       {:optional true, :doc "Disables file picker"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:name {:optional true, :doc "Input name attribute"} :string]],
     :defaults {},
     :gestures [:change],
     :unmapped {"multiple" "Multiple"},
     :children :any},
    :list
    {:description
     "A vertical list; each item renders on its own line. :items is optional:\n     a bound :list gets its items from a source. An item is now a MAP\n     (ADR-graph-ui-v0-013-01 Sec17, legal because v2.0 is a major): {:label\n     string :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean} — covers the SPEC-002\n     'nav row' gap (icon + ellipsised text + trailing accessory, active/dim\n     states). {:label \"Foo\"} alone renders identically to a bare string\n     under v1.x, so the common case stays exactly as terse. :empty-label:\n     shown in place of a silently-blank pane when :items resolves to an\n     empty vector. :value (ADR-graph-ui-v0-013-01 Sec24): the item's click target,\n     substituted as $value into the dispatched command. It was MISSING from\n     this closed map while every source already returned it — invisible only\n     because BOUND items skip props validation, so a literal-authored item\n     carrying :value was rejected while the identical item from a source was\n     accepted. Declared now so model and code agree by agreeing, not because\n     one of them is never checked.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none},
    :scroll-area
    {:description
     "A scrolling viewport — Mantine `ScrollArea` (ADR-graph-ui-v0-013-01 Sec22).\n     This closes an AC-1 gap, not a styling one: WHAT SCROLLS was hardcoded\n     per widget in the renderer (:outline, :tree and :list each carried their\n     own overflow-y-auto), so no description could say 'this pane scrolls as\n     one document' — a capability reachable only through bespoke renderer\n     code, which is what AC-1 forbids.\n\n     It is also a known, still-open defect rather than a new observation:\n     graph_ui/web/render.cljs records (2026-07-14) that adding min-h-0 to the\n     SHARED root, to give descendants a bounded scroll box, collapsed the\n     content pane entirely against the real vault, was reverted, and left the\n     app unable to scroll long pages — with the fix explicitly deferred to\n     'the content pane's own flex chain'. Naming the scrolling box in the\n     description IS that fix: the renderer stops having to guess on a root it\n     shares with every island.\n\n     :type and :scrollbars are Mantine's own enums verbatim.\n     :scrollbarSize/:offsetScrollbars are not adopted — no consumer needs\n     them. A :scroll-area needs a bounded height to scroll WITHIN, so it\n     normally carries :flex 1 inside a :stack that has one.",
     :status :in-progress,
     :props
     [:map
      [:type
       {:optional true}
       [:enum :auto :always :scroll :hover :never]]
      [:scrollbars {:optional true} [:enum :x :y :xy :none]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:type :hover, :scrollbars :y},
     :children :any},
    :semi-circle-progress
    {:description
     "Mantine `SemiCircleProgress` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 9 prop(s), 1\n     named child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic\n     drives the component named above straight from this declaration — the\n     props here are the legal ones, the gestures here are the wired ones, and\n     nothing else reaches the DOM. Generic is not finished: this kind has no\n     data binding, no edit buffer and no selection state of its own. A kind\n     that needs one of those graduates to a hand-written widget and an explicit\n     case in render.cljs — move it above the GENERATED marker and give it a\n     description that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine\n     declares no `children` for this component, so a child is admitted solely\n     to fill one of the named slots above, saying which with :section. A child\n     that names no slot is not body content here — there is no body to put it\n     in.",
     :status :generated,
     :mantine {:component "SemiCircleProgress"},
     :props
     [:map
      [:empty-segment-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default the value is determined based on the color scheme value"}
       [:or :keyword :string]]
      [:fill-direction
       {:optional true,
        :doc "Direction from which the circle is filled"}
       [:enum :right-to-left :left-to-right]]
      [:filled-segment-color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Label position relative to the circle center"}
       [:enum :center :bottom]]
      [:orientation
       {:optional true, :doc "Orientation of the circle"}
       [:enum :up :down]]
      [:size
       {:optional true, :doc "Diameter of the svg in px"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Circle thickness in px"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Progress value from `0` to `100`"}
       [:or :int :double]]],
     :defaults
     {:fill-direction :left-to-right,
      :label-position :bottom,
      :orientation :up,
      :size 200,
      :thickness 12,
      :transition-duration 0},
     :slots [:label],
     :children :slots},
    :pagination
    {:description
     "Mantine `Pagination` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 5\n     gesture(s), and 5 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "Pagination"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:boundaries
       {:optional true,
        :doc "Number of elements visible on the left/right edges"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc "Key of `theme.colors`, active item color"}
       [:or :keyword :string]]
      [:default-value
       {:optional true,
        :doc
        "Active page for uncontrolled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Disables all controls, applies disabled styles"}
       :boolean]
      [:gap
       {:optional true,
        :doc "Key of `theme.spacing`, gap between controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:hide-with-one-page
       {:optional true,
        :doc
        "If set, the pagination is hidden when only one page is available (`total={1}`)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:siblings
       {:optional true,
        :doc
        "Number of siblings displayed on the left/right side of the selected page"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "`height` and `min-width` of controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:total
       {:optional true,
        :doc "Total number of pages, must be an integer"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Active page for controlled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:with-controls
       {:optional true,
        :doc "If set, next/previous controls are displayed"}
       :boolean]
      [:with-edges
       {:optional true,
        :doc "If set, first/last controls are displayed"}
       :boolean]
      [:with-pages
       {:optional true,
        :doc "If set to `false`, pages controls are hidden"}
       :boolean]],
     :defaults
     {:boundaries 1,
      :gap 8,
      :hide-with-one-page false,
      :siblings 1,
      :size :md,
      :with-controls true,
      :with-edges false,
      :with-pages true},
     :gestures
     [:change :first-page :last-page :next-page :previous-page],
     :unmapped
     {"dotsIcon" "PaginationIcon",
      "firstIcon" "PaginationIcon",
      "lastIcon" "PaginationIcon",
      "nextIcon" "PaginationIcon",
      "previousIcon" "PaginationIcon"},
     :children :none},
    :color-input
    {:description
     "A swatch-picker input — Mantine `ColorInput` (ADR-graph-ui-v0-013-01\n     Sec16), the theme editor's field. :value is a CSS colour string (hex,\n     as the theme tokens already are — ADR-graph-ui-v0-009-01). Fires\n     :on-gesture's :submit key on change, $value = the picked colour — the\n     same input->command shape :input/:select already use.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :avatar
    {:description
     "Mantine `Avatar` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Avatar"},
     :props
     [:map
      [:allowed-initials-colors
       {:optional true,
        :doc
        "A list of colors that is used for autogenerated initials. By default, all default Mantine colors can be used except gray and dark."}
       [:vector :any]]
      [:alt
       {:optional true,
        :doc
        "Image `alt` attribute, also used as `title` attribute for placeholder"}
       :string]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or
        [:enum
         :dark
         :gray
         :red
         :pink
         :grape
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :initials]
        :string]]
      [:gradient
       {:optional true,
        :doc "Gradient configuration for `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:name
       {:optional true,
        :doc
        "Name of the user. When `src` is not set, used to display initials and to generate color when `color=\"initials\"` is set."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Width and height of the avatar, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src
       {:optional true,
        :doc
        "Image url, if the image cannot be loaded or `src={null}`, then placeholder is displayed instead"}
       :string]],
     :defaults {:color :gray, :radius "1000px", :size :md},
     :children :any},
    :text-input
    {:description
     "Mantine `TextInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "TextInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :highlight-list
    {:description
     "The document's highlights, listed beside it — ikc1's right gutter\n     (F-platform-v0-011-01, ADR-graph-ui-v0-017-01 §5). One row per highlight: a\n     dot in the highlight's own colour, the level badge when a level is set, the\n     marked text on ONE line (truncated, because a chunk-sized highlight is\n     paragraphs long and the gutter is a column), the note when there is one, and\n     an X that removes it, and — when the description wires a :link gesture — a\n     control that copies a wikilink to that mark, for pasting into a note.\n\n     THREE ACTS, AND NONE IS ANOTHER (2026-08-24). A row's click GOES to the\n     words. The link control COPIES a link. The X REMOVES it. George asked for\n     that split by name: \"without this click on bookmark to delete it, have some\n     more narrow way to delete it\".\n\n     NOT NAMED :highlight, which is taken — the generated Mantine `Highlight`\n     kind below marks substrings matching a search term and is unrelated. Two\n     things called highlight in one closed vocabulary would be a trap for every\n     later reader.\n\n     :items is the bound prop and its shape is :highlights/for-page's result\n     VERBATIM, whichever storage served it: a native page's highlights arrive as\n     block-relative and a vault page's as file-relative, and this widget cannot\n     tell, which is the point (ADR-ikc-v3-064-01 §3).\n\n     ORPHANED ROWS STAY LISTED, dimmed. A highlight whose text has been edited\n     away is a fact worth seeing — 'you marked this and it is gone' — and hiding\n     it would be the one behaviour that loses information silently\n     (CONCEPT-ikc-v3-008-01).\n\n     ONE GESTURE, :remove, $value = the row's :id. Creating a highlight is not a\n     gutter affordance: you make one by selecting text in the document, so there\n     is deliberately no empty-state gesture here and no :empty-reachable entry\n     below — a gutter with nothing in it is a document with nothing marked, and\n     the way out is in the document, not the gutter.\n\n     :title IS OPTIONAL AND MEANS A HEADER. Without one the column draws no\n     caption — which is what the reading area asks for, because the gutter sits\n     directly beside the text with each row level with the words it marks, and a\n     caption over that labels the self-evident. It captioned itself\n     unconditionally while it was a panel out at the pane's right edge; George\n     struck that panel through on 2026-08-16, saying the highlight in it\n     'belongs to the right gutter'. THE RIGHT GUTTER IS THIS, AND THERE IS ONLY\n     ONE — the per-row `2 hl` chip column that briefly sat between the text and\n     this one is gone (see the :outline kind).",
     :status :in-progress,
     :props
     [:map
      [:level-with-text {:optional true} :boolean]
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:block-id {:optional true} :string]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:title {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:chrome {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:chrome true},
     :children :none},
    :container
    {:description
     "A centred, max-width content column — Mantine `Container`\n     (ADR-graph-ui-v0-013-01 Sec20). SPEC-graph-ui-v0-002-01's locked target\n     centres its reading pane in a `max-width: 900px` column; nothing else in\n     v2.0 can say that, so a reading UI otherwise runs its prose edge-to-edge\n     on a wide monitor — a legibility defect, not a cosmetic one, in the\n     island whose whole purpose is reading.\n\n     :size is Mantine's own max-width scale: :xs 540 / :sm 720 / :md 960 /\n     :lg 1140 / :xl 1320 pixels, read from the shipped styles.css rather than\n     recalled. (Corrected 2026-07-28: this rule first said :md 768 / :lg 992,\n     which are Mantine's BREAKPOINT values, not its container sizes. The error\n     put the reading column at 1140px — wider than the target instead of nearer\n     it.) :fluid takes the parent's full width and ignores :size.\n\n     OPEN SINCE ADR-graph-ui-v0-001-01. :size also accepts a NUMBER (pixels) or any\n     CSS length string, which is Mantine's own documented contract — the size\n     prop accepts any valid CSS value or a number. It was closed to five tokens\n     by 057-01 Sec0, and that clamp is what this declaration used to confess to:\n     'the enum cannot express 900 exactly, which is the standing trade'.\n\n     The trade was worse than lossy. CONCEPT-graph-ui-v0-009-01 defines measure\n     as Bringhurst does — the length of a line counted in CHARACTERS — and a\n     measure in pixels is not a measure: change the type size and the line\n     length moves while :md does not. So a reading column says {:size \"66ch\"}\n     and means it, instead of naming the nearest breakpoint token and hoping.\n     The tokens remain valid and remain the ordinary case for non-prose widths.\n\n     The renderer lays a :container out as a flex COLUMN, so that a child\n     carrying :flex 1 fills it. Mantine's Container is a plain block element,\n     and a :flex 1 child inside a block parent silently falls back to its own\n     content height (measured: a 180px reading pane inside a 986px column). Mantine's :strategy ('block' | 'grid') is deliberately NOT\n     adopted: no consumer needs grid-centring, and an unused prop is a\n     promise the renderer has to keep.",
     :status :in-progress,
     :props
     [:map
      [:size
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:fluid {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:size :lg},
     :children :any},
    :indicator
    {:description
     "Mantine `Indicator` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Indicator"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:disabled
       {:optional true, :doc "If set, the indicator is hidden"}
       :boolean]
      [:inline
       {:optional true,
        :doc
        "Determines whether the indicator container should be an inline element"}
       :boolean]
      [:offset
       {:optional true,
        :doc
        "Indicator offset relative to the target element, usually used for elements with border-radius"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Indicator position relative to the target element"}
       [:enum
        :top-end
        :top-start
        :bottom-end
        :bottom-start
        :top-center
        :bottom-center
        :middle-center
        :middle-end
        :middle-start]]
      [:processing
       {:optional true,
        :doc "If set, the indicator has processing animation"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Indicator width and height"}
       [:or :string :int :double]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:z-index
       {:optional true, :doc "Indicator z-index"}
       [:or :string :int :double]]],
     :defaults
     {:inline false,
      :position :top-end,
      :processing false,
      :radius 100,
      :size 10,
      :z-index 200},
     :slots [:label],
     :children :slots},
    :stack
    {:description
     "Vertical stack — Mantine `Stack`, the common default arrangement\n     (ADR-graph-ui-v0-013-01 Sec0). :gap/:align/:justify keep Mantine's names;\n     values closed (Sec0).",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any},
    :outline
    {:description
     "ADR-graph-ui-v0-006-01: a flat, :order-sorted list of typed blocks, nested\n     VISUALLY by each item's :depth (never a real tree — the native\n     block-frame engine keeps every block a flat :child-of child of its\n     page). :items is optional: a bound :outline gets its list from a\n     source (:block-outline). Each item is {:block-id uuid-str :block-type\n     kw :content string :order number :depth int :checked? bool :collapsed?\n     bool}.\n\n     THERE IS NO :meta PROP. ADR-graph-ui-v0-013-01 Sec17 accepted one — a\n     trailing chip/badge gutter, third track in every row, captured from ikc1\n     by SPEC-graph-ui-v0-002-01 (`30px / 1fr / 132px`). Removed 2026-08-15,\n     George: \"What is this invented meta-gutter? The right gutter is the place\n     for meta information, no extra gutters.\" ikc3 has one margin beside the\n     document (F-platform-v0-011-01) that ikc1 did not, and meta about a block\n     belongs there; two gutters is two places to look for one kind of thing.\n     Nothing ever emitted :meta in production, so nothing is lost — the\n     reversal is recorded in that same ADR's Sec17. A deeper\n     item whose ancestor has :collapsed? true is hidden by the renderer, not\n     the source. Dispatches :on-gesture's named keys (ADR-graph-ui-v0-013 Sec7-8,\n     replacing v1.x's :actions): :indent/:outdent/:toggle-done/\n     :toggle-collapse/:delete/:insert-after/:update-text/:insert-first.\n     $value's meaning is still per gesture key (row actions: the acted-on\n     item's :block-id; :update-text: the edited text) but documented once, on\n     :on-gesture itself, not re-derived here.\n\n     :insert-first is the EMPTY state's gesture, and the only one that fires\n     when there are no items. Every other gesture acts on a row, so a page with\n     no blocks could not be given one: :insert-after needs a block to insert\n     after, and the empty state rendered as inert text. A note editor that\n     cannot accept its first character is not an editor, and the gap was\n     invisible until a wiped graph produced an empty page (2026-08-03). It\n     carries no $value — the target page is the session's selected one, which\n     the handler resolves, because the empty state has no row to name it.\n\n     :row-menu declares WHICH of the gestures above a row offers, in what order,\n     and how each is labelled. One list, rendered twice: as the hover strip on a\n     row and as the right-click context menu over it. Before this the strip was\n     four buttons hand-written in widgets.cljs, so adding an action cost three\n     edits in three languages — a command in this manifest, a gesture in the\n     description, and a button in ClojureScript. The gestures were declared; only\n     their PRESENTATION was not (2026-08-03).\n\n     Each entry is {:gesture <a key of this node's :on-gesture> :label <string>\n     :icon <string, optional> :tone <token, optional> :divider-before <bool,\n     optional>} — deliberately the same :label/:gesture/:tone shape v2.0's :menu\n     items use, so the two read alike. :row-menu is not a :menu widget, though:\n     a menu over a ROW must act on THAT row, and :menu's items have no notion of\n     which row they are over. The outline's gestures already carry the row id\n     through $value, so the same list renders as both the hover strip and the\n     right-click menu without any selected-block state to feed it. validate-dsl fails an entry naming a gesture the node does not\n     wire — a menu item that dispatches nothing looks identical to one that\n     works until it is clicked.\n\n     Omitting :row-menu means NO row affordances, which is a real choice for a\n     read-only outline rather than a reason to fall back to a built-in default:\n     a hidden default is how the hardcoded strip survived unnoticed.\n\n     :slash-menu declares the commands a row offers when its text begins with\n     '/' — the outliner idiom where typing turns a block into a to-do, a\n     separator, or a date without leaving the keyboard. Same shape as :row-menu\n     with one addition: :trigger is what you type after the slash, and what the\n     list filters on as you keep typing.\n\n     Each entry is {:trigger <string> :gesture <a key of :on-gesture>\n     :label <string> :icon <string, optional>}. validate-dsl fails an entry\n     naming a gesture the node does not wire, and fails two entries sharing a\n     :trigger — an ambiguous trigger picks one silently, and which one depends\n     on map ordering nobody declared.\n\n     The gesture's own template carries whatever the command needs (/todo and\n     /--- are both :ui/set-block-type with different literal :block-type args),\n     so a new slash command is usually a gesture plus a line here, and no\n     renderer change at all.\n\n     TUI renders read-only (gutters/numbering only, no dispatch).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:highlights {:optional true} [:vector [:map-of :keyword :any]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]]]]
      [:slash-menu
       {:optional true}
       [:vector
        [:map
         [:trigger :string]
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]]]]],
     :defaults {},
     :children :none},
    :typography
    {:description
     "Mantine `Typography` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Typography"},
     :props [:map],
     :defaults {},
     :children :any},
    :angle-slider
    {:description
     "Mantine `AngleSlider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "AngleSlider"},
     :props
     [:map
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `data-disabled` attribute, disables interactions"}
       :boolean]
      [:marks
       {:optional true, :doc "Array of marks displayed on the slider"}
       [:vector :any]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:restrict-to-marks
       {:optional true,
        :doc
        "If set, the selection is allowed only from the given marks array"}
       :boolean]
      [:size
       {:optional true, :doc "Slider size in px"}
       [:or :int :double]]
      [:step
       {:optional true, :doc "Step between values"}
       [:or :int :double]]
      [:thumb-size
       {:optional true,
        :doc
        "Size of the thumb in px. Calculated based on the `size` value by default."}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]
      [:with-label
       {:optional true,
        :doc "If set, the label is displayed inside the slider"}
       :boolean]],
     :defaults {:restrict-to-marks false, :step 1, :with-label true},
     :gestures [:change :change-end :scrub-end :scrub-start],
     :children :none},
    :dialog
    {:description
     "Mantine `Dialog` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Dialog"},
     :props
     [:map
      [:keep-mounted
       {:optional true,
        :doc
        "If set, dialog is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:opened {:optional true, :doc "Opened state"} :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls `width` of the dialog"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is displayed"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]],
     :defaults
     {:size :md,
      :with-close-button true,
      :within-portal true,
      :z-index 200},
     :gestures [:close],
     :unmapped {"position" "AffixPosition"},
     :children :any},
    :pills-input
    {:description
     "Mantine `PillsInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "PillsInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots},
    :combobox
    {:description
     "Mantine `Combobox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 6 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Combobox"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "Determines whether the `Combobox` value can be changed"}
       :boolean]
      [:reset-selection-on-option-hover
       {:optional true,
        :doc
        "Determines whether selection should be reset when option is hovered"}
       :boolean]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true,
        :doc "Controls items `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:reset-selection-on-option-hover false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :floating-strategy :absolute,
      :arrow-offset 5,
      :size :sm,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :option-submit
      :position-change],
     :unmapped
     {"dropdownPadding" "Padding<string | number>",
      "middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "store" "ComboboxStore",
      "width" "PopoverWidth"},
     :children :any},
    :image
    {:description
     "Mantine `Image` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "Image"},
     :props
     [:map
      [:fallback-src
       {:optional true,
        :doc
        "Image url used as a fallback if the image cannot be loaded"}
       :string]
      [:fit
       {:optional true, :doc "Controls `object-fit` style"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :fill
        :none
        :contain
        :cover
        :scale-down]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:fit :cover, :radius 0},
     :gestures [:error],
     :unmapped {"src" "any"},
     :children :none},
    :autocomplete
    {:description
     "Mantine `Autocomplete` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 27 prop(s), 5 named\n     child slot(s), 5 gesture(s), and 3 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"data" "ComboboxStringData",
      "filter" "OptionsFilter",
      "renderOption" "RenderAutocompleteOption"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :auto-select-on-blur false,
      :open-on-focus true,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "Autocomplete"},
     :status :generated,
     :gestures
     [:change :clear :dropdown-close :dropdown-open :option-submit],
     :props
     [:map
      [:auto-select-on-blur
       {:optional true,
        :doc
        "If set, the highlighted option is selected when the input loses focus"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed when the component has a value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-value
       {:optional true,
        :doc "Default value for uncontrolled component"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :hover-card
    {:description
     "Mantine `HoverCard` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 32 prop(s), 1 named\n     child slot(s), 6 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "HoverCard"},
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:initially-opened
       {:optional true, :doc "Initial opened state"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:variant {:optional true} :string]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :children :any},
    :anchor
    {:description
     "Mantine `Anchor` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Anchor"},
     :props
     [:map
      [:color {:optional true} [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]
      [:underline
       {:optional true,
        :doc
        "Defines when `text-decoration: underline` styles are applied."}
       [:enum :always :hover :not-hover :never]]],
     :defaults {:inherit false, :inline false, :size :md},
     :children :any},
    :stepper
    {:description
     "Mantine `Stepper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Stepper"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active step"}
       [:or :int :double]]
      [:allow-next-steps-select
       {:optional true, :doc "If set, next steps can be selected"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls colors of active and progress steps"}
       [:or :keyword :string]]
      [:completed-icon
       {:optional true,
        :doc
        "Step icon displayed when step is completed, check icon by default"}
       :boolean]
      [:content-padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `padding-top` of the content"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:icon
       {:optional true,
        :doc "Step icon, default value is `step index + 1`"}
       :boolean]
      [:icon-position
       {:optional true, :doc "Icon position relative to the step body"}
       [:enum :left :right]]
      [:icon-size
       {:optional true,
        :doc
        "Controls size of the step icon, by default icon size is inferred from `size` prop"}
       [:or :string :int :double]]
      [:orientation
       {:optional true, :doc "Stepper orientation"}
       [:enum :horizontal :vertical]]
      [:progress-icon
       {:optional true,
        :doc
        "Step icon displayed when step is in progress, default value is `step index + 1`"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set steps border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls size of various Stepper elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:wrap
       {:optional true,
        :doc
        "Determines whether steps should wrap to the next line if no space is available"}
       :boolean]],
     :defaults
     {:allow-next-steps-select true,
      :icon-position :left,
      :orientation :horizontal,
      :radius :xl,
      :wrap true},
     :gestures [:step-click],
     :children :any},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer and,\n     on Enter, dispatches :on-gesture's :submit key (ADR-graph-ui-v0-013-01\n     Sec7-8, replacing v1.x's :on-submit). :leading-icon (ADR-graph-ui-v0-013 Sec17): an\n     optional :icon name shown at the input's leading edge — Mantine's\n     `leftSection`, the search field's magnifying glass. :state: a\n     validation/enablement hint — :invalid highlights the field, :disabled\n     greys it out and blocks edits. :variant (ADR-graph-ui-v0-013-01 Sec21):\n     Mantine's own InputVariant enum verbatim ('default' | 'filled' |\n     'unstyled'). :unstyled drops the field chrome, so an editable page title\n     paired with the universal :size :h1 reads as a HEADING rather than as a\n     form control — the locked target's 27px editable h1, expressed entirely\n     in Mantine's vocabulary rather than an ikc3 invention.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:leading-icon {:optional true} :keyword]
      [:variant {:optional true} [:enum :default :filled :unstyled]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :timeline
    {:description
     "Mantine `Timeline` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Timeline"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active element"}
       [:or :int :double]]
      [:align
       {:optional true,
        :doc "Position of content relative to the bullet"}
       [:enum :left :right]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:bullet-size
       {:optional true, :doc "Size of the bullet"}
       [:or :string :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to control active item colors"}
       [:or :keyword :string]]
      [:line-width
       {:optional true, :doc "Control width of the line"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:reverse-active
       {:optional true,
        :doc
        "If set, the active items direction is reversed without reversing items order"}
       :boolean]],
     :defaults
     {:align :left,
      :bullet-size 20,
      :radius :xl,
      :reverse-active false},
     :children :any},
    :password-input
    {:description
     "Mantine `PasswordInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"visibilityToggleIcon" "FC<{ reveal: boolean; }>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "PasswordInput"},
     :status :generated,
     :gestures [:visibility-change],
     :props
     [:map
      [:default-visible
       {:optional true,
        :doc "If set, the input value is visible by default"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:visible
       {:optional true,
        :doc "If set, the input value is visible visible"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :progress
    {:description
     "Mantine `Progress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Progress"},
     :props
     [:map
      [:animated
       {:optional true,
        :doc
        "If set, the sections stripes are animated, `striped` prop is ignored"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS value"}
       [:or :keyword :string]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls track height"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:striped
       {:optional true, :doc "If set, the section has stripes"}
       :boolean]
      [:transition-duration
       {:optional true,
        :doc
        "Controls sections width transition duration, value is specified in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Value of the progress"}
       [:or :int :double]]],
     :defaults
     {:animated false,
      :orientation :horizontal,
      :size :md,
      :striped false,
      :transition-duration 100},
     :children :none},
    :badge
    {:description
     "A static label pill — Mantine `Badge` (ADR-graph-ui-v0-013-01 Sec13). Also\n     covers the 'status LED' row: :label absent + :circle true + a small\n     implicit size IS a state-coloured dot, deliberately not a seventh\n     kind. Non-interactive — no :on-gesture.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:circle {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none},
    :table-of-contents
    {:description
     "Mantine `TableOfContents` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "TableOfContents"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:depth-offset
       {:optional true,
        :doc
        "Controls padding on the left side of control, multiplied by (`depth` - `minDepthToOffset`), `20px` by default"}
       [:or :string :int :double]]
      [:initial-data
       {:optional true,
        :doc
        "Data used to render content until actual values are retrieved from the DOM"}
       [:vector :any]]
      [:min-depth-to-offset
       {:optional true,
        :doc
        "Minimum `depth` value that requires offset, `1` by default"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls font-size and padding of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :unmapped {"scrollSpyOptions" "UseScrollSpyOptions"},
     :children :none},
    :breadcrumbs
    {:description
     "Mantine `Breadcrumbs` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Breadcrumbs"},
     :props
     [:map
      [:separator-margin
       {:optional true,
        :doc "Controls spacing between separator and breadcrumb"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:separator-margin :xs},
     :slots [:separator],
     :children :any},
    :pin-input
    {:description
     "Mantine `PinInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 22 prop(s), 2\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "PinInput"},
     :props
     [:map
      [:aria-label
       {:optional true, :doc "`aria-label` attribute"}
       :string]
      [:auto-focus
       {:optional true,
        :doc
        "If set, the first input is focused when component is mounted"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true, :doc "Adds disabled attribute to all inputs"}
       :boolean]
      [:error
       {:optional true,
        :doc
        "Sets `aria-invalid` attribute and applies error styles to all inputs"}
       :boolean]
      [:form
       {:optional true, :doc "Hidden input `form` attribute"}
       :string]
      [:gap
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `gap` between inputs, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:id
       {:optional true,
        :doc "Base id used to generate unique ids for inputs"}
       :string]
      [:input-mode
       {:optional true,
        :doc
        "`inputmode` attribute, inferred from the `type` prop if not specified"}
       [:enum :search :text :none :tel :email :url :numeric :decimal]]
      [:input-type
       {:optional true,
        :doc
        "Inputs `type` attribute, inferred from the `type` prop if not specified"}
       [:or
        [:enum
         :number
         :button
         :search
         :time
         :image
         :text
         :hidden
         :color
         :radio
         :checkbox
         :tel
         :password
         :date
         :datetime-local
         :email
         :file
         :month
         :range
         :reset
         :submit
         :url
         :week]
        :string]]
      [:length
       {:optional true, :doc "Number of inputs"}
       [:or :int :double]]
      [:manage-focus
       {:optional true,
        :doc
        "Determines whether focus should be moved automatically to the next input once filled"}
       :boolean]
      [:mask
       {:optional true, :doc "Changes input type to `\"password\"`"}
       :boolean]
      [:name
       {:optional true, :doc "Hidden input `name` attribute"}
       :string]
      [:one-time-code
       {:optional true,
        :doc
        "Determines whether `autocomplete=\"one-time-code\"` attribute should be set on all inputs"}
       :boolean]
      [:placeholder
       {:optional true, :doc "Inputs placeholder"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true, :doc "If set, the user cannot edit the value"}
       :boolean]
      [:size
       {:optional true, :doc "Controls inputs `width` and `height`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Determines which values can be entered"}
       [:or [:enum :number :alphanumeric] :string]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]],
     :defaults
     {:mask false,
      :one-time-code true,
      :placeholder "○",
      :type :alphanumeric,
      :size :sm,
      :manage-focus true,
      :gap :md,
      :length 4,
      :auto-focus false},
     :gestures [:change :complete],
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :children :none},
    :code-view
    {:description
     "A whole source FILE, shown the way an editor shows one: syntax colour, line\n     numbers, code folding, and the corpus ids and handler symbols inside the\n     text rendered as links that navigate to the frames they name. Read-only.\n     :value is the file body and :language the grammar to colour it with, both\n     normally bound to a source rather than written in the description. The TUI\n     renders it as plain monospaced text, as it does every code widget here.\n\n     Distinct from :code-block, which is a snippet inside a document and needs\n     only colour.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:line-numbers {:optional true} :boolean]
      [:folding {:optional true} :boolean]
      [:links
       {:optional true}
       [:vector [:map [:text :string] [:frame-id :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:line-numbers true, :folding true},
     :children :none},
    :json-input
    {:description
     "Mantine `JsonInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 6 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "JsonInput"},
     :props
     [:map
      [:autosize
       {:optional true,
        :doc
        "If set, enables textarea height growing with its content"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:format-on-blur
       {:optional true,
        :doc
        "Determines whether the value should be formatted on blur"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max-rows
       {:optional true,
        :doc
        "Maximum rows for autosize textarea to grow, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:min-rows
       {:optional true,
        :doc
        "Minimum rows of autosize textarea, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:resize
       {:optional true, :doc "Controls `resize` CSS property"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :inline
        :none
        :block
        :horizontal
        :vertical
        :both]]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:autosize false,
      :left-section-pointer-events "none",
      :format-on-blur false,
      :right-section-pointer-events "none",
      :resize :none,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :gestures [:change],
     :slots
     [:description
      :error
      :label
      :left-section
      :right-section
      :validation-error],
     :children :slots},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is\n     a vector of {:label <string> :gesture <keyword> :tone <token,\n     optional> :disabled <bool, optional>} maps (ADR-graph-ui-v0-013-01 Sec9,\n     replacing v1.x's per-item :command/:with): :gesture names a key in\n     this SAME node's :on-gesture map, where the actual command template\n     lives, authored once alongside every other gesture the node carries.\n     Clicking an item dispatches its named :on-gesture entry — $session-id\n     substituted, plus whatever :with that entry's template carries.\n     Distinct from :list (plain display) and :button (one action): :menu is\n     a grouped set of commands. Web-only interactive; the TUI renders the\n     item labels as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:gesture {:optional true} :keyword]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:disabled {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none},
    :tooltip
    {:description
     "Mantine `Tooltip` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 5 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"events" "{ hover: boolean; focus: boolean; touch: boolean; }",
      "middlewares" "TooltipMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "target" "string | HTMLElement | RefObject<HTMLElement>"},
     :slots [:label],
     :defaults
     {:arrow-offset 5,
      :arrow-radius 0,
      :arrow-size 4,
      :close-delay 0,
      :floating-strategy :absolute,
      :with-arrow false},
     :mantine {:component "Tooltip"},
     :status :generated,
     :gestures [:position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position relative to the tooltip"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls tooltip background, by default set based on current color scheme"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled tooltip initial opened state"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, tooltip element will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:inline
       {:optional true,
        :doc "Must be set if the tooltip target is an inline element"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the tooltip is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:multiline
       {:optional true,
        :doc
        "Determines whether content should be wrapped on to the next line, `false` by default"}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:opened
       {:optional true, :doc "Controlled opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc
        "Tooltip position relative to target element (`Tooltip` component) or mouse (`Tooltip.Floating` component)"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:ref-prop
       {:optional true,
        :doc
        "Key of the prop that can be used to access element ref, `ref` by default"}
       :string]
      [:with-arrow
       {:optional true, :doc "If set, the tooltip has an arrow"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether tooltip should be rendered within `Portal`, `true` by default"}
       :boolean]
      [:z-index
       {:optional true, :doc "Tooltip z-index, `300` by default"}
       [:or :string :int :double]]]},
    :blockquote
    {:description
     "Mantine `Blockquote` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Blockquote"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:icon-size
       {:optional true,
        :doc
        "Controls icon `width` and `height`, numbers are converted to rem"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:icon-size 40},
     :slots [:cite :icon],
     :children :slots},
    :modal-base
    {:description
     "Mantine `ModalBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "ModalBase"},
     :props
     [:map
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:unstyled {:optional true} :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :shadow :xl,
      :lock-scroll true},
     :gestures [:close :enter-transition-end :exit-transition-end],
     :children :any},
    :switch
    {:description
     "Mantine `Switch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 7 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label :off-label :thumb-icon],
     :defaults
     {:label-position :right, :radius :xl, :with-thumb-indicator true},
     :mantine {:component "Switch"},
     :status :generated,
     :gestures [:label],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:id
       {:optional true,
        :doc
        "Id used to bind input and label, if not passed, unique id will be generated instead"}
       :string]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-thumb-indicator
       {:optional true,
        :doc "If set, the indicator will be displayed inside thumb"}
       :boolean]]},
    :rating
    {:description
     "Mantine `Rating` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 2\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "Rating"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any CSS color value"}
       [:or :keyword :string]]
      [:count
       {:optional true, :doc "Number of controls"}
       [:or :int :double]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:fractions
       {:optional true,
        :doc "Number of fractions each item can be divided into"}
       [:or :int :double]]
      [:highlight-selected-only
       {:optional true,
        :doc
        "If set, only the selected symbol changes to full symbol when selected"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "`name` attribute passed down to all inputs. By default, `name` is generated randomly."}
       :string]
      [:read-only
       {:optional true,
        :doc "If set, the user cannot interact with the component"}
       :boolean]
      [:size
       {:optional true, :doc "Controls component size"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]],
     :defaults
     {:color :yellow,
      :count 5,
      :fractions 1,
      :highlight-selected-only false,
      :read-only false,
      :size :sm},
     :gestures [:change :hover],
     :children :none},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n     :options is the list of choices — a vector of {:label <string> :value\n     <string>} maps, bindable via :bind. :value names the initially-selected\n     option's :value. On change the renderer dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the chosen option's :value — mirroring :input's\n     Enter->command seam. :placeholder shows as a disabled leading option\n     when no :value matches. Web-only interactive; the TUI renders the\n     current value (or placeholder) as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none},
    :slider
    {:description
     "Mantine `Slider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 19 prop(s), 1 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"domain" "[number, number]"},
     :slots [:thumb-children],
     :defaults
     {:show-label-on-hover true,
      :min 0,
      :restrict-to-marks false,
      :radius :xl,
      :size :md,
      :max 100,
      :label-always-on false,
      :step 1,
      :inverted false},
     :mantine {:component "Slider"},
     :status :generated,
     :gestures [:change :change-end],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls color of track and thumb"}
       [:or :keyword :string]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled {:optional true, :doc "Disables slider"} :boolean]
      [:inverted
       {:optional true,
        :doc
        "Determines whether track value representation should be inverted"}
       :boolean]
      [:label-always-on
       {:optional true,
        :doc
        "Determines whether the label should be visible when the slider is not being dragged or hovered"}
       :boolean]
      [:marks
       {:optional true, :doc "Marks displayed on the track"}
       [:vector :any]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimal possible value"}
       [:or :int :double]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:precision
       {:optional true,
        :doc "Number of significant digits after the decimal point"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:restrict-to-marks
       {:optional true,
        :doc
        "Determines whether the selection should be only allowed from the given marks array"}
       :boolean]
      [:show-label-on-hover
       {:optional true,
        :doc
        "Determines whether the label should be displayed when the slider is hovered"}
       :boolean]
      [:size
       {:optional true, :doc "Controls size of the track"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with thumb drag and arrows"}
       [:or :int :double]]
      [:thumb-label
       {:optional true, :doc "Thumb `aria-label`"}
       :string]
      [:thumb-size
       {:optional true,
        :doc
        "Thumb `width` and `height`, by default value is computed based on `size` prop"}
       [:or :string :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]]},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a bound :text\n     (see :bind) gets its value from a data source. Type size, weight and\n     casing are NOT declared here: they are the :font-size/:font-weight/\n     :text-transform UNIVERSAL SLOTS as of ADR-graph-ui-v0-013-01 Sec19, because\n     they were never properties of text specifically (v1.x's own :size/:weight\n     stay on v1.x's :text forever, unchanged).\n     :empty-label (Sec23): what to show when the bound value resolves to an\n     empty string — the locked target's 'Add tags…' on a page with no tags.\n     Same slot name and same meaning :list/:tree/:outline already carry, so a\n     resolved-empty binding reads as EMPTY rather than as a broken pane. Not\n     :placeholder: that name already means 'hint text in an editable field'\n     on :input, and one name with two senses is how vocabulary rots.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none}}},
  "v2.1-SNAPSHOT"
  {:status :snapshot,
   :universal-slots
   {:pane
    {:description
     "WHERE THIS CHILD SITS IN A :dock, what its tab says, and how wide it opens.\n\n     Universal for the reason :section is: it is a statement a CHILD makes about\n     its place in its parent, and not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being a pane.\n\n     :direction is dockview's own word. Without :reference it is relative to the\n     pane declared BEFORE this one — `right` puts this pane to the right of\n     that one. The FIRST pane of a dock carries no :direction, because it is the\n     root of the grid and there is no earlier pane to be relative to. A pane\n     with no :direction at all joins the previous pane's group, which draws the\n     two as tabs.\n\n     :folded SAYS THE ISLAND OPENS WITH THIS PANE CLOSED (2026-09-09). George,\n     on the research island: the graph view is not usable in its bare-minimum\n     shape and can stay off by default, and so can the internals. A pane is\n     still there and still one icon from open — this is an initial state, never\n     a removal. THE PERSON'S OWN CHOICE ALWAYS WINS: a stored visibility and a\n     toggle in this visit both override it, because a default that fought the\n     person would be worse than no default. Only a pane that also declares\n     `can fold` may declare this, since a pane with no way back would be a\n     trap.\n\n     :reference NAMES THE PANE THE DIRECTION IS ABOUT, and it is what lets a\n     pattern stack (2026-09-09). Until now the reference was always the previous\n     pane, so `below` and `above` were in this enum and unreachable: a pattern\n     could say a pane sits at a place, and every later pane at that place was\n     put BESIDE its sibling. Five panes at `right` therefore made the last one\n     170 px wide with six columns in it (George: the Results pane is\n     unreadable), and there was no way to say `under the tree`.\n\n     THE PATTERN'S OWN WORD FOR IT ALREADY EXISTED. building-blocks.edn declares\n     `sits` to mean where this is, RELATIVE TO SOMETHING ELSE — so\n     `[thought-body sits below thought-tree]` is a legal fact of four names\n     against one of the thirteen relations. What was missing was a reader,\n     ui.patterns/pane-props, and this slot to carry its answer.\n\n     WHY IT EXISTS. A dock with no direction on any pane puts every pane in ONE\n     group. Measured 2026-09-02 on reader-v3's first load: `groups=1`, two tabs.\n     A pattern that says `navigator sits left` and `reading-area sits middle`\n     means side by side, so the panes have to say so and nothing else could.\n\n     :width IS A PIXEL COUNT, and this is the one level it may be. A pattern\n     states a named measure — narrow-measure — and ui.patterns resolves it here,\n     the way a block's :draws resolves one. Without it a dock splits the surface\n     evenly and a sidebar opens at half the window.\n\n     :height IS THE SAME PIXEL COUNT ON THE OTHER AXIS, and only a band needs\n     it. A band states its extent on ONE axis, so dockview halves the other.\n\n     :absorbs SAYS THIS PANE TAKES WHAT THE OTHERS LEAVE (2026-09-11). George\n     chose it from four answers: size the all-remaining pane last from what is\n     left. A dock cannot work this out alone, because `all-remaining` resolves\n     to NO width on purpose — so the pane that means it looks exactly like a\n     pane that states nothing. Measured at 1920 on the research island before\n     this slot existed: the reading column opened at 100 pixels, dockviews own\n     minimum, while the Guide took 640 and the Add pane 910.\n\n     ONE PANE OF A SURFACE, AND NEVER TWO. The arithmetic is the surface minus\n     what every other column claims, so a second pane with this slot would have\n     nothing to divide. ui.patterns reads the pane whose measure is\n     all-remaining and which is a COLUMN — a pane BELOW another pane is in that\n     panes column and has that columns width already.\n\n     :shares SAYS THIS PANE TAKES AN EQUAL PART OF THE SAME SPACE (2026-09-12).\n     George: it looks to me that narrow-measure and all-remaining will be well\n     balanced by equally-divided, but it cannot be applied in isolation. It is\n     the middle term of three — one number that never moves, an equal part of\n     what is left, and everything that is left.\n\n     TWO OR MORE, AND validate-dsl REFUSES ONE. A single pane cannot divide\n     anything equally. It also refuses a surface that carries both slots,\n     because both claim the space the numbers leave.\n\n     WRITTEN BY ui.patterns, NOT BY A PERSON. A pattern's facts are projected\n     onto the page's placed blocks at seed time (ADR-graph-ui-v0-026-01). A\n     description may still carry it by hand, the way :section may.\n\n     ONE SLOT AND NOT TWO. The tab label was a bare :title, and :title is a prop\n     of some widget kinds and of neither :stack nor :container — the two roots a\n     docked building block actually has. So a conformant description could not\n     carry its own label. The label is part of what makes a child a pane, so it\n     is stated in the same place.\n\n     A DOCK WHOSE PANES ARE HAND-WRITTEN :box NODES may still use a bare :title,\n     which is the convention :tab-set uses for its child boxes.\n\n     :id IS THE PANE'S IDENTITY ACROSS A RELOAD, and the pattern's own name for\n     it — navigator, reading-area. A stored arrangement refers to panels by id,\n     and the stamp that decides whether a stored arrangement still applies is\n     built from them. :import-id cannot serve: :ui/attach strips it, so a dock\n     without this named its panes by position and the stamp never changed.",
     :shape
     [:map
      [:id {:optional true} :string]
      [:title {:optional true} :string]
      [:direction
       {:optional true}
       [:enum "left" "right" "above" "below" "within"]]
      [:reference {:optional true} :string]
      [:foldable {:optional true} :boolean]
      [:folded {:optional true} :boolean]
      [:width {:optional true} :int]
      [:height {:optional true} :int]
      [:absorbs {:optional true} :boolean]
      [:shares {:optional true} :boolean]]},
    :text-transform
    {:description
     "Text casing — Mantine's `tt`. :uppercase is SPEC-002's sidebar section\n     header (11px / 700 / uppercase / letter-spaced) and its kind badge; the\n     renderer pairs :uppercase with the target's letter-spacing, since the\n     two always travel together in the locked target and a separate\n     letter-spacing slot would be a prop with exactly one legal use.",
     :shape [:enum :none :uppercase]},
    :import-id
    {:description
     "This node's AUTHORED IDENTITY — stable across re-seeds, and the join\n     between a description FILE and the frames it becomes.\n\n     The platform's own mechanism, not a new one: `frames-lib.store/create-frame!`\n     treats :import-id as a stable identity — a frame already bearing one is\n     SYNCED IN PLACE, same :frame/id, rather than duplicated — and\n     `ui.frames/node->slots` already lifts it off a widget node. Seeding an\n     island twice therefore leaves every :widget-id byte-identical, which is\n     what makes a Penpot board, an op-spec or any stored reference survive a\n     re-seed (verified 2026-08-04 across two seeds of the reader).\n\n     Why it is authored rather than the uuid: a :widget-id is minted by whichever\n     database was running, so a file full of uuids names frames that a wiped\n     graph no longer has. \"reader/vault-search\" survives the wipe and says what\n     the node IS. The uuid remains the join key between the graph and Penpot;\n     this is the join key between the file and the graph.\n\n     Namespaced by island by convention (\"reader/…\", \"reader-v2/…\") so two\n     islands may both hold a `vault-search` without colliding in one graph.\n\n     DECLARED HERE BECAUSE THE ENTRY SCHEMA IS CLOSED. The seeder read this key\n     from day one and the validator rejected it as a disallowed key — the files\n     were stamped, the islands seeded, `validate-dsl` passed (it checks this\n     manifest, not the instances), and only the full suite caught it. A slot the\n     platform reads and the vocabulary does not declare is exactly the drift\n     DSL-First exists to make impossible.",
     :shape :string},
    :widget-component
    {:description
     "This node is an OCCURRENCE of a named definition rather than a widget in\n     its own right — ADR-ikc-v3-060-01 §5. The value names a definition in the\n     description's own :components map.\n\n        {:widget-component :reading-pane :section :main :size \"66ch\"}\n\n     Everything beside :widget-component is an OVERRIDE, merged over the\n     definition. Under ADR-graph-ui-v0-002-01 any property may be overridden and each\n     one is TOUCHED — the occurrence's own, no longer following the definition.\n     Verified against Penpot 2.17 on 2026-08-04, whose component copies behave\n     exactly this way.\n\n     WHY THIS EXISTS. A description is read far more often than it is written,\n     and reader-ui.edn is 863 lines nested nine deep — you cannot see the page.\n     Naming its parts lets the top of a file BE the page, six lines long, with\n     each part opening on its own. It is also what a Penpot component maps to,\n     one-for-one, so a board and a description can talk about the same thing\n     (§6).\n\n     EXPANDED AT SEED TIME, for now. The seeder inlines each occurrence before\n     creating frames, so the graph holds a plain widget tree and the renderers\n     need no new case. That means the graph does not yet KNOW a component exists\n     — ADR-060 §1's :widget-component frame type and §3's occurrence links are\n     not built, so a definition change does not propagate to live occurrences and\n     a round-trip cannot give components back. Stated plainly because the gap is\n     invisible from the file, which looks like it has components either way.",
     :shape :keyword},
    :font-size
    {:description
     "Type size — Mantine's `fz` style prop (universal there too, for the same\n     reason). Two scales in ONE enum, exactly as Mantine's own MantineFontSize\n     does: the :xs-:xl step scale, and :h1-:h6 for heading sizes. :h1 is what\n     makes an editable page title LOOK like a title (with :variant :unstyled\n     on :input — Sec21) instead of like a form control.\n\n     Distinct from a kind's own :size (:icon, :drawer, :container), which\n     means that KIND's own dimension, never type size.",
     :shape [:enum :xs :sm :md :lg :xl :h1 :h2 :h3 :h4 :h5 :h6]},
    :font-weight
    {:description
     "Font weight — Mantine's `fw`. Mantine types it to raw CSS fontWeight,\n     which would make it unvalidatable, so v2.0 closes it to three named\n     steps (Sec0's standing trade). Moved here from :text's own :props\n     (Sec19) — it was never a property of text specifically. v1.x's :text\n     keeps its own :weight forever; a released version's vocabulary never\n     changes (ADR-graph-ui-v0-004-01).",
     :shape [:enum :normal :medium :bold]},
    :section
    {:description
     "Which named PLACE in its parent this child fills.\n\n     Universal for the same reason :flex is: it is a statement a CHILD makes\n     about its place in its parent, not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being the navbar.\n\n     TWO FAMILIES OF VALUE, ONE IDEA. The first five are an :app-shell's page\n     regions — Mantine's AppShell.Header / .Navbar / .Aside / .Main / .Footer,\n     named rather than ordered (ADR-graph-ui-v0-001-01 §B). The rest are the\n     named child slots the generated kinds declare: a `Divider`'s label, an\n     `Alert`'s title and icon, a `TextInput`'s description and error. Mantine's\n     `leftSection` and `label` props are the same idea as its `AppShell.Navbar`\n     — a place a widget goes — so this vocabulary says it once. Inventing a\n     second mechanism for the second family is what ADR-graph-ui-v0-013-01 was\n     written to end.\n\n     WHY THE SECOND FAMILY IS HERE AT ALL (AC-graph-ui-v0-001-01 §C, 2026-08-05).\n     It was not, and the consequence was that 31 kinds declared named slots that\n     NO valid description could fill: the enum could not spell :label, so\n     graph-ui.web.mantine-generic/split-slots — correct code — was unreachable.\n     A browser found it; nothing else could, because both halves were\n     individually valid and only their conjunction was wrong.\n\n     A documented no-op where it means nothing — the same contract :flex sets\n     for the TUI. This enum stays CLOSED (ADR-ikc-v3-041-01): a name that is not\n     here is rejected, so a typo is still caught. dsl/scripts/validate.clj holds\n     it to the vocabulary — every :slots name any kind declares must appear\n     below, and a generator run that adds a new slot name fails the build until\n     it does. That check is what stops this list from drifting back out of step,\n     which is the failure it was written after.\n\n     A :tab-set READS TWO OF THESE NAMES (2026-10-09, lane\n     IKC3/PLAN-ikc-v3-068-01/T). A child of a :tab-set that says\n     :left-section or :right-section is not a tab. It is drawn on the line\n     of the tabs: :left-section before the tabs, :right-section after them,\n     at the right edge. It has no panel, and the tab-set never hides it. The\n     index in :active, and in a bound tab-set, counts the tabs only. So a\n     row of actions and a row of tabs share one line, and the reading pane\n     of George's edit needs no new kind and no new name. The TUI draws these\n     children on one line above its tab labels.",
     :shape
     [:enum
      :aside
      :chevron
      :cite
      :description
      :error
      :footer
      :header
      :hide-label
      :icon
      :label
      :left-section
      :legend
      :main
      :navbar
      :nothing-found-message
      :off-label
      :placeholder
      :right-section
      :separator
      :show-label
      :thumb-children
      :thumb-icon
      :title
      :validation-error]},
    :per-row
    {:description
     "DRAW MY ONE CHILD ONCE PER ROW OF A SOURCE, each copy with $row bound to\n     that row (PLAN-ikc-v3-026-01 Q2, RESEARCH-ikc-v3-021-01 D6).\n\n     The value is a bind spec — {:source :tot-relations :args {…}} — whose\n     answer is a vector of maps. The node keeps ONE child in the graph, the\n     template, and the renderer draws it once per row, in the source's order.\n     Inside a copy `$row` IS the row, and [:of $row name] reads one of its\n     fields — in a :label, in a :with, anywhere in the template. The reference\n     is collapsed when the copy is made, so a gesture later fills a template\n     that already names its row.\n\n     WHY IT EXISTS. `one chip per declared relation` (D6) cannot be written\n     with a fixed list of chips: a relation a person declares from the thought\n     tree must be a chip on the next draw. :per-tile solved the same shape for\n     tiles — one template, a count that is data — and this is its sibling for\n     any source. A :list draws rows as text; this draws rows as WIDGETS.\n\n     THE TUI DRAWS EVERY ROW TOO. ui.bind/resolve-bindings expands the copies\n     server-side the same way, so the two renderers agree on how many children\n     the node has (the binding runtime is duplicated, CLAUDE.md).\n\n     A bind INSIDE the template may not depend on $row in its :args tonight:\n     the subscribe walk runs before the rows are known.",
     :shape [:map [:source :keyword] [:args {:optional true} :map]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-graph-ui-v0-003-01-widget-tree"]}},
    :flex
    {:description
     "How this child sizes itself inside a flex/grid parent — ADR-graph-ui-v0-013-01\n     Sec4: :layout-self's four-key map collapses to Mantine's own `flex` CSS\n     shorthand, one value. :layout-self {:grow 1 :basis :zero} becomes :flex 1.\n     :shrink/:basis/:align-self are DROPPED, not renamed (Sec4) — a child\n     needing its own cross-axis alignment is deferred until a concrete island\n     needs it (ADR-graph-ui-v0-013 Deferred). Web renderer only — the TUI ignores it\n     (documented no-op, ADR-graph-ui-v0-007-01). Distinct from the :flex WIDGET\n     KIND below (Mantine's Flex container) — this is the self-sizing PROP\n     every node may carry, mirroring Mantine's own dual use of `flex` as both\n     a Mantine component name and a Box style prop.",
     :shape [:enum 0 1 2 3]},
    :narrow
    {:description
     "What this node does when the window is narrower than --viewport-narrow.\n\n     :keep    no change — the default, and the whole vocabulary for a node that\n              fits a phone already.\n     :hide    the node is ABSENT below the breakpoint. For desktop-only chrome\n              whose content is reachable another way — the conversations roster\n              is a seven-column table beside a picker that lists the same\n              conversations, so the phone keeps the picker.\n     :scroll  the node scrolls sideways INSIDE its own box below the\n              breakpoint, so the PAGE does not. For a wide table whose columns\n              are the point.\n     :fold    a two-pane split hands the width to its filling pane and starts\n              its resizable pane folded, one tap from open. :split-pane only.\n     :stack   a two-pane split becomes one vertical column, the resizable pane\n              first. :split-pane only.\n\n     :hide is a real loss of content and is why this slot is not a boolean. A\n     description states which answer it takes, and a reader of the description\n     can see which one it chose.\n\n     TWO VALUES ARE HONOURED BY ONE KIND, which is this manifest's standing\n     contract rather than a wart: :backdrop says the same of the six kinds that\n     draw a box, and :flex says it of the TUI. A slot is a statement a node\n     makes about its place, and a split is the only node whose narrow answer is\n     about its own two panes. Spelling those two as a SECOND key would put\n     :narrow in the schema twice, which malli refuses outright\n     (:malli.core/duplicate-keys — the collision that named :font-size).\n\n     Honoured by the web renderer. The TUI ignores it, which is the contract\n     :flex and :backdrop already set (ADR-graph-ui-v0-007-01) — a terminal has\n     one width and no phone.",
     :shape [:enum :keep :hide :scroll :fold :stack]},
    :from
    {:description
     "WHERE THIS NODE IS AUTHORED-IN — the stamp ui.blocks/expand puts on every\n     node it makes (ADR-graph-ui-v0-015-01 Sec4). :file is the block file.\n     :part is the named part inside that file. :repeated names the collection a\n     repeater drew this node for.\n\n     EXPANSION IS THE ONLY MOMENT ANYTHING KNOWS. A tree now comes from a page\n     and its block files. Structural position therefore does not say which file\n     a node belongs to. A change made in the graph or on a Penpot board cannot\n     be written back without this slot. The web x-ray overlay reads it\n     (graph-ui.web.xray). It draws the block boundaries over the island.\n\n     IT WAS UNDECLARED FOR THE WHOLE OF v2.0. The cost was measured on\n     2026-09-15. All 17 compositions were seeded on a memory bus. Eight islands\n     materialised to a tree that ui.interpret/problems refused: gi, reader-v2,\n     reader-v3, studio, tot, research, alatus-book and alatus-reader. :from was\n     the only offending key in all eight. Only gi had a test on it\n     (T-frames-006). So one platform gap read as one unfinished island. The test\n     message sent every reader to gi's UI. George, 2026-09-15: declare it in the\n     Meta-UI.\n\n     v2.0 IS RELEASED AND KEEPS ITS OWN VOCABULARY. The four islands that\n     pinned v2.0 and expand from blocks now pin this version instead.",
     :shape
     [:map
      [:file :string]
      [:part {:optional true} :symbol]
      [:repeated {:optional true} :symbol]]},
    :backdrop
    {:description
     "The declared surface token this node paints as its background — one of the\n     :surfaces group in dsl/instances/themes.edn. `:surface body` becomes\n     `background: var(--body)`, which is the whole translation.\n\n     COLOUR ONLY, and no stroke, radius or padding with it. Those are a CELL's\n     treatment (dsl/design/*.edn, ui/widgets cell-style) and a cell is drawn by a\n     component that owns its own grid. A node in a widget tree has no such owner,\n     so it gets the one property that needs none.\n\n     Honoured on the kinds that draw a box — :box :stack :group :container\n     :scroll-area :markdown. A documented no-op elsewhere, which is the contract\n     :flex and the typography slots above already set. The TUI ignores it, the\n     same way it ignores every surface token (ADR-graph-ui-v0-007-01).\n\n     :border and :border-2 are absent from the range on purpose. They are in the\n     :surfaces group because they are painted colours, and neither is a surface\n     anything sits on.",
     :shape
     [:enum :ground :panel :raised :card :field :body :gutter :hover]},
    :per-tile
    {:description
     "DRAW MY ONE CHILD ONCE PER TILE, each copy scoped to that tile's session\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01).\n\n     true or absent. The node keeps ONE child in the graph — the template — and\n     the renderer draws it once for each open tile of the island, in order. Copy\n     n resolves as if it carried `:session-of n`.\n\n     WHY THE FRAMES HOLD ONE COPY AND NOT SIX. A frame is identified by its\n     :import-id, and frames-lib.store upserts by it — so six copies of a pane\n     would collapse into one frame and the tree would be wrong. Six copies would\n     also quadruple the description of every island that draws a pane, for a\n     feature most of them never use.\n\n     WHY THE COUNT IS NOT HERE. George, 2026-08-22: \"the 6 tiles is not hard UI\n     - it is fluid config from 1, 2, 4 or 6 tiles in the grid\". The count is\n     data — the island's own tiles — so the declaration says \"per tile\" and\n     never says how many. :tile-columns says how they are laid out.\n\n     THE CONTENT IS THE SAME AS ANYWHERE ELSE, and that is the point. George:\n     \"a conversation has same content in the tile and in the reading pane of the\n     reader-v2 or if floating free in the infinite canvas.\" The template is the\n     same part the single pane draws, so there is one declaration of what a\n     conversation looks like and no copy to drift.\n\n     THE TUI DRAWS ONE COPY, the focused tile. A terminal has one pane\n     (ADR-ikc-v3-048-01 TUI-lag), and this is declared rather than discovered.",
     :shape :boolean,
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}},
    :session-of
    {:description
     "THIS SUBTREE ANSWERS FOR ANOTHER SESSION — the nth TILE of this pane\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01 phase 2).\n\n     An integer, counting from 0. The whole subtree resolves with `$session-id`\n     bound to that tile's session, so every bind inside it reads the tile's own\n     answer.\n\n     WHY IT EXISTS. George, 2026-08-21: \"Conversation pane can be reworked so\n     2, 4 or 6 conversations can be observed and participated at once, displayed\n     as tiles.\" Six tiles bind about 40 sources each. Without this slot, each\n     tile would need its own copy of every source: 240 declarations, and a sixth\n     copy of every source added later. With it, `:page-title` stays one source\n     and answers for the session it is asked about, which it always did.\n\n     A NODE WHOSE INDEX NAMES NO TILE IS NOT DRAWN, and it reads nothing. A grid\n     of six cells over a pane of two tiles shows two. The alternative is worse\n     than an empty cell: a cell that fell back to the TAB's session would show\n     the wrong item and say nothing.\n\n     TWO KINDS OF VALUE. An INTEGER names a position. The keyword `:focused`\n     names whichever tile has the focus, and the reading pane uses it: the pane\n     draws ONE column, and that column follows the focus.\n\n     WHY THE PANE DOES NOT YET DRAW SIX COLUMNS, said here because a reader will\n     ask. Every node in the column carries an `:import-id`, and a frame is\n     identified by it. Six copies would be six nodes with one identity, so\n     per-tile identity is its own step and phase 3 does it.\n\n     WHICH SESSION EACH INDEX HOLDS COMES FROM THE :tile-sessions SOURCE, not\n     from the description. The description is seeded once and the tiles change\n     while a person works, so a position is the only thing a description can\n     name. Both binding runtimes read that source and carry it in their\n     substitutions under `$tile-sessions`.",
     :shape [:or :int [:enum :focused]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns\n     the edit buffer, seeded from :value (bindable). It dispatches\n     :on-gesture's :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing\n     v1.x's :on-submit) with $value = the buffer.\n\n     ENTER SENDS. Shift+Enter inserts a newline, and Ctrl/Cmd+Enter still\n     sends. Until 2026-08-20 the ONLY way to send was Ctrl/Cmd+Enter, which\n     George reported as a box that does not send (\"The input field does not\n     send on Enter and there is no submit button\"). Two reasons Enter wins.\n     A prompt box is a chat box, and every chat box in the world sends on\n     Enter. And a phone keyboard has no Ctrl key at all, so the phone\n     surface of phase 6 had no way to send anything.\n\n     :rows sets the\n     initial height; :auto-grow expands as the user types; :markdown\n     toggles a live preview of inline **bold**, *italic*, and `code`.\n     :triggers is an optional vector of trigger characters (e.g. [\"@\" \"/\"\n     \"#\"]) carried as data for future chip support. Web renderer only —\n     the TUI renders the buffer as plain read-only text.\n\n     A PASTED IMAGE GOES WITH THE PROMPT (PLAN-ikc-v3-017-01 phase 11).\n     George, 2026-08-21: \"I often paste an image in the terminal — is it\n     supported in a tile?\" A paste that carries an image file dispatches\n     the :paste gesture, whose $value is the whole `data:` URL, and the image\n     never enters the buffer: the bytes are written once into the :attachments\n     vault, and the prompt carries the path. THE GESTURE AND NOT A DIRECT\n     DISPATCH, because a tile bakes its own session into every gesture it holds\n     (ADR-graph-ui-v0-023-01) — a paste that dispatched by itself attached the\n     image to the TAB'S session, and the tile showed nothing. A paste of TEXT is untouched, because the default is stopped only\n     when an image was found. NO PROP DECLARES THIS. A paste is what this\n     widget is for, in the same way that Enter sends.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :aspect-ratio
    {:description
     "Mantine `AspectRatio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "AspectRatio"},
     :props
     [:map
      [:ratio
       {:optional true,
        :doc
        "Aspect ratio, for example, `16 / 9`, `4 / 3`, `1920 / 1080`"}
       [:or :int :double]]],
     :defaults {:ratio 1},
     :children :any,
     :box-from :props,
     :box-to-children :definite},
    :fieldset
    {:description
     "Mantine `Fieldset` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Fieldset"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {},
     :slots [:legend],
     :children :slots,
     :box-from :content},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit buffer\n     and, on Ctrl/Cmd+Enter or its Save button, dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the buffer — the editor half of the Foam markdown Edit\n     view (ADR-ikc-v3-052-01). :value seeds the buffer (bindable). :rows is\n     the initial visible height. In the TUI it renders as plain read-only\n     text. :draft-key: a client draft channel to publish the live buffer to\n     on every (debounced) change, so a live-preview widget (:island-view)\n     can render what is being typed BEFORE it is submitted. :format: :edn\n     (default) shows the buffer as-is; :indent converts the bound EDN value\n     to a bracket-stripped indentation format for display.\n\n     :font-size is NOT declared here under v2.0 — it is the UNIVERSAL SLOT\n     (ADR-graph-ui-v0-013-01 Sec19). v1.x declared it as this kind's own prop, which\n     was always a mislabelling: scaling the editor's code font is typography,\n     not a property of text areas specifically. Declaring both would be the\n     same key twice, which malli rejects outright (:malli.core/duplicate-keys)\n     — the check that found this. v1.x keeps its own :font-size forever.\n\n     :wrap (2026-10-05, George: \"togle wrap long lines\"). true: a line longer\n     than the editor continues on the next screen line, and the text is not\n     changed. false or absent: each line stays one line, and the editor scrolls\n     to the side inside its own scroller. Absent keeps the behaviour every\n     earlier description had, so the Studio's EDN editor does not move. The\n     TUI ignores it, as it ignores :font-size: a terminal has its own width.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:wrap {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                 contain formatted text. :value is the markdown source. In the TUI it\n                 renders as plain text (no styled rendering); a web renderer renders\n                 it as HTML. A bound :markdown gets its :value from a data source.\n\n                 SINCE 2026-08-14 IT CAN ALSO BE MARKED (F-platform-v0-011-01):\n                 :highlights is this page's highlights, and the marked text is\n                 washed in each one's colour. Selecting text offers four colour\n                 swatches and fires the :highlight gesture, whose $value is the\n                 whole selection map — the text, an advisory position, and the\n                 chosen colour — because a gesture carries one value and both\n                 capture modes must converge before the command\n                 (ADR-graph-ui-v0-017-01 §1-2).\n\n                 :value and :highlights are TWO bindings on one widget, which the\n                 per-prop :bind form has expressed since 2026-07-19; no new binding\n                 mechanism was needed for it.\n\n                 SINCE 2026-08-20 THE SELECTION CAN ALSO BOOKMARK\n                 (PLAN-ikc-v3-015-01 phase 3): the same popover offers a\n                 bookmark control beside the swatches, firing the :bookmark\n                 gesture with the same selection map, colour omitted. A\n                 description wires it only where the body is a conversation —\n                 the gesture resolves the selection to an entry id, and only a\n                 conversation has entries.\n\n                 SINCE v2.1-SNAPSHOT THE SELECTION CAN ALSO BECOME EVIDENCE\n                 (PLAN-ikc-v3-026-01 Phase D, RESEARCH-ikc-v3-021-01 R-AC-7):\n                 two controls beside the swatches fire :to-thought and\n                 :against-thought with the same selection map, colour omitted;\n                 the command adds the highlight and links it to the session's\n                 selected thought as :supports or :contradicts. A description\n                 wires them where a thought can be selected — the reader's own\n                 reading area carries them, so reader-v3 and the research island\n                 both can.\n\n                 A HIGHLIGHT'S :level IS DRAWN AS ITS LAYER (D5): layer 1 is the\n                 wash alone, 2 bold, 3 bold and underlined, 4 a double line, 5\n                 italic too — one class per layer (ikc-hl-layer-2 … 5 in\n                 ikc-base.css), riding on the colour the reader chose, so a\n                 layer-3 span inside a layer-2 span is bold and washed twice.\n\n                 A highlight map may carry :entry-id — the conversation storage\n                 form (ADR-ikc-v3-076-01 §3). The paint path is unchanged:\n                 offsets into the rendered source decide where a wash is drawn,\n                 whichever form stored it.\n\n                 AND ITS [[wikilinks]] CAN NAVIGATE (2026-08-18): :links is\n                 [{:target :page-id}] — every wikilink target in this body, each\n                 resolved on the SERVER by :page-content-links, bound with\n                 :link-bind rather than :bind because it is a second, independent\n                 binding beside :value.\n\n                 A target that names no page is still DRAWN, as a muted chip that\n                 does nothing. An unresolved wikilink is an invitation to create\n                 that page, not an error.\n\n                 A LEADING FRONTMATTER BLOCK IS METADATA, NOT BODY (2026-09-08,\n                 George: it showed in the Reading pane's preview as text). It is\n                 drawn folded, one line with the title and the source, the rows\n                 behind a click. The highlights' offsets are into the file, so\n                 the renderer moves them past the block; nothing stored changes.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:links
       {:optional true}
       [:vector [:map [:target :string] [:page-id [:maybe :string]]]]]
      [:highlights
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:block-id {:optional true} :string]
         [:entry-id {:optional true} :string]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:refused-tags {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :input-base
    {:description
     "Mantine `InputBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "InputBase"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:multiline
       {:optional true,
        :doc
        "If set, the input can have multiple lines, for example when `component=\"textarea\"`"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-aria
       {:optional true,
        :doc
        "If set, `aria-` and other accessibility attributes are added to the input"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :with-aria true,
      :right-section-pointer-events "none",
      :multiline false,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :loader
    {:description
     "Mantine `Loader` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped
     {"loaders"
      "Partial<Record<(string & {}) | \"bars\" | \"dots\" | \"oval\", MantineLoaderComponent>>"},
     :defaults {:size :md, :type :oval},
     :box-to-children :block-flow,
     :mantine {:component "Loader"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the loader. `Loader` has predefined `xs`-`xl` values. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Loader type, key of `loaders` prop"}
       [:or [:enum :bars :dots :oval] :string]]]},
    :unstyled-button
    {:description
     "Mantine `UnstyledButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "UnstyledButton"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :report-button
    {:description
     "REPORT OR + CREATE IN THE TOP BAR OF A TRACKER SCREEN\n     (IKC3/PLAN-ikc-v3-080-01/INT, screen 1 of the plan, wireframe\n     1-board.png). A click opens the dialog of the report, which lane REPORT\n     made (graph-ui.web.support). The form of the dialog follows the role of\n     the party, as for each other Report control.\n\n     TWO FORMS.\n       :report  takes the picture of the screen first, then opens the\n                dialog. It is the Report control of the top bar of each\n                island, with words.\n       :create  opens the same dialog with no picture. A new work item does\n                not start from a fault on the screen. Take a picture adds\n                one.\n\n     NO GESTURE. The dialog sends :support/file-report, and the bus decides.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the label in brackets, and\n     dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:label
       {:optional true,
        :doc
        "The words of the button. Report or + Create when absent."}
       :string]
      [:form
       {:optional true,
        :doc "Which dialog opens: :report, the default, or :create."}
       [:enum :report :create]]],
     :defaults {:form :report},
     :children :none,
     :box-from :content},
    :loading-overlay
    {:description
     "Mantine `LoadingOverlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "LoadingOverlay"},
     :props
     [:map
      [:visible
       {:optional true,
        :doc "Determines whether the overlay should be visible"}
       :boolean]
      [:z-index
       {:optional true, :doc "Controls overlay `z-index`"}
       [:or :string :int :double]]],
     :defaults {:visible false, :z-index 400},
     :children :none,
     :box-from :parent,
     :needs :both},
    :space
    {:description
     "Mantine `Space` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Space"},
     :props [:map],
     :defaults {},
     :children :none,
     :box-from :props},
    :in-progress-list
    {:description
     "THE LIST OF IN PROGRESS (IKC3/PLAN-ikc-v3-080-01/ME, screen 9 of the plan):\n     one row for each work item in Started, Idle, In review or For deploy.\n     The columns: the key, what (the title and the lane id), where (the\n     machine, the worktree and the branch), the pull request with its state,\n     the next step, and when it changed with the assignee.\n\n     A ROW. The mark of the work type and the key as a link to the page of\n     the item (/browse/IKC-n). The pull request is a link with the badge\n     REVIEW or MERGED. An idle item shows the flag \"Idle:\" and its reason\n     in place of the next step, in the danger tone: the symbol and the word\n     for an e-ink screen, the colour for the others.\n\n     NO GESTURE. An agent updates its row with `tracker move` and `tracker\n     next`, and a person opens the item by its key.\n\n     WHY A KIND OF ITS OWN. A cell of a :table is only text: it has no link,\n     no badge and no second line (rule 4 of section 6 of the plan).\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws one line for each row,\n     \"KEY title · machine · next step\".",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:key {:optional true} :string]
         [:kind {:optional true} :string]
         [:title :string]
         [:lane {:optional true} :string]
         [:where {:optional true} :string]
         [:pull-request {:optional true} :string]
         [:pull-request-url {:optional true} :string]
         [:pull-request-state {:optional true} :string]
         [:next-step {:optional true} :string]
         [:idle {:optional true} :string]
         [:updated {:optional true} :string]]]]
      [:empty-label
       {:optional true, :doc "What the list says with no row."}
       :string]],
     :defaults {},
     :gestures [],
     :children :none,
     :box-from :content},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one —\n     the Studio preview pane. Renders the island the current session has\n     selected / is composing: its saved tree by default, or the description\n     currently in the editor buffer AS YOU TYPE (WYSIWYG), whichever the\n     client draft holds, with the saved tree as the fallback. The preview\n     attaches NOTHING — it reads via :ui/preview-context, so it can never\n     steal or leak the lock the composer holds. Carries a self-embed guard.\n     Web-only; the TUI renders a labelled placeholder.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none,
     :box-from :parent,
     :needs :both},
    :tree
    {:description
     "A nested outline; each item is now a MAP with optional recursive\n     :children (ADR-graph-ui-v0-013-01 Sec17): {:label string :children [item ...]\n     :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean}. :items is optional: a\n     bound :tree gets its outline from a source. The recursive sibling of\n     :list. Recognises TWO :on-gesture keys (ADR-graph-ui-v0-013 Sec7-8): :submit\n     (click-to-navigate — the web renderer wires clicking any node to it) and\n     :fork (the explicit fork action, typically the 'f' key; declared but not\n     yet wired in the web renderer, same as v1.x's :on-fork always was).\n     $value substitutes the clicked/forked item's :entry-id either way.\n\n     SIX MORE GESTURES SINCE v2.1-SNAPSHOT (PLAN-ikc-v3-026-01 Q2, RESEARCH-\n     ikc-v3-021-01 D8 — Leo's tree pane): :insert (Enter), :indent (Tab),\n     :outdent (Shift-Tab), :move (Alt-Up, Alt-Down, Alt-Home, Alt-End — $value\n     carries :direction :up :down :first :last), :set-kind (one letter, q h b f\n     o d — $value carries :kind), :delegate (the letter a). Each fires only\n     when the description declares it AND a row is selected by :active-value.\n     For these six $value is the SELECTED ITEM'S WHOLE MAP plus what the key\n     added, so a template reads a field with [:of $value parent-id] — a source\n     that draws a thought tree puts :thought-id, :parent-id, :frame-id,\n     :previous-sibling and :grandparent on each item for exactly that. An item\n     may also carry :kind, :confidence, :clone? and :edge-count; the source\n     bakes the kind's icon into :icon and the count into :accessory, so the\n     row renderer is unchanged.\n\n     ONE MORE GESTURE, :open, A CONTROL AT THE END OF A ROW\n     (IKC3/PLAN-ikc-v3-057-01/RA-2). A row gets a second act, apart from the\n     click on its label. The item carries :open-label, the words of the\n     control, and :open-value, the value the control sends as $value. A row\n     with a blank :open-value draws :open-label as muted text in the same\n     slot, and no control. A row with no :open-label draws nothing there. The\n     control is always drawn, never on hover, so it does not move the row.\n     It is a key of :on-gesture and not a prop, so a description that wires it\n     validates at every version, as :remove does.\n     :direction: :column (default) stacks items vertically as an indented\n     outline; :row lays a FLAT item list out horizontally as a strip of\n     clickable buttons (the daily-note nav bar) and ignores nesting. :value\n     (ADR-graph-ui-v0-013-01 Sec24): the clicked node's own click target — see\n     :list's :value note for why it was missing.\n\n     A CLICKED ROW ACKNOWLEDGES ITSELF, and it is not a prop. Added 2026-08-17,\n     because a click on a page row costs a dispatch plus one :ui/read for every\n     source the server says changed — measured at 337ms for a single frame read\n     against the live graph, so a click is a wait, and the row used to give back\n     nothing at all while it ran. The row now shows a turning ring at its trailing\n     edge from the moment of the click until this session stops waiting on the bus.\n     The ring is OUT OF FLOW — absolute at the row's right edge, so appearing costs\n     no layout and a row with an accessory does not have its count or its reference\n     text shoved left mid-click. In :direction :row the strip uses the Button's own\n     loading state for the same reason, which also disables the control so a second\n     click cannot queue a second dispatch behind the first.\n     Deliberately NOT declared as a prop: an island cannot ask for it, cannot turn\n     it off, and cannot bind it. It is not data about the outline — it is the state\n     of the client that is drawing the outline, and the value it reports is one no\n     bus source could serve, since reading a source is the very round trip being\n     waited on. It lives in graph-ui.web.busy, the reagent-atom pattern\n     graph-ui.web.activity and graph-ui.web.draft already use, and the TUI simply\n     has nothing to draw here. The matching WINDOW-level signal — a sweeping line\n     on the chrome bar once a wait passes the declared limit\n     graph-ui.web.busy/visible-after-ms — is in graph-ui.web.core for the\n     same reason a viewport-spanning bar is not an island widget: it is a fact\n     about the frame, not about anything on the canvas.",
     :status :in-progress,
     :props
     [:map
      [:row {:optional true} [:enum :line :card]]
      [:active-value {:optional true} [:maybe :string]]
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:children {:optional true} [:vector :any]]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]
         [:has-children {:optional true} :boolean]
         [:open-value {:optional true} :string]
         [:open-label {:optional true} :string]]]]
      [:children-query
       {:optional true}
       [:map
        [:source :keyword]
        [:args {:optional true} :map]
        [:branch-arg {:optional true} :keyword]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:wrap {:optional true} :boolean]
      [:empty-label {:optional true} :string]
      [:open-mode {:optional true} [:enum :instant :enter]]
      [:look {:optional true} [:enum :plain :boxed]]
      [:edit-field {:optional true} :string]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]]]]],
     :defaults {:open-mode :enter, :look :plain},
     :children :none,
     :box-from :content},
    :group
    {:description
     "Horizontal row — Mantine `Group` (ADR-graph-ui-v0-013-01 Sec0). :wrap is\n     boolean here (true -> CSS `wrap`, false -> `nowrap`), the same\n     convention v1.x's :box :wrap already used. :grow gives every child\n     `flex-grow: 1`.",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:wrap {:optional true} :boolean]
      [:grow {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-row},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n     declares the header — a vector of {:label <string> :key\n     <keyword|string>} maps; each row's cell for a column is looked up by\n     that column's :key. :rows is the data — a vector of maps, bindable via\n     :bind. :tone/:density tune the visual weight. In the TUI it renders as\n     plain text rows.\n\n     ONE GESTURE SINCE 2026-09-09, :submit (PLAN-ikc-v3-029-01 Q4). A row is\n     clickable only when the description wires it, and $value is the ROW'S OWN\n     MAP — the :tree's six gestures hand the selected item the same way, so a\n     template reads a field with [:of $value measurement-id]. Absent, nothing\n     fires and every existing table is unchanged, display-only as before.\n\n     ADDED TO THIS SNAPSHOT ONLY. v1.0, v1.2 and v2.0 carry an identical\n     :props block and an almost identical description; two of those versions\n     are RELEASED and their rules are frozen, so the edit is made by position\n     and not by a text replace over the file (the lesson :tree's :row prop\n     left here on 2026-08-15).\n\n     WHY A GESTURE AND NOT A RELEASE. The plan's stop condition asks the\n     question and answers it: a :table kind already exists, and a table that\n     cannot open a row is a table missing an affordance, not a vocabulary\n     missing a kind. So the snapshot gains the gesture.\n\n     A ROW :tone, 2026-10-05 (decision 33 of RESEARCH-ikc-v3-033-01). A row\n     map that holds :tone, a value of the :tone enum, draws its text in that\n     colour token. The board draws a blocked card so. A row with no :tone is\n     unchanged. The cells still come from :columns only.\n\n     :draggable, 2026-10-08 (IKC3/PLAN-ikc-v3-064-01/DRAG, SPEC-ikc-v3-001-01\n     A13). With it, each row can be dragged. A :box with :on-gesture :drop\n     takes the row, and $dragged in its template is the row's own map, as\n     $value is for :submit. The row crosses as JSON under the MIME type\n     application/x-ikc-row+json, so a file is not taken as a row. The click of\n     a row stays: a keyboard and the terminal have no drag. The terminal\n     renderer ignores the prop.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:draggable {:optional true} :boolean]],
     :gestures [:submit],
     :defaults {},
     :children :none,
     :box-from :content},
    :file-input
    {:description
     "Mantine `FileInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 23 prop(s), 6 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"component" "any",
      "defaultValue" "Multiple extends true ? File[] : File",
      "multiple" "Multiple",
      "value" "Multiple extends true ? File[] : File"},
     :slots
     [:description
      :error
      :label
      :left-section
      :placeholder
      :right-section],
     :defaults
     {:clearable false,
      :left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "FileInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:name {:optional true, :doc "Input name attribute"} :string]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set, the input value cannot be changed"}
       :boolean]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :affix
    {:description
     "Mantine `Affix` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"position" "AffixPosition"},
     :defaults {:within-portal true, :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Affix"},
     :status :generated,
     :box-from :viewport,
     :props
     [:map
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]]},
    :portal
    {:description
     "Mantine `Portal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped {"target" "string | HTMLElement"},
     :defaults {:reuse-target-node true},
     :box-to-children :block-flow,
     :mantine {:component "Portal"},
     :status :generated,
     :box-from :viewport,
     :props
     [:map
      [:reuse-target-node
       {:optional true,
        :doc "If set, all portals are rendered in the same DOM node"}
       :boolean]]},
    :tags-input
    {:description
     "A TAG EDITOR: the tags of the thing being read, each one removable, with a\n     field that completes from the vocabulary the graph already holds.\n\n     HAND-WRITTEN SINCE 2026-09-15, and the generated header it replaced says\n     exactly why it had to graduate: a generated kind has 'no data binding, no\n     edit buffer and no selection state of its own'. This kind needs all three.\n     :value is BOUND to the tags of the selected page and :suggestions to the tag\n     vocabulary, the field keeps a buffer while a person types, and the dropdown\n     keeps which row is active. graph-ui.web.widgets/widget-tags-input and an\n     explicit case in render.cljs are what those three cost.\n\n     THIRTY-THREE PROPS BECAME FIVE, and the ones that went were the library's,\n     not the product's. Mantine's TagsInput exposes its whole controlled-combobox\n     surface — :dropdown-opened, :search-value, :select-first-option-on-change\n     and twenty-five more. A description that set any of them would be reaching\n     past the contract into the component. What is declared here is the CONTRACT:\n     two bound props, one label, one posture, one size.\n\n     FOUR WAYS TO ADD AND THREE TO REMOVE, and each is the outliner idiom rather\n     than a choice made here. Enter, a comma and a loss of focus each add what is\n     typed. The cross on a tag removes it, and Backspace in an empty field\n     removes the last one.\n\n     THE SUGGESTIONS ARRIVE AS AN ORDINARY BIND, and the client narrows them per\n     keystroke. George decided that on 2026-08-20. The vocabulary is about 300\n     strings on this corpus, so one read beats a protocol that speaks on every\n     key.\n\n     A GESTURE CARRIES ONE TAG IN $value, never the whole list. The two commands\n     that write a :tags slot take one tag each (ADR-ikc-v3-080-01 decision 7), and\n     a widget that emitted the vector would make the handler compute a difference\n     to find out what a person did.\n\n     WHAT IT CANNOT DO, AND THE HELP PAGE SAYS SO. The editor writes the :tags\n     SLOT. An inline #hashtag lives in the text, and the file is the truth\n     (ADR-ikc-v3-052-01), so a cross on such a tag would promise a removal this\n     cannot perform. :tags/tags-of-frame reports which storage each tag came\n     from, and only a slot tag is offered a cross.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the tags as joined text and\n     dispatches nothing. A terminal has no dropdown, and a line of words is what\n     a reader of that surface needs.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true,
        :doc
        "The tags on the thing being read. BOUND, normally to\n                        :page-tag-list."}
       [:vector :string]]
      [:suggestions
       {:optional true,
        :doc
        "The known tag vocabulary, for completion. BOUND,\n                              normally to :tag-vocabulary. The client filters\n                              it."}
       [:vector :string]]
      [:placeholder
       {:optional true,
        :doc
        "What the empty field says. An empty tag editor is\n                              indistinguishable from a broken one without it."}
       :string]
      [:read-only
       {:optional true,
        :doc
        "Draw the tags and accept nothing. The TUI's posture,\n                            and a reading surface that must not be edited."}
       :boolean]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:size :sm},
     :gestures [:add :remove],
     :children :none,
     :box-from :content},
    :radio
    {:description
     "Mantine `Radio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"icon" "FC<RadioIconProps>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label],
     :defaults {:label-position :right, :radius :xl, :size :sm},
     :mantine {:component "Radio"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color, by default value depends on `theme.autoContrast`"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :transition
    {:description
     "Mantine `Transition` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :defaults {:duration 250, :exit-duration 250},
     :box-to-children :block-flow,
     :mantine {:component "Transition", :children :function},
     :status :generated,
     :box-from :content,
     :gestures [:enter :entered :exit :exited],
     :props
     [:map
      [:duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]
      [:enter-delay
       {:optional true,
        :doc "Delay in ms before enter transition starts"}
       [:or :int :double]]
      [:exit-delay
       {:optional true,
        :doc "Delay in ms before exit transition starts"}
       [:or :int :double]]
      [:exit-duration
       {:optional true, :doc "Exit transition duration in ms"}
       [:or :int :double]]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the element is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:mounted
       {:optional true,
        :doc
        "Determines whether component should be mounted to the DOM"}
       :boolean]
      [:timing-function
       {:optional true, :doc "Transition timing function"}
       :string]
      [:transition
       {:optional true, :doc "Transition name or object"}
       [:or
        [:enum
         :scale
         :fade
         :fade-down
         :fade-up
         :fade-left
         :fade-right
         :skew-up
         :skew-down
         :rotate-right
         :rotate-left
         :slide-down
         :slide-up
         :slide-right
         :slide-left
         :scale-y
         :scale-x
         :pop
         :pop-top-left
         :pop-top-right
         :pop-bottom-left
         :pop-bottom-right]
        :string]]]},
    :button
    {:description
     "ADR-graph-ui-v0-007-01: a standalone clickable button, built on\n     @radix-ui/react-slot. :label is the button's text; :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit) is\n     dispatched on click — $session-id substitutes as usual, $value is not\n     meaningful for a plain button unless a specific template hardcodes\n     one. :disabled blocks the click. TUI renders the label as plain text,\n     read-only.\n\n     :density is the SAME noun :box, :stack and :group carry, and it means the\n     same thing. It says how much room the kind takes around its content.\n     :compact gives the button Mantine compact padding, which is 8 px on each\n     side against 18 px. A row of buttons in a narrow column needs it. ikc1\n     gives its own sidebar row 8 px (AthensSidebar.tsx line 793).\n\n     :effect (IKC3/PLAN-ikc-v3-082-01/WD-PUSH): a step that only the browser\n     can do, before the command. The one value is :enable-push. The click asks\n     for the permission to notify, subscribes this device to push messages, and\n     then sends the :submit command with $push-subscription and $device-label\n     filled. A refusal of the browser shows beside the button as a sentence,\n     and no command goes. The TUI has no browser and ignores it.\n\n     :show-result {:key k :says s}: after the command, the button writes s and\n     the value of the key k of the answer beside itself. It is for a command\n     that answers with a count, as :contact/send does. A refusal shows in its\n     place.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:effect {:optional true} [:enum :enable-push]]
      [:show-result
       {:optional true}
       [:map [:key :keyword] [:says :string]]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :spoiler
    {:description
     "Mantine `Spoiler` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"controlRef" "ForwardedRef<HTMLButtonElement>"},
     :slots [:hide-label :show-label],
     :defaults {:max-height 100, :transition-duration 200},
     :box-to-children :block-flow,
     :mantine {:component "Spoiler"},
     :status :generated,
     :box-from :content,
     :gestures [:expanded-change],
     :props
     [:map
      [:expanded
       {:optional true, :doc "Controlled expanded state value"}
       :boolean]
      [:initial-state
       {:optional true,
        :doc
        "Initial spoiler state, `true` to wrap content in spoiler, `false` to show content without spoiler, opened state is updated on mount"}
       :boolean]
      [:max-height
       {:optional true,
        :doc
        "Maximum height of the visible content, when this point is reached spoiler appears"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Spoiler reveal transition duration in ms, set 0 or null to turn off animation"}
       [:or :int :double]]]},
    :notification
    {:description
     "Mantine `Notification` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 3 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :slots [:icon :title],
     :defaults {:with-close-button true},
     :box-to-children :block-flow,
     :mantine {:component "Notification"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Controls notification line or icon color, key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:loading
       {:optional true,
        :doc
        "If set, the `Loader` component is displayed instead of the icon"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is visible"}
       :boolean]]},
    :highlight
    {:description
     "Mantine `Highlight` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Highlight"},
     :props
     [:map
      [:children
       {:optional true,
        :doc "String parts of which must be highlighted"}
       :string]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:highlight
       {:optional true,
        :doc
        "Substring or a list of substrings to highlight in `children`"}
       [:vector :any]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:span
       {:optional true, :doc "Shorthand for `component=\"span\"`"}
       :boolean]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]],
     :defaults
     {:highlight [], :inherit false, :inline false, :size :md},
     :unmapped {"color" "string | (string & {})"},
     :children :none,
     :box-from :content},
    :mark
    {:description
     "Mantine `Mark` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Mark"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :checkbox
    {:description
     "Mantine `Checkbox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"icon" "FC<{ indeterminate: boolean; className: string; }>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label],
     :defaults {:label-position :right, :size :sm},
     :mantine {:component "Checkbox"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input background color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color. By default, depends on `theme.autoContrast`."}
       [:or :keyword :string]]
      [:id {:optional true, :doc "Unique input id"} :string]
      [:indeterminate
       {:optional true,
        :doc
        "Indeterminate state of the checkbox. If set, `checked` prop is ignored."}
       :boolean]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                 be a :box with a :title (used as the tab label). :active (default 0)\n                 is the index of the visible tab. The renderer draws a tab header line\n                 and shows only the active child's content below it.\n\n                 THE WEB RENDERER DID NOT DO THAT UNTIL 2026-08-23, and this\n                 paragraph is why it now does. It mounted every panel, so a page\n                 click — which changes the bound value of all of them — rebuilt\n                 the lot: 798 DOM mutations for one click, 799 of 815 of them\n                 inside the Tabs component, measured on the running deployment.\n                 The TUI had drawn only the active child all along, so two\n                 renderers disagreed about one description and the words above\n                 were on the TUI's side (PLAN-ikc-v3-019-01 phase 4).\n\n                 ONE EXCEPTION, AND IT IS DERIVED RATHER THAN DECLARED. A child\n                 whose subtree holds a widget with an edit buffer — :input,\n                 :text-area, :outline — keeps its content drawn whichever tab is\n                 active. That buffer lives in the renderer, so unmounting it would\n                 throw away text a person typed and has not saved, with nothing\n                 saying so. The renderer reads it off the child's own subtree\n                 (graph-ui.web.widgets/holds-draft?), so no island declares it and\n                 none can forget it.\n\n                 DERIVED BECAUSE A DERIVED RULE CANNOT DRIFT, and for no other\n                 reason. An earlier draft of this paragraph also argued that a\n                 declared slot would be unavailable to an island pinned to a\n                 released vocabulary. George struck that on 2026-08-23: a version\n                 pin is not a reason to shape a design around it. If the right\n                 answer needs a slot, the slot is added and the island is moved.\n\n                 THE EXCEPTION IS A SYMPTOM AND IT HAS AN OWNER. An editor's\n                 unsaved text should not live in component state at all\n                 (PLAN-ikc-v3-018-01: drafts in browser storage, keyed by the\n                 thing being edited). When it does not, holds-draft? is deleted\n                 and a tab-set draws one child with no exception at all.\n\n                 THE TITLE IS THE TAB LABEL, AND ONLY THAT. A :box child does not\n                 draw its :title a second time as a header above its content.\n                 Until 2026-10-06 both renderers drew it twice. reader-v3 then\n                 showed PAGE, FILE and PREVIEW or EDIT under the tabs that said\n                 them, in nested frames (fault report 20fee998). Each renderer\n                 has one rule for it: graph-ui.web.widgets/tab-panel and\n                 ui.render.tui/tab-panel. With :chrome false no tab draws, and\n                 the :title is still only a label.\n\n                 THE LINE OF THE TABS CAN HOLD OTHER WIDGETS (2026-10-09, lane\n                 IKC3/PLAN-ikc-v3-068-01/T). A child with :section :left-section\n                 is drawn before the tabs, and one with :section :right-section\n                 after them, at the right edge. Such a child is not a tab: it has\n                 no panel, it is never hidden, and :active counts the tabs only.\n                 George's edit of the reading pane put pin, copy, File and Frame\n                 on one line, and this is how a description says it. With\n                 :chrome false no tab is drawn, and the line holds these children\n                 only. The line wraps, so a narrow pane cuts no control. The TUI\n                 draws these children on one line above its tab labels. Each\n                 renderer splits the children by one rule:\n                 graph-ui.web.widgets/tab-line-child? and\n                 ui.render.tui/tab-line-child?. Both bind runtimes use the same\n                 rule in hides-child?.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any,
     :box-from :content,
     :box-to-children :definite},
    :pill
    {:description
     "Mantine `Pill` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :defaults {:radius :xl, :size :sm, :with-remove-button false},
     :box-to-children :block-flow,
     :mantine {:component "Pill"},
     :status :generated,
     :box-from :content,
     :gestures [:remove],
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Adds disabled attribute, applies disabled styles"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls pill `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-remove-button
       {:optional true,
        :doc "Controls visibility of the remove button"}
       :boolean]]},
    :simple-grid
    {:description
     "Equal-width columns — Mantine `SimpleGrid` (ADR-graph-ui-v0-013-01 Sec0), the\n     common case :grid's :span bookkeeping would be overkill for.",
     :status :in-progress,
     :props
     [:map
      [:cols {:optional true} :int]
      [:spacing {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:vertical-spacing
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:cols 1},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :grid
    {:description
     "Real 2D proportional layout — CSS GRID (ADR-graph-ui-v0-013-01 Sec3).\n     :columns is the TOTAL (12 by default); each :grid-col child states\n     its :span of that total — '50-50' is two :grid-col children at :span 6.\n     :gutter is the gap between cells (a separate name from :gap elsewhere\n     in this vocabulary, because Mantine's Grid named it that and every\n     declaration here says :gutter). Children SHOULD be :grid-col.\n\n     EVERY CELL HAS A DEFINITE HEIGHT, and every row an equal share of the\n     grid. That is the whole reason this kind is CSS grid and not Mantine's\n     `Grid`, which is a wrapping flexbox: a flexbox row is as tall as its\n     content, so a :scroll-area in a cell grew instead of scrolling, and a\n     second row did not share the height with the first (2026-08-23).\n\n     :grow AND :offset ARE GONE, with the :auto and :content spans. A\n     wrapping flexbox could do those three and a grid cannot. Nothing\n     declared them, so a description that names one is now refused at\n     \"disallowed key\" instead of the renderer dropping it without a word.\n     The gate is the description validator that every island's own test\n     runs, and NOT validate-dsl, which checks this manifest and not the\n     instances.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} :int]
      [:gutter {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:columns 12},
     :children :any,
     :box-from :content,
     :box-to-children :definite},
    :visually-hidden
    {:description
     "Mantine `VisuallyHidden` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "VisuallyHidden"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :floating-indicator
    {:description
     "Mantine `FloatingIndicator` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 4 prop(s),\n     and 2 prop(s) whose type carries no data contract (see :unmapped).\n     RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the component\n     named above straight from this declaration — the props here are the legal\n     ones, the gestures here are the wired ones, and nothing else reaches the\n     DOM. Generic is not finished: this kind has no data binding, no edit\n     buffer and no selection state of its own. A kind that needs one of those\n     graduates to a hand-written widget and an explicit case in render.cljs —\n     move it above the GENERATED marker and give it a description that explains\n     ITSELF.",
     :children :none,
     :needs :both,
     :unmapped {"parent" "HTMLElement", "target" "HTMLElement"},
     :defaults {:transition-duration 150},
     :mantine {:component "FloatingIndicator"},
     :status :generated,
     :box-from :parent,
     :props
     [:map
      [:display-after-transition-end
       {:optional true,
        :doc
        "If set, the indicator is displayed after transition ends. Should be set if the component is used inside a container that has `transform: scale(n)` styles."}
       :boolean]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :string :int :double]]]},
    :popover
    {:description
     "Mantine `Popover` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 29 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "Popover"},
     :status :generated,
     :box-from :viewport,
     :gestures
     [:change
      :close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n     the toggle line; :collapsed (default false) controls initial state.\n     :count (ADR-graph-ui-v0-013-01 Sec17): an optional int shown beside the\n     title (the '12 pages' style header). :icon: an optional :icon name\n     leading the title. The expand/collapse chevron itself is not a prop —\n     every :collapsible has one, it is not a per-instance choice.\n\n     :hide-when-empty (F-platform-v0-014-01, 2026-08-18) — draw NOTHING, not an\n     empty heading, when every bound child inside is empty. Default false, which\n     is every existing section's behaviour.\n\n     WHY IT HAS TO BE A PROP. Emptiness is a RUNTIME fact, so it cannot be\n     settled where a section's existence is otherwise decided: ui.blocks drops a\n     collection that has no :source at EXPANSION time, which is a statement about\n     the declaration, not about today's data. A Pinned section has a source and is\n     usually empty, and ikc1 draws it only once something is pinned\n     (AthensSidebar.tsx: `{pinnedFrames.length > 0 && …}`).\n\n     AND WHY THIS DOES NOT CONTRADICT THE RIGHT GUTTER, which is drawn even when\n     empty on the stated rule that 'a column that comes and goes per row is not a\n     column' (dsl/design/block-row.edn). A sidebar section is not a column:\n     nothing aligns to it, and an empty one spends a heading plus its own vertical\n     space on every screen. Progressive disclosure applies\n     (CONCEPT-graph-ui-v0-008-01); column stability does not.\n\n     :on-gesture :toggle (2026-09-08, PLAN-ikc-v3-028-01 Q5): fires when the\n     chevron opens or closes the section, $value = {:import-id :open?}. The open\n     state stays the client's; the gesture is how a guide learns that a section\n     was looked at. Absent, nothing fires — every existing section is unchanged.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:count {:optional true} :int]
      [:icon {:optional true} :keyword]
      [:hide-when-empty {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false, :hide-when-empty false},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :swimlane
    {:description
     "ONE HORIZONTAL BAND OF THE BOARD, WITH A COLUMN FOR EACH STATUS CATEGORY\n     (IKC3/PLAN-ikc-v3-080-01/BOARD, screen 1 of the plan). Its children are\n     :board-column nodes, side by side, each as tall as the longest one. Each\n     column has its own heading with its count, so each swimlane has its own\n     headings (decision 4 of the plan).\n\n     THE SPEED LANE SHOWS ONLY WHEN IT HOLDS AN ITEM. With :hide-when-empty\n     true and a bound :value whose :count is 0, the swimlane draws nothing, its\n     title and its headings too. Then it takes no place, and the furniture\n     under it does not move while it is absent.\n\n     A TITLE, when :value or the node gives one, is one line over the columns,\n     with the count, in the tone of the node.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the title, then its columns\n     as a stack.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:hide-when-empty {:optional true} :boolean]
      [:value
       {:optional true}
       [:map
        [:title {:optional true} :string]
        [:count {:optional true} :int]]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-row},
    :ring-progress
    {:description
     "Mantine `RingProgress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "RingProgress"},
     :props
     [:map
      [:root-color
       {:optional true,
        :doc
        "Color of the root section, key of theme.colors or CSS color value"}
       [:or :keyword :string]]
      [:round-caps
       {:optional true,
        :doc
        "Sets whether the edges of the progress circle are rounded"}
       :boolean]
      [:sections {:optional true, :doc "Ring sections"} [:vector :any]]
      [:size
       {:optional true, :doc "Width and height of the progress ring"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Ring thickness"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]],
     :defaults
     {:sections [], :size 120, :thickness 12, :transition-duration 0},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :segmented-control
    {:description
     "Mantine `SegmentedControl` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "SegmentedControl"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, changes color of indicator, by default color is based on current color scheme"}
       [:or :keyword :string]]
      [:data
       {:optional true,
        :doc "Data based on which controls are rendered"}
       [:vector :any]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Determines whether the component is disabled"}
       :boolean]
      [:full-width
       {:optional true,
        :doc
        "Determines whether the component should take 100% width of its parent"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "Name of the radio group, by default random name is generated"}
       :string]
      [:orientation
       {:optional true, :doc "Component orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set to `false`, prevents changing the value"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls `font-size`, `padding` and `height` properties"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc
        "Indicator `transition-duration` in ms, set `0` to turn off transitions"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "Indicator `transition-timing-function` property"}
       :string]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-items-borders
       {:optional true,
        :doc
        "Determines whether there should be borders between items"}
       :boolean]],
     :defaults
     {:data [],
      :full-width false,
      :orientation :horizontal,
      :size :sm,
      :transition-duration 200,
      :with-items-borders true},
     :gestures [:change],
     :children :none,
     :box-from :content},
    :number-formatter
    {:description
     "Mantine `NumberFormatter` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "NumberFormatter"},
     :props
     [:map
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that are displayed after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true,
        :doc "Character used as a decimal separator, `'.'` by default"}
       :string]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, zeros are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:prefix
       {:optional true, :doc "Prefix added before the value"}
       :string]
      [:suffix
       {:optional true, :doc "Suffix added after the value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style"}
       [:enum :none :thousand :lakh :wan]]
      [:value
       {:optional true, :doc "Value to format"}
       [:or :string :int :double]]],
     :defaults
     {:allow-negative true,
      :fixed-decimal-scale false,
      :thousand-separator ","},
     :children :none,
     :box-from :content},
    :status-menu
    {:description
     "THE STATUS OF A WORK ITEM AND THE MOVES IT CAN TAKE\n     (IKC3/PLAN-ikc-v3-080-01/ITEM, screen 3 of the plan). A button shows the\n     status. A click on it opens the list of moves that the workflow declares\n     from that status. A choice sends the gesture :move with the target\n     category as $value. Beside the button, the first moves are links, as in\n     Jira, so the usual move is one click.\n\n     THE MOVES COME FROM THE DECLARATION. :value is bound to the answer of the\n     workflow: the status, and each declared transition from it with its\n     label. A rule of the move can still refuse one, and the refusal is the\n     sentence of the status line of the surface.\n\n     REOPEN ASKS FOR A REASON (IKC3/PLAN-ikc-v3-080-01/REPORT, screen 1b).\n     A transition carries its :name. The move named reopen opens the Reopen\n     dialog for :item-id, and that dialog sends :workflow/reopen. It sends\n     no gesture :move.\n\n     A MOVE CAN SEND ITS :value IN PLACE OF ITS :to\n     (IKC3/PLAN-ikc-v3-080-01/FLOW34, decision 34). A move into Done with a\n     resolution of its own, as Accept without verification, has :value, the\n     name of its transition. Its gesture :move sends that name as $value.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the status and the labels of\n     the moves, and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true}
       [:map
        [:label :string]
        [:category :string]
        [:item-id {:optional true} :string]
        [:transitions
         [:vector
          [:map
           [:to :string]
           [:label :string]
           [:name {:optional true} :string]
           [:value {:optional true} :string]]]]]]
      [:shown
       {:optional true,
        :doc
        "How many moves show as links beside the button. Default 2."}
       :int]],
     :defaults {:shown 2},
     :gestures [:move],
     :children :none,
     :box-from :content},
    :multi-select
    {:description
     "Mantine `MultiSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 6 named\n     child slot(s), 7 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData", "filter" "OptionsFilter"},
     :slots
     [:description
      :error
      :label
      :left-section
      :nothing-found-message
      :right-section],
     :defaults
     {:check-icon-position :left,
      :left-section-pointer-events "none",
      :hidden-input-values-divider ",",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :searchable false,
      :pointer false,
      :open-on-focus true,
      :with-check-icon true,
      :with-asterisk false,
      :with-aligned-labels false,
      :with-error-styles true,
      :required false,
      :hide-picked-options false},
     :mantine {:component "MultiSelect"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change
      :clear
      :dropdown-close
      :dropdown-open
      :option-submit
      :remove
      :search-change],
     :props
     [:map
      [:check-icon-position
       {:optional true,
        :doc "Position of the check icon relative to the option label"}
       [:enum :left :right]]
      [:chevron-color
       {:optional true, :doc "Controls color of the default chevron"}
       [:or :keyword :string]]
      [:clear-search-on-change
       {:optional true,
        :doc "Clear search value when item is selected"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section when the component has value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-search-value
       {:optional true, :doc "Default search value"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:vector :string]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:hidden-input-values-divider
       {:optional true,
        :doc
        "Divider used to separate values in the hidden input `value` attribute"}
       :string]
      [:hide-picked-options
       {:optional true,
        :doc
        "If set, picked options are removed from the options list"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:max-values
       {:optional true,
        :doc "Maximum number of values, no limit if not set"}
       [:or :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:search-value
       {:optional true, :doc "Controlled search value"}
       :string]
      [:searchable {:optional true, :doc "Allows searching"} :boolean]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:vector :string]]
      [:with-aligned-labels
       {:optional true,
        :doc "If set, unchecked labels are aligned with checked ones"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-check-icon
       {:optional true,
        :doc
        "If set, the check icon is displayed near the selected option label"}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :app-shell
    {:description
     "A PAGE — Mantine's `AppShell`, adopted whole (ADR-graph-ui-v0-001-01 §B).\n     Header / Navbar / Aside / Main / Footer, which is what a surface with a\n     navigation sidebar and a content area actually IS.\n\n     Adopted because the reader was hand-rolling one. `{:widget :split-pane\n     :initial 270 :min 180 :max 440}` wrapping a `:container` is a Navbar and a\n     Main expressed as flex arithmetic, with the sidebar's resize and collapse left\n     for the renderer to invent. Mantine ships that behaviour, including the\n     breakpoint at which the sidebar collapses — so 057-01's deferral of\n     responsiveness partly dissolves here rather than needing its own model.\n\n     SECTIONS ARE NAMED, NOT ORDERED. Children declare which section they are\n     via :section; there is no positional convention to remember and a\n     description that omits a section simply has none. That is the whole reason\n     this is a kind and not a :grid with agreed cells.\n\n     :mode is Mantine's own, and it is load-bearing HERE in a way it is not in a\n     plain web app. Mantine defaults to 'fixed', which positions every section\n     except Main against the VIEWPORT — correct for a page that owns the window,\n     wrong for an ikc3 island, which may be one pane of a canvas or embedded in\n     a tile. A fixed navbar would escape its island and land on the window. So\n     :mode defaults to :static here, and :fixed is the deliberate opt-in for a\n     surface that really does own the viewport. (The risk was named in the ADR\n     before this kind was declared; `mode` is Mantine's own answer to it, so\n     nothing had to be invented to resolve it.)\n\n     :navbar-width / :aside-width / :header-height / :footer-height take the\n     same open value :container's :size does — a token, a number, or a CSS\n     length — so a sidebar can be stated in ch or rem rather than pixels.\n     :navbar-breakpoint is the width below which the sidebar collapses; Mantine's\n     own token scale.\n\n     Gestures: none. An :app-shell arranges; it does not dispatch.",
     :children :any,
     :needs :both,
     :slots [:aside :footer :header :main :navbar],
     :defaults {:mode :static, :padding :md},
     :box-to-children :definite,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:mode {:optional true} [:enum :static :fixed]]
      [:padding {:optional true} [:enum :none :xs :sm :md :lg :xl]]
      [:navbar-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:aside-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:header-height {:optional true} :int]
      [:footer-height {:optional true} :int]
      [:navbar-breakpoint
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]]},
    :close-button
    {:description
     "Mantine `CloseButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :slots [:icon],
     :defaults {:size :md},
     :box-to-children :block-flow,
     :mantine {:component "CloseButton"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute, assigns disabled styles"}
       :boolean]
      [:icon-size
       {:optional true, :doc "`X` icon `width` and `height`"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :grid-col
    {:description
     "One cell of a :grid parent (ADR-graph-ui-v0-013-01 Sec3). :span is this\n     child's share of the parent's :columns total — STATED, not emergent\n     from siblings. An int only: :auto and :content went with the flexbox\n     (see :grid), and so did :offset.",
     :status :in-progress,
     :props
     [:map
      [:span {:optional true} :int]
      [:order {:optional true} :int]],
     :defaults {},
     :children :any,
     :box-from :props,
     :box-to-children :flex-column},
    :color-swatch
    {:description
     "Mantine `ColorSwatch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ColorSwatch"},
     :props
     [:map
      [:color
       {:optional true, :doc "Valid CSS color to display"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the swatch, any valid CSS value, numbers are converted to rem."}
       [:or :string :int :double]]
      [:with-shadow
       {:optional true,
        :doc
        "Determines whether the swatch should have inner `box-shadow`"}
       :boolean]],
     :defaults {:radius 1000, :size 28, :with-shadow true},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :box
    {:description
     "A plain container with no layout opinion — ADR-graph-ui-v0-013-01 Sec0: v1.x's\n     :layout enum and flex props (:direction/:wrap/:justify/:align/:gap) are\n     DROPPED from :box itself (a prop-level change within a kind that still\n     exists, so no :drops entry is needed for it — only whole kind/slot names\n     require one). Arrangement lives on :stack/:group/:flex/:grid/\n     :simple-grid below; :box is for grouping + chrome only.\n\n     ONE GESTURE, :drop, 2026-10-08 (IKC3/PLAN-ikc-v3-064-01/DRAG,\n     SPEC-ikc-v3-001-01 A13). A box with :on-gesture :drop takes a row dragged\n     from a :table that is :draggable, and sends ONE command. In its :with,\n     $dragged is the dragged row's own map, and [:of $dragged item-id] reads\n     one key. A drag that carries no row, for example a file, is refused.\n     While a row is over the box, the box shows an outline and the token\n     colour --accent-soft, and its layout does not change. The terminal\n     renderer ignores the gesture. A drop never replaces a keyboard path, so\n     the island keeps a click or a select for the same command.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:border {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation
       {:optional true}
       [:enum :flat :raised :floating :overlay]]],
     :gestures [:drop],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :paper
    {:description
     "Mantine `Paper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Paper"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                 is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                 plain monospaced text; a web renderer may apply syntax highlighting.\n                 A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :native-select
    {:description
     "Mantine `NativeSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "NativeSelect"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :kbd
    {:description
     "Mantine `Kbd` — GENERATED from @mantine/core's own TypeScript declarations\n     (PLAN-graph-ui-v0-009-01), not hand-written, so this kind says exactly\n     what the library promises and no more. 1 prop(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Kbd"},
     :props
     [:map
      [:size
       {:optional true, :doc "Controls `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :sm},
     :children :none,
     :box-from :content},
    :burger
    {:description
     "Mantine `Burger` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Burger"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS value, by default `theme.white` in dark color scheme and `theme.black` in light"}
       [:or :keyword :string]]
      [:line-size
       {:optional true,
        :doc
        "Controls height of lines, by default calculated based on `size` prop"}
       [:or :string :int :double]]
      [:opened
       {:optional true,
        :doc
        "State of the burger, when `true` burger is transformed into X"}
       :boolean]
      [:size
       {:optional true,
        :doc
        "Controls burger `width` and `height`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc "`transition-duration` property value in ms"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "`transition-timing-function` property value"}
       :string]],
     :defaults
     {:opened false,
      :size :md,
      :transition-duration 300,
      :transition-timing-function "ease"},
     :children :none,
     :box-from :content},
    :copy-button
    {:description
     "Mantine `CopyButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "CopyButton", :children :function},
     :props
     [:map
      [:timeout
       {:optional true, :doc "Copied status timeout in ms"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Value that is copied to the clipboard when the button is clicked"}
       :string]],
     :defaults {:timeout 1000},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :work-card
    {:description
     "ONE WORK ITEM AS A CARD OF THE BOARD (IKC3/PLAN-ikc-v3-080-01/BOARD, screen 1\n     of the plan). The title on two lines at most, the label of its epic, the\n     icon of its work type, its key, the arrow of its priority and the initials\n     of its assignee. Under a line, one sentence with its date: when it was\n     made, started, merged, deployed or resolved, and its pull request as a\n     link. An idle card or a blocked card has a flag with its reason. A card\n     in Deployed has the buttons Accept and Reopen.\n\n     THREE GESTURES. $value is the card map of :value, so a description reads\n     one key with [:of $value item-id].\n       :select  a click on the card\n       :accept  a click on Accept\n       :reopen  a click on Reopen. The browser first opens the Reopen\n                dialog of the card (graph-ui.web.reopen), which sends\n                :workflow/reopen. Then it sends the gesture.\n       :accept-unverified  a click on Accept without verification\n                (IKC3/PLAN-ikc-v3-080-01/FLOW34, decision 34).\n\n     A DRAG CARRIES THE CARD MAP when :draggable is true, as a row of a\n     :table that is :draggable does. A :board-column or a :box with\n     :on-gesture :drop takes it as $dragged.\n\n     THE RULES ARE IN THE GATE. The card shows each button that its :actions\n     names, and the command decides. A refusal is the sentence of the status\n     line of the surface, never a control that is grey.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the key, the title and the\n     sentence of the card on lines of their own, and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true}
       [:map
        [:item-id :string]
        [:title :string]
        [:key {:optional true} :string]
        [:type {:optional true} :string]
        [:type-label {:optional true} :string]
        [:priority {:optional true} :string]
        [:priority-label {:optional true} :string]
        [:assignee {:optional true} :string]
        [:initials {:optional true} :string]
        [:label {:optional true} :string]
        [:footer {:optional true} :string]
        [:link
         {:optional true}
         [:map [:label :string] [:href :string]]]
        [:flag {:optional true} :string]
        [:tone {:optional true} :string]
        [:selected {:optional true} :boolean]
        [:actions
         {:optional true}
         [:vector [:map [:gesture :string] [:label :string]]]]]]
      [:draggable
       {:optional true, :doc "A drag carries the card map."}
       :boolean]],
     :defaults {},
     :gestures [:select :accept :reopen :accept-unverified],
     :children :none,
     :box-from :content},
    :alert
    {:description
     "Mantine `Alert` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :slots [:icon :title],
     :defaults {:with-close-button false},
     :mantine {:component "Alert"},
     :status :generated,
     :box-from :content,
     :gestures [:close],
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-button-label
       {:optional true, :doc "Close button `aria-label`"}
       :string]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-close-button
       {:optional true,
        :doc "Determines whether close button should be displayed"}
       :boolean]]},
    :voice
    {:description
     "THE SPOKEN SURFACE — speech to text for a prompt, text to speech for the\n     entries this session is reading. George walks the dog with the phone in one\n     hand and the headphones on, and the headphones are only audio transport\n     (the plan says so): everything that has to be built is here and in the\n     browser.\n\n     TWO CONTROLS, EACH ITS OWN BOOLEAN. :dictate shows the control that\n     listens. :read shows the control that speaks. A node may show one, the\n     other, or both, because they belong in different places — the prompt box\n     wants the microphone and the reading pane wants the reader.\n\n     THE RECOGNIZED TEXT IS NEVER SENT. It lands in the prompt box named by\n     :target, as if the reader had typed it, and the reader sends it. That is\n     the platform's standing rule that user input travels verbatim and a person\n     decides (ADR-ikc-v3-075-01 - the prompt box forwards the text VERBATIM).\n     Speech recognition is wrong often enough that auto-dispatch would be a\n     command nobody wrote. :target is the :import-id of the :prompt-area, not a\n     widget id, so it survives a re-seed like every other authored reference.\n\n     WHAT IS READ ALOUD is the bound value: the entries of the conversation this\n     session has selected, each with its :role, its :text, its :thinking and its\n     :harness? flag. A HARNESS BLOCK IS NEVER SPOKEN. The harness writes machine\n     messages with the role user (the harness fold, 2026-08-20), and reading one\n     aloud in a synthetic voice would be the same defect one layer out - the\n     record would lie in his ear instead of on his screen. THINKING IS NOT\n     SPOKEN unless :read-thinking is true: an answer is what a reader walking a\n     dog asked for. The thinking is longer than the answer.\n\n     :read-count is how many of the NEWEST entries the read control speaks. A\n     conversation is thousands of entries long and a reader who taps 'read'\n     wants what just arrived, so the control reads a tail and says on the\n     surface how many of how many it took. Three by default.\n\n     :language is a BCP-47 tag for both halves - recognition and speech. One\n     slot, because a reader who dictates in one language does not want the\n     answer read in another.\n\n     Gestures: NONE, and that is the point. A :voice dispatches no command. It\n     fills a prompt box and it drives the audio output, both of which are this\n     browser's own business.\n\n     WITHOUT A SECURE CONTEXT IT SAYS SO. The browser speech APIs are absent on\n     plain HTTP, so the controls cannot work until phase 5 puts the deployment\n     behind TLS. The widget then renders its controls DISABLED with the reason\n     and the remedy in words on the surface, and records the refusal on the\n     observability surface. A silent no-op is what\n     PRINCIPLE-ikc-v3-010-01 calls a defect, and a console line is a signal\n     nobody walking a dog can read.\n\n     Web renderer only. The TUI has no microphone and no loudspeaker, so it\n     renders nothing at all - the same documented no-op that :flex sets.",
     :status :in-progress,
     :props
     [:map
      [:dictate {:optional true} :boolean]
      [:read {:optional true} :boolean]
      [:target {:optional true} :string]
      [:language {:optional true} :string]
      [:read-thinking {:optional true} :boolean]
      [:read-count {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:language "en-US", :read-thinking false, :read-count 3},
     :children :none,
     :box-from :content},
    :flex
    {:description
     "Explicit flex container, direction stated — Mantine `Flex`\n     (ADR-graph-ui-v0-013-01 Sec0). For when :stack (always vertical) / :group\n     (always horizontal) aren't enough. Distinct from the :flex UNIVERSAL\n     SLOT (this version's :universal-slots) — that is a CHILD's self-sizing\n     hint; this is a CONTAINER kind. Mantine overloads `flex` the same way (a\n     Mantine Flex component AND a Box style prop); v2.0 keeps that overlap rather\n     than inventing new names.",
     :status :in-progress,
     :props
     [:map
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:row-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:column-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-both},
    :focus-trap
    {:description
     "Mantine `FocusTrap` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "FocusTrap"},
     :props
     [:map
      [:active
       {:optional true, :doc "If set to `false`, disables focus trap"}
       :boolean]
      [:ref-prop
       {:optional true, :doc "Prop that is used to access element ref"}
       :string]],
     :defaults {:ref-prop "ref"},
     :unmapped {"children" "any", "innerRef" "ForwardedRef<any>"},
     :children :none,
     :box-from :content},
    :icon
    {:description
     "A line icon — ADR-graph-ui-v0-013-01 Sec11: @tabler/icons-react, closed to a\n     named set (not the library's full catalogue). :icon maps 1:1 to one\n     tabler React component in the renderer's own lookup table (widgets.cljs's\n     icon-components). Closed as a real [:enum ...] (not a bare :keyword,\n     which a prior draft of this rule wrongly claimed was already\n     validate-dsl-catchable — it was not, a keyword type check accepts any\n     keyword; fixed 2026-07-27 when Phase 2 needed 5 more names). Web-only;\n     TUI renders nothing (documented no-op, same precedent as\n     :elevation/:button). The 20 from Sec11's original set plus 5 added for\n     PLAN-graph-ui-v0-007-01 Phase 2's locked-target reader (the mockup's own\n     'outline view'/'theme config'/'theme selector'/'pin'/'copy' icons, none\n     of which are on a disabled/not-yet-built affordance, so they earn a real\n     name now rather than waiting).",
     :status :in-progress,
     :props
     [:map
      [:icon
       {:optional true}
       [:enum
        :search
        :chevron-down
        :chevron-right
        :chevron-up
        :chevron-left
        :tag
        :star
        :settings
        :close
        :plus
        :more
        :check
        :calendar
        :folder
        :file
        :link
        :trash
        :edit
        :menu
        :home
        :outline-view
        :theme-config
        :theme-selector
        :pin
        :copy]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :verse-rows
    {:description
     "A book's reading surface: one row per verse, each row carrying the\n     translation, the source text and the verse's notes as three aligned\n     cells. :items is the bound list, each item\n     {:verse-id string :text string :original string\n      :notes [{:head string :kind string}]}.\n\n     :show-source and :show-notes are the reader's, not the author's — the\n     second and third columns can be closed, which is what George asked for\n     when he said a reader may prefer the book without the Chinese. Closing a\n     column widens the ones that remain rather than leaving a gap.\n\n     A verse is ONE paragraph, so prose typography needs no markdown here: the\n     cell is styled text and reads the same. That is what lets the row exist\n     at all — a markdown document cannot be a table cell.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:empty-label {:optional true} :string]
      [:show-source {:optional true} :boolean]
      [:show-notes {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:show-source true, :show-notes true},
     :children :none,
     :box-from :content},
    :color-picker
    {:description
     "Mantine `ColorPicker` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 12 prop(s), 3\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "ColorPicker"},
     :props
     [:map
      [:alpha-label
       {:optional true, :doc "Alpha slider `aria-label`"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:focusable
       {:optional true,
        :doc
        "If set, interactive elements (sliders thumbs and swatches) are focusable with keyboard"}
       :boolean]
      [:format
       {:optional true, :doc "Color format"}
       [:enum :hex :hexa :rgba :rgb :hsl :hsla]]
      [:full-width
       {:optional true,
        :doc "If set, the component takes 100% width of its container"}
       :boolean]
      [:hue-label
       {:optional true, :doc "Hue slider `aria-label`"}
       :string]
      [:saturation-label
       {:optional true, :doc "Saturation slider `aria-label`"}
       :string]
      [:size
       {:optional true,
        :doc "Controls size of hue, alpha and saturation sliders"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:swatches
       {:optional true,
        :doc
        "A list of colors used to display swatches list below the color picker"}
       [:vector :string]]
      [:swatches-per-row
       {:optional true, :doc "Number of swatches per row"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-picker
       {:optional true,
        :doc "Determines whether the color picker should be displayed"}
       :boolean]],
     :defaults
     {:focusable true,
      :format :hex,
      :full-width false,
      :size :md,
      :swatches-per-row 7,
      :with-picker true},
     :gestures [:change :change-end :color-swatch-click],
     :children :none,
     :box-from :content},
    :drawer
    {:description
     "A slide-over — Mantine `Drawer`/`DrawerRoot` (ADR-graph-ui-v0-013-01 Sec15):\n     SPEC-002's '340px slide-over + scrim' is Drawer's own overlay, not\n     hand-rolled. Closing (Escape, scrim click, or the built-in close\n     button — all three are ModalBase's own affordances) fires\n     :on-gesture's :submit key with no $value, the same slot a plain\n     :button fires.",
     :status :in-progress,
     :props
     [:map
      [:opened {:optional true} :boolean]
      [:title {:optional true} :string]
      [:position {:optional true} [:enum :left :right :top :bottom]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:position :right},
     :children :any,
     :box-from :viewport,
     :box-to-children :block-flow},
    :icon-button
    {:description
     "An icon button — Mantine `ActionIcon` (ADR-graph-ui-v0-013-01 Sec12). Also\n     covers SPEC-002's 'toggle button' row: a toggle is an icon-button with\n     :on set; mutual exclusion among several is the COMPOSING description's\n     concern (each button's :on-gesture clears its siblings), not a second\n     widget kind. :on is a renderer convention (ActionIcon has no native\n     'pressed' prop): true swaps Mantine's `variant` to :filled, false/absent\n     to :subtle. :tooltip wraps the button in Mantine's `Tooltip`. Fires\n     :on-gesture's :submit key on click, same as :button.\n\n     :confirm (lane AL-R, 2026-09-29): a question the click asks first. The\n     command goes only after the person says yes. With no answer, or no, the\n     click sends nothing. It is for a destructive command, as Delete note is\n     (ikc1 asks with window.confirm before handleDeletePage). A script that\n     sends the command directly is not asked: the question guards a gesture,\n     not the command.\n\n     :copy-result (lane AL-R, 2026-09-29): a key of the command's answer. The\n     click writes that value to the clipboard when the answer comes back, as\n     Copy note as text does with :text. A server cannot reach a clipboard, so\n     the command answers with the text and the button that asked writes it\n     (:ui/link-to-mark and the highlight row do the same).\n\n     Both are web-renderer behaviour. The TUI has no dialog and no clipboard,\n     and ignores them.",
     :status :in-progress,
     :props
     [:map
      [:icon {:optional true} :keyword]
      [:tooltip {:optional true} :string]
      [:on {:optional true} :boolean]
      [:disabled {:optional true} :boolean]
      [:confirm {:optional true} :string]
      [:copy-result {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :modal
    {:description
     "Mantine `Modal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 21 prop(s), 2 named\n     child slot(s), 3 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"xOffset" "MarginLeft<string | number>",
      "yOffset" "MarginTop<string | number>"},
     :slots [:title],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :with-close-button true,
      :full-screen false,
      :with-overlay true,
      :centered false,
      :shadow :xl,
      :lock-scroll true},
     :box-to-children :block-flow,
     :mantine {:component "Modal"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:centered
       {:optional true,
        :doc "If set, the modal is centered vertically"}
       :boolean]
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:full-screen
       {:optional true,
        :doc "If set, the modal takes the entire screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:stack-id
       {:optional true, :doc "Id of the modal in the `Modal.Stack`"}
       :string]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is rendered"}
       :boolean]
      [:with-overlay
       {:optional true, :doc "If set, the overlay is rendered"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :accordion
    {:description
     "Mantine `Accordion` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"defaultValue" "AccordionValue<Multiple>",
      "multiple" "Multiple",
      "order" "AccordionHeadingOrder",
      "value" "AccordionValue<Multiple>"},
     :slots [:chevron],
     :defaults
     {:chevron-icon-size 16, :loop true, :transition-duration 200},
     :mantine {:component "Accordion"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:chevron-icon-size
       {:optional true,
        :doc
        "Size of the default chevron icon. Ignored when `chevron` prop is set."}
       [:or :string :int :double]]
      [:chevron-position
       {:optional true,
        :doc "Position of the chevron relative to the item label"}
       [:enum :left :right]]
      [:chevron-size
       {:optional true, :doc "Size of the chevron icon container"}
       [:or :string :int :double]]
      [:disable-chevron-rotation
       {:optional true, :doc "If set, chevron rotation is disabled"}
       :boolean]
      [:loop
       {:optional true,
        :doc
        "If set, arrow keys loop though items (first to last and last to first)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]]},
    :theme-icon
    {:description
     "Mantine `ThemeIcon` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ThemeIcon"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color."}
       [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc "Gradient data used when `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :title
    {:description
     "Mantine `Title` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"order" "TitleOrder", "size" "TitleSize"},
     :defaults {:text-wrap :wrap},
     :box-to-children :block-flow,
     :mantine {:component "Title"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which heading will be truncated"}
       [:or :int :double]]
      [:text-wrap
       {:optional true, :doc "Heading `text-wrap` CSS property"}
       [:enum :nowrap :wrap :balance :pretty :stable]]]},
    :skeleton
    {:description
     "Mantine `Skeleton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"height" "Height<string | number>",
      "radius" "BorderRadius<string | number>"},
     :defaults {:animate true, :circle false, :visible true},
     :box-to-children :block-flow,
     :mantine {:component "Skeleton"},
     :status :generated,
     :box-from :props,
     :props
     [:map
      [:animate {:optional true, :doc "Enables animation"} :boolean]
      [:circle
       {:optional true,
        :doc
        "If set, Skeleton `width` and `border-radius` are equal to its `height`"}
       :boolean]
      [:visible
       {:optional true,
        :doc "Determines whether Skeleton overlay should be displayed"}
       :boolean]
      [:width
       {:optional true,
        :doc
        "Skeleton `width`, numbers are converted to rem, ignored when `circle` prop is set."}
       [:or :string :int :double]]]},
    :nav-link
    {:description
     "Mantine `NavLink` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 5 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :slots [:description :label :left-section :right-section],
     :defaults
     {:active false,
      :children-offset :lg,
      :disable-right-section-rotation false,
      :disabled false,
      :no-wrap false},
     :box-to-children :block-flow,
     :mantine {:component "NavLink"},
     :status :generated,
     :box-from :content,
     :gestures [:change :click :key-down],
     :props
     [:map
      [:active
       {:optional true,
        :doc "Determines whether the link should have active styles"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:children-offset
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set collapsed links `padding-left`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS color to control active styles"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled nested items collapse initial state"}
       :boolean]
      [:disable-right-section-rotation
       {:optional true,
        :doc
        "If set, right section will not be rotated when collapse is opened"}
       :boolean]
      [:disabled
       {:optional true,
        :doc
        "If set, disabled styles will be added to the root element"}
       :boolean]
      [:no-wrap
       {:optional true,
        :doc
        "If set, label and description do not wrap to the next line"}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled nested items collapse state"}
       :boolean]]},
    :center
    {:description
     "Mantine `Center` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Center"},
     :props
     [:map
      [:inline
       {:optional true,
        :doc "If set, `inline-flex` is used instead of `flex`"}
       :boolean]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :content},
    :number-input
    {:description
     "Mantine `NumberInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 5 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"handlersRef" "ForwardedRef<NumberInputHandlers>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :hide-controls false,
      :allow-decimal true,
      :allow-negative true,
      :type :text,
      :right-section-pointer-events "none",
      :value-is-numeric-string false,
      :decimal-separator ".",
      :size :sm,
      :allow-leading-zeros true,
      :fixed-decimal-scale false,
      :trim-leading-zeroes-on-blur true,
      :with-asterisk false,
      :start-value 0,
      :with-keyboard-events true,
      :step 1,
      :with-error-styles true,
      :required false},
     :mantine {:component "NumberInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change :value-change],
     :props
     [:map
      [:allow-decimal
       {:optional true, :doc "If set, decimal values are allowed"}
       :boolean]
      [:allow-leading-zeros
       {:optional true,
        :doc
        "Determines whether leading zeros are allowed. If set to `false`, leading zeros are removed when the input value becomes a valid number."}
       :boolean]
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:allowed-decimal-separators
       {:optional true,
        :doc
        "Characters which when pressed result in a decimal separator"}
       [:vector :string]]
      [:clamp-behavior
       {:optional true,
        :doc
        "Controls how value is clamped, `strict` – user is not allowed to enter values that are not in `[min, max]` range, `blur` – user is allowed to enter any values, but the value is clamped when the input loses focus (default behavior), `none` – lifts all restrictions, `[min, max]` range is applied only for controls and up/down keys"}
       [:enum :none :strict :blur]]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that can be entered after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true, :doc "Character used as a decimal separator"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :string :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, 0s are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:hide-controls
       {:optional true, :doc "If set, the up/down controls are hidden"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimum possible value"}
       [:or :int :double]]
      [:prefix
       {:optional true, :doc "Prefix added before the input value"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:start-value
       {:optional true,
        :doc
        "Value set to the input when increment/decrement buttons are clicked or up/down arrows pressed if the input is empty"}
       [:or :int :double]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with up/down controls and keyboard arrows"}
       [:or :int :double]]
      [:step-hold-delay
       {:optional true,
        :doc
        "Initial delay in milliseconds before stepping the value."}
       [:or :int :double]]
      [:suffix
       {:optional true, :doc "Suffix added after the input value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style."}
       [:enum :none :thousand :lakh :wan]]
      [:trim-leading-zeroes-on-blur
       {:optional true,
        :doc
        "If set, leading zeros are removed on blur. For example, `00100` -> `100`"}
       :boolean]
      [:type
       {:optional true, :doc "Controls input `type` attribute"}
       [:enum :text :tel :password]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :string :int :double]]
      [:value-is-numeric-string
       {:optional true,
        :doc
        "If value is passed as string representation of numbers (unformatted) and number is used in any format props like in prefix or suffix in numeric format and format prop in pattern format then this should be passed as `true`."}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-keyboard-events
       {:optional true,
        :doc
        "If set, up/down keyboard events increment/decrement value"}
       :boolean]]},
    :background-image
    {:description
     "Mantine `BackgroundImage` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "BackgroundImage"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src {:optional true, :doc "Image url"} :string]],
     :defaults {:radius 0},
     :children :none,
     :box-from :content},
    :card
    {:description
     "Mantine `Card` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Card"},
     :props
     [:map
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the card"}
       :boolean]],
     :defaults {:padding :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :tracker-sidebar
    {:description
     "THE SIDEBAR OF THE TRACKER (IKC3/PLAN-ikc-v3-080-01/BOARD, §2 of the plan):\n     one link for each screen of the tracker. It folds to a column of icons,\n     and the pin keeps it open with the names. The link of the screen that\n     shows has the accent.\n\n     THE PIN IS A CHOICE OF THE READER, not of the description. The widget\n     keeps it in the browser of the reader, so each reader keeps the sidebar\n     as he set it. With no stored choice, it is folded.\n\n     A LINK IS A TEXT, NOT A COMMAND, so it needs no handler. :href is a page\n     address, as /index.html?island=board.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the names, one on each line,\n     with a mark at the current one.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         [:label :string]
         [:href :string]
         [:icon
          {:optional true}
          [:enum
           "board"
           "backlog"
           "releases"
           "workflow"
           "work"
           "progress"
           "help"]]
         [:current {:optional true} :boolean]]]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :divider
    {:description
     "Mantine `Divider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Divider"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default value depends on color scheme"}
       [:or :keyword :string]]
      [:label-position
       {:optional true, :doc "Controls label position"}
       [:enum :center :left :right]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:size
       {:optional true,
        :doc "Controls width/height (depends on orientation)"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults
     {:label-position :center, :orientation :horizontal, :size :xs},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n     (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n     Exactly two children: the RESIZABLE/foldable pane and the FILLING\n     pane. :fold-side picks which side the resizable one is on — :left\n     (default) = child 1 is resizable and folds left; :right = child 2 is\n     resizable and folds right. :pane-id is the localStorage key under\n     which THIS pane's width + folded state are remembered. :initial is the\n     resizable pane's starting px width; :min is its floor; :max an\n     optional hard ceiling. :flex-min is the FILLING pane's floor (px).\n     :collapsible shows the fold button.\n\n     :narrow IS THE PHONE (2026-08-20, PLAN-ikc-v3-015-01 phase 6). It is the\n     UNIVERSAL slot of that name, not a prop of this kind — one word for one\n     idea (Rule 1.11), and a second key would have collided with the first in\n     malli's own schema, which is how :font-size came to be named that. This\n     kind honours two of its five values, and DEFAULTS to one of them. Below\n     --viewport-narrow a two-pane split does not fit: :initial 270 plus\n     :flex-min 280 plus the divider is 556px, and the pane's own\n     `overflow-x: auto` then makes the whole island scroll sideways. This\n     prop says which of the two things it does instead.\n\n       :fold   the resizable pane starts FOLDED and the filling pane takes\n               the width. Its fold control is still there, so the sidebar is one\n               tap away — the sidebar becomes a control, which is what a\n               sidebar is on a phone.\n       :stack  both panes as one vertical column, the resizable one first.\n               For a split whose two halves are both content (a source and\n               its preview), where hiding one loses the point.\n       :keep   the desktop split, sideways scroll included. Deliberate, and\n               sayable, for a surface nobody opens on a phone.\n\n     THE DEFAULT IS :fold, and that is a declaration, not an inference\n     (ADR-graph-ui-v0-011-01's own safety net: 'where the renderer can safely\n     default to filling, it should'). The failure mode of forgetting this\n     prop is a page that scrolls sideways under the reader's thumb, so the\n     safe answer is the one a description gets for free. A folded pane is\n     recoverable by one tap. A sideways-scrolled reading column is not\n     recoverable at all until the reader finds it.\n\n     The fold is NOT remembered across the breakpoint. :pane-id's stored\n     fold state is the reader's choice on a wide window, and a phone visit\n     must not overwrite it — so the narrow fold is computed, never stored.",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true,
      :narrow :fold},
     :children :any,
     :box-from :parent,
     :needs :both,
     :box-to-children :definite},
    :chip
    {:description
     "An interactive, selectable pill — Mantine `Chip` (ADR-graph-ui-v0-013-01\n     Sec14). Where :badge is a label with no behaviour, :chip reports its\n     own selected state — the ikc1 #tag filter needs a clickable tag that\n     toggles, which :badge cannot do. Fires :on-gesture's :submit key on\n     toggle, $value = the new selected state (true/false) — mirroring\n     :select's choose->command convention.",
     :status :in-progress,
     :props
     [:map
      [:label :string]
      [:selected {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :field-list
    {:description
     "THE FIELDS OF ONE THING, ONE ROW EACH, AND A CLICK EDITS A VALUE\n     (IKC3/PLAN-ikc-v3-080-01/ITEM, screen 3 of the plan). Each row is a label\n     and a value. A row with an :editor other than :none edits in place: a\n     click on the value opens the editor, and Enter or Save sends the gesture\n     :edit with $value {:field :value}. Escape or Cancel sends nothing.\n\n     THE EDITORS.\n       :none    the value is only text, for example the reporter\n       :text    one line\n       :lines   a text area. The value is one item for each line, and the\n                command splits it\n       :number  a whole number\n       :day     a day, written as 2026-10-20\n       :select  one of :options, [{:value :label}]. A choice sends at once\n\n     WHY A KIND OF ITS OWN. A product surface is a declared widget kind, not a\n     generic table (rule 4 of section 6 of the plan). A :table has no editor,\n     and a stack of :input widgets reads as a form.\n\n     THE ROWS ARE BOUND, AND THE SOURCE DECIDES WHICH ROWS EXIST. A Decision\n     has the rows question, options, recommendation and opens. A Bug has none\n     of them, so its source gives no row, and the widget draws nothing when\n     :items is empty and no :empty-label is set. Each value is a text, because\n     a row is what a person reads.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws one line for each row,\n     \"label: value\", and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         [:field :string]
         [:label :string]
         [:value {:optional true} :string]
         [:editor
          {:optional true}
          [:enum :none :text :lines :number :day :select]]
         [:options
          {:optional true}
          [:vector [:map [:value :string] [:label :string]]]]]]]
      [:title
       {:optional true, :doc "A heading over the rows."}
       :string]
      [:empty-label
       {:optional true,
        :doc "What an empty list says. Absent: nothing is drawn."}
       :string]],
     :defaults {},
     :gestures [:edit],
     :children :none,
     :box-from :content},
    :overlay
    {:description
     "Mantine `Overlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :needs :both,
     :defaults
     {:background-opacity 0.6,
      :blur 0,
      :center false,
      :fixed false,
      :radius 0,
      :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Overlay"},
     :status :generated,
     :box-from :parent,
     :props
     [:map
      [:background-opacity
       {:optional true,
        :doc
        "Overlay `background-color` opacity 0–1, ignored when `gradient` prop is set"}
       [:or :int :double]]
      [:blur
       {:optional true, :doc "Overlay background blur"}
       [:or :string :int :double]]
      [:center
       {:optional true, :doc "Centers content inside the overlay"}
       :boolean]
      [:color
       {:optional true, :doc "Overlay `background-color`"}
       [:or
        [:enum
         :gray
         :red
         :pink
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :transparent
         :white
         "-moz-initial"
         :inherit
         :initial
         :revert
         :revert-layer
         :unset
         :aliceblue
         :antiquewhite
         :aqua
         :aquamarine
         :azure
         :beige
         :bisque
         :black
         :blanchedalmond
         :blueviolet
         :brown
         :burlywood
         :cadetblue
         :chartreuse
         :chocolate
         :coral
         :cornflowerblue
         :cornsilk
         :crimson
         :darkblue
         :darkcyan
         :darkgoldenrod
         :darkgray
         :darkgreen
         :darkgrey
         :darkkhaki
         :darkmagenta
         :darkolivegreen
         :darkorange
         :darkorchid
         :darkred
         :darksalmon
         :darkseagreen
         :darkslateblue
         :darkslategray
         :darkslategrey
         :darkturquoise
         :darkviolet
         :deeppink
         :deepskyblue
         :dimgray
         :dimgrey
         :dodgerblue
         :firebrick
         :floralwhite
         :forestgreen
         :fuchsia
         :gainsboro
         :ghostwhite
         :gold
         :goldenrod
         :greenyellow
         :grey
         :honeydew
         :hotpink
         :indianred
         :ivory
         :khaki
         :lavender
         :lavenderblush
         :lawngreen
         :lemonchiffon
         :lightblue
         :lightcoral
         :lightcyan
         :lightgoldenrodyellow
         :lightgray
         :lightgreen
         :lightgrey
         :lightpink
         :lightsalmon
         :lightseagreen
         :lightskyblue
         :lightslategray
         :lightslategrey
         :lightsteelblue
         :lightyellow
         :limegreen
         :linen
         :magenta
         :maroon
         :mediumaquamarine
         :mediumblue
         :mediumorchid
         :mediumpurple
         :mediumseagreen
         :mediumslateblue
         :mediumspringgreen
         :mediumturquoise
         :mediumvioletred
         :midnightblue
         :mintcream
         :mistyrose
         :moccasin
         :navajowhite
         :navy
         :oldlace
         :olive
         :olivedrab
         :orangered
         :orchid
         :palegoldenrod
         :palegreen
         :paleturquoise
         :palevioletred
         :papayawhip
         :peachpuff
         :peru
         :plum
         :powderblue
         :purple
         :rebeccapurple
         :rosybrown
         :royalblue
         :saddlebrown
         :salmon
         :sandybrown
         :seagreen
         :seashell
         :sienna
         :silver
         :skyblue
         :slateblue
         :slategray
         :slategrey
         :snow
         :springgreen
         :steelblue
         :tan
         :thistle
         :tomato
         :turquoise
         :wheat
         :whitesmoke
         :yellowgreen
         :AccentColor
         :AccentColorText
         :ActiveText
         :ButtonBorder
         :ButtonFace
         :ButtonText
         :Canvas
         :CanvasText
         :Field
         :FieldText
         :GrayText
         :Highlight
         :HighlightText
         :LinkText
         :Mark
         :MarkText
         :SelectedItem
         :SelectedItemText
         :VisitedText
         :ActiveBorder
         :ActiveCaption
         :AppWorkspace
         :Background
         :ButtonHighlight
         :ButtonShadow
         :CaptionText
         :InactiveBorder
         :InactiveCaption
         :InactiveCaptionText
         :InfoBackground
         :InfoText
         :Menu
         :MenuText
         :Scrollbar
         :ThreeDDarkShadow
         :ThreeDFace
         :ThreeDHighlight
         :ThreeDLightShadow
         :ThreeDShadow
         :Window
         :WindowFrame
         :WindowText
         :currentColor]
        :string]]
      [:fixed
       {:optional true, :doc "Changes position to `fixed`"}
       :boolean]
      [:gradient
       {:optional true,
        :doc
        "Changes overlay to gradient. If set, `color` prop is ignored."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:z-index
       {:optional true, :doc "Overlay z-index"}
       [:or :string :int :double]]]},
    :criteria-list
    {:description
     "THE ACCEPTANCE CRITERIA OF A WORK ITEM, EACH WITH ITS VERIFIER\n     (IKC3/PLAN-ikc-v3-080-01/ITEM, sections 3.4 and 10.3 of the plan). One row\n     for each criterion: a box that is checked when the criterion is proven,\n     the text, and the verifier as a picker: George, Supervisor or Test. A\n     proven row also says who proved it and when. A field under the rows adds\n     a criterion.\n\n     THREE GESTURES, AND NONE IS ANOTHER.\n       :prove         a click on the box. $value {:criterion-id :proven},\n                      :proven true to prove, false to open it again\n       :set-verifier  a choice of the picker. $value {:criterion-id :verifier}\n       :add           Enter in the field. $value is the text of the new\n                      criterion\n\n     THE RULE IS IN THE GATE. George decides what the supervisor verifies, and\n     the supervisor cannot prove a criterion that George kept. The commands of\n     the workflow refuse each act that the rule forbids, and the refusal is the\n     sentence of the status line of the surface. So the widget draws every\n     control for every row, and it decides nothing. ONE EXCEPTION: a row with\n     the verifier test has a grey box and says why, because the page cannot\n     name a test. A tick waits for the reply of the bus. A refusal, or no\n     reply, returns the box to the stored value with a sentence under the rows.\n\n     :add IS REACHABLE WHEN THE LIST IS EMPTY, so a work item with no criterion\n     can get its first one here (ui.edn :wiring :empty-reachable).\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws one line for each row,\n     \"[x] text · verifier\", and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:text :string]
         [:verifier :string]
         [:verifier-label :string]
         [:state :string]
         [:proven-by {:optional true} :string]
         [:proven-at {:optional true} :string]
         [:verifier-options
          {:optional true}
          [:vector [:map [:value :string] [:label :string]]]]]]]
      [:title
       {:optional true, :doc "A heading over the rows."}
       :string]
      [:add-placeholder
       {:optional true, :doc "What the field of a new criterion says."}
       :string]
      [:empty-label
       {:optional true, :doc "What the list says with no criterion."}
       :string]],
     :defaults {},
     :gestures [:prove :set-verifier :add],
     :children :none,
     :box-from :content},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session —\n     every bus command dispatched (with its round-trip ms) and the\n     client-only UI events that never reach the bus, newest last. Purely a\n     CLIENT-side observability surface: reads a client ring-buffer directly,\n     never a bus :source. Web-only; the TUI renders a labelled placeholder.\n     :slow-ms marks any dispatch at/above it as slow (tone shift).",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none,
     :box-from :content},
    :file-button
    {:description
     "Mantine `FileButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped {"multiple" "Multiple"},
     :defaults {},
     :box-to-children :block-flow,
     :mantine {:component "FileButton", :children :function},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:disabled
       {:optional true, :doc "Disables file picker"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:name {:optional true, :doc "Input name attribute"} :string]]},
    :list
    {:description
     "A vertical list; each item renders on its own line. :items is optional:\n     a bound :list gets its items from a source. An item is now a MAP\n     (ADR-graph-ui-v0-013-01 Sec17, legal because v2.0 is a major): {:label\n     string :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean} — covers the SPEC-002\n     'nav row' gap (icon + ellipsised text + trailing accessory, active/dim\n     states). {:label \"Foo\"} alone renders identically to a bare string\n     under v1.x, so the common case stays exactly as terse. :empty-label:\n     shown in place of a silently-blank pane when :items resolves to an\n     empty vector. :value (ADR-graph-ui-v0-013-01 Sec24): the item's click target,\n     substituted as $value into the dispatched command. It was MISSING from\n     this closed map while every source already returned it — invisible only\n     because BOUND items skip props validation, so a literal-authored item\n     carrying :value was rejected while the identical item from a source was\n     accepted. Declared now so model and code agree by agreeing, not because\n     one of them is never checked.\n\n     :wrap (2026-10-06, fault reports 3fc8e2c6 and d8463f96): true shows\n     the whole label of each row. A long label continues on the next lines,\n     and a line break in the label starts a new line. false or absent keeps\n     each row one line, and a long label ends in an ellipsis, which is right\n     for a nav row. A conversation thread is not a nav row: George could not\n     read an answer or his own question in gi and in studio. The TUI ignores\n     it.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]
      [:wrap {:optional true} :boolean]],
     :defaults {},
     :children :none,
     :box-from :content},
    :scroll-area
    {:description
     "A scrolling viewport — Mantine `ScrollArea` (ADR-graph-ui-v0-013-01 Sec22).\n     This closes an AC-1 gap, not a styling one: WHAT SCROLLS was hardcoded\n     per widget in the renderer (:outline, :tree and :list each carried their\n     own overflow-y-auto), so no description could say 'this pane scrolls as\n     one document' — a capability reachable only through bespoke renderer\n     code, which is what AC-1 forbids.\n\n     It is also a known, still-open defect rather than a new observation:\n     graph_ui/web/render.cljs records (2026-07-14) that adding min-h-0 to the\n     SHARED root, to give descendants a bounded scroll box, collapsed the\n     content pane entirely against the real vault, was reverted, and left the\n     app unable to scroll long pages — with the fix explicitly deferred to\n     'the content pane's own flex chain'. Naming the scrolling box in the\n     description IS that fix: the renderer stops having to guess on a root it\n     shares with every island.\n\n:reset-key IS THE SAME NOUN :input CARRIES, and it means the same\n     thing. When the value changes, the box drops what it holds. For an\n     :input that is the text. For a :scroll-area it is the scroll offset.\n\n     The reading pane needs it, and a measurement says why. The pane holds\n     seven :scroll-area boxes, one for each modality, inside one :tab-set. A\n     second note of the SAME modality reuses the same box, so the offset\n     stays. Measured on the deployment 2026-09-20: a note of 126,287 px was\n     read to its foot, and the next note opened at 12,830 px of its own\n     13,372 px. The reader arrived 96 per cent of the way down a note they\n     had just opened.\n\n     :type and :scrollbars are Mantine's own enums verbatim.\n     :scrollbarSize/:offsetScrollbars are not adopted — no consumer needs\n     them. A :scroll-area needs a bounded height to scroll WITHIN, so it\n     normally carries :flex 1 inside a :stack that has one.",
     :children :any,
     :needs :block,
     :self-flex :block,
     :defaults {:type :hover, :scrollbars :y},
     :box-to-children :block-flow,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:type
       {:optional true}
       [:enum :auto :always :scroll :hover :never]]
      [:scrollbars {:optional true} [:enum :x :y :xy :none]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:reset-key {:optional true} [:maybe :string]]]},
    :semi-circle-progress
    {:description
     "Mantine `SemiCircleProgress` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 9 prop(s), 1\n     named child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic\n     drives the component named above straight from this declaration — the\n     props here are the legal ones, the gestures here are the wired ones, and\n     nothing else reaches the DOM. Generic is not finished: this kind has no\n     data binding, no edit buffer and no selection state of its own. A kind\n     that needs one of those graduates to a hand-written widget and an explicit\n     case in render.cljs — move it above the GENERATED marker and give it a\n     description that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine\n     declares no `children` for this component, so a child is admitted solely\n     to fill one of the named slots above, saying which with :section. A child\n     that names no slot is not body content here — there is no body to put it\n     in.",
     :status :generated,
     :mantine {:component "SemiCircleProgress"},
     :props
     [:map
      [:empty-segment-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default the value is determined based on the color scheme value"}
       [:or :keyword :string]]
      [:fill-direction
       {:optional true,
        :doc "Direction from which the circle is filled"}
       [:enum :right-to-left :left-to-right]]
      [:filled-segment-color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Label position relative to the circle center"}
       [:enum :center :bottom]]
      [:orientation
       {:optional true, :doc "Orientation of the circle"}
       [:enum :up :down]]
      [:size
       {:optional true, :doc "Diameter of the svg in px"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Circle thickness in px"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Progress value from `0` to `100`"}
       [:or :int :double]]],
     :defaults
     {:fill-direction :left-to-right,
      :label-position :bottom,
      :orientation :up,
      :size 200,
      :thickness 12,
      :transition-duration 0},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :pagination
    {:description
     "Mantine `Pagination` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 5\n     gesture(s), and 5 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped
     {"dotsIcon" "PaginationIcon",
      "firstIcon" "PaginationIcon",
      "lastIcon" "PaginationIcon",
      "nextIcon" "PaginationIcon",
      "previousIcon" "PaginationIcon"},
     :defaults
     {:boundaries 1,
      :gap 8,
      :hide-with-one-page false,
      :siblings 1,
      :size :md,
      :with-controls true,
      :with-edges false,
      :with-pages true},
     :mantine {:component "Pagination"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change :first-page :last-page :next-page :previous-page],
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:boundaries
       {:optional true,
        :doc "Number of elements visible on the left/right edges"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc "Key of `theme.colors`, active item color"}
       [:or :keyword :string]]
      [:default-value
       {:optional true,
        :doc
        "Active page for uncontrolled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Disables all controls, applies disabled styles"}
       :boolean]
      [:gap
       {:optional true,
        :doc "Key of `theme.spacing`, gap between controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:hide-with-one-page
       {:optional true,
        :doc
        "If set, the pagination is hidden when only one page is available (`total={1}`)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:siblings
       {:optional true,
        :doc
        "Number of siblings displayed on the left/right side of the selected page"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "`height` and `min-width` of controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:total
       {:optional true,
        :doc "Total number of pages, must be an integer"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Active page for controlled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:with-controls
       {:optional true,
        :doc "If set, next/previous controls are displayed"}
       :boolean]
      [:with-edges
       {:optional true,
        :doc "If set, first/last controls are displayed"}
       :boolean]
      [:with-pages
       {:optional true,
        :doc "If set to `false`, pages controls are hidden"}
       :boolean]]},
    :color-input
    {:description
     "A swatch-picker input — Mantine `ColorInput` (ADR-graph-ui-v0-013-01\n     Sec16), the theme editor's field. :value is a CSS colour string (hex,\n     as the theme tokens already are — ADR-graph-ui-v0-009-01). Fires\n     :on-gesture's :submit key on change, $value = the picked colour — the\n     same input->command shape :input/:select already use.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :development-panel
    {:description
     "THE CODE OF THE WORK ON ONE WORK ITEM (IKC3/PLAN-ikc-v3-080-01/ITEM, screen 3\n     of the plan, the Development panel of Jira): the pull request with its\n     link, the branch, the worktree, the machine, the session, the merge\n     commit, the commit that runs, and the deploy. A fact that the item does\n     not hold is not drawn. With no fact, the panel says :empty-label.\n\n     READ ONLY. The pull request is set by the work (the command line, an\n     agent, the board), and the deploy is measured (decision 32 of\n     RESEARCH-ikc-v3-033-01). So this kind has no gesture.\n\n     TUI POSTURE: one line for each fact, \"label: value\".",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true}
       [:map
        [:pull-request {:optional true} :int]
        [:pull-request-url {:optional true} :string]
        [:branch {:optional true} :string]
        [:worktree {:optional true} :string]
        [:machine {:optional true} :string]
        [:session {:optional true} :string]
        [:merge-commit {:optional true} :string]
        [:boot-commit {:optional true} :string]
        [:deployed {:optional true} :string]]]
      [:title {:optional true} :string]
      [:empty-label {:optional true} :string]],
     :defaults {:title "Development"},
     :children :none,
     :box-from :content},
    :avatar
    {:description
     "Mantine `Avatar` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Avatar"},
     :props
     [:map
      [:allowed-initials-colors
       {:optional true,
        :doc
        "A list of colors that is used for autogenerated initials. By default, all default Mantine colors can be used except gray and dark."}
       [:vector :any]]
      [:alt
       {:optional true,
        :doc
        "Image `alt` attribute, also used as `title` attribute for placeholder"}
       :string]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or
        [:enum
         :dark
         :gray
         :red
         :pink
         :grape
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :initials]
        :string]]
      [:gradient
       {:optional true,
        :doc "Gradient configuration for `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:name
       {:optional true,
        :doc
        "Name of the user. When `src` is not set, used to display initials and to generate color when `color=\"initials\"` is set."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Width and height of the avatar, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src
       {:optional true,
        :doc
        "Image url, if the image cannot be loaded or `src={null}`, then placeholder is displayed instead"}
       :string]],
     :defaults {:color :gray, :radius "1000px", :size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :graph
    {:description
     "A SUBGRAPH, DRAWN. One node at the centre, what it connects to around it,\n     and the edges between them.\n\n     :subgraph IS THE BOUND PROP and its shape is :knowledge-graph/subgraph-of's\n     result VERBATIM. That is deliberate: the widget invents no structure of its\n     own, so what is on the screen is what the store answered, and a question\n     about the picture is answerable by running the query.\n\n     IT IS AN EGO GRAPH AND NOT `THE GRAPH`. SPEC-alatus-v0-002-01 AC-2 says\n     the UI must not load the whole graph to become usable, and ikc1 is the\n     evidence: it held every frame WITH ITS CONTENT in the browser and froze for\n     a minute before a keystroke. The bound query is bounded at both ends —\n     :depth limits the walk and :max-nodes caps the answer — so a description\n     cannot ask for the corpus. :truncated? in the bound value says the cap was\n     reached, and the widget says so on the screen rather than drawing a lie.\n\n     NO GRAPH LIBRARY, AND THAT IS A DECISION. The layouts are computed in the\n     browser from the node and edge lists — a few hundred lines, no dependency.\n     ikc1 needed d3-force and React Flow for the same picture; a declaration\n     that named a library would put a second vocabulary beside this one, and the\n     bundle would carry it for every island that never draws a graph. Above about\n     2,000 nodes this stops being the right answer (M8 names canvas or WebGL\n     there), which is what :max-nodes exists to keep away from.\n\n     :layout FOLLOWS THE RELATION, which is M8's own rule:\n       :radial  rings by hop, the focus at the centre. The default, and the one\n                that reads best for `what does this connect to` — a ring IS the\n                distance, so nothing has to be inferred from a line's length.\n       :force   a spring relaxation. For a neighbourhood with its own clusters,\n                where a ring would put two unrelated groups side by side.\n       :tree    left to right by hop. For a relation that IS a hierarchy —\n                :child-of, and later :broader.\n\n     ONE GESTURE, :submit, and $value is the node's :id — the same contract\n     :tree and :list already carry, so opening a node is the command the\n     description already knows how to write. A hub node (a tag, a folder) has an\n     id that names no frame, and a description that opens pages should expect it:\n     the widget still reports it, because refusing to would make half the picture\n     dead to the touch.\n\n     :encoding NAMES A TABLE, NOT A COLOUR. Type to colour and shape, relation\n     to stroke, derived to dashed — declared as data in dsl/design/graph-\n     encoding.edn and read by the renderer, which invents nothing. A description\n     that wants a different encoding names a different table; it never states a\n     colour, for the reason ADR-graph-ui-v0-009-01 gives.\n\n     THE TUI DRAWS IT AS A LIST. A terminal has no plane to lay a graph out on,\n     so the TUI prints the focus and then one line per neighbour, `relation →\n     label`. That is real parity for the question the pane answers, not a\n     placeholder — the same choice :highlight-list made\n     (ADR-graph-ui-v0-007-01).\n\n     AMENDMENT, 2026-10-13 (lane IKC3/PLAN-ikc-v3-073-01/GV). THE PICTURE IS\n     PAINTED ON A CANVAS, AND THERE IS STILL NO GRAPH LIBRARY. The text above\n     stays true. What changed is the size: the island graph draws a whole\n     partition or a whole frame type, and it asks for up to 2,000 nodes. So\n     the step that M8 names above about 2,000 nodes is taken now.\n\n     THE MEASUREMENT, 2026-10-13. Headless Chrome on kubu24-dev-01, a generated graph with\n     about 2.5 edges for each node, 60 frames of pan and zoom, 2026-10-13:\n       nodes  edges  SVG frame  canvas frame  sigma.js frame  sigma first draw\n         180    438   16.7 ms     16.7 ms        102 ms          779 ms\n         500  1,241   33.8 ms     16.1 ms        172 ms          747 ms\n       2,000  4,996    113 ms     25.9 ms        462 ms        1,027 ms\n     On 2026-10-13 the canvas drew 2,000 nodes in 5 ms of script for each frame. The SVG\n     makes one element for each mark, and the browser lays out 7,000 elements\n     on each frame. sigma.js and graphology added about 185 KB to the bundle of\n     every island (measured 2026-10-13). This host has no GPU, so its WebGL is SwiftShader in\n     software. On a GPU sigma.js is faster than this table. But the canvas\n     is already in the frame budget, and the library would put a second\n     vocabulary beside this one. So the decision is canvas, with our code.\n\n     THE LAYOUT, NOT THE PAINT, IS THE COST AT 2,000 NODES. In the same\n     measurement a force layout of all pairs cost about 3 s for 2,000 nodes,\n     and ForceAtlas2 of graphology cost 8.5 s. Up to 300 nodes the widget\n     repels every pair. Above 300 it repels through a grid of cells, and it\n     runs the steps in animation frames. So the first frame comes at once,\n     and the picture settles while the person looks at it.\n\n     ON THE CORPUS, 2026-10-13, a probe bus with the declared vaults, the\n     island graph in headless Chrome:\n       scope            nodes   links   query   first paint  settled  paint\n       foam-home          180   3,741   145 ms      250 ms    250 ms   3 ms\n       foam-home          500   8,314   152 ms      180 ms    882 ms   5 ms\n       foam-home        1,694  10,540   133 ms      248 ms  4,895 ms   8 ms\n       type page          180   2,222   268 ms       95 ms     95 ms   2 ms\n       type page          500   8,672   281 ms      188 ms    614 ms   4 ms\n       type page        2,000  19,886   270 ms      449 ms  5,854 ms  12 ms\n     paint is the script time of one frame of pan. foam-home gives 1,694\n     nodes in all, so the cap of 2,000 cuts nothing there.\n\n     ABOVE 3,000 LINKS EVERY LINK IS SOLID. A dashed line costs about three\n     times a solid one to paint in software: 233 ms against 82 ms for 8,000\n     links (2026-10-13). The legend says so when it happens.\n\n     :layout NOW HAS A RULE FOR A SET SCOPE. A set scope gives each node :hops\n     1, so :radial puts every node on one ring. When the bound value names no\n     :layout, a set scope draws :force and the ego scope draws the layout of\n     the description.\n\n     THE PERSON CAN NOW DRAG A NODE, and the drag lasts until the data\n     changes. :search draws a box above the picture. It finds a node by its\n     label and moves the view to it. It does not open the node, because the\n     open is the :submit gesture and a search is not a choice.\n\n     :cut-by AND :elapsed-ms ARE SAID IN THE CAPTION. A set scope keeps the\n     nodes with the most links, and the caption says so, with the count of the\n     nodes that it did not keep.",
     :status :in-progress,
     :props
     [:map
      [:subgraph
       {:optional true}
       [:maybe
        [:map
         [:focus {:optional true} [:maybe :string]]
         [:depth {:optional true} :int]
         [:relations {:optional true} [:vector :keyword]]
         [:nodes
          [:vector
           [:map
            [:id :string]
            [:label :string]
            [:frame-type {:optional true} [:maybe :keyword]]
            [:partition {:optional true} [:maybe :keyword]]
            [:hops :int]
            [:focus? {:optional true} :boolean]]]]
         [:edges
          [:vector
           [:map
            [:from :string]
            [:to :string]
            [:relation :keyword]
            [:derived? {:optional true} :boolean]
            [:inferred? {:optional true} :boolean]]]]
         [:count {:optional true} :int]
         [:edge-count {:optional true} :int]
         [:truncated? {:optional true} :boolean]
         [:omitted {:optional true} :int]
         [:scope
          {:optional true}
          [:maybe [:enum :ego :partition :frame-type]]]
         [:in-partition {:optional true} [:maybe :keyword]]
         [:frame-type {:optional true} [:maybe :keyword]]
         [:cut-by {:optional true} [:maybe [:enum :ring :degree]]]
         [:layout
          {:optional true}
          [:maybe [:enum :radial :force :tree]]]
         [:elapsed-ms {:optional true} [:maybe :int]]]]]
      [:layout {:optional true} [:enum :radial :force :tree]]
      [:search {:optional true} :boolean]
      [:caption {:optional true} :boolean]
      [:legend {:optional true} :boolean]
      [:encoding {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:title {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:layout :radial,
      :caption true,
      :legend true,
      :search false,
      :encoding "design/graph-encoding.edn"},
     :children :none,
     :box-from :content},
    :text-input
    {:description
     "Mantine `TextInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "TextInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :highlight-list
    {:description
     "The document's highlights, listed beside it — ikc1's right gutter\n     (F-platform-v0-011-01, ADR-graph-ui-v0-017-01 §5). One row per highlight: a\n     dot in the highlight's own colour, the level badge when a level is set, the\n     marked text on ONE line (truncated, because a chunk-sized highlight is\n     paragraphs long and the gutter is a column), the note when there is one, and\n     an X that removes it, and — when the description wires a :link gesture — a\n     control that copies a wikilink to that mark, for pasting into a note.\n\n     THREE ACTS, AND NONE IS ANOTHER (2026-08-24). A row's click GOES to the\n     words. The link control COPIES a link. The X REMOVES it. George asked for\n     that split by name: \"without this click on bookmark to delete it, have some\n     more narrow way to delete it\".\n\n     NOT NAMED :highlight, which is taken — the generated Mantine `Highlight`\n     kind below marks substrings matching a search term and is unrelated. Two\n     things called highlight in one closed vocabulary would be a trap for every\n     later reader.\n\n     :items is the bound prop and its shape is :highlights/for-page's result\n     VERBATIM, whichever storage served it: a native page's highlights arrive as\n     block-relative and a vault page's as file-relative, and this widget cannot\n     tell, which is the point (ADR-ikc-v3-064-01 §3).\n\n     ORPHANED ROWS STAY LISTED, dimmed. A highlight whose text has been edited\n     away is a fact worth seeing — 'you marked this and it is gone' — and hiding\n     it would be the one behaviour that loses information silently\n     (CONCEPT-ikc-v3-008-01).\n\n     ONE GESTURE, :remove, $value = the row's :id — and since v2.1-SNAPSHOT a\n     second, :set-level (PLAN-ikc-v3-026-01 Phase D): when the description\n     wires it, each row carries a picker for the highlight's LAYER, 1 to 5\n     (RESEARCH-ikc-v3-021-01 D5), and firing it hands $value {:highlight-id\n     :level}. Creating a highlight is not a\n     gutter affordance: you make one by selecting text in the document, so there\n     is deliberately no empty-state gesture here and no :empty-reachable entry\n     below — a gutter with nothing in it is a document with nothing marked, and\n     the way out is in the document, not the gutter.\n\n     :title IS OPTIONAL AND MEANS A HEADER. Without one the column draws no\n     caption — which is what the reading area asks for, because the gutter sits\n     directly beside the text with each row level with the words it marks, and a\n     caption over that labels the self-evident. It captioned itself\n     unconditionally while it was a panel out at the pane's right edge; George\n     struck that panel through on 2026-08-16, saying the highlight in it\n     'belongs to the right gutter'. THE RIGHT GUTTER IS THIS, AND THERE IS ONLY\n     ONE — the per-row `2 hl` chip column that briefly sat between the text and\n     this one is gone (see the :outline kind).",
     :status :in-progress,
     :props
     [:map
      [:level-with-text {:optional true} :boolean]
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:block-id {:optional true} :string]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:title {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:chrome {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:chrome true},
     :children :none,
     :box-from :content},
    :container
    {:description
     "A centred, max-width content column — Mantine `Container`\n     (ADR-graph-ui-v0-013-01 Sec20). SPEC-alatus-v0-002-01's locked target\n     centres its reading pane in a `max-width: 900px` column; nothing else in\n     v2.0 can say that, so a reading UI otherwise runs its prose edge-to-edge\n     on a wide monitor — a legibility defect, not a cosmetic one, in the\n     island whose whole purpose is reading.\n\n     :size is Mantine's own max-width scale: :xs 540 / :sm 720 / :md 960 /\n     :lg 1140 / :xl 1320 pixels, read from the shipped styles.css rather than\n     recalled. (Corrected 2026-07-28: this rule first said :md 768 / :lg 992,\n     which are Mantine's BREAKPOINT values, not its container sizes. The error\n     put the reading column at 1140px — wider than the target instead of nearer\n     it.) :fluid takes the parent's full width and ignores :size.\n\n     OPEN SINCE ADR-graph-ui-v0-001-01. :size also accepts a NUMBER (pixels) or any\n     CSS length string, which is Mantine's own documented contract — the size\n     prop accepts any valid CSS value or a number. It was closed to five tokens\n     by 057-01 Sec0, and that clamp is what this declaration used to confess to:\n     'the enum cannot express 900 exactly, which is the standing trade'.\n\n     The trade was worse than lossy. CONCEPT-graph-ui-v0-009-01 defines measure\n     as Bringhurst does — the length of a line counted in CHARACTERS — and a\n     measure in pixels is not a measure: change the type size and the line\n     length moves while :md does not. So a reading column says {:size \"66ch\"}\n     and means it, instead of naming the nearest breakpoint token and hoping.\n     The tokens remain valid and remain the ordinary case for non-prose widths.\n\n     The renderer lays a :container out as a flex COLUMN, so that a child\n     carrying :flex 1 fills it. Mantine's Container is a plain block element,\n     and a :flex 1 child inside a block parent silently falls back to its own\n     content height (measured: a 180px reading pane inside a 986px column). Mantine's :strategy ('block' | 'grid') is deliberately NOT\n     adopted: no consumer needs grid-centring, and an unused prop is a\n     promise the renderer has to keep.",
     :children :any,
     :needs :inline,
     :self-flex :inline,
     :defaults {:size :lg},
     :box-to-children :flex-column,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:size
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:fluid {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]]},
    :indicator
    {:description
     "Mantine `Indicator` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Indicator"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:disabled
       {:optional true, :doc "If set, the indicator is hidden"}
       :boolean]
      [:inline
       {:optional true,
        :doc
        "Determines whether the indicator container should be an inline element"}
       :boolean]
      [:offset
       {:optional true,
        :doc
        "Indicator offset relative to the target element, usually used for elements with border-radius"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Indicator position relative to the target element"}
       [:enum
        :top-end
        :top-start
        :bottom-end
        :bottom-start
        :top-center
        :bottom-center
        :middle-center
        :middle-end
        :middle-start]]
      [:processing
       {:optional true,
        :doc "If set, the indicator has processing animation"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Indicator width and height"}
       [:or :string :int :double]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:z-index
       {:optional true, :doc "Indicator z-index"}
       [:or :string :int :double]]],
     :defaults
     {:inline false,
      :position :top-end,
      :processing false,
      :radius 100,
      :size 10,
      :z-index 200},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :stack
    {:description
     "Vertical stack — Mantine `Stack`, the common default arrangement\n     (ADR-graph-ui-v0-013-01 Sec0). :gap/:align/:justify keep Mantine's names;\n     values closed (Sec0).",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :outline
    {:description
     "ADR-graph-ui-v0-006-01: a flat, :order-sorted list of typed blocks, nested\n     VISUALLY by each item's :depth (never a real tree — the native\n     block-frame engine keeps every block a flat :child-of child of its\n     page). :items is optional: a bound :outline gets its list from a\n     source (:block-outline). Each item is {:block-id uuid-str :block-type\n     kw :content string :order number :depth int :checked? bool :collapsed?\n     bool}.\n\n     THERE IS NO :meta PROP. ADR-graph-ui-v0-013-01 Sec17 accepted one — a\n     trailing chip/badge gutter, third track in every row, captured from ikc1\n     by SPEC-alatus-v0-002-01 (`30px / 1fr / 132px`). Removed 2026-08-15,\n     George: \"What is this invented meta-gutter? The right gutter is the place\n     for meta information, no extra gutters.\" ikc3 has one margin beside the\n     document (F-platform-v0-011-01) that ikc1 did not, and meta about a block\n     belongs there; two gutters is two places to look for one kind of thing.\n     Nothing ever emitted :meta in production, so nothing is lost — the\n     reversal is recorded in that same ADR's Sec17. A deeper\n     item whose ancestor has :collapsed? true is hidden by the renderer, not\n     the source. Dispatches :on-gesture's named keys (ADR-graph-ui-v0-013 Sec7-8,\n     replacing v1.x's :actions): :indent/:outdent/:toggle-done/\n     :toggle-collapse/:delete/:insert-after/:update-text/:insert-first.\n     $value's meaning is still per gesture key (row actions: the acted-on\n     item's :block-id; :update-text: the edited text) but documented once, on\n     :on-gesture itself, not re-derived here.\n\n     :insert-first is the EMPTY state's gesture, and the only one that fires\n     when there are no items. Every other gesture acts on a row, so a page with\n     no blocks could not be given one: :insert-after needs a block to insert\n     after, and the empty state rendered as inert text. A note editor that\n     cannot accept its first character is not an editor, and the gap was\n     invisible until a wiped graph produced an empty page (2026-08-03). It\n     carries no $value — the target page is the session's selected one, which\n     the handler resolves, because the empty state has no row to name it.\n\n     :row-menu declares WHICH of the gestures above a row offers, in what order,\n     and how each is labelled. One list, rendered twice: as the hover strip on a\n     row and as the right-click context menu over it. Before this the strip was\n     four buttons hand-written in widgets.cljs, so adding an action cost three\n     edits in three languages — a command in this manifest, a gesture in the\n     description, and a button in ClojureScript. The gestures were declared; only\n     their PRESENTATION was not (2026-08-03).\n\n     Each entry is {:gesture <a key of this node's :on-gesture> :label <string>\n     :icon <string, optional> :tone <token, optional> :divider-before <bool,\n     optional>} — deliberately the same :label/:gesture/:tone shape v2.0's :menu\n     items use, so the two read alike. :row-menu is not a :menu widget, though:\n     a menu over a ROW must act on THAT row, and :menu's items have no notion of\n     which row they are over. The outline's gestures already carry the row id\n     through $value, so the same list renders as both the hover strip and the\n     right-click menu without any selected-block state to feed it. validate-dsl fails an entry naming a gesture the node does not\n     wire — a menu item that dispatches nothing looks identical to one that\n     works until it is clicked.\n\n     THREE MORE KEYS OF AN ENTRY (lane AL-K, 2026-09-29), with the meaning\n     they have on :icon-button. :confirm <string> is a question the item asks\n     first; with no yes it sends nothing. :copy-result <keyword> writes that key\n     of the command's answer to the clipboard, as Copy does with :text.\n     :from-clipboard :paragraphs reads the clipboard first, cuts its text at\n     each empty line, and sends the paragraphs as $value, as Paste as blocks\n     does. The row's id is $block-id for every item, and the caret of an open\n     row is $offset. All three are web-renderer behaviour. The TUI has no\n     dialog and no clipboard, and ignores them.\n\n     :from-file :image (fault report 08e4f4c1, 2026-10-05) opens the browser's\n     file picker for one image and sends it as the data URL of $value, as a\n     pasted image is. The reply's markdown goes in at the caret, and the row\n     is saved. Firefox for Android gives a keyboard image only to a\n     contenteditable field, never to the block's textarea, so this is the\n     path that works there. On a phone it opens the photo picker or the\n     camera. Web renderer only.\n\n     Omitting :row-menu means NO row affordances, which is a real choice for a\n     read-only outline rather than a reason to fall back to a built-in default:\n     a hidden default is how the hardcoded strip survived unnoticed.\n\n     :slash-menu declares the commands a row offers when its text begins with\n     '/' — the outliner idiom where typing turns a block into a to-do, a\n     separator, or a date without leaving the keyboard. Same shape as :row-menu\n     with one addition: :trigger is what you type after the slash, and what the\n     list filters on as you keep typing.\n\n     Each entry is {:trigger <string> :gesture <a key of :on-gesture>\n     :label <string> :icon <string, optional>}. validate-dsl fails an entry\n     naming a gesture the node does not wire, and fails two entries sharing a\n     :trigger — an ambiguous trigger picks one silently, and which one depends\n     on map ordering nobody declared.\n\n     The gesture's own template carries whatever the command needs (/todo and\n     /--- are both :ui/set-block-type with different literal :block-type args),\n     so a new slash command is usually a gesture plus a line here, and no\n     renderer change at all.\n\n     :completions declares what a TRIGGER CHARACTER inside a row offers. Same\n     idea as :slash-menu and a different shape, because the two answer different\n     questions. A slash menu is a CLOSED list of commands, declared here, and a\n     pick DISPATCHES one. A completion is an OPEN list of data — the tag\n     vocabulary is about 300 strings and grows as a person writes — so the list\n     cannot live in this file, and a pick DISPATCHES NOTHING. It splices text\n     into the buffer and the ordinary edit path carries it from there.\n\n     Each entry is {:trigger <text> :items <a prop of this node>}, or\n     {:trigger <text> :source <a bind source> …} for a list that is too large\n     to hold in a prop (lane IKC3/PLAN-alatus-v0-003-01/AL-L: `[[` asks\n     :page-search-results for up to :limit pages of :kinds, as the Ctrl+K\n     palette does, and a pick writes `[[Title]]`; :create? adds the typed text\n     as a last row, as ikc1's picker did). The\n     items arrive through an ordinary per-prop bind, so both bind runtimes fill\n     it generically and neither needs to know what a completion is. The trigger\n     matches at a WORD BOUNDARY before the caret, not at the start of the buffer:\n     a hashtag is written mid-sentence, and a slash command is not.\n\n     WHY A PICK DISPATCHES NOTHING, and it is the whole reason the two mechanisms\n     are separate. A `#` pick writes text. On a file-backed page the next scan\n     indexes it. On a native page the tags context's block-event subscriber\n     indexes it (ADR-ikc-v3-080-01 decision 3). Either way the tag reaches the\n     tree through the text, which is the one storage that cannot disagree with\n     what a person actually wrote.\n\n     validate-dsl fails an entry with no :trigger, two entries sharing one, and\n     an :items that does not name a prop this kind declares — a completion\n     pointing at nothing opens an empty popup and looks broken.\n\n     TUI renders read-only (gutters/numbering only, no dispatch).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:highlights {:optional true} [:vector [:map-of :keyword :any]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]
         [:confirm {:optional true} :string]
         [:copy-result {:optional true} :keyword]
         [:from-clipboard {:optional true} [:enum :paragraphs]]
         [:from-file {:optional true} [:enum :image :file]]]]]
      [:slash-menu
       {:optional true}
       [:vector
        [:map
         [:trigger :string]
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]]]]
      [:completions
       {:optional true}
       [:vector
        [:map
         [:trigger :string]
         [:items {:optional true} :keyword]
         [:source {:optional true} :keyword]
         [:kinds {:optional true} [:vector :keyword]]
         [:limit {:optional true} :int]
         [:close {:optional true} :string]
         [:create? {:optional true} :boolean]
         [:label {:optional true} :string]]]]
      [:tag-suggestions {:optional true} [:vector :string]]
      [:attachment-limit {:optional true} [:map-of :keyword :any]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :typography
    {:description
     "Mantine `Typography` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Typography"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :angle-slider
    {:description
     "Mantine `AngleSlider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "AngleSlider"},
     :props
     [:map
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `data-disabled` attribute, disables interactions"}
       :boolean]
      [:marks
       {:optional true, :doc "Array of marks displayed on the slider"}
       [:vector :any]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:restrict-to-marks
       {:optional true,
        :doc
        "If set, the selection is allowed only from the given marks array"}
       :boolean]
      [:size
       {:optional true, :doc "Slider size in px"}
       [:or :int :double]]
      [:step
       {:optional true, :doc "Step between values"}
       [:or :int :double]]
      [:thumb-size
       {:optional true,
        :doc
        "Size of the thumb in px. Calculated based on the `size` value by default."}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]
      [:with-label
       {:optional true,
        :doc "If set, the label is displayed inside the slider"}
       :boolean]],
     :defaults {:restrict-to-marks false, :step 1, :with-label true},
     :gestures [:change :change-end :scrub-end :scrub-start],
     :children :none,
     :box-from :content},
    :dialog
    {:description
     "Mantine `Dialog` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"position" "AffixPosition"},
     :defaults
     {:size :md,
      :with-close-button true,
      :within-portal true,
      :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Dialog"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close],
     :props
     [:map
      [:keep-mounted
       {:optional true,
        :doc
        "If set, dialog is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:opened {:optional true, :doc "Opened state"} :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls `width` of the dialog"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is displayed"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]]},
    :pills-input
    {:description
     "Mantine `PillsInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "PillsInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :combobox
    {:description
     "Mantine `Combobox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 6 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"dropdownPadding" "Padding<string | number>",
      "middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "store" "ComboboxStore",
      "width" "PopoverWidth"},
     :defaults
     {:reset-selection-on-option-hover false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :floating-strategy :absolute,
      :arrow-offset 5,
      :size :sm,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "Combobox"},
     :status :generated,
     :box-from :content,
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :option-submit
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "Determines whether the `Combobox` value can be changed"}
       :boolean]
      [:reset-selection-on-option-hover
       {:optional true,
        :doc
        "Determines whether selection should be reset when option is hovered"}
       :boolean]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true,
        :doc "Controls items `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :image
    {:description
     "Mantine `Image` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped {"src" "any"},
     :defaults {:fit :cover, :radius 0},
     :mantine {:component "Image"},
     :status :generated,
     :box-from :content,
     :gestures [:error],
     :props
     [:map
      [:fallback-src
       {:optional true,
        :doc
        "Image url used as a fallback if the image cannot be loaded"}
       :string]
      [:fit
       {:optional true, :doc "Controls `object-fit` style"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :fill
        :none
        :contain
        :cover
        :scale-down]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :status-chain
    {:description
     "THE STATUSES OF THE WORKFLOW, IN ORDER, AS A CHAIN OF BOXES WITH ARROWS\n     (IKC3/PLAN-ikc-v3-080-01/BOARD, screen 6 of the plan). Each box has the\n     name of a status and one short line. Its colour is the Jira category of\n     the status: To Do, In Progress or Done. The chain wraps on a narrow\n     screen.\n\n     DRAWN FROM THE DECLARATION. :value is bound to a source that reads\n     :grammar of workflow.edn, so a new status is a new box with no edit here.\n\n     NO GESTURE. It shows the workflow, and the board moves the work.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the names on one line,\n     joined by arrows.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true}
       [:vector
        [:map
         [:label :string]
         [:note {:optional true} :string]
         [:group
          {:optional true}
          [:enum "to-do" "in-progress" "done"]]]]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :autocomplete
    {:description
     "Mantine `Autocomplete` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 27 prop(s), 5 named\n     child slot(s), 5 gesture(s), and 3 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"data" "ComboboxStringData",
      "filter" "OptionsFilter",
      "renderOption" "RenderAutocompleteOption"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :auto-select-on-blur false,
      :open-on-focus true,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "Autocomplete"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change :clear :dropdown-close :dropdown-open :option-submit],
     :props
     [:map
      [:auto-select-on-blur
       {:optional true,
        :doc
        "If set, the highlighted option is selected when the input loses focus"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed when the component has a value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-value
       {:optional true,
        :doc "Default value for uncontrolled component"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :inline-edit
    {:description
     "A TEXT THAT A CLICK EDITS IN PLACE (IKC3/PLAN-ikc-v3-080-01/ITEM, screen 3\n     of the plan). It shows :value as text. A click on the text opens a field\n     with the same text, a Save button and a Cancel button. Enter in a field of\n     one line, or Save, sends the gesture :submit with the new text as $value.\n     Escape, or Cancel, closes the field and sends nothing.\n\n     WHY A KIND OF ITS OWN. Jira edits a field with a click on it, and George\n     accepted that design on 2026-10-13. An :input is always a field, so a page\n     of inputs reads as a form, not as a work item. A :text cannot be edited.\n     This kind is the text and its editor, with one gesture.\n\n     :variant :heading draws the text as the title of a page. :multiline true\n     opens a text area, where Enter starts a new line and only Save sends.\n     An empty :value shows :placeholder in a muted tone, so the empty field\n     is a place to click, not a hole.\n\n     THE GESTURE SENDS THE WHOLE TEXT. The command writes it, and a refusal is\n     the sentence of the status line of the surface. The field closes after\n     the send, and the bound :value shows what the store holds.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the text, or the placeholder,\n     and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true, :doc "The text. BOUND, normally."}
       :string]
      [:placeholder
       {:optional true, :doc "What an empty text says."}
       :string]
      [:label
       {:optional true, :doc "A small heading above the text."}
       :string]
      [:multiline
       {:optional true,
        :doc "A text area in place of a field of one line."}
       :boolean]
      [:variant {:optional true} [:enum :heading :body]]
      [:read-only
       {:optional true, :doc "Draw the text and accept no click."}
       :boolean]],
     :defaults {:variant :body},
     :gestures [:submit],
     :children :none,
     :box-from :content},
    :hover-card
    {:description
     "Mantine `HoverCard` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 32 prop(s), 1 named\n     child slot(s), 6 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "HoverCard"},
     :status :generated,
     :box-from :viewport,
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:initially-opened
       {:optional true, :doc "Initial opened state"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:variant {:optional true} :string]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :anchor
    {:description
     "Mantine `Anchor` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Anchor"},
     :props
     [:map
      [:color {:optional true} [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]
      [:underline
       {:optional true,
        :doc
        "Defines when `text-decoration: underline` styles are applied."}
       [:enum :always :hover :not-hover :never]]],
     :defaults {:inherit false, :inline false, :size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :file-drop
    {:description
     "A SURFACE THAT TAKES FILES. A zone to drop files on, a button that opens the\n     file picker, the limit of one file in words, and a list. George,\n     2026-10-06: \"whatever is the means of upload should state its limist and\n     be vocal for errors\".\n\n     ONE GESTURE, :attach. Each file goes as its own dispatch, one after the\n     other, and $value is a MAP: {:name :media :bytes :data-url :base64}. So a\n     template reads a field with [:of $value name], as a :table row does.\n     :data-url is the whole `data:` URL and :base64 is the part after its\n     comma. A file with no type in the browser has the media\n     application/octet-stream.\n\n     :limit IS THE LARGEST FILE, in bytes. A bound :limit may also be the map\n     of the source :attachment-limit, {:max-bytes :text}, and then the zone\n     shows its :text and never formats the number a second way. When the map\n     also gives the free space of the disk, the zone shows it beside the\n     limit. A file over the limit is REFUSED BEFORE IT IS\n     READ, in words: \"This file is 48 MB. The limit is 3 MB.\" Nothing is\n     sent. With no :limit the zone says that the bus did not give the limit,\n     and the bus refuses a file that is too large.\n\n     THE LIST HAS TWO PARTS. First, the files of THIS SESSION that are not\n     stored: each one sending, or refused in red with its reason. A refusal of\n     the bus, a lost connection and an error of the vault each keep their row\n     (STALL, never VANISH). The rows stay for the visit, and a remount does not\n     lose them. Second, :items, the stored files: {:name :size :time :path\n     :notes}, each with the link Open and the notes that link to it. A file\n     that this session sent leaves the first part when :items holds its path.\n\n     :read-source names the source that answers a data URL for a :path. Open\n     reads it through the bus and opens the bytes in a new tab of the browser.\n     :note-href is the address of a note, where {page-id} is put in place of\n     the note's id.\n\n     Web renderer only. The TUI has no file picker, and it draws :items as\n     lines.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:limit {:optional true} :any]
      [:items {:optional true} [:vector :any]]
      [:accept {:optional true} :string]
      [:read-source {:optional true} :keyword]
      [:note-href {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:label "Drop files here, or choose them.",
      :empty-label "The vault holds no file."},
     :gestures [:attach],
     :children :none,
     :box-from :content},
    :stepper
    {:description
     "Mantine `Stepper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :defaults
     {:allow-next-steps-select true,
      :icon-position :left,
      :orientation :horizontal,
      :radius :xl,
      :wrap true},
     :box-to-children :block-flow,
     :mantine {:component "Stepper"},
     :status :generated,
     :box-from :content,
     :gestures [:step-click],
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active step"}
       [:or :int :double]]
      [:allow-next-steps-select
       {:optional true, :doc "If set, next steps can be selected"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls colors of active and progress steps"}
       [:or :keyword :string]]
      [:completed-icon
       {:optional true,
        :doc
        "Step icon displayed when step is completed, check icon by default"}
       :boolean]
      [:content-padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `padding-top` of the content"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:icon
       {:optional true,
        :doc "Step icon, default value is `step index + 1`"}
       :boolean]
      [:icon-position
       {:optional true, :doc "Icon position relative to the step body"}
       [:enum :left :right]]
      [:icon-size
       {:optional true,
        :doc
        "Controls size of the step icon, by default icon size is inferred from `size` prop"}
       [:or :string :int :double]]
      [:orientation
       {:optional true, :doc "Stepper orientation"}
       [:enum :horizontal :vertical]]
      [:progress-icon
       {:optional true,
        :doc
        "Step icon displayed when step is in progress, default value is `step index + 1`"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set steps border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls size of various Stepper elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:wrap
       {:optional true,
        :doc
        "Determines whether steps should wrap to the next line if no space is available"}
       :boolean]]},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer and,\n     on Enter, dispatches :on-gesture's :submit key (ADR-graph-ui-v0-013-01\n     Sec7-8, replacing v1.x's :on-submit). :leading-icon (ADR-graph-ui-v0-013 Sec17): an\n     optional :icon name shown at the input's leading edge — Mantine's\n     `leftSection`, the search field's magnifying glass. :state: a\n     validation/enablement hint — :invalid highlights the field, :disabled\n     greys it out and blocks edits. :variant (ADR-graph-ui-v0-013-01 Sec21):\n     Mantine's own InputVariant enum verbatim ('default' | 'filled' |\n     'unstyled'). :unstyled drops the field chrome, so an editable page title\n     paired with the universal :size :h1 reads as a HEADING rather than as a\n     form control — the locked target's 27px editable h1, expressed entirely\n     in Mantine's vocabulary rather than an ikc3 invention.\n\n     :masked (2026-10-06, IKC3/PLAN-ikc-v3-059-01/AT-2): true draws each typed\n     character as a dot, the way a password field does. The field keeps its\n     words after a refusal (STALL, never VANISH), so a masked field keeps\n     them as dots. The people island masks its field First secret. A masked\n     field is one line, and :multiline is ignored. The TUI draws a bound\n     value of a masked field as dots too.\n\n     :submit-label (2026-10-13, IKC3/PLAN-ikc-v3-056-01/TU, bindable): a\n     button with these words beside the field. It does what Enter does, and\n     it shows that it works until the bus answers. Without it, Enter is the\n     only way to submit, and nothing on the screen says so. George typed a\n     message in the tree of a session and pressed a different button to send\n     it (fault report ab952203). No :submit-label, no button.\n\n     :reset-key keeps the words of each key (2026-10-13, fault report\n     ff329728). Words typed and not submitted stay with the key they were\n     typed for, and come back with it. They never stand in the box of\n     another key, and they are never dropped.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:leading-icon {:optional true} :keyword]
      [:variant {:optional true} [:enum :default :filled :unstyled]]
      [:multiline {:optional true} :boolean]
      [:reset-key {:optional true} [:maybe :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]
      [:masked {:optional true} :boolean]
      [:submit-label {:optional true} [:maybe :string]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :dock
    {:description
     "THE ARRANGEMENT OF PANES, and the only kind that does not draw one —\n     ADR-graph-ui-v0-026-01. dockview owns level 5 of\n     CONCEPT-graph-ui-v0-014-01: it arranges PANES, and levels 4 and below\n     arrange what is inside one. That boundary is why ADR-013's single layout\n     model became one model PER SURFACE.\n\n     IT HOLDS NO GEOMETRY, and that is the decision rather than an omission.\n     Sizes, positions, split ratios and tab order are a VALUE the person owns —\n     api.toJSON() — stored on their session frame (ADR-graph-ui-v0-025-01 Sec4),\n     so an arrangement travels to the phone in their pocket. A description that\n     stated geometry would be a second authority over the same fact, and the\n     one-authority rule refuses that. This kind is the level-2 DOOR to a level-5\n     authority and nothing more.\n\n     EACH CHILD IS ONE PANE. The child's :title is the tab label and its\n     :import-id is the panel id, so a pane keeps its identity across a reload —\n     the same convention :tab-set already uses for its child boxes. A child\n     needs no other prop to be a pane.\n\n     ONLY A PERSON'S MOVE IS A COMMAND. dockview's onWillMutateLayout reports\n     :origin user or api. An api change is our own render, and echoing it back\n     as a person's choice is the defect class CONCEPT-ikc-v3-012-01 records.\n\n     :split-pane STAYS FROZEN (ADR-graph-ui-v0-025-01 Sec5). It holds exactly\n     two panes and cannot be the class for four.\n\n     ON A PHONE IT DRAWS ONE PANE AT A TIME (IKC3-Bugs-20260928, bug 3). Below\n     --viewport-narrow the web renderer draws a row of tabs, one for each pane\n     that shows, and the chosen pane takes the full width. It opens on the\n     pane that takes the remaining width, and a new page brings that pane\n     back. The stored arrangement is not read or written there.",
     :status :in-progress,
     :props
     [:map
      [:fallback {:optional true} [:enum :stack :first]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {:fallback :stack},
     :children :any,
     :box-from :parent,
     :needs :both,
     :box-to-children :definite},
    :timeline
    {:description
     "Mantine `Timeline` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Timeline"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active element"}
       [:or :int :double]]
      [:align
       {:optional true,
        :doc "Position of content relative to the bullet"}
       [:enum :left :right]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:bullet-size
       {:optional true, :doc "Size of the bullet"}
       [:or :string :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to control active item colors"}
       [:or :keyword :string]]
      [:line-width
       {:optional true, :doc "Control width of the line"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:reverse-active
       {:optional true,
        :doc
        "If set, the active items direction is reversed without reversing items order"}
       :boolean]],
     :defaults
     {:align :left,
      :bullet-size 20,
      :radius :xl,
      :reverse-active false},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :your-work-group
    {:description
     "ONE GROUP OF YOUR WORK (IKC3/PLAN-ikc-v3-080-01/ME, screen 8 of the plan):\n     Decide, Verify, Do, Schedule, or Reported by me. A heading with the\n     name, the count and one sentence, then one row for each work item, the\n     oldest first.\n\n     A ROW. The mark of the work type, the key as a link to the page of the\n     item (/browse/IKC-n), the title, one line of context, the age, and the\n     buttons of :actions. The title is never cut. It wraps to the lines it\n     needs (IKC-317, George, 2026-11-01).\n\n     THE ACTIONS. Each one sends ONE gesture :act with a map that the widget\n     composes, so a description reads its keys with [:of $value key].\n       decide     Decide… opens a field under the row, with the options of\n                  the Decision as buttons. Decide sends\n                  {:item-id :action \"decide\" :value <the answer>}\n       accept     Accept sends {:item-id :action \"accept\"}\n       reopen     Reopen… opens the Reopen dialog of the tracker\n                  (graph-ui.web.reopen). It sends no gesture: the dialog\n                  sends :workflow/reopen\n       done       Done sends {:item-id :action \"done\"}\n       pick-time  Pick a time… opens a field under the row. Send sends\n                  {:item-id :action \"pick-time\" :value <the time>}\n\n     THE RULES ARE IN THE GATE. The group draws each action of a row, and\n     the commands of the workflow decide. A refusal is the sentence of the\n     status line of the surface.\n\n     WHY A KIND OF ITS OWN. A product surface is a declared widget kind, not a\n     generic table (rule 4 of section 6 of the plan). A :table has no button\n     in a row and no field that opens under a row.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the heading, then one line\n     for each row, \"KEY title · context\", and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true,
        :doc "The group: {:id :label :says :count :rows}."}
       [:map
        [:id {:optional true} :string]
        [:label :string]
        [:says {:optional true} :string]
        [:count {:optional true} :int]
        [:rows
         {:optional true}
         [:vector
          [:map
           [:id :string]
           [:key {:optional true} :string]
           [:kind {:optional true} :string]
           [:title :string]
           [:context {:optional true} :string]
           [:age {:optional true} :string]
           [:status {:optional true} :string]
           [:actions
            {:optional true}
            [:vector
             [:enum "decide" "accept" "reopen" "done" "pick-time"]]]
           [:options {:optional true} [:vector :string]]
           [:recommendation {:optional true} :string]]]]]]
      [:empty-label
       {:optional true,
        :doc
        "What an empty group says. Absent: the group is not drawn when it is empty."}
       :string]],
     :defaults {},
     :gestures [:act],
     :children :none,
     :box-from :content},
    :password-input
    {:description
     "Mantine `PasswordInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"visibilityToggleIcon" "FC<{ reveal: boolean; }>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "PasswordInput"},
     :status :generated,
     :box-from :content,
     :gestures [:visibility-change],
     :props
     [:map
      [:default-visible
       {:optional true,
        :doc "If set, the input value is visible by default"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:visible
       {:optional true,
        :doc "If set, the input value is visible visible"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :progress
    {:description
     "Mantine `Progress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Progress"},
     :props
     [:map
      [:animated
       {:optional true,
        :doc
        "If set, the sections stripes are animated, `striped` prop is ignored"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS value"}
       [:or :keyword :string]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls track height"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:striped
       {:optional true, :doc "If set, the section has stripes"}
       :boolean]
      [:transition-duration
       {:optional true,
        :doc
        "Controls sections width transition duration, value is specified in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Value of the progress"}
       [:or :int :double]]],
     :defaults
     {:animated false,
      :orientation :horizontal,
      :size :md,
      :striped false,
      :transition-duration 100},
     :children :none,
     :box-from :content},
    :board-column
    {:description
     "ONE STATUS CATEGORY OF THE BOARD AS A COLUMN OF CARDS\n     (IKC3/PLAN-ikc-v3-080-01/BOARD, screen 1 of the plan). A heading with the\n     name and the count, as \"TODO · 3\", and a note under it, as \"pull request\n     open\". Then each card, drawn as a :work-card. A column can also group its\n     cards: Deployed has one group for each release, with a heading, a link to\n     the release notes and the count of accepted work.\n\n     THE CATEGORY IS A LITERAL PROP, so gate 12f of validate-dsl reads the\n     columns of a description and compares them with :grammar :views of\n     workflow.edn. :value is bound, and it holds the cards.\n\n     FIVE GESTURES.\n       :drop    a card dropped on the column. $dragged is the card map, so\n                [:of $dragged item-id] reads its id. $value is empty.\n       :select  a click on one of its cards. $value is the card map.\n       :accept  Accept on one of its cards. $value is the card map.\n       :reopen  Reopen on one of its cards. $value is the card map. The\n                browser first opens the Reopen dialog of the card\n                (graph-ui.web.reopen), which sends :workflow/reopen. Then it\n                sends the gesture.\n       :accept-unverified  Accept without verification on one of its\n                cards. $value is the card map (IKC3/PLAN-ikc-v3-080-01/FLOW34,\n                decision 34).\n\n     ABSENT, NOT EMPTY. A column whose :value says :absent true draws nothing:\n     Idle drawn as a flag has no column (PLAN-ikc-v3-080-01 §3.2). An empty\n     column is drawn, with its heading, so a drop has a place to land.\n\n     ON A PHONE ONE COLUMN SHOWS. :narrow :hide on the node hides the column\n     below the display profile :narrow, as on each other kind.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the heading, then one line for\n     each card, and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:category
       {:doc "The status category, a literal: \"todo\"."}
       :string]
      [:label
       {:optional true, :doc "The heading before the first read."}
       :string]
      [:note
       {:optional true, :doc "The line under the heading."}
       :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:value
       {:optional true}
       [:map
        [:label {:optional true} :string]
        [:count {:optional true} :int]
        [:note {:optional true} :string]
        [:absent {:optional true} :boolean]
        [:cards {:optional true} [:vector [:map-of :keyword :any]]]
        [:groups
         {:optional true}
         [:vector
          [:map
           [:heading :string]
           [:link
            {:optional true}
            [:map [:label :string] [:href :string]]]
           [:cards [:vector [:map-of :keyword :any]]]]]]
        [:more
         {:optional true}
         [:map [:label :string] [:href :string]]]
        [:empty-label {:optional true} :string]]]],
     :defaults {},
     :gestures [:drop :select :accept :reopen :accept-unverified],
     :children :none,
     :box-from :content},
    :badge
    {:description
     "A static label pill — Mantine `Badge` (ADR-graph-ui-v0-013-01 Sec13). Also\n     covers the 'status LED' row: :label absent + :circle true + a small\n     implicit size IS a state-coloured dot, deliberately not a seventh\n     kind. Non-interactive — no :on-gesture.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:circle {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :table-of-contents
    {:description
     "Mantine `TableOfContents` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "TableOfContents"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:depth-offset
       {:optional true,
        :doc
        "Controls padding on the left side of control, multiplied by (`depth` - `minDepthToOffset`), `20px` by default"}
       [:or :string :int :double]]
      [:initial-data
       {:optional true,
        :doc
        "Data used to render content until actual values are retrieved from the DOM"}
       [:vector :any]]
      [:min-depth-to-offset
       {:optional true,
        :doc
        "Minimum `depth` value that requires offset, `1` by default"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls font-size and padding of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :unmapped {"scrollSpyOptions" "UseScrollSpyOptions"},
     :children :none,
     :box-from :content},
    :breadcrumbs
    {:description
     "Mantine `Breadcrumbs` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :slots [:separator],
     :defaults {:separator-margin :xs},
     :box-to-children :block-flow,
     :mantine {:component "Breadcrumbs"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:separator-margin
       {:optional true,
        :doc "Controls spacing between separator and breadcrumb"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :pin-input
    {:description
     "Mantine `PinInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 22 prop(s), 2\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :defaults
     {:mask false,
      :one-time-code true,
      :placeholder "○",
      :type :alphanumeric,
      :size :sm,
      :manage-focus true,
      :gap :md,
      :length 4,
      :auto-focus false},
     :mantine {:component "PinInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change :complete],
     :props
     [:map
      [:aria-label
       {:optional true, :doc "`aria-label` attribute"}
       :string]
      [:auto-focus
       {:optional true,
        :doc
        "If set, the first input is focused when component is mounted"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true, :doc "Adds disabled attribute to all inputs"}
       :boolean]
      [:error
       {:optional true,
        :doc
        "Sets `aria-invalid` attribute and applies error styles to all inputs"}
       :boolean]
      [:form
       {:optional true, :doc "Hidden input `form` attribute"}
       :string]
      [:gap
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `gap` between inputs, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:id
       {:optional true,
        :doc "Base id used to generate unique ids for inputs"}
       :string]
      [:input-mode
       {:optional true,
        :doc
        "`inputmode` attribute, inferred from the `type` prop if not specified"}
       [:enum :search :text :none :tel :email :url :numeric :decimal]]
      [:input-type
       {:optional true,
        :doc
        "Inputs `type` attribute, inferred from the `type` prop if not specified"}
       [:or
        [:enum
         :number
         :button
         :search
         :time
         :image
         :text
         :hidden
         :color
         :radio
         :checkbox
         :tel
         :password
         :date
         :datetime-local
         :email
         :file
         :month
         :range
         :reset
         :submit
         :url
         :week]
        :string]]
      [:length
       {:optional true, :doc "Number of inputs"}
       [:or :int :double]]
      [:manage-focus
       {:optional true,
        :doc
        "Determines whether focus should be moved automatically to the next input once filled"}
       :boolean]
      [:mask
       {:optional true, :doc "Changes input type to `\"password\"`"}
       :boolean]
      [:name
       {:optional true, :doc "Hidden input `name` attribute"}
       :string]
      [:one-time-code
       {:optional true,
        :doc
        "Determines whether `autocomplete=\"one-time-code\"` attribute should be set on all inputs"}
       :boolean]
      [:placeholder
       {:optional true, :doc "Inputs placeholder"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true, :doc "If set, the user cannot edit the value"}
       :boolean]
      [:size
       {:optional true, :doc "Controls inputs `width` and `height`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Determines which values can be entered"}
       [:or [:enum :number :alphanumeric] :string]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]]},
    :code-view
    {:description
     "A whole source FILE, shown the way an editor shows one: syntax colour, line\n     numbers, code folding, and the corpus ids and handler symbols inside the\n     text rendered as links that navigate to the frames they name. Read-only.\n     :value is the file body and :language the grammar to colour it with, both\n     normally bound to a source rather than written in the description. The TUI\n     renders it as plain monospaced text, as it does every code widget here.\n\n     Distinct from :code-block, which is a snippet inside a document and needs\n     only colour.\n\n     :wrap (2026-10-05): true wraps a line longer than the view onto the next\n     screen line. false or absent keeps each line one line, and the view\n     scrolls to the side. The TUI ignores it.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:line-numbers {:optional true} :boolean]
      [:folding {:optional true} :boolean]
      [:wrap {:optional true} :boolean]
      [:links
       {:optional true}
       [:vector [:map [:text :string] [:frame-id :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:line-numbers true, :folding true},
     :children :none,
     :box-from :parent,
     :needs :block,
     :self-flex :block},
    :coach-mark
    {:description
     "A GUIDE'S POINTER (PLAN-ikc-v3-028-01 Phase D). The CARD draws where the\n     description puts it, in flow — the Guide pane — with :title, :says,\n     `index / count`, and the buttons: `Previous` and `Next` fire :previous and :next with $value = the\n     step's number to show; `Do it for me` fires :submit; `Resume` (drawn when\n     :pinned?) fires :resume; `Start again` (drawn when :done-all?) fires\n     :restart. :dim? draws a translucent overlay over the rest of the island, so\n     the eye goes to the target. :has-do? false, or :done? true, disables `Do it\n     for me` — the step is done by hand, and :says names the key, or it is done\n     already and the header says so.\n\n     WHAT FLOATS is the target's ring and a small badge with the step's number,\n     at the corner of the widget whose root carries data-import-id = :target\n     (the renderer stamps every root). A card floated beside a column of\n     controls covered one of them every time (2026-09-08), so the card does not\n     float. With no such element on the screen there is no badge and the card\n     still says the step — never nothing. The mark is STATELESS: everything it\n     shows is bound from :guide-current, and every button is one declared\n     command.",
     :status :in-progress,
     :props
     [:map
      [:target {:optional true} :string]
      [:step {:optional true} :string]
      [:title {:optional true} :string]
      [:says {:optional true} :string]
      [:index {:optional true} :int]
      [:count {:optional true} :int]
      [:has-do? {:optional true} :boolean]
      [:done? {:optional true} :boolean]
      [:pinned? {:optional true} :boolean]
      [:done-all? {:optional true} :boolean]
      [:dim? {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {:dim? false},
     :children :none,
     :box-from :content},
    :json-input
    {:description
     "Mantine `JsonInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 6 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :slots
     [:description
      :error
      :label
      :left-section
      :right-section
      :validation-error],
     :defaults
     {:autosize false,
      :left-section-pointer-events "none",
      :format-on-blur false,
      :right-section-pointer-events "none",
      :resize :none,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "JsonInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:autosize
       {:optional true,
        :doc
        "If set, enables textarea height growing with its content"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:format-on-blur
       {:optional true,
        :doc
        "Determines whether the value should be formatted on blur"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max-rows
       {:optional true,
        :doc
        "Maximum rows for autosize textarea to grow, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:min-rows
       {:optional true,
        :doc
        "Minimum rows of autosize textarea, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:resize
       {:optional true, :doc "Controls `resize` CSS property"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :inline
        :none
        :block
        :horizontal
        :vertical
        :both]]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is\n     a vector of {:label <string> :gesture <keyword> :tone <token,\n     optional> :disabled <bool, optional>} maps (ADR-graph-ui-v0-013-01 Sec9,\n     replacing v1.x's per-item :command/:with): :gesture names a key in\n     this SAME node's :on-gesture map, where the actual command template\n     lives, authored once alongside every other gesture the node carries.\n     Clicking an item dispatches its named :on-gesture entry — $session-id\n     substituted, plus whatever :with that entry's template carries.\n     Distinct from :list (plain display) and :button (one action): :menu is\n     a grouped set of commands. Web-only interactive; the TUI renders the\n     item labels as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:gesture {:optional true} :keyword]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:disabled {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :tooltip
    {:description
     "Mantine `Tooltip` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 5 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"events" "{ hover: boolean; focus: boolean; touch: boolean; }",
      "middlewares" "TooltipMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "target" "string | HTMLElement | RefObject<HTMLElement>"},
     :slots [:label],
     :defaults
     {:arrow-offset 5,
      :arrow-radius 0,
      :arrow-size 4,
      :close-delay 0,
      :floating-strategy :absolute,
      :with-arrow false},
     :box-to-children :block-flow,
     :mantine {:component "Tooltip"},
     :status :generated,
     :box-from :viewport,
     :gestures [:position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position relative to the tooltip"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls tooltip background, by default set based on current color scheme"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled tooltip initial opened state"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, tooltip element will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:inline
       {:optional true,
        :doc "Must be set if the tooltip target is an inline element"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the tooltip is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:multiline
       {:optional true,
        :doc
        "Determines whether content should be wrapped on to the next line, `false` by default"}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:opened
       {:optional true, :doc "Controlled opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc
        "Tooltip position relative to target element (`Tooltip` component) or mouse (`Tooltip.Floating` component)"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:ref-prop
       {:optional true,
        :doc
        "Key of the prop that can be used to access element ref, `ref` by default"}
       :string]
      [:with-arrow
       {:optional true, :doc "If set, the tooltip has an arrow"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether tooltip should be rendered within `Portal`, `true` by default"}
       :boolean]
      [:z-index
       {:optional true, :doc "Tooltip z-index, `300` by default"}
       [:or :string :int :double]]]},
    :blockquote
    {:description
     "Mantine `Blockquote` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Blockquote"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:icon-size
       {:optional true,
        :doc
        "Controls icon `width` and `height`, numbers are converted to rem"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:icon-size 40},
     :slots [:cite :icon],
     :children :slots,
     :box-from :content},
    :modal-base
    {:description
     "Mantine `ModalBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :shadow :xl,
      :lock-scroll true},
     :box-to-children :block-flow,
     :mantine {:component "ModalBase"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:unstyled {:optional true} :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :switch
    {:description
     "Mantine `Switch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 7 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label :off-label :thumb-icon],
     :defaults
     {:label-position :right, :radius :xl, :with-thumb-indicator true},
     :mantine {:component "Switch"},
     :status :generated,
     :box-from :content,
     :gestures [:label],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:id
       {:optional true,
        :doc
        "Id used to bind input and label, if not passed, unique id will be generated instead"}
       :string]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-thumb-indicator
       {:optional true,
        :doc "If set, the indicator will be displayed inside thumb"}
       :boolean]]},
    :rating
    {:description
     "Mantine `Rating` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 2\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "Rating"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any CSS color value"}
       [:or :keyword :string]]
      [:count
       {:optional true, :doc "Number of controls"}
       [:or :int :double]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:fractions
       {:optional true,
        :doc "Number of fractions each item can be divided into"}
       [:or :int :double]]
      [:highlight-selected-only
       {:optional true,
        :doc
        "If set, only the selected symbol changes to full symbol when selected"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "`name` attribute passed down to all inputs. By default, `name` is generated randomly."}
       :string]
      [:read-only
       {:optional true,
        :doc "If set, the user cannot interact with the component"}
       :boolean]
      [:size
       {:optional true, :doc "Controls component size"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]],
     :defaults
     {:color :yellow,
      :count 5,
      :fractions 1,
      :highlight-selected-only false,
      :read-only false,
      :size :sm},
     :gestures [:change :hover],
     :children :none,
     :box-from :content},
    :backlog-band
    {:description
     "ONE BAND OF THE BACKLOG (IKC3/PLAN-ikc-v3-080-01/BACKLOG, screen 2 of the\n     plan): the speed lane, Triage, On the board or Backlog. A heading with\n     the count and a hint, then one row for each work item.\n\n     A ROW. A box to select it, the work type, the key, the title, a lozenge\n     \"+2 similar\" when the row leads a group of similar reports, a line\n     with the date and the reporter, the priority and the status. A row that\n     a move to Todo refused also shows the missing fields, one badge each.\n     Then the buttons of :row-actions: Todo, Backlog and Close.\n\n     ON A NARROW ROW THE TITLE WINS (IKC-317, George, 2026-10-29). The row\n     wraps. The title keeps at least 24ch, and it takes a line of its own\n     when the row is too narrow for one line. The date and the reporter\n     shorten first. The controls go under the title. Before this a phone in\n     landscape showed the key and one word of the title, because the meta\n     and the buttons held their width. A phone in landscape is about 890\n     CSS pixels.\n\n     THE TITLE IS NEVER CUT (IKC-317, George, 2026-11-01). It wraps to the\n     lines it needs, on a wide row and on a narrow row. Before this a long\n     title ended in an ellipsis, and the reopen of 2026-11-01 showed it.\n\n     A ROW DRAGS FROM ITS BODY, NEVER FROM A CONTROL (IKC-298, George,\n     2026-10-24). In Firefox the choice Close... of a draggable row did not\n     open. So a press on a control turns the drag of the row off first.\n\n     THE GESTURES. Each one sends a map that the widget composes, so a\n     description reads its keys with [:of $value key].\n       :open   a click on the title. $value {:item-id}\n       :move   the button Todo or Backlog. $value {:item-id :category}\n       :close  a choice of the button Close. $value {:item-id :resolution}\n       :bulk   a button of the bulk bar. $value {:item-ids :action :value}.\n               :action is todo, backlog, priority or close. :value is the\n               priority or the resolution. For todo, :value is the chosen\n               priority, and each item with no priority gets it\n       :rank   a drop of a row of this band on a row of this band.\n               $value {:item-id :before-id}\n       :drop   a drop of a row of another band on this band.\n               $value {:item-id}\n\n     THE BULK BAR shows when one row or more is selected: Move to Todo, a\n     choice of the priority and Close. The selection is a state of the\n     browser. It goes when the rows change.\n\n     THE CHOSEN PRIORITY (IKC-297, George, 2026-10-24). The choice shows the\n     entry of :priorities with :default true until the person chooses\n     another. A choice sets the priority of each selected item at once, and\n     the rows stay selected. Move to Todo sends the chosen priority.\n\n     THE RULES ARE IN THE GATE. The band draws every control for every row,\n     and the commands of the workflow decide. A refusal is the sentence of\n     the status line of the surface, and the missing fields of a refused row\n     come back in its :missing.\n\n     WHY A KIND OF ITS OWN. A product surface is a declared widget kind, not a\n     generic table (rule 4 of section 6 of the plan). A :table has no box to\n     select, no button in a row and no drop on a row.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the heading, then one line\n     for each row, \"KEY title · meta\", and dispatches nothing.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:key {:optional true} :string]
         [:kind {:optional true} :string]
         [:title :string]
         [:meta {:optional true} :string]
         [:priority {:optional true} :string]
         [:status {:optional true} :string]
         [:similar {:optional true} :string]
         [:missing {:optional true} [:vector :string]]
         [:selected {:optional true} :boolean]]]]
      [:title
       {:optional true,
        :doc "The name of the band, for example Triage."}
       :string]
      [:count
       {:optional true,
        :doc "The count after the name. Absent: the count of :items."}
       :string]
      [:hint
       {:optional true, :doc "One sentence after the count."}
       :string]
      [:tone
       {:optional true,
        :doc
        "The frame of the band: :danger for the speed lane, :warning for Triage."}
       [:enum :default :danger :warning]]
      [:row-actions
       {:optional true, :doc "The buttons of each row, in order."}
       [:vector [:enum :todo :backlog :close]]]
      [:selectable
       {:optional true,
        :doc
        "Each row has a box to select it, and the bulk bar shows."}
       :boolean]
      [:rankable
       {:optional true,
        :doc
        "A row of this band dropped on a row of this band sends :rank."}
       :boolean]
      [:accepts-drop
       {:optional true,
        :doc "A row of another band dropped on this band sends :drop."}
       :boolean]
      [:resolutions
       {:optional true,
        :doc "The choices of Close, [{:value :label}]."}
       [:vector [:map [:value :string] [:label :string]]]]
      [:priorities
       {:optional true,
        :doc
        "The choices of the priority in the bulk bar, [{:value :label :default}]. The entry with :default true is chosen first."}
       [:vector
        [:map
         [:value :string]
         [:label :string]
         [:default {:optional true} :boolean]]]]
      [:empty-label
       {:optional true,
        :doc
        "What an empty band says. Absent: the band is not drawn when it is empty."}
       :string]],
     :defaults {},
     :gestures [:open :move :close :bulk :rank :drop],
     :children :none,
     :box-from :content},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n     :options is the list of choices — a vector of {:label <string> :value\n     <string>} maps, bindable via :bind. :value names the initially-selected\n     option's :value. On change the renderer dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the chosen option's :value — mirroring :input's\n     Enter->command seam. :placeholder shows as a disabled leading option\n     when no :value matches. Web-only interactive; the TUI renders the\n     current value (or placeholder) as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :slider
    {:description
     "Mantine `Slider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 19 prop(s), 1 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"domain" "[number, number]"},
     :slots [:thumb-children],
     :defaults
     {:show-label-on-hover true,
      :min 0,
      :restrict-to-marks false,
      :radius :xl,
      :size :md,
      :max 100,
      :label-always-on false,
      :step 1,
      :inverted false},
     :mantine {:component "Slider"},
     :status :generated,
     :box-from :content,
     :gestures [:change :change-end],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls color of track and thumb"}
       [:or :keyword :string]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled {:optional true, :doc "Disables slider"} :boolean]
      [:inverted
       {:optional true,
        :doc
        "Determines whether track value representation should be inverted"}
       :boolean]
      [:label-always-on
       {:optional true,
        :doc
        "Determines whether the label should be visible when the slider is not being dragged or hovered"}
       :boolean]
      [:marks
       {:optional true, :doc "Marks displayed on the track"}
       [:vector :any]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimal possible value"}
       [:or :int :double]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:precision
       {:optional true,
        :doc "Number of significant digits after the decimal point"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:restrict-to-marks
       {:optional true,
        :doc
        "Determines whether the selection should be only allowed from the given marks array"}
       :boolean]
      [:show-label-on-hover
       {:optional true,
        :doc
        "Determines whether the label should be displayed when the slider is hovered"}
       :boolean]
      [:size
       {:optional true, :doc "Controls size of the track"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with thumb drag and arrows"}
       [:or :int :double]]
      [:thumb-label
       {:optional true, :doc "Thumb `aria-label`"}
       :string]
      [:thumb-size
       {:optional true,
        :doc
        "Thumb `width` and `height`, by default value is computed based on `size` prop"}
       [:or :string :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]]},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a bound :text\n     (see :bind) gets its value from a data source. Type size, weight and\n     casing are NOT declared here: they are the :font-size/:font-weight/\n     :text-transform UNIVERSAL SLOTS as of ADR-graph-ui-v0-013-01 Sec19, because\n     they were never properties of text specifically (v1.x's own :size/:weight\n     stay on v1.x's :text forever, unchanged).\n     :empty-label (Sec23): what to show when the bound value resolves to an\n     empty string — the locked target's 'Add tags…' on a page with no tags.\n     Same slot name and same meaning :list/:tree/:outline already carry, so a\n     resolved-empty binding reads as EMPTY rather than as a broken pane. Not\n     :placeholder: that name already means 'hint text in an editable field'\n     on :input, and one name with two senses is how vocabulary rots.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none,
     :box-from :content}}},
  "v2.1"
  {:status :released,
   :content-hash "f0a2cb21",
   :universal-slots
   {:pane
    {:description
     "WHERE THIS CHILD SITS IN A :dock, what its tab says, and how wide it opens.\n\n     Universal for the reason :section is: it is a statement a CHILD makes about\n     its place in its parent, and not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being a pane.\n\n     :direction is dockview's own word. Without :reference it is relative to the\n     pane declared BEFORE this one — `right` puts this pane to the right of\n     that one. The FIRST pane of a dock carries no :direction, because it is the\n     root of the grid and there is no earlier pane to be relative to. A pane\n     with no :direction at all joins the previous pane's group, which draws the\n     two as tabs.\n\n     :folded SAYS THE ISLAND OPENS WITH THIS PANE CLOSED (2026-09-09). George,\n     on the research island: the graph view is not usable in its bare-minimum\n     shape and can stay off by default, and so can the internals. A pane is\n     still there and still one icon from open — this is an initial state, never\n     a removal. THE PERSON'S OWN CHOICE ALWAYS WINS: a stored visibility and a\n     toggle in this visit both override it, because a default that fought the\n     person would be worse than no default. Only a pane that also declares\n     `can fold` may declare this, since a pane with no way back would be a\n     trap.\n\n     :reference NAMES THE PANE THE DIRECTION IS ABOUT, and it is what lets a\n     pattern stack (2026-09-09). Until now the reference was always the previous\n     pane, so `below` and `above` were in this enum and unreachable: a pattern\n     could say a pane sits at a place, and every later pane at that place was\n     put BESIDE its sibling. Five panes at `right` therefore made the last one\n     170 px wide with six columns in it (George: the Results pane is\n     unreadable), and there was no way to say `under the tree`.\n\n     THE PATTERN'S OWN WORD FOR IT ALREADY EXISTED. building-blocks.edn declares\n     `sits` to mean where this is, RELATIVE TO SOMETHING ELSE — so\n     `[thought-body sits below thought-tree]` is a legal fact of four names\n     against one of the thirteen relations. What was missing was a reader,\n     ui.patterns/pane-props, and this slot to carry its answer.\n\n     WHY IT EXISTS. A dock with no direction on any pane puts every pane in ONE\n     group. Measured 2026-09-02 on reader-v3's first load: `groups=1`, two tabs.\n     A pattern that says `navigator sits left` and `reading-area sits middle`\n     means side by side, so the panes have to say so and nothing else could.\n\n     :width IS A PIXEL COUNT, and this is the one level it may be. A pattern\n     states a named measure — narrow-measure — and ui.patterns resolves it here,\n     the way a block's :draws resolves one. Without it a dock splits the surface\n     evenly and a sidebar opens at half the window.\n\n     :height IS THE SAME PIXEL COUNT ON THE OTHER AXIS, and only a band needs\n     it. A band states its extent on ONE axis, so dockview halves the other.\n\n     :absorbs SAYS THIS PANE TAKES WHAT THE OTHERS LEAVE (2026-09-11). George\n     chose it from four answers: size the all-remaining pane last from what is\n     left. A dock cannot work this out alone, because `all-remaining` resolves\n     to NO width on purpose — so the pane that means it looks exactly like a\n     pane that states nothing. Measured at 1920 on the research island before\n     this slot existed: the reading column opened at 100 pixels, dockviews own\n     minimum, while the Guide took 640 and the Add pane 910.\n\n     ONE PANE OF A SURFACE, AND NEVER TWO. The arithmetic is the surface minus\n     what every other column claims, so a second pane with this slot would have\n     nothing to divide. ui.patterns reads the pane whose measure is\n     all-remaining and which is a COLUMN — a pane BELOW another pane is in that\n     panes column and has that columns width already.\n\n     :shares SAYS THIS PANE TAKES AN EQUAL PART OF THE SAME SPACE (2026-09-12).\n     George: it looks to me that narrow-measure and all-remaining will be well\n     balanced by equally-divided, but it cannot be applied in isolation. It is\n     the middle term of three — one number that never moves, an equal part of\n     what is left, and everything that is left.\n\n     TWO OR MORE, AND validate-dsl REFUSES ONE. A single pane cannot divide\n     anything equally. It also refuses a surface that carries both slots,\n     because both claim the space the numbers leave.\n\n     WRITTEN BY ui.patterns, NOT BY A PERSON. A pattern's facts are projected\n     onto the page's placed blocks at seed time (ADR-graph-ui-v0-026-01). A\n     description may still carry it by hand, the way :section may.\n\n     ONE SLOT AND NOT TWO. The tab label was a bare :title, and :title is a prop\n     of some widget kinds and of neither :stack nor :container — the two roots a\n     docked building block actually has. So a conformant description could not\n     carry its own label. The label is part of what makes a child a pane, so it\n     is stated in the same place.\n\n     A DOCK WHOSE PANES ARE HAND-WRITTEN :box NODES may still use a bare :title,\n     which is the convention :tab-set uses for its child boxes.\n\n     :id IS THE PANE'S IDENTITY ACROSS A RELOAD, and the pattern's own name for\n     it — navigator, reading-area. A stored arrangement refers to panels by id,\n     and the stamp that decides whether a stored arrangement still applies is\n     built from them. :import-id cannot serve: :ui/attach strips it, so a dock\n     without this named its panes by position and the stamp never changed.",
     :shape
     [:map
      [:id {:optional true} :string]
      [:title {:optional true} :string]
      [:direction
       {:optional true}
       [:enum "left" "right" "above" "below" "within"]]
      [:reference {:optional true} :string]
      [:foldable {:optional true} :boolean]
      [:folded {:optional true} :boolean]
      [:width {:optional true} :int]
      [:height {:optional true} :int]
      [:absorbs {:optional true} :boolean]
      [:shares {:optional true} :boolean]]},
    :text-transform
    {:description
     "Text casing — Mantine's `tt`. :uppercase is SPEC-002's sidebar section\n     header (11px / 700 / uppercase / letter-spaced) and its kind badge; the\n     renderer pairs :uppercase with the target's letter-spacing, since the\n     two always travel together in the locked target and a separate\n     letter-spacing slot would be a prop with exactly one legal use.",
     :shape [:enum :none :uppercase]},
    :import-id
    {:description
     "This node's AUTHORED IDENTITY — stable across re-seeds, and the join\n     between a description FILE and the frames it becomes.\n\n     The platform's own mechanism, not a new one: `frames-lib.store/create-frame!`\n     treats :import-id as a stable identity — a frame already bearing one is\n     SYNCED IN PLACE, same :frame/id, rather than duplicated — and\n     `ui.frames/node->slots` already lifts it off a widget node. Seeding an\n     island twice therefore leaves every :widget-id byte-identical, which is\n     what makes a Penpot board, an op-spec or any stored reference survive a\n     re-seed (verified 2026-08-04 across two seeds of the reader).\n\n     Why it is authored rather than the uuid: a :widget-id is minted by whichever\n     database was running, so a file full of uuids names frames that a wiped\n     graph no longer has. \"reader/vault-search\" survives the wipe and says what\n     the node IS. The uuid remains the join key between the graph and Penpot;\n     this is the join key between the file and the graph.\n\n     Namespaced by island by convention (\"reader/…\", \"reader-v2/…\") so two\n     islands may both hold a `vault-search` without colliding in one graph.\n\n     DECLARED HERE BECAUSE THE ENTRY SCHEMA IS CLOSED. The seeder read this key\n     from day one and the validator rejected it as a disallowed key — the files\n     were stamped, the islands seeded, `validate-dsl` passed (it checks this\n     manifest, not the instances), and only the full suite caught it. A slot the\n     platform reads and the vocabulary does not declare is exactly the drift\n     DSL-First exists to make impossible.",
     :shape :string},
    :widget-component
    {:description
     "This node is an OCCURRENCE of a named definition rather than a widget in\n     its own right — ADR-ikc-v3-060-01 §5. The value names a definition in the\n     description's own :components map.\n\n        {:widget-component :reading-pane :section :main :size \"66ch\"}\n\n     Everything beside :widget-component is an OVERRIDE, merged over the\n     definition. Under ADR-graph-ui-v0-002-01 any property may be overridden and each\n     one is TOUCHED — the occurrence's own, no longer following the definition.\n     Verified against Penpot 2.17 on 2026-08-04, whose component copies behave\n     exactly this way.\n\n     WHY THIS EXISTS. A description is read far more often than it is written,\n     and reader-ui.edn is 863 lines nested nine deep — you cannot see the page.\n     Naming its parts lets the top of a file BE the page, six lines long, with\n     each part opening on its own. It is also what a Penpot component maps to,\n     one-for-one, so a board and a description can talk about the same thing\n     (§6).\n\n     EXPANDED AT SEED TIME, for now. The seeder inlines each occurrence before\n     creating frames, so the graph holds a plain widget tree and the renderers\n     need no new case. That means the graph does not yet KNOW a component exists\n     — ADR-060 §1's :widget-component frame type and §3's occurrence links are\n     not built, so a definition change does not propagate to live occurrences and\n     a round-trip cannot give components back. Stated plainly because the gap is\n     invisible from the file, which looks like it has components either way.",
     :shape :keyword},
    :font-size
    {:description
     "Type size — Mantine's `fz` style prop (universal there too, for the same\n     reason). Two scales in ONE enum, exactly as Mantine's own MantineFontSize\n     does: the :xs-:xl step scale, and :h1-:h6 for heading sizes. :h1 is what\n     makes an editable page title LOOK like a title (with :variant :unstyled\n     on :input — Sec21) instead of like a form control.\n\n     Distinct from a kind's own :size (:icon, :drawer, :container), which\n     means that KIND's own dimension, never type size.",
     :shape [:enum :xs :sm :md :lg :xl :h1 :h2 :h3 :h4 :h5 :h6]},
    :font-weight
    {:description
     "Font weight — Mantine's `fw`. Mantine types it to raw CSS fontWeight,\n     which would make it unvalidatable, so v2.0 closes it to three named\n     steps (Sec0's standing trade). Moved here from :text's own :props\n     (Sec19) — it was never a property of text specifically. v1.x's :text\n     keeps its own :weight forever; a released version's vocabulary never\n     changes (ADR-graph-ui-v0-004-01).",
     :shape [:enum :normal :medium :bold]},
    :section
    {:description
     "Which named PLACE in its parent this child fills.\n\n     Universal for the same reason :flex is: it is a statement a CHILD makes\n     about its place in its parent, not a property of the child's own kind. A\n     :stack does not become a different kind of stack by being the navbar.\n\n     TWO FAMILIES OF VALUE, ONE IDEA. The first five are an :app-shell's page\n     regions — Mantine's AppShell.Header / .Navbar / .Aside / .Main / .Footer,\n     named rather than ordered (ADR-graph-ui-v0-001-01 §B). The rest are the\n     named child slots the generated kinds declare: a `Divider`'s label, an\n     `Alert`'s title and icon, a `TextInput`'s description and error. Mantine's\n     `leftSection` and `label` props are the same idea as its `AppShell.Navbar`\n     — a place a widget goes — so this vocabulary says it once. Inventing a\n     second mechanism for the second family is what ADR-graph-ui-v0-013-01 was\n     written to end.\n\n     WHY THE SECOND FAMILY IS HERE AT ALL (AC-graph-ui-v0-001-01 §C, 2026-08-05).\n     It was not, and the consequence was that 31 kinds declared named slots that\n     NO valid description could fill: the enum could not spell :label, so\n     graph-ui.web.mantine-generic/split-slots — correct code — was unreachable.\n     A browser found it; nothing else could, because both halves were\n     individually valid and only their conjunction was wrong.\n\n     A documented no-op where it means nothing — the same contract :flex sets\n     for the TUI. This enum stays CLOSED (ADR-ikc-v3-041-01): a name that is not\n     here is rejected, so a typo is still caught. dsl/scripts/validate.clj holds\n     it to the vocabulary — every :slots name any kind declares must appear\n     below, and a generator run that adds a new slot name fails the build until\n     it does. That check is what stops this list from drifting back out of step,\n     which is the failure it was written after.",
     :shape
     [:enum
      :aside
      :chevron
      :cite
      :description
      :error
      :footer
      :header
      :hide-label
      :icon
      :label
      :left-section
      :legend
      :main
      :navbar
      :nothing-found-message
      :off-label
      :placeholder
      :right-section
      :separator
      :show-label
      :thumb-children
      :thumb-icon
      :title
      :validation-error]},
    :per-row
    {:description
     "DRAW MY ONE CHILD ONCE PER ROW OF A SOURCE, each copy with $row bound to\n     that row (PLAN-ikc-v3-026-01 Q2, RESEARCH-ikc-v3-021-01 D6).\n\n     The value is a bind spec — {:source :tot-relations :args {…}} — whose\n     answer is a vector of maps. The node keeps ONE child in the graph, the\n     template, and the renderer draws it once per row, in the source's order.\n     Inside a copy `$row` IS the row, and [:of $row name] reads one of its\n     fields — in a :label, in a :with, anywhere in the template. The reference\n     is collapsed when the copy is made, so a gesture later fills a template\n     that already names its row.\n\n     WHY IT EXISTS. `one chip per declared relation` (D6) cannot be written\n     with a fixed list of chips: a relation a person declares from the thought\n     tree must be a chip on the next draw. :per-tile solved the same shape for\n     tiles — one template, a count that is data — and this is its sibling for\n     any source. A :list draws rows as text; this draws rows as WIDGETS.\n\n     THE TUI DRAWS EVERY ROW TOO. ui.bind/resolve-bindings expands the copies\n     server-side the same way, so the two renderers agree on how many children\n     the node has (the binding runtime is duplicated, CLAUDE.md).\n\n     A bind INSIDE the template may not depend on $row in its :args tonight:\n     the subscribe walk runs before the rows are known.",
     :shape [:map [:source :keyword] [:args {:optional true} :map]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-graph-ui-v0-003-01-widget-tree"]}},
    :flex
    {:description
     "How this child sizes itself inside a flex/grid parent — ADR-graph-ui-v0-013-01\n     Sec4: :layout-self's four-key map collapses to Mantine's own `flex` CSS\n     shorthand, one value. :layout-self {:grow 1 :basis :zero} becomes :flex 1.\n     :shrink/:basis/:align-self are DROPPED, not renamed (Sec4) — a child\n     needing its own cross-axis alignment is deferred until a concrete island\n     needs it (ADR-graph-ui-v0-013 Deferred). Web renderer only — the TUI ignores it\n     (documented no-op, ADR-graph-ui-v0-007-01). Distinct from the :flex WIDGET\n     KIND below (Mantine's Flex container) — this is the self-sizing PROP\n     every node may carry, mirroring Mantine's own dual use of `flex` as both\n     a Mantine component name and a Box style prop.",
     :shape [:enum 0 1 2 3]},
    :narrow
    {:description
     "What this node does when the window is narrower than --viewport-narrow.\n\n     :keep    no change — the default, and the whole vocabulary for a node that\n              fits a phone already.\n     :hide    the node is ABSENT below the breakpoint. For desktop-only chrome\n              whose content is reachable another way — the conversations roster\n              is a seven-column table beside a picker that lists the same\n              conversations, so the phone keeps the picker.\n     :scroll  the node scrolls sideways INSIDE its own box below the\n              breakpoint, so the PAGE does not. For a wide table whose columns\n              are the point.\n     :fold    a two-pane split hands the width to its filling pane and starts\n              its resizable pane folded, one tap from open. :split-pane only.\n     :stack   a two-pane split becomes one vertical column, the resizable pane\n              first. :split-pane only.\n\n     :hide is a real loss of content and is why this slot is not a boolean. A\n     description states which answer it takes, and a reader of the description\n     can see which one it chose.\n\n     TWO VALUES ARE HONOURED BY ONE KIND, which is this manifest's standing\n     contract rather than a wart: :backdrop says the same of the six kinds that\n     draw a box, and :flex says it of the TUI. A slot is a statement a node\n     makes about its place, and a split is the only node whose narrow answer is\n     about its own two panes. Spelling those two as a SECOND key would put\n     :narrow in the schema twice, which malli refuses outright\n     (:malli.core/duplicate-keys — the collision that named :font-size).\n\n     Honoured by the web renderer. The TUI ignores it, which is the contract\n     :flex and :backdrop already set (ADR-graph-ui-v0-007-01) — a terminal has\n     one width and no phone.",
     :shape [:enum :keep :hide :scroll :fold :stack]},
    :from
    {:description
     "WHERE THIS NODE IS AUTHORED-IN — the stamp ui.blocks/expand puts on every\n     node it makes (ADR-graph-ui-v0-015-01 Sec4). :file is the block file.\n     :part is the named part inside that file. :repeated names the collection a\n     repeater drew this node for.\n\n     EXPANSION IS THE ONLY MOMENT ANYTHING KNOWS. A tree now comes from a page\n     and its block files. Structural position therefore does not say which file\n     a node belongs to. A change made in the graph or on a Penpot board cannot\n     be written back without this slot. The web x-ray overlay reads it\n     (graph-ui.web.xray). It draws the block boundaries over the island.\n\n     IT WAS UNDECLARED FOR THE WHOLE OF v2.0. The cost was measured on\n     2026-09-15. All 17 compositions were seeded on a memory bus. Eight islands\n     materialised to a tree that ui.interpret/problems refused: gi, reader-v2,\n     reader-v3, studio, tot, research, alatus-book and alatus-reader. :from was\n     the only offending key in all eight. Only gi had a test on it\n     (T-frames-006). So one platform gap read as one unfinished island. The test\n     message sent every reader to gi's UI. George, 2026-09-15: declare it in the\n     Meta-UI.\n\n     v2.0 IS RELEASED AND KEEPS ITS OWN VOCABULARY. The four islands that\n     pinned v2.0 and expand from blocks now pin this version instead.",
     :shape
     [:map
      [:file :string]
      [:part {:optional true} :symbol]
      [:repeated {:optional true} :symbol]]},
    :backdrop
    {:description
     "The declared surface token this node paints as its background — one of the\n     :surfaces group in dsl/instances/themes.edn. `:surface body` becomes\n     `background: var(--body)`, which is the whole translation.\n\n     COLOUR ONLY, and no stroke, radius or padding with it. Those are a CELL's\n     treatment (dsl/design/*.edn, ui/widgets cell-style) and a cell is drawn by a\n     component that owns its own grid. A node in a widget tree has no such owner,\n     so it gets the one property that needs none.\n\n     Honoured on the kinds that draw a box — :box :stack :group :container\n     :scroll-area :markdown. A documented no-op elsewhere, which is the contract\n     :flex and the typography slots above already set. The TUI ignores it, the\n     same way it ignores every surface token (ADR-graph-ui-v0-007-01).\n\n     :border and :border-2 are absent from the range on purpose. They are in the\n     :surfaces group because they are painted colours, and neither is a surface\n     anything sits on.",
     :shape
     [:enum :ground :panel :raised :card :field :body :gutter :hover]},
    :per-tile
    {:description
     "DRAW MY ONE CHILD ONCE PER TILE, each copy scoped to that tile's session\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01).\n\n     true or absent. The node keeps ONE child in the graph — the template — and\n     the renderer draws it once for each open tile of the island, in order. Copy\n     n resolves as if it carried `:session-of n`.\n\n     WHY THE FRAMES HOLD ONE COPY AND NOT SIX. A frame is identified by its\n     :import-id, and frames-lib.store upserts by it — so six copies of a pane\n     would collapse into one frame and the tree would be wrong. Six copies would\n     also quadruple the description of every island that draws a pane, for a\n     feature most of them never use.\n\n     WHY THE COUNT IS NOT HERE. George, 2026-08-22: \"the 6 tiles is not hard UI\n     - it is fluid config from 1, 2, 4 or 6 tiles in the grid\". The count is\n     data — the island's own tiles — so the declaration says \"per tile\" and\n     never says how many. :tile-columns says how they are laid out.\n\n     THE CONTENT IS THE SAME AS ANYWHERE ELSE, and that is the point. George:\n     \"a conversation has same content in the tile and in the reading pane of the\n     reader-v2 or if floating free in the infinite canvas.\" The template is the\n     same part the single pane draws, so there is one declaration of what a\n     conversation looks like and no copy to drift.\n\n     THE TUI DRAWS ONE COPY, the focused tile. A terminal has one pane\n     (ADR-ikc-v3-048-01 TUI-lag), and this is declared rather than discovered.",
     :shape :boolean,
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}},
    :session-of
    {:description
     "THIS SUBTREE ANSWERS FOR ANOTHER SESSION — the nth TILE of this pane\n     (ADR-graph-ui-v0-023-01, PLAN-ikc-v3-017-01 phase 2).\n\n     An integer, counting from 0. The whole subtree resolves with `$session-id`\n     bound to that tile's session, so every bind inside it reads the tile's own\n     answer.\n\n     WHY IT EXISTS. George, 2026-08-21: \"Conversation pane can be reworked so\n     2, 4 or 6 conversations can be observed and participated at once, displayed\n     as tiles.\" Six tiles bind about 40 sources each. Without this slot, each\n     tile would need its own copy of every source: 240 declarations, and a sixth\n     copy of every source added later. With it, `:page-title` stays one source\n     and answers for the session it is asked about, which it always did.\n\n     A NODE WHOSE INDEX NAMES NO TILE IS NOT DRAWN, and it reads nothing. A grid\n     of six cells over a pane of two tiles shows two. The alternative is worse\n     than an empty cell: a cell that fell back to the TAB's session would show\n     the wrong item and say nothing.\n\n     TWO KINDS OF VALUE. An INTEGER names a position. The keyword `:focused`\n     names whichever tile has the focus, and the reading pane uses it: the pane\n     draws ONE column, and that column follows the focus.\n\n     WHY THE PANE DOES NOT YET DRAW SIX COLUMNS, said here because a reader will\n     ask. Every node in the column carries an `:import-id`, and a frame is\n     identified by it. Six copies would be six nodes with one identity, so\n     per-tile identity is its own step and phase 3 does it.\n\n     WHICH SESSION EACH INDEX HOLDS COMES FROM THE :tile-sessions SOURCE, not\n     from the description. The description is seeded once and the tiles change\n     while a person works, so a position is the only thing a description can\n     name. Both binding runtimes read that source and carry it in their\n     substitutions under `$tile-sessions`.",
     :shape [:or :int [:enum :focused]],
     :gaks-refs
     {:decision
      ["ADR-graph-ui-v0-023-01-a-tile-is-a-view-of-a-session"],
      :concept ["CONCEPT-ikc-v3-007-01-detachable-presentation"]}}},
   :rules
   {:prompt-area
    {:description
     "A rich multi-line prompt input for chat/agent use. The renderer owns\n     the edit buffer, seeded from :value (bindable). It dispatches\n     :on-gesture's :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing\n     v1.x's :on-submit) with $value = the buffer.\n\n     ENTER SENDS. Shift+Enter inserts a newline, and Ctrl/Cmd+Enter still\n     sends. Until 2026-08-20 the ONLY way to send was Ctrl/Cmd+Enter, which\n     George reported as a box that does not send (\"The input field does not\n     send on Enter and there is no submit button\"). Two reasons Enter wins.\n     A prompt box is a chat box, and every chat box in the world sends on\n     Enter. And a phone keyboard has no Ctrl key at all, so the phone\n     surface of phase 6 had no way to send anything.\n\n     :rows sets the\n     initial height; :auto-grow expands as the user types; :markdown\n     toggles a live preview of inline **bold**, *italic*, and `code`.\n     :triggers is an optional vector of trigger characters (e.g. [\"@\" \"/\"\n     \"#\"]) carried as data for future chip support. Web renderer only —\n     the TUI renders the buffer as plain read-only text.\n\n     A PASTED IMAGE GOES WITH THE PROMPT (PLAN-ikc-v3-017-01 phase 11).\n     George, 2026-08-21: \"I often paste an image in the terminal — is it\n     supported in a tile?\" A paste that carries an image file dispatches\n     the :paste gesture, whose $value is the whole `data:` URL, and the image\n     never enters the buffer: the bytes are written once into the :attachments\n     vault, and the prompt carries the path. THE GESTURE AND NOT A DIRECT\n     DISPATCH, because a tile bakes its own session into every gesture it holds\n     (ADR-graph-ui-v0-023-01) — a paste that dispatched by itself attached the\n     image to the TAB'S session, and the tile showed nothing. A paste of TEXT is untouched, because the default is stopped only\n     when an image was found. NO PROP DECLARES THIS. A paste is what this\n     widget is for, in the same way that Enter sends.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:auto-grow {:optional true} :boolean]
      [:markdown {:optional true} :boolean]
      [:triggers {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :aspect-ratio
    {:description
     "Mantine `AspectRatio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "AspectRatio"},
     :props
     [:map
      [:ratio
       {:optional true,
        :doc
        "Aspect ratio, for example, `16 / 9`, `4 / 3`, `1920 / 1080`"}
       [:or :int :double]]],
     :defaults {:ratio 1},
     :children :any,
     :box-from :props,
     :box-to-children :definite},
    :fieldset
    {:description
     "Mantine `Fieldset` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Fieldset"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {},
     :slots [:legend],
     :children :slots,
     :box-from :content},
    :text-area
    {:description
     "A multi-line editable text area. The renderer keeps the edit buffer\n     and, on Ctrl/Cmd+Enter or its Save button, dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the buffer — the editor half of the Foam markdown Edit\n     view (ADR-ikc-v3-052-01). :value seeds the buffer (bindable). :rows is\n     the initial visible height. In the TUI it renders as plain read-only\n     text. :draft-key: a client draft channel to publish the live buffer to\n     on every (debounced) change, so a live-preview widget (:island-view)\n     can render what is being typed BEFORE it is submitted. :format: :edn\n     (default) shows the buffer as-is; :indent converts the bound EDN value\n     to a bracket-stripped indentation format for display.\n\n     :font-size is NOT declared here under v2.0 — it is the UNIVERSAL SLOT\n     (ADR-graph-ui-v0-013-01 Sec19). v1.x declared it as this kind's own prop, which\n     was always a mislabelling: scaling the editor's code font is typography,\n     not a property of text areas specifically. Declaring both would be the\n     same key twice, which malli rejects outright (:malli.core/duplicate-keys)\n     — the check that found this. v1.x keeps its own :font-size forever.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:rows {:optional true} :int]
      [:draft-key {:optional true} :keyword]
      [:format {:optional true} [:enum :edn :indent]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :markdown
    {:description
     "A rendered markdown block — the widget for assistant messages that\n                 contain formatted text. :value is the markdown source. In the TUI it\n                 renders as plain text (no styled rendering); a web renderer renders\n                 it as HTML. A bound :markdown gets its :value from a data source.\n\n                 SINCE 2026-08-14 IT CAN ALSO BE MARKED (F-platform-v0-011-01):\n                 :highlights is this page's highlights, and the marked text is\n                 washed in each one's colour. Selecting text offers four colour\n                 swatches and fires the :highlight gesture, whose $value is the\n                 whole selection map — the text, an advisory position, and the\n                 chosen colour — because a gesture carries one value and both\n                 capture modes must converge before the command\n                 (ADR-graph-ui-v0-017-01 §1-2).\n\n                 :value and :highlights are TWO bindings on one widget, which the\n                 per-prop :bind form has expressed since 2026-07-19; no new binding\n                 mechanism was needed for it.\n\n                 SINCE 2026-08-20 THE SELECTION CAN ALSO BOOKMARK\n                 (PLAN-ikc-v3-015-01 phase 3): the same popover offers a\n                 bookmark control beside the swatches, firing the :bookmark\n                 gesture with the same selection map, colour omitted. A\n                 description wires it only where the body is a conversation —\n                 the gesture resolves the selection to an entry id, and only a\n                 conversation has entries.\n\n                 SINCE v2.1-SNAPSHOT THE SELECTION CAN ALSO BECOME EVIDENCE\n                 (PLAN-ikc-v3-026-01 Phase D, RESEARCH-ikc-v3-021-01 R-AC-7):\n                 two controls beside the swatches fire :to-thought and\n                 :against-thought with the same selection map, colour omitted;\n                 the command adds the highlight and links it to the session's\n                 selected thought as :supports or :contradicts. A description\n                 wires them where a thought can be selected — the reader's own\n                 reading area carries them, so reader-v3 and the research island\n                 both can.\n\n                 A HIGHLIGHT'S :level IS DRAWN AS ITS LAYER (D5): layer 1 is the\n                 wash alone, 2 bold, 3 bold and underlined, 4 a double line, 5\n                 italic too — one class per layer (ikc-hl-layer-2 … 5 in\n                 ikc-base.css), riding on the colour the reader chose, so a\n                 layer-3 span inside a layer-2 span is bold and washed twice.\n\n                 A highlight map may carry :entry-id — the conversation storage\n                 form (ADR-ikc-v3-076-01 §3). The paint path is unchanged:\n                 offsets into the rendered source decide where a wash is drawn,\n                 whichever form stored it.\n\n                 AND ITS [[wikilinks]] CAN NAVIGATE (2026-08-18): :links is\n                 [{:target :page-id}] — every wikilink target in this body, each\n                 resolved on the SERVER by :page-content-links, bound with\n                 :link-bind rather than :bind because it is a second, independent\n                 binding beside :value.\n\n                 A target that names no page is still DRAWN, as a muted chip that\n                 does nothing. An unresolved wikilink is an invitation to create\n                 that page, not an error.\n\n                 A LEADING FRONTMATTER BLOCK IS METADATA, NOT BODY (2026-09-08,\n                 George: it showed in the Reading pane's preview as text). It is\n                 drawn folded, one line with the title and the source, the rows\n                 behind a click. The highlights' offsets are into the file, so\n                 the renderer moves them past the block; nothing stored changes.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:links
       {:optional true}
       [:vector [:map [:target :string] [:page-id [:maybe :string]]]]]
      [:highlights
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:block-id {:optional true} :string]
         [:entry-id {:optional true} :string]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:refused-tags {:optional true} [:vector :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :input-base
    {:description
     "Mantine `InputBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "InputBase"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:multiline
       {:optional true,
        :doc
        "If set, the input can have multiple lines, for example when `component=\"textarea\"`"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-aria
       {:optional true,
        :doc
        "If set, `aria-` and other accessibility attributes are added to the input"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :with-aria true,
      :right-section-pointer-events "none",
      :multiline false,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :loader
    {:description
     "Mantine `Loader` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped
     {"loaders"
      "Partial<Record<(string & {}) | \"bars\" | \"dots\" | \"oval\", MantineLoaderComponent>>"},
     :defaults {:size :md, :type :oval},
     :box-to-children :block-flow,
     :mantine {:component "Loader"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the loader. `Loader` has predefined `xs`-`xl` values. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Loader type, key of `loaders` prop"}
       [:or [:enum :bars :dots :oval] :string]]]},
    :unstyled-button
    {:description
     "Mantine `UnstyledButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "UnstyledButton"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :loading-overlay
    {:description
     "Mantine `LoadingOverlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "LoadingOverlay"},
     :props
     [:map
      [:visible
       {:optional true,
        :doc "Determines whether the overlay should be visible"}
       :boolean]
      [:z-index
       {:optional true, :doc "Controls overlay `z-index`"}
       [:or :string :int :double]]],
     :defaults {:visible false, :z-index 400},
     :children :none,
     :box-from :parent,
     :needs :both},
    :space
    {:description
     "Mantine `Space` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Space"},
     :props [:map],
     :defaults {},
     :children :none,
     :box-from :props},
    :island-view
    {:description
     "A live, READ-ONLY render of ANOTHER island embedded inside this one —\n     the Studio preview pane. Renders the island the current session has\n     selected / is composing: its saved tree by default, or the description\n     currently in the editor buffer AS YOU TYPE (WYSIWYG), whichever the\n     client draft holds, with the saved tree as the fallback. The preview\n     attaches NOTHING — it reads via :ui/preview-context, so it can never\n     steal or leak the lock the composer holds. Carries a self-embed guard.\n     Web-only; the TUI renders a labelled placeholder.",
     :status :in-progress,
     :props
     [:map
      [:draft-source {:optional true} :keyword]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none,
     :box-from :parent,
     :needs :both},
    :tree
    {:description
     "A nested outline; each item is now a MAP with optional recursive\n     :children (ADR-graph-ui-v0-013-01 Sec17): {:label string :children [item ...]\n     :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean}. :items is optional: a\n     bound :tree gets its outline from a source. The recursive sibling of\n     :list. Recognises TWO :on-gesture keys (ADR-graph-ui-v0-013 Sec7-8): :submit\n     (click-to-navigate — the web renderer wires clicking any node to it) and\n     :fork (the explicit fork action, typically the 'f' key; declared but not\n     yet wired in the web renderer, same as v1.x's :on-fork always was).\n     $value substitutes the clicked/forked item's :entry-id either way.\n\n     SIX MORE GESTURES SINCE v2.1-SNAPSHOT (PLAN-ikc-v3-026-01 Q2, RESEARCH-\n     ikc-v3-021-01 D8 — Leo's tree pane): :insert (Enter), :indent (Tab),\n     :outdent (Shift-Tab), :move (Alt-Up, Alt-Down, Alt-Home, Alt-End — $value\n     carries :direction :up :down :first :last), :set-kind (one letter, q h b f\n     o d — $value carries :kind), :delegate (the letter a). Each fires only\n     when the description declares it AND a row is selected by :active-value.\n     For these six $value is the SELECTED ITEM'S WHOLE MAP plus what the key\n     added, so a template reads a field with [:of $value parent-id] — a source\n     that draws a thought tree puts :thought-id, :parent-id, :frame-id,\n     :previous-sibling and :grandparent on each item for exactly that. An item\n     may also carry :kind, :confidence, :clone? and :edge-count; the source\n     bakes the kind's icon into :icon and the count into :accessory, so the\n     row renderer is unchanged.\n     :direction: :column (default) stacks items vertically as an indented\n     outline; :row lays a FLAT item list out horizontally as a strip of\n     clickable buttons (the daily-note nav bar) and ignores nesting. :value\n     (ADR-graph-ui-v0-013-01 Sec24): the clicked node's own click target — see\n     :list's :value note for why it was missing.\n\n     A CLICKED ROW ACKNOWLEDGES ITSELF, and it is not a prop. Added 2026-08-17,\n     because a click on a page row costs a dispatch plus one :ui/read for every\n     source the server says changed — measured at 337ms for a single frame read\n     against the live graph, so a click is a wait, and the row used to give back\n     nothing at all while it ran. The row now shows a turning ring at its trailing\n     edge from the moment of the click until this session stops waiting on the bus.\n     The ring is OUT OF FLOW — absolute at the row's right edge, so appearing costs\n     no layout and a row with an accessory does not have its count or its reference\n     text shoved left mid-click. In :direction :row the strip uses the Button's own\n     loading state for the same reason, which also disables the control so a second\n     click cannot queue a second dispatch behind the first.\n     Deliberately NOT declared as a prop: an island cannot ask for it, cannot turn\n     it off, and cannot bind it. It is not data about the outline — it is the state\n     of the client that is drawing the outline, and the value it reports is one no\n     bus source could serve, since reading a source is the very round trip being\n     waited on. It lives in graph-ui.web.busy, the reagent-atom pattern\n     graph-ui.web.activity and graph-ui.web.draft already use, and the TUI simply\n     has nothing to draw here. The matching WINDOW-level signal — a sweeping line\n     on the chrome bar once a wait passes 400ms — is in graph-ui.web.core for the\n     same reason a viewport-spanning bar is not an island widget: it is a fact\n     about the frame, not about anything on the canvas.",
     :status :in-progress,
     :props
     [:map
      [:row {:optional true} [:enum :line :card]]
      [:active-value {:optional true} [:maybe :string]]
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:children {:optional true} [:vector :any]]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]
         [:has-children {:optional true} :boolean]]]]
      [:children-query
       {:optional true}
       [:map
        [:source :keyword]
        [:args {:optional true} :map]
        [:branch-arg {:optional true} :keyword]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:direction {:optional true} [:enum :column :row]]
      [:wrap {:optional true} :boolean]
      [:empty-label {:optional true} :string]
      [:open-mode {:optional true} [:enum :instant :enter]]
      [:look {:optional true} [:enum :plain :boxed]]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]]]]],
     :defaults {:open-mode :enter, :look :plain},
     :children :none,
     :box-from :content},
    :group
    {:description
     "Horizontal row — Mantine `Group` (ADR-graph-ui-v0-013-01 Sec0). :wrap is\n     boolean here (true -> CSS `wrap`, false -> `nowrap`), the same\n     convention v1.x's :box :wrap already used. :grow gives every child\n     `flex-grow: 1`.",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:wrap {:optional true} :boolean]
      [:grow {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-row},
    :table
    {:description
     "A read-only tabular grid (native <table> in the web renderer). :columns\n     declares the header — a vector of {:label <string> :key\n     <keyword|string>} maps; each row's cell for a column is looked up by\n     that column's :key. :rows is the data — a vector of maps, bindable via\n     :bind. :tone/:density tune the visual weight. In the TUI it renders as\n     plain text rows.\n\n     ONE GESTURE SINCE 2026-09-09, :submit (PLAN-ikc-v3-029-01 Q4). A row is\n     clickable only when the description wires it, and $value is the ROW'S OWN\n     MAP — the :tree's six gestures hand the selected item the same way, so a\n     template reads a field with [:of $value measurement-id]. Absent, nothing\n     fires and every existing table is unchanged, display-only as before.\n\n     ADDED TO THIS SNAPSHOT ONLY. v1.0, v1.2 and v2.0 carry an identical\n     :props block and an almost identical description; two of those versions\n     are RELEASED and their rules are frozen, so the edit is made by position\n     and not by a text replace over the file (the lesson :tree's :row prop\n     left here on 2026-08-15).\n\n     WHY A GESTURE AND NOT A RELEASE. The plan's stop condition asks the\n     question and answers it: a :table kind already exists, and a table that\n     cannot open a row is a table missing an affordance, not a vocabulary\n     missing a kind. So the snapshot gains the gesture.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} [:vector :any]]
      [:rows {:optional true} [:vector :any]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :file-input
    {:description
     "Mantine `FileInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 23 prop(s), 6 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"component" "any",
      "defaultValue" "Multiple extends true ? File[] : File",
      "multiple" "Multiple",
      "value" "Multiple extends true ? File[] : File"},
     :slots
     [:description
      :error
      :label
      :left-section
      :placeholder
      :right-section],
     :defaults
     {:clearable false,
      :left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "FileInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:name {:optional true, :doc "Input name attribute"} :string]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set, the input value cannot be changed"}
       :boolean]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :affix
    {:description
     "Mantine `Affix` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"position" "AffixPosition"},
     :defaults {:within-portal true, :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Affix"},
     :status :generated,
     :box-from :viewport,
     :props
     [:map
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]]},
    :portal
    {:description
     "Mantine `Portal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s), 1 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped {"target" "string | HTMLElement"},
     :defaults {:reuse-target-node true},
     :box-to-children :block-flow,
     :mantine {:component "Portal"},
     :status :generated,
     :box-from :viewport,
     :props
     [:map
      [:reuse-target-node
       {:optional true,
        :doc "If set, all portals are rendered in the same DOM node"}
       :boolean]]},
    :tags-input
    {:description
     "A TAG EDITOR: the tags of the thing being read, each one removable, with a\n     field that completes from the vocabulary the graph already holds.\n\n     HAND-WRITTEN SINCE 2026-09-15, and the generated header it replaced says\n     exactly why it had to graduate: a generated kind has 'no data binding, no\n     edit buffer and no selection state of its own'. This kind needs all three.\n     :value is BOUND to the tags of the selected page and :suggestions to the tag\n     vocabulary, the field keeps a buffer while a person types, and the dropdown\n     keeps which row is active. graph-ui.web.widgets/widget-tags-input and an\n     explicit case in render.cljs are what those three cost.\n\n     THIRTY-THREE PROPS BECAME FIVE, and the ones that went were the library's,\n     not the product's. Mantine's TagsInput exposes its whole controlled-combobox\n     surface — :dropdown-opened, :search-value, :select-first-option-on-change\n     and twenty-five more. A description that set any of them would be reaching\n     past the contract into the component. What is declared here is the CONTRACT:\n     two bound props, one label, one posture, one size.\n\n     FOUR WAYS TO ADD AND THREE TO REMOVE, and each is the outliner idiom rather\n     than a choice made here. Enter, a comma and a loss of focus each add what is\n     typed. The cross on a tag removes it, and Backspace in an empty field\n     removes the last one.\n\n     THE SUGGESTIONS ARRIVE AS AN ORDINARY BIND, and the client narrows them per\n     keystroke. George decided that on 2026-08-20. The vocabulary is about 300\n     strings on this corpus, so one read beats a protocol that speaks on every\n     key.\n\n     A GESTURE CARRIES ONE TAG IN $value, never the whole list. The two commands\n     that write a :tags slot take one tag each (ADR-ikc-v3-080-01 decision 7), and\n     a widget that emitted the vector would make the handler compute a difference\n     to find out what a person did.\n\n     WHAT IT CANNOT DO, AND THE HELP PAGE SAYS SO. The editor writes the :tags\n     SLOT. An inline #hashtag lives in the text, and the file is the truth\n     (ADR-ikc-v3-052-01), so a cross on such a tag would promise a removal this\n     cannot perform. :tags/tags-of-frame reports which storage each tag came\n     from, and only a slot tag is offered a cross.\n\n     TUI POSTURE: READ-ONLY. ui.render.tui draws the tags as joined text and\n     dispatches nothing. A terminal has no dropdown, and a line of words is what\n     a reader of that surface needs.",
     :status :in-progress,
     :props
     [:map
      [:value
       {:optional true,
        :doc
        "The tags on the thing being read. BOUND, normally to\n                        :page-tag-list."}
       [:vector :string]]
      [:suggestions
       {:optional true,
        :doc
        "The known tag vocabulary, for completion. BOUND,\n                              normally to :tag-vocabulary. The client filters\n                              it."}
       [:vector :string]]
      [:placeholder
       {:optional true,
        :doc
        "What the empty field says. An empty tag editor is\n                              indistinguishable from a broken one without it."}
       :string]
      [:read-only
       {:optional true,
        :doc
        "Draw the tags and accept nothing. The TUI's posture,\n                            and a reading surface that must not be edited."}
       :boolean]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:size :sm},
     :gestures [:add :remove],
     :children :none,
     :box-from :content},
    :radio
    {:description
     "Mantine `Radio` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"icon" "FC<RadioIconProps>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label],
     :defaults {:label-position :right, :radius :xl, :size :sm},
     :mantine {:component "Radio"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color, by default value depends on `theme.autoContrast`"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :transition
    {:description
     "Mantine `Transition` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :defaults {:duration 250, :exit-duration 250},
     :box-to-children :block-flow,
     :mantine {:component "Transition", :children :function},
     :status :generated,
     :box-from :content,
     :gestures [:enter :entered :exit :exited],
     :props
     [:map
      [:duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]
      [:enter-delay
       {:optional true,
        :doc "Delay in ms before enter transition starts"}
       [:or :int :double]]
      [:exit-delay
       {:optional true,
        :doc "Delay in ms before exit transition starts"}
       [:or :int :double]]
      [:exit-duration
       {:optional true, :doc "Exit transition duration in ms"}
       [:or :int :double]]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the element is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:mounted
       {:optional true,
        :doc
        "Determines whether component should be mounted to the DOM"}
       :boolean]
      [:timing-function
       {:optional true, :doc "Transition timing function"}
       :string]
      [:transition
       {:optional true, :doc "Transition name or object"}
       [:or
        [:enum
         :scale
         :fade
         :fade-down
         :fade-up
         :fade-left
         :fade-right
         :skew-up
         :skew-down
         :rotate-right
         :rotate-left
         :slide-down
         :slide-up
         :slide-right
         :slide-left
         :scale-y
         :scale-x
         :pop
         :pop-top-left
         :pop-top-right
         :pop-bottom-left
         :pop-bottom-right]
        :string]]]},
    :button
    {:description
     "ADR-graph-ui-v0-007-01: a standalone clickable button, built on\n     @radix-ui/react-slot. :label is the button's text; :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit) is\n     dispatched on click — $session-id substitutes as usual, $value is not\n     meaningful for a plain button unless a specific template hardcodes\n     one. :disabled blocks the click. TUI renders the label as plain text,\n     read-only.\n\n     :density is the SAME noun :box, :stack and :group carry, and it means the\n     same thing. It says how much room the kind takes around its content.\n     :compact gives the button Mantine compact padding, which is 8 px on each\n     side against 18 px. A row of buttons in a narrow column needs it. ikc1\n     gives its own sidebar row 8 px (AthensSidebar.tsx line 793).",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:disabled {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :spoiler
    {:description
     "Mantine `Spoiler` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"controlRef" "ForwardedRef<HTMLButtonElement>"},
     :slots [:hide-label :show-label],
     :defaults {:max-height 100, :transition-duration 200},
     :box-to-children :block-flow,
     :mantine {:component "Spoiler"},
     :status :generated,
     :box-from :content,
     :gestures [:expanded-change],
     :props
     [:map
      [:expanded
       {:optional true, :doc "Controlled expanded state value"}
       :boolean]
      [:initial-state
       {:optional true,
        :doc
        "Initial spoiler state, `true` to wrap content in spoiler, `false` to show content without spoiler, opened state is updated on mount"}
       :boolean]
      [:max-height
       {:optional true,
        :doc
        "Maximum height of the visible content, when this point is reached spoiler appears"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Spoiler reveal transition duration in ms, set 0 or null to turn off animation"}
       [:or :int :double]]]},
    :notification
    {:description
     "Mantine `Notification` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 3 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :slots [:icon :title],
     :defaults {:with-close-button true},
     :box-to-children :block-flow,
     :mantine {:component "Notification"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Controls notification line or icon color, key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:loading
       {:optional true,
        :doc
        "If set, the `Loader` component is displayed instead of the icon"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is visible"}
       :boolean]]},
    :highlight
    {:description
     "Mantine `Highlight` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Highlight"},
     :props
     [:map
      [:children
       {:optional true,
        :doc "String parts of which must be highlighted"}
       :string]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:highlight
       {:optional true,
        :doc
        "Substring or a list of substrings to highlight in `children`"}
       [:vector :any]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:span
       {:optional true, :doc "Shorthand for `component=\"span\"`"}
       :boolean]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]],
     :defaults
     {:highlight [], :inherit false, :inline false, :size :md},
     :unmapped {"color" "string | (string & {})"},
     :children :none,
     :box-from :content},
    :mark
    {:description
     "Mantine `Mark` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Mark"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :checkbox
    {:description
     "Mantine `Checkbox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 3 named\n     child slot(s), and 2 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"icon" "FC<{ indeterminate: boolean; className: string; }>",
      "rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label],
     :defaults {:label-position :right, :size :sm},
     :mantine {:component "Checkbox"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input background color in checked state"}
       [:or :keyword :string]]
      [:icon-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set icon color. By default, depends on `theme.autoContrast`."}
       [:or :keyword :string]]
      [:id {:optional true, :doc "Unique input id"} :string]
      [:indeterminate
       {:optional true,
        :doc
        "Indeterminate state of the checkbox. If set, `checked` prop is ignored."}
       :boolean]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of the component"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :tab-set
    {:description
     "A tabbed container: one child visible at a time. Each child should\n                 be a :box with a :title (used as the tab label). :active (default 0)\n                 is the index of the visible tab. The renderer draws a tab header line\n                 and shows only the active child's content below it.\n\n                 THE WEB RENDERER DID NOT DO THAT UNTIL 2026-08-23, and this\n                 paragraph is why it now does. It mounted every panel, so a page\n                 click — which changes the bound value of all of them — rebuilt\n                 the lot: 798 DOM mutations for one click, 799 of 815 of them\n                 inside the Tabs component, measured on the running deployment.\n                 The TUI had drawn only the active child all along, so two\n                 renderers disagreed about one description and the words above\n                 were on the TUI's side (PLAN-ikc-v3-019-01 phase 4).\n\n                 ONE EXCEPTION, AND IT IS DERIVED RATHER THAN DECLARED. A child\n                 whose subtree holds a widget with an edit buffer — :input,\n                 :text-area, :outline — keeps its content drawn whichever tab is\n                 active. That buffer lives in the renderer, so unmounting it would\n                 throw away text a person typed and has not saved, with nothing\n                 saying so. The renderer reads it off the child's own subtree\n                 (graph-ui.web.widgets/holds-draft?), so no island declares it and\n                 none can forget it.\n\n                 DERIVED BECAUSE A DERIVED RULE CANNOT DRIFT, and for no other\n                 reason. An earlier draft of this paragraph also argued that a\n                 declared slot would be unavailable to an island pinned to a\n                 released vocabulary. George struck that on 2026-08-23: a version\n                 pin is not a reason to shape a design around it. If the right\n                 answer needs a slot, the slot is added and the island is moved.\n\n                 THE EXCEPTION IS A SYMPTOM AND IT HAS AN OWNER. An editor's\n                 unsaved text should not live in component state at all\n                 (PLAN-ikc-v3-018-01: drafts in browser storage, keyed by the\n                 thing being edited). When it does not, holds-draft? is deleted\n                 and a tab-set draws one child with no exception at all.",
     :status :in-progress,
     :props
     [:map
      [:active {:optional true} :int]
      [:chrome {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:active 0},
     :children :any,
     :box-from :content,
     :box-to-children :definite},
    :pill
    {:description
     "Mantine `Pill` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :defaults {:radius :xl, :size :sm, :with-remove-button false},
     :box-to-children :block-flow,
     :mantine {:component "Pill"},
     :status :generated,
     :box-from :content,
     :gestures [:remove],
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Adds disabled attribute, applies disabled styles"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls pill `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-remove-button
       {:optional true,
        :doc "Controls visibility of the remove button"}
       :boolean]]},
    :simple-grid
    {:description
     "Equal-width columns — Mantine `SimpleGrid` (ADR-graph-ui-v0-013-01 Sec0), the\n     common case :grid's :span bookkeeping would be overkill for.",
     :status :in-progress,
     :props
     [:map
      [:cols {:optional true} :int]
      [:spacing {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:vertical-spacing
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]],
     :defaults {:cols 1},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :grid
    {:description
     "Real 2D proportional layout — CSS GRID (ADR-graph-ui-v0-013-01 Sec3).\n     :columns is the TOTAL (12 by default); each :grid-col child states\n     its :span of that total — '50-50' is two :grid-col children at :span 6.\n     :gutter is the gap between cells (a separate name from :gap elsewhere\n     in this vocabulary, because Mantine's Grid named it that and every\n     declaration here says :gutter). Children SHOULD be :grid-col.\n\n     EVERY CELL HAS A DEFINITE HEIGHT, and every row an equal share of the\n     grid. That is the whole reason this kind is CSS grid and not Mantine's\n     `Grid`, which is a wrapping flexbox: a flexbox row is as tall as its\n     content, so a :scroll-area in a cell grew instead of scrolling, and a\n     second row did not share the height with the first (2026-08-23).\n\n     :grow AND :offset ARE GONE, with the :auto and :content spans. A\n     wrapping flexbox could do those three and a grid cannot. Nothing\n     declared them, so a description that names one is now refused at\n     \"disallowed key\" instead of the renderer dropping it without a word.\n     The gate is the description validator that every island's own test\n     runs, and NOT validate-dsl, which checks this manifest and not the\n     instances.",
     :status :in-progress,
     :props
     [:map
      [:columns {:optional true} :int]
      [:gutter {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:columns 12},
     :children :any,
     :box-from :content,
     :box-to-children :definite},
    :visually-hidden
    {:description
     "Mantine `VisuallyHidden` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "VisuallyHidden"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :floating-indicator
    {:description
     "Mantine `FloatingIndicator` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 4 prop(s),\n     and 2 prop(s) whose type carries no data contract (see :unmapped).\n     RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the component\n     named above straight from this declaration — the props here are the legal\n     ones, the gestures here are the wired ones, and nothing else reaches the\n     DOM. Generic is not finished: this kind has no data binding, no edit\n     buffer and no selection state of its own. A kind that needs one of those\n     graduates to a hand-written widget and an explicit case in render.cljs —\n     move it above the GENERATED marker and give it a description that explains\n     ITSELF.",
     :children :none,
     :needs :both,
     :unmapped {"parent" "HTMLElement", "target" "HTMLElement"},
     :defaults {:transition-duration 150},
     :mantine {:component "FloatingIndicator"},
     :status :generated,
     :box-from :parent,
     :props
     [:map
      [:display-after-transition-end
       {:optional true,
        :doc
        "If set, the indicator is displayed after transition ends. Should be set if the component is used inside a container that has `transform: scale(n)` styles."}
       :boolean]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :string :int :double]]]},
    :popover
    {:description
     "Mantine `Popover` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 29 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "Popover"},
     :status :generated,
     :box-from :viewport,
     :gestures
     [:change
      :close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :collapsible
    {:description
     "A container that can expand or collapse its children. :title labels\n     the toggle line; :collapsed (default false) controls initial state.\n     :count (ADR-graph-ui-v0-013-01 Sec17): an optional int shown beside the\n     title (the '12 pages' style header). :icon: an optional :icon name\n     leading the title. The expand/collapse chevron itself is not a prop —\n     every :collapsible has one, it is not a per-instance choice.\n\n     :hide-when-empty (F-platform-v0-014-01, 2026-08-18) — draw NOTHING, not an\n     empty heading, when every bound child inside is empty. Default false, which\n     is every existing section's behaviour.\n\n     WHY IT HAS TO BE A PROP. Emptiness is a RUNTIME fact, so it cannot be\n     settled where a section's existence is otherwise decided: ui.blocks drops a\n     collection that has no :source at EXPANSION time, which is a statement about\n     the declaration, not about today's data. A Pinned section has a source and is\n     usually empty, and ikc1 draws it only once something is pinned\n     (AthensSidebar.tsx: `{pinnedFrames.length > 0 && …}`).\n\n     AND WHY THIS DOES NOT CONTRADICT THE RIGHT GUTTER, which is drawn even when\n     empty on the stated rule that 'a column that comes and goes per row is not a\n     column' (dsl/design/block-row.edn). A sidebar section is not a column:\n     nothing aligns to it, and an empty one spends a heading plus its own vertical\n     space on every screen. Progressive disclosure applies\n     (CONCEPT-graph-ui-v0-008-01); column stability does not.\n\n     :on-gesture :toggle (2026-09-08, PLAN-ikc-v3-028-01 Q5): fires when the\n     chevron opens or closes the section, $value = {:import-id :open?}. The open\n     state stays the client's; the gesture is how a guide learns that a section\n     was looked at. Absent, nothing fires — every existing section is unchanged.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:collapsed {:optional true} :boolean]
      [:count {:optional true} :int]
      [:icon {:optional true} :keyword]
      [:hide-when-empty {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:collapsed false, :hide-when-empty false},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :ring-progress
    {:description
     "Mantine `RingProgress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "RingProgress"},
     :props
     [:map
      [:root-color
       {:optional true,
        :doc
        "Color of the root section, key of theme.colors or CSS color value"}
       [:or :keyword :string]]
      [:round-caps
       {:optional true,
        :doc
        "Sets whether the edges of the progress circle are rounded"}
       :boolean]
      [:sections {:optional true, :doc "Ring sections"} [:vector :any]]
      [:size
       {:optional true, :doc "Width and height of the progress ring"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Ring thickness"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]],
     :defaults
     {:sections [], :size 120, :thickness 12, :transition-duration 0},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :segmented-control
    {:description
     "Mantine `SegmentedControl` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 1\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "SegmentedControl"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, changes color of indicator, by default color is based on current color scheme"}
       [:or :keyword :string]]
      [:data
       {:optional true,
        :doc "Data based on which controls are rendered"}
       [:vector :any]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Determines whether the component is disabled"}
       :boolean]
      [:full-width
       {:optional true,
        :doc
        "Determines whether the component should take 100% width of its parent"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "Name of the radio group, by default random name is generated"}
       :string]
      [:orientation
       {:optional true, :doc "Component orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "If set to `false`, prevents changing the value"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls `font-size`, `padding` and `height` properties"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc
        "Indicator `transition-duration` in ms, set `0` to turn off transitions"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "Indicator `transition-timing-function` property"}
       :string]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-items-borders
       {:optional true,
        :doc
        "Determines whether there should be borders between items"}
       :boolean]],
     :defaults
     {:data [],
      :full-width false,
      :orientation :horizontal,
      :size :sm,
      :transition-duration 200,
      :with-items-borders true},
     :gestures [:change],
     :children :none,
     :box-from :content},
    :number-formatter
    {:description
     "Mantine `NumberFormatter` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "NumberFormatter"},
     :props
     [:map
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that are displayed after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true,
        :doc "Character used as a decimal separator, `'.'` by default"}
       :string]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, zeros are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:prefix
       {:optional true, :doc "Prefix added before the value"}
       :string]
      [:suffix
       {:optional true, :doc "Suffix added after the value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style"}
       [:enum :none :thousand :lakh :wan]]
      [:value
       {:optional true, :doc "Value to format"}
       [:or :string :int :double]]],
     :defaults
     {:allow-negative true,
      :fixed-decimal-scale false,
      :thousand-separator ","},
     :children :none,
     :box-from :content},
    :multi-select
    {:description
     "Mantine `MultiSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 6 named\n     child slot(s), 7 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData", "filter" "OptionsFilter"},
     :slots
     [:description
      :error
      :label
      :left-section
      :nothing-found-message
      :right-section],
     :defaults
     {:check-icon-position :left,
      :left-section-pointer-events "none",
      :hidden-input-values-divider ",",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :searchable false,
      :pointer false,
      :open-on-focus true,
      :with-check-icon true,
      :with-asterisk false,
      :with-aligned-labels false,
      :with-error-styles true,
      :required false,
      :hide-picked-options false},
     :mantine {:component "MultiSelect"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change
      :clear
      :dropdown-close
      :dropdown-open
      :option-submit
      :remove
      :search-change],
     :props
     [:map
      [:check-icon-position
       {:optional true,
        :doc "Position of the check icon relative to the option label"}
       [:enum :left :right]]
      [:chevron-color
       {:optional true, :doc "Controls color of the default chevron"}
       [:or :keyword :string]]
      [:clear-search-on-change
       {:optional true,
        :doc "Clear search value when item is selected"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed in the right section when the component has value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-search-value
       {:optional true, :doc "Default search value"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:vector :string]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:hidden-input-values-divider
       {:optional true,
        :doc
        "Divider used to separate values in the hidden input `value` attribute"}
       :string]
      [:hide-picked-options
       {:optional true,
        :doc
        "If set, picked options are removed from the options list"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:max-values
       {:optional true,
        :doc "Maximum number of values, no limit if not set"}
       [:or :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:search-value
       {:optional true, :doc "Controlled search value"}
       :string]
      [:searchable {:optional true, :doc "Allows searching"} :boolean]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:vector :string]]
      [:with-aligned-labels
       {:optional true,
        :doc "If set, unchecked labels are aligned with checked ones"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-check-icon
       {:optional true,
        :doc
        "If set, the check icon is displayed near the selected option label"}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :app-shell
    {:description
     "A PAGE — Mantine's `AppShell`, adopted whole (ADR-graph-ui-v0-001-01 §B).\n     Header / Navbar / Aside / Main / Footer, which is what a surface with a\n     navigation sidebar and a content area actually IS.\n\n     Adopted because the reader was hand-rolling one. `{:widget :split-pane\n     :initial 270 :min 180 :max 440}` wrapping a `:container` is a Navbar and a\n     Main expressed as flex arithmetic, with the sidebar's resize and collapse left\n     for the renderer to invent. Mantine ships that behaviour, including the\n     breakpoint at which the sidebar collapses — so 057-01's deferral of\n     responsiveness partly dissolves here rather than needing its own model.\n\n     SECTIONS ARE NAMED, NOT ORDERED. Children declare which section they are\n     via :section; there is no positional convention to remember and a\n     description that omits a section simply has none. That is the whole reason\n     this is a kind and not a :grid with agreed cells.\n\n     :mode is Mantine's own, and it is load-bearing HERE in a way it is not in a\n     plain web app. Mantine defaults to 'fixed', which positions every section\n     except Main against the VIEWPORT — correct for a page that owns the window,\n     wrong for an ikc3 island, which may be one pane of a canvas or embedded in\n     a tile. A fixed navbar would escape its island and land on the window. So\n     :mode defaults to :static here, and :fixed is the deliberate opt-in for a\n     surface that really does own the viewport. (The risk was named in the ADR\n     before this kind was declared; `mode` is Mantine's own answer to it, so\n     nothing had to be invented to resolve it.)\n\n     :navbar-width / :aside-width / :header-height / :footer-height take the\n     same open value :container's :size does — a token, a number, or a CSS\n     length — so a sidebar can be stated in ch or rem rather than pixels.\n     :navbar-breakpoint is the width below which the sidebar collapses; Mantine's\n     own token scale.\n\n     Gestures: none. An :app-shell arranges; it does not dispatch.",
     :children :any,
     :needs :both,
     :slots [:aside :footer :header :main :navbar],
     :defaults {:mode :static, :padding :md},
     :box-to-children :definite,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:mode {:optional true} [:enum :static :fixed]]
      [:padding {:optional true} [:enum :none :xs :sm :md :lg :xl]]
      [:navbar-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:aside-width
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:header-height {:optional true} :int]
      [:footer-height {:optional true} :int]
      [:navbar-breakpoint
       {:optional true}
       [:enum :xs :sm :md :lg :xl]]]},
    :close-button
    {:description
     "Mantine `CloseButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :slots [:icon],
     :defaults {:size :md},
     :box-to-children :block-flow,
     :mantine {:component "CloseButton"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute, assigns disabled styles"}
       :boolean]
      [:icon-size
       {:optional true, :doc "`X` icon `width` and `height`"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :grid-col
    {:description
     "One cell of a :grid parent (ADR-graph-ui-v0-013-01 Sec3). :span is this\n     child's share of the parent's :columns total — STATED, not emergent\n     from siblings. An int only: :auto and :content went with the flexbox\n     (see :grid), and so did :offset.",
     :status :in-progress,
     :props
     [:map
      [:span {:optional true} :int]
      [:order {:optional true} :int]],
     :defaults {},
     :children :any,
     :box-from :props,
     :box-to-children :flex-column},
    :color-swatch
    {:description
     "Mantine `ColorSwatch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ColorSwatch"},
     :props
     [:map
      [:color
       {:optional true, :doc "Valid CSS color to display"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls `width` and `height` of the swatch, any valid CSS value, numbers are converted to rem."}
       [:or :string :int :double]]
      [:with-shadow
       {:optional true,
        :doc
        "Determines whether the swatch should have inner `box-shadow`"}
       :boolean]],
     :defaults {:radius 1000, :size 28, :with-shadow true},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :box
    {:description
     "A plain container with no layout opinion — ADR-graph-ui-v0-013-01 Sec0: v1.x's\n     :layout enum and flex props (:direction/:wrap/:justify/:align/:gap) are\n     DROPPED from :box itself (a prop-level change within a kind that still\n     exists, so no :drops entry is needed for it — only whole kind/slot names\n     require one). Arrangement lives on :stack/:group/:flex/:grid/\n     :simple-grid below; :box is for grouping + chrome only.",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:border {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:elevation
       {:optional true}
       [:enum :flat :raised :floating :overlay]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :paper
    {:description
     "Mantine `Paper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Paper"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :code-block
    {:description
     "A syntax-highlighted code block. :value is the code text; :language\n                 is an optional hint (e.g. :clojure :js). In the TUI it renders as\n                 plain monospaced text; a web renderer may apply syntax highlighting.\n                 A bound :code-block gets its :value from a data source.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :native-select
    {:description
     "Mantine `NativeSelect` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"data" "ComboboxData"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "NativeSelect"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :kbd
    {:description
     "Mantine `Kbd` — GENERATED from @mantine/core's own TypeScript declarations\n     (PLAN-graph-ui-v0-009-01), not hand-written, so this kind says exactly\n     what the library promises and no more. 1 prop(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Kbd"},
     :props
     [:map
      [:size
       {:optional true, :doc "Controls `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :sm},
     :children :none,
     :box-from :content},
    :burger
    {:description
     "Mantine `Burger` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Burger"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS value, by default `theme.white` in dark color scheme and `theme.black` in light"}
       [:or :keyword :string]]
      [:line-size
       {:optional true,
        :doc
        "Controls height of lines, by default calculated based on `size` prop"}
       [:or :string :int :double]]
      [:opened
       {:optional true,
        :doc
        "State of the burger, when `true` burger is transformed into X"}
       :boolean]
      [:size
       {:optional true,
        :doc
        "Controls burger `width` and `height`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true,
        :doc "`transition-duration` property value in ms"}
       [:or :int :double]]
      [:transition-timing-function
       {:optional true,
        :doc "`transition-timing-function` property value"}
       :string]],
     :defaults
     {:opened false,
      :size :md,
      :transition-duration 300,
      :transition-timing-function "ease"},
     :children :none,
     :box-from :content},
    :copy-button
    {:description
     "Mantine `CopyButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "CopyButton", :children :function},
     :props
     [:map
      [:timeout
       {:optional true, :doc "Copied status timeout in ms"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Value that is copied to the clipboard when the button is clicked"}
       :string]],
     :defaults {:timeout 1000},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :alert
    {:description
     "Mantine `Alert` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 2 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :slots [:icon :title],
     :defaults {:with-close-button false},
     :mantine {:component "Alert"},
     :status :generated,
     :box-from :content,
     :gestures [:close],
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-button-label
       {:optional true, :doc "Close button `aria-label`"}
       :string]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-close-button
       {:optional true,
        :doc "Determines whether close button should be displayed"}
       :boolean]]},
    :voice
    {:description
     "THE SPOKEN SURFACE — speech to text for a prompt, text to speech for the\n     entries this session is reading. George walks the dog with the phone in one\n     hand and the headphones on, and the headphones are only audio transport\n     (the plan says so): everything that has to be built is here and in the\n     browser.\n\n     TWO CONTROLS, EACH ITS OWN BOOLEAN. :dictate shows the control that\n     listens. :read shows the control that speaks. A node may show one, the\n     other, or both, because they belong in different places — the prompt box\n     wants the microphone and the reading pane wants the reader.\n\n     THE RECOGNIZED TEXT IS NEVER SENT. It lands in the prompt box named by\n     :target, as if the reader had typed it, and the reader sends it. That is\n     the platform's standing rule that user input travels verbatim and a person\n     decides (ADR-ikc-v3-075-01 - the prompt box forwards the text VERBATIM).\n     Speech recognition is wrong often enough that auto-dispatch would be a\n     command nobody wrote. :target is the :import-id of the :prompt-area, not a\n     widget id, so it survives a re-seed like every other authored reference.\n\n     WHAT IS READ ALOUD is the bound value: the entries of the conversation this\n     session has selected, each with its :role, its :text, its :thinking and its\n     :harness? flag. A HARNESS BLOCK IS NEVER SPOKEN. The harness writes machine\n     messages with the role user (the harness fold, 2026-08-20), and reading one\n     aloud in a synthetic voice would be the same defect one layer out - the\n     record would lie in his ear instead of on his screen. THINKING IS NOT\n     SPOKEN unless :read-thinking is true: an answer is what a reader walking a\n     dog asked for. The thinking is longer than the answer.\n\n     :read-count is how many of the NEWEST entries the read control speaks. A\n     conversation is thousands of entries long and a reader who taps 'read'\n     wants what just arrived, so the control reads a tail and says on the\n     surface how many of how many it took. Three by default.\n\n     :language is a BCP-47 tag for both halves - recognition and speech. One\n     slot, because a reader who dictates in one language does not want the\n     answer read in another.\n\n     Gestures: NONE, and that is the point. A :voice dispatches no command. It\n     fills a prompt box and it drives the audio output, both of which are this\n     browser's own business.\n\n     WITHOUT A SECURE CONTEXT IT SAYS SO. The browser speech APIs are absent on\n     plain HTTP, so the controls cannot work until phase 5 puts the deployment\n     behind TLS. The widget then renders its controls DISABLED with the reason\n     and the remedy in words on the surface, and records the refusal on the\n     observability surface. A silent no-op is what\n     PRINCIPLE-ikc-v3-010-01 calls a defect, and a console line is a signal\n     nobody walking a dog can read.\n\n     Web renderer only. The TUI has no microphone and no loudspeaker, so it\n     renders nothing at all - the same documented no-op that :flex sets.",
     :status :in-progress,
     :props
     [:map
      [:dictate {:optional true} :boolean]
      [:read {:optional true} :boolean]
      [:target {:optional true} :string]
      [:language {:optional true} :string]
      [:read-thinking {:optional true} :boolean]
      [:read-count {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:language "en-US", :read-thinking false, :read-count 3},
     :children :none,
     :box-from :content},
    :flex
    {:description
     "Explicit flex container, direction stated — Mantine `Flex`\n     (ADR-graph-ui-v0-013-01 Sec0). For when :stack (always vertical) / :group\n     (always horizontal) aren't enough. Distinct from the :flex UNIVERSAL\n     SLOT (this version's :universal-slots) — that is a CHILD's self-sizing\n     hint; this is a CONTAINER kind. Mantine overloads `flex` the same way (a\n     Mantine Flex component AND a Box style prop); v2.0 keeps that overlap rather\n     than inventing new names.",
     :status :in-progress,
     :props
     [:map
      [:direction {:optional true} [:enum :row :column]]
      [:wrap {:optional true} :boolean]
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:row-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:column-gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-both},
    :focus-trap
    {:description
     "Mantine `FocusTrap` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "FocusTrap"},
     :props
     [:map
      [:active
       {:optional true, :doc "If set to `false`, disables focus trap"}
       :boolean]
      [:ref-prop
       {:optional true, :doc "Prop that is used to access element ref"}
       :string]],
     :defaults {:ref-prop "ref"},
     :unmapped {"children" "any", "innerRef" "ForwardedRef<any>"},
     :children :none,
     :box-from :content},
    :icon
    {:description
     "A line icon — ADR-graph-ui-v0-013-01 Sec11: @tabler/icons-react, closed to a\n     named set (not the library's full catalogue). :icon maps 1:1 to one\n     tabler React component in the renderer's own lookup table (widgets.cljs's\n     icon-components). Closed as a real [:enum ...] (not a bare :keyword,\n     which a prior draft of this rule wrongly claimed was already\n     validate-dsl-catchable — it was not, a keyword type check accepts any\n     keyword; fixed 2026-07-27 when Phase 2 needed 5 more names). Web-only;\n     TUI renders nothing (documented no-op, same precedent as\n     :elevation/:button). The 20 from Sec11's original set plus 5 added for\n     PLAN-graph-ui-v0-007-01 Phase 2's locked-target reader (the mockup's own\n     'outline view'/'theme config'/'theme selector'/'pin'/'copy' icons, none\n     of which are on a disabled/not-yet-built affordance, so they earn a real\n     name now rather than waiting).",
     :status :in-progress,
     :props
     [:map
      [:icon
       {:optional true}
       [:enum
        :search
        :chevron-down
        :chevron-right
        :chevron-up
        :chevron-left
        :tag
        :star
        :settings
        :close
        :plus
        :more
        :check
        :calendar
        :folder
        :file
        :link
        :trash
        :edit
        :menu
        :home
        :outline-view
        :theme-config
        :theme-selector
        :pin
        :copy]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :verse-rows
    {:description
     "A book's reading surface: one row per verse, each row carrying the\n     translation, the source text and the verse's notes as three aligned\n     cells. :items is the bound list, each item\n     {:verse-id string :text string :original string\n      :notes [{:head string :kind string}]}.\n\n     :show-source and :show-notes are the reader's, not the author's — the\n     second and third columns can be closed, which is what George asked for\n     when he said a reader may prefer the book without the Chinese. Closing a\n     column widens the ones that remain rather than leaving a gap.\n\n     A verse is ONE paragraph, so prose typography needs no markdown here: the\n     cell is styled text and reads the same. That is what lets the row exist\n     at all — a markdown document cannot be a table cell.",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:empty-label {:optional true} :string]
      [:show-source {:optional true} :boolean]
      [:show-notes {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:show-source true, :show-notes true},
     :children :none,
     :box-from :content},
    :color-picker
    {:description
     "Mantine `ColorPicker` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 12 prop(s), 3\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "ColorPicker"},
     :props
     [:map
      [:alpha-label
       {:optional true, :doc "Alpha slider `aria-label`"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:focusable
       {:optional true,
        :doc
        "If set, interactive elements (sliders thumbs and swatches) are focusable with keyboard"}
       :boolean]
      [:format
       {:optional true, :doc "Color format"}
       [:enum :hex :hexa :rgba :rgb :hsl :hsla]]
      [:full-width
       {:optional true,
        :doc "If set, the component takes 100% width of its container"}
       :boolean]
      [:hue-label
       {:optional true, :doc "Hue slider `aria-label`"}
       :string]
      [:saturation-label
       {:optional true, :doc "Saturation slider `aria-label`"}
       :string]
      [:size
       {:optional true,
        :doc "Controls size of hue, alpha and saturation sliders"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:swatches
       {:optional true,
        :doc
        "A list of colors used to display swatches list below the color picker"}
       [:vector :string]]
      [:swatches-per-row
       {:optional true, :doc "Number of swatches per row"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-picker
       {:optional true,
        :doc "Determines whether the color picker should be displayed"}
       :boolean]],
     :defaults
     {:focusable true,
      :format :hex,
      :full-width false,
      :size :md,
      :swatches-per-row 7,
      :with-picker true},
     :gestures [:change :change-end :color-swatch-click],
     :children :none,
     :box-from :content},
    :drawer
    {:description
     "A slide-over — Mantine `Drawer`/`DrawerRoot` (ADR-graph-ui-v0-013-01 Sec15):\n     SPEC-002's '340px slide-over + scrim' is Drawer's own overlay, not\n     hand-rolled. Closing (Escape, scrim click, or the built-in close\n     button — all three are ModalBase's own affordances) fires\n     :on-gesture's :submit key with no $value, the same slot a plain\n     :button fires.",
     :status :in-progress,
     :props
     [:map
      [:opened {:optional true} :boolean]
      [:title {:optional true} :string]
      [:position {:optional true} [:enum :left :right :top :bottom]]
      [:size {:optional true} [:enum :xs :sm :md :lg :xl]]],
     :defaults {:position :right},
     :children :any,
     :box-from :viewport,
     :box-to-children :block-flow},
    :icon-button
    {:description
     "An icon button — Mantine `ActionIcon` (ADR-graph-ui-v0-013-01 Sec12). Also\n     covers SPEC-002's 'toggle button' row: a toggle is an icon-button with\n     :on set; mutual exclusion among several is the COMPOSING description's\n     concern (each button's :on-gesture clears its siblings), not a second\n     widget kind. :on is a renderer convention (ActionIcon has no native\n     'pressed' prop): true swaps Mantine's `variant` to :filled, false/absent\n     to :subtle. :tooltip wraps the button in Mantine's `Tooltip`. Fires\n     :on-gesture's :submit key on click, same as :button.",
     :status :in-progress,
     :props
     [:map
      [:icon {:optional true} :keyword]
      [:tooltip {:optional true} :string]
      [:on {:optional true} :boolean]
      [:disabled {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :modal
    {:description
     "Mantine `Modal` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 21 prop(s), 2 named\n     child slot(s), 3 gesture(s), and 2 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"xOffset" "MarginLeft<string | number>",
      "yOffset" "MarginTop<string | number>"},
     :slots [:title],
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :with-close-button true,
      :full-screen false,
      :with-overlay true,
      :centered false,
      :shadow :xl,
      :lock-scroll true},
     :box-to-children :block-flow,
     :mantine {:component "Modal"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:centered
       {:optional true,
        :doc "If set, the modal is centered vertically"}
       :boolean]
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:full-screen
       {:optional true,
        :doc "If set, the modal takes the entire screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:stack-id
       {:optional true, :doc "Id of the modal in the `Modal.Stack`"}
       :string]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is rendered"}
       :boolean]
      [:with-overlay
       {:optional true, :doc "If set, the overlay is rendered"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :accordion
    {:description
     "Mantine `Accordion` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"defaultValue" "AccordionValue<Multiple>",
      "multiple" "Multiple",
      "order" "AccordionHeadingOrder",
      "value" "AccordionValue<Multiple>"},
     :slots [:chevron],
     :defaults
     {:chevron-icon-size 16, :loop true, :transition-duration 200},
     :mantine {:component "Accordion"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:chevron-icon-size
       {:optional true,
        :doc
        "Size of the default chevron icon. Ignored when `chevron` prop is set."}
       [:or :string :int :double]]
      [:chevron-position
       {:optional true,
        :doc "Position of the chevron relative to the item label"}
       [:enum :left :right]]
      [:chevron-size
       {:optional true, :doc "Size of the chevron icon container"}
       [:or :string :int :double]]
      [:disable-chevron-rotation
       {:optional true, :doc "If set, chevron rotation is disabled"}
       :boolean]
      [:loop
       {:optional true,
        :doc
        "If set, arrow keys loop though items (first to last and last to first)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:transition-duration
       {:optional true, :doc "Transition duration in ms"}
       [:or :int :double]]]},
    :theme-icon
    {:description
     "Mantine `ThemeIcon` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 5 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "ThemeIcon"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color."}
       [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc "Gradient data used when `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Controls width and height of the button. Numbers are converted to rem."}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :title
    {:description
     "Mantine `Title` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"order" "TitleOrder", "size" "TitleSize"},
     :defaults {:text-wrap :wrap},
     :box-to-children :block-flow,
     :mantine {:component "Title"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which heading will be truncated"}
       [:or :int :double]]
      [:text-wrap
       {:optional true, :doc "Heading `text-wrap` CSS property"}
       [:enum :nowrap :wrap :balance :pretty :stable]]]},
    :skeleton
    {:description
     "Mantine `Skeleton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), and 2\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"height" "Height<string | number>",
      "radius" "BorderRadius<string | number>"},
     :defaults {:animate true, :circle false, :visible true},
     :box-to-children :block-flow,
     :mantine {:component "Skeleton"},
     :status :generated,
     :box-from :props,
     :props
     [:map
      [:animate {:optional true, :doc "Enables animation"} :boolean]
      [:circle
       {:optional true,
        :doc
        "If set, Skeleton `width` and `border-radius` are equal to its `height`"}
       :boolean]
      [:visible
       {:optional true,
        :doc "Determines whether Skeleton overlay should be displayed"}
       :boolean]
      [:width
       {:optional true,
        :doc
        "Skeleton `width`, numbers are converted to rem, ignored when `circle` prop is set."}
       [:or :string :int :double]]]},
    :nav-link
    {:description
     "Mantine `NavLink` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 5 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :slots [:description :label :left-section :right-section],
     :defaults
     {:active false,
      :children-offset :lg,
      :disable-right-section-rotation false,
      :disabled false,
      :no-wrap false},
     :box-to-children :block-flow,
     :mantine {:component "NavLink"},
     :status :generated,
     :box-from :content,
     :gestures [:change :click :key-down],
     :props
     [:map
      [:active
       {:optional true,
        :doc "Determines whether the link should have active styles"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:children-offset
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set collapsed links `padding-left`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` of any valid CSS color to control active styles"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled nested items collapse initial state"}
       :boolean]
      [:disable-right-section-rotation
       {:optional true,
        :doc
        "If set, right section will not be rotated when collapse is opened"}
       :boolean]
      [:disabled
       {:optional true,
        :doc
        "If set, disabled styles will be added to the root element"}
       :boolean]
      [:no-wrap
       {:optional true,
        :doc
        "If set, label and description do not wrap to the next line"}
       :boolean]
      [:opened
       {:optional true, :doc "Controlled nested items collapse state"}
       :boolean]]},
    :center
    {:description
     "Mantine `Center` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Center"},
     :props
     [:map
      [:inline
       {:optional true,
        :doc "If set, `inline-flex` is used instead of `flex`"}
       :boolean]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :content},
    :number-input
    {:description
     "Mantine `NumberInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 37 prop(s), 5 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"handlersRef" "ForwardedRef<NumberInputHandlers>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :hide-controls false,
      :allow-decimal true,
      :allow-negative true,
      :type :text,
      :right-section-pointer-events "none",
      :value-is-numeric-string false,
      :decimal-separator ".",
      :size :sm,
      :allow-leading-zeros true,
      :fixed-decimal-scale false,
      :trim-leading-zeroes-on-blur true,
      :with-asterisk false,
      :start-value 0,
      :with-keyboard-events true,
      :step 1,
      :with-error-styles true,
      :required false},
     :mantine {:component "NumberInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change :value-change],
     :props
     [:map
      [:allow-decimal
       {:optional true, :doc "If set, decimal values are allowed"}
       :boolean]
      [:allow-leading-zeros
       {:optional true,
        :doc
        "Determines whether leading zeros are allowed. If set to `false`, leading zeros are removed when the input value becomes a valid number."}
       :boolean]
      [:allow-negative
       {:optional true, :doc "If set, negative values are allowed"}
       :boolean]
      [:allowed-decimal-separators
       {:optional true,
        :doc
        "Characters which when pressed result in a decimal separator"}
       [:vector :string]]
      [:clamp-behavior
       {:optional true,
        :doc
        "Controls how value is clamped, `strict` – user is not allowed to enter values that are not in `[min, max]` range, `blur` – user is allowed to enter any values, but the value is clamped when the input loses focus (default behavior), `none` – lifts all restrictions, `[min, max]` range is applied only for controls and up/down keys"}
       [:enum :none :strict :blur]]
      [:decimal-scale
       {:optional true,
        :doc
        "Limits the number of digits that can be entered after the decimal point"}
       [:or :int :double]]
      [:decimal-separator
       {:optional true, :doc "Character used as a decimal separator"}
       :string]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :string :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:fixed-decimal-scale
       {:optional true,
        :doc
        "If set, 0s are added after `decimalSeparator` to match given `decimalScale`."}
       :boolean]
      [:hide-controls
       {:optional true, :doc "If set, the up/down controls are hidden"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimum possible value"}
       [:or :int :double]]
      [:prefix
       {:optional true, :doc "Prefix added before the input value"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:start-value
       {:optional true,
        :doc
        "Value set to the input when increment/decrement buttons are clicked or up/down arrows pressed if the input is empty"}
       [:or :int :double]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with up/down controls and keyboard arrows"}
       [:or :int :double]]
      [:step-hold-delay
       {:optional true,
        :doc
        "Initial delay in milliseconds before stepping the value."}
       [:or :int :double]]
      [:suffix
       {:optional true, :doc "Suffix added after the input value"}
       :string]
      [:thousand-separator
       {:optional true, :doc "A character used to separate thousands"}
       :boolean]
      [:thousands-group-style
       {:optional true, :doc "Defines the thousand grouping style."}
       [:enum :none :thousand :lakh :wan]]
      [:trim-leading-zeroes-on-blur
       {:optional true,
        :doc
        "If set, leading zeros are removed on blur. For example, `00100` -> `100`"}
       :boolean]
      [:type
       {:optional true, :doc "Controls input `type` attribute"}
       [:enum :text :tel :password]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :string :int :double]]
      [:value-is-numeric-string
       {:optional true,
        :doc
        "If value is passed as string representation of numbers (unformatted) and number is used in any format props like in prefix or suffix in numeric format and format prop in pattern format then this should be passed as `true`."}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-keyboard-events
       {:optional true,
        :doc
        "If set, up/down keyboard events increment/decrement value"}
       :boolean]]},
    :background-image
    {:description
     "Mantine `BackgroundImage` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 2 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "BackgroundImage"},
     :props
     [:map
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src {:optional true, :doc "Image url"} :string]],
     :defaults {:radius 0},
     :children :none,
     :box-from :content},
    :card
    {:description
     "Mantine `Card` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Card"},
     :props
     [:map
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:with-border
       {:optional true, :doc "Adds border to the card"}
       :boolean]],
     :defaults {:padding :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :divider
    {:description
     "Mantine `Divider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Divider"},
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default value depends on color scheme"}
       [:or :keyword :string]]
      [:label-position
       {:optional true, :doc "Controls label position"}
       [:enum :center :left :right]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:size
       {:optional true,
        :doc "Controls width/height (depends on orientation)"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults
     {:label-position :center, :orientation :horizontal, :size :xs},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :split-pane
    {:description
     "A two-pane split with a draggable divider and a fold button\n     (F-graph-ui-v0-004-01) — the ikc1 resizable/collapsible sidebar.\n     Exactly two children: the RESIZABLE/foldable pane and the FILLING\n     pane. :fold-side picks which side the resizable one is on — :left\n     (default) = child 1 is resizable and folds left; :right = child 2 is\n     resizable and folds right. :pane-id is the localStorage key under\n     which THIS pane's width + folded state are remembered. :initial is the\n     resizable pane's starting px width; :min is its floor; :max an\n     optional hard ceiling. :flex-min is the FILLING pane's floor (px).\n     :collapsible shows the fold button.\n\n     :narrow IS THE PHONE (2026-08-20, PLAN-ikc-v3-015-01 phase 6). It is the\n     UNIVERSAL slot of that name, not a prop of this kind — one word for one\n     idea (Rule 1.11), and a second key would have collided with the first in\n     malli's own schema, which is how :font-size came to be named that. This\n     kind honours two of its five values, and DEFAULTS to one of them. Below\n     --viewport-narrow a two-pane split does not fit: :initial 270 plus\n     :flex-min 280 plus the divider is 556px, and the pane's own\n     `overflow-x: auto` then makes the whole island scroll sideways. This\n     prop says which of the two things it does instead.\n\n       :fold   the resizable pane starts FOLDED and the filling pane takes\n               the width. Its fold control is still there, so the sidebar is one\n               tap away — the sidebar becomes a control, which is what a\n               sidebar is on a phone.\n       :stack  both panes as one vertical column, the resizable one first.\n               For a split whose two halves are both content (a source and\n               its preview), where hiding one loses the point.\n       :keep   the desktop split, sideways scroll included. Deliberate, and\n               sayable, for a surface nobody opens on a phone.\n\n     THE DEFAULT IS :fold, and that is a declaration, not an inference\n     (ADR-graph-ui-v0-011-01's own safety net: 'where the renderer can safely\n     default to filling, it should'). The failure mode of forgetting this\n     prop is a page that scrolls sideways under the reader's thumb, so the\n     safe answer is the one a description gets for free. A folded pane is\n     recoverable by one tap. A sideways-scrolled reading column is not\n     recoverable at all until the reader finds it.\n\n     The fold is NOT remembered across the breakpoint. :pane-id's stored\n     fold state is the reader's choice on a wide window, and a phone visit\n     must not overwrite it — so the narrow fold is computed, never stored.",
     :status :in-progress,
     :props
     [:map
      [:pane-id :string]
      [:initial {:optional true} :int]
      [:min {:optional true} :int]
      [:max {:optional true} :int]
      [:flex-min {:optional true} :int]
      [:fold-side {:optional true} [:enum :left :right]]
      [:collapsible {:optional true} :boolean]],
     :defaults
     {:initial 270,
      :min 140,
      :flex-min 280,
      :fold-side :left,
      :collapsible true,
      :narrow :fold},
     :children :any,
     :box-from :parent,
     :needs :both,
     :box-to-children :definite},
    :chip
    {:description
     "An interactive, selectable pill — Mantine `Chip` (ADR-graph-ui-v0-013-01\n     Sec14). Where :badge is a label with no behaviour, :chip reports its\n     own selected state — the ikc1 #tag filter needs a clickable tag that\n     toggles, which :badge cannot do. Fires :on-gesture's :submit key on\n     toggle, $value = the new selected state (true/false) — mirroring\n     :select's choose->command convention.",
     :status :in-progress,
     :props
     [:map
      [:label :string]
      [:selected {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :overlay
    {:description
     "Mantine `Overlay` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :needs :both,
     :defaults
     {:background-opacity 0.6,
      :blur 0,
      :center false,
      :fixed false,
      :radius 0,
      :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Overlay"},
     :status :generated,
     :box-from :parent,
     :props
     [:map
      [:background-opacity
       {:optional true,
        :doc
        "Overlay `background-color` opacity 0–1, ignored when `gradient` prop is set"}
       [:or :int :double]]
      [:blur
       {:optional true, :doc "Overlay background blur"}
       [:or :string :int :double]]
      [:center
       {:optional true, :doc "Centers content inside the overlay"}
       :boolean]
      [:color
       {:optional true, :doc "Overlay `background-color`"}
       [:or
        [:enum
         :gray
         :red
         :pink
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :transparent
         :white
         "-moz-initial"
         :inherit
         :initial
         :revert
         :revert-layer
         :unset
         :aliceblue
         :antiquewhite
         :aqua
         :aquamarine
         :azure
         :beige
         :bisque
         :black
         :blanchedalmond
         :blueviolet
         :brown
         :burlywood
         :cadetblue
         :chartreuse
         :chocolate
         :coral
         :cornflowerblue
         :cornsilk
         :crimson
         :darkblue
         :darkcyan
         :darkgoldenrod
         :darkgray
         :darkgreen
         :darkgrey
         :darkkhaki
         :darkmagenta
         :darkolivegreen
         :darkorange
         :darkorchid
         :darkred
         :darksalmon
         :darkseagreen
         :darkslateblue
         :darkslategray
         :darkslategrey
         :darkturquoise
         :darkviolet
         :deeppink
         :deepskyblue
         :dimgray
         :dimgrey
         :dodgerblue
         :firebrick
         :floralwhite
         :forestgreen
         :fuchsia
         :gainsboro
         :ghostwhite
         :gold
         :goldenrod
         :greenyellow
         :grey
         :honeydew
         :hotpink
         :indianred
         :ivory
         :khaki
         :lavender
         :lavenderblush
         :lawngreen
         :lemonchiffon
         :lightblue
         :lightcoral
         :lightcyan
         :lightgoldenrodyellow
         :lightgray
         :lightgreen
         :lightgrey
         :lightpink
         :lightsalmon
         :lightseagreen
         :lightskyblue
         :lightslategray
         :lightslategrey
         :lightsteelblue
         :lightyellow
         :limegreen
         :linen
         :magenta
         :maroon
         :mediumaquamarine
         :mediumblue
         :mediumorchid
         :mediumpurple
         :mediumseagreen
         :mediumslateblue
         :mediumspringgreen
         :mediumturquoise
         :mediumvioletred
         :midnightblue
         :mintcream
         :mistyrose
         :moccasin
         :navajowhite
         :navy
         :oldlace
         :olive
         :olivedrab
         :orangered
         :orchid
         :palegoldenrod
         :palegreen
         :paleturquoise
         :palevioletred
         :papayawhip
         :peachpuff
         :peru
         :plum
         :powderblue
         :purple
         :rebeccapurple
         :rosybrown
         :royalblue
         :saddlebrown
         :salmon
         :sandybrown
         :seagreen
         :seashell
         :sienna
         :silver
         :skyblue
         :slateblue
         :slategray
         :slategrey
         :snow
         :springgreen
         :steelblue
         :tan
         :thistle
         :tomato
         :turquoise
         :wheat
         :whitesmoke
         :yellowgreen
         :AccentColor
         :AccentColorText
         :ActiveText
         :ButtonBorder
         :ButtonFace
         :ButtonText
         :Canvas
         :CanvasText
         :Field
         :FieldText
         :GrayText
         :Highlight
         :HighlightText
         :LinkText
         :Mark
         :MarkText
         :SelectedItem
         :SelectedItemText
         :VisitedText
         :ActiveBorder
         :ActiveCaption
         :AppWorkspace
         :Background
         :ButtonHighlight
         :ButtonShadow
         :CaptionText
         :InactiveBorder
         :InactiveCaption
         :InactiveCaptionText
         :InfoBackground
         :InfoText
         :Menu
         :MenuText
         :Scrollbar
         :ThreeDDarkShadow
         :ThreeDFace
         :ThreeDHighlight
         :ThreeDLightShadow
         :ThreeDShadow
         :Window
         :WindowFrame
         :WindowText
         :currentColor]
        :string]]
      [:fixed
       {:optional true, :doc "Changes position to `fixed`"}
       :boolean]
      [:gradient
       {:optional true,
        :doc
        "Changes overlay to gradient. If set, `color` prop is ignored."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:z-index
       {:optional true, :doc "Overlay z-index"}
       [:or :string :int :double]]]},
    :activity-log
    {:description
     "A live, timestamped log of recent activity in THIS browser session —\n     every bus command dispatched (with its round-trip ms) and the\n     client-only UI events that never reach the bus, newest last. Purely a\n     CLIENT-side observability surface: reads a client ring-buffer directly,\n     never a bus :source. Web-only; the TUI renders a labelled placeholder.\n     :slow-ms marks any dispatch at/above it as slow (tone shift).",
     :status :in-progress,
     :props
     [:map
      [:title {:optional true} :string]
      [:max-rows {:optional true} :int]
      [:slow-ms {:optional true} :int]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:max-rows 60, :slow-ms 200},
     :children :none,
     :box-from :content},
    :file-button
    {:description
     "Mantine `FileButton` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 6 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :unmapped {"multiple" "Multiple"},
     :defaults {},
     :box-to-children :block-flow,
     :mantine {:component "FileButton", :children :function},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:accept
       {:optional true,
        :doc
        "File input accept attribute, for example, `\"image/png,image/jpeg\"`"}
       :string]
      [:capture
       {:optional true,
        :doc
        "Specifies that, optionally, a new file should be captured, and which device should be used to capture that new media of a type defined by the accept attribute."}
       [:enum :user :environment]]
      [:disabled
       {:optional true, :doc "Disables file picker"}
       :boolean]
      [:form {:optional true, :doc "Input form attribute"} :string]
      [:name {:optional true, :doc "Input name attribute"} :string]]},
    :list
    {:description
     "A vertical list; each item renders on its own line. :items is optional:\n     a bound :list gets its items from a source. An item is now a MAP\n     (ADR-graph-ui-v0-013-01 Sec17, legal because v2.0 is a major): {:label\n     string :icon (:optional) keyword :accessory (:optional) string :active\n     (:optional) boolean :dim (:optional) boolean} — covers the SPEC-002\n     'nav row' gap (icon + ellipsised text + trailing accessory, active/dim\n     states). {:label \"Foo\"} alone renders identically to a bare string\n     under v1.x, so the common case stays exactly as terse. :empty-label:\n     shown in place of a silently-blank pane when :items resolves to an\n     empty vector. :value (ADR-graph-ui-v0-013-01 Sec24): the item's click target,\n     substituted as $value into the dispatched command. It was MISSING from\n     this closed map while every source already returned it — invisible only\n     because BOUND items skip props validation, so a literal-authored item\n     carrying :value was rejected while the identical item from a source was\n     accepted. Declared now so model and code agree by agreeing, not because\n     one of them is never checked.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:value {:optional true} :string]
         [:icon {:optional true} :keyword]
         [:accessory {:optional true} :string]
         [:active {:optional true} :boolean]
         [:dim {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none,
     :box-from :content},
    :scroll-area
    {:description
     "A scrolling viewport — Mantine `ScrollArea` (ADR-graph-ui-v0-013-01 Sec22).\n     This closes an AC-1 gap, not a styling one: WHAT SCROLLS was hardcoded\n     per widget in the renderer (:outline, :tree and :list each carried their\n     own overflow-y-auto), so no description could say 'this pane scrolls as\n     one document' — a capability reachable only through bespoke renderer\n     code, which is what AC-1 forbids.\n\n     It is also a known, still-open defect rather than a new observation:\n     graph_ui/web/render.cljs records (2026-07-14) that adding min-h-0 to the\n     SHARED root, to give descendants a bounded scroll box, collapsed the\n     content pane entirely against the real vault, was reverted, and left the\n     app unable to scroll long pages — with the fix explicitly deferred to\n     'the content pane's own flex chain'. Naming the scrolling box in the\n     description IS that fix: the renderer stops having to guess on a root it\n     shares with every island.\n\n:reset-key IS THE SAME NOUN :input CARRIES, and it means the same\n     thing. When the value changes, the box drops what it holds. For an\n     :input that is the text. For a :scroll-area it is the scroll offset.\n\n     The reading pane needs it, and a measurement says why. The pane holds\n     seven :scroll-area boxes, one for each modality, inside one :tab-set. A\n     second note of the SAME modality reuses the same box, so the offset\n     stays. Measured on the deployment 2026-09-20: a note of 126,287 px was\n     read to its foot, and the next note opened at 12,830 px of its own\n     13,372 px. The reader arrived 96 per cent of the way down a note they\n     had just opened.\n\n     :type and :scrollbars are Mantine's own enums verbatim.\n     :scrollbarSize/:offsetScrollbars are not adopted — no consumer needs\n     them. A :scroll-area needs a bounded height to scroll WITHIN, so it\n     normally carries :flex 1 inside a :stack that has one.",
     :children :any,
     :needs :block,
     :self-flex :block,
     :defaults {:type :hover, :scrollbars :y},
     :box-to-children :block-flow,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:type
       {:optional true}
       [:enum :auto :always :scroll :hover :never]]
      [:scrollbars {:optional true} [:enum :x :y :xy :none]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:reset-key {:optional true} [:maybe :string]]]},
    :semi-circle-progress
    {:description
     "Mantine `SemiCircleProgress` — GENERATED from @mantine/core's own\n     TypeScript declarations (PLAN-graph-ui-v0-009-01), not hand-written, so\n     this kind says exactly what the library promises and no more. 9 prop(s), 1\n     named child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic\n     drives the component named above straight from this declaration — the\n     props here are the legal ones, the gestures here are the wired ones, and\n     nothing else reaches the DOM. Generic is not finished: this kind has no\n     data binding, no edit buffer and no selection state of its own. A kind\n     that needs one of those graduates to a hand-written widget and an explicit\n     case in render.cljs — move it above the GENERATED marker and give it a\n     description that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine\n     declares no `children` for this component, so a child is admitted solely\n     to fill one of the named slots above, saying which with :section. A child\n     that names no slot is not body content here — there is no body to put it\n     in.",
     :status :generated,
     :mantine {:component "SemiCircleProgress"},
     :props
     [:map
      [:empty-segment-color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color value, by default the value is determined based on the color scheme value"}
       [:or :keyword :string]]
      [:fill-direction
       {:optional true,
        :doc "Direction from which the circle is filled"}
       [:enum :right-to-left :left-to-right]]
      [:filled-segment-color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:label-position
       {:optional true,
        :doc "Label position relative to the circle center"}
       [:enum :center :bottom]]
      [:orientation
       {:optional true, :doc "Orientation of the circle"}
       [:enum :up :down]]
      [:size
       {:optional true, :doc "Diameter of the svg in px"}
       [:or :int :double]]
      [:thickness
       {:optional true, :doc "Circle thickness in px"}
       [:or :int :double]]
      [:transition-duration
       {:optional true,
        :doc
        "Transition duration of filled section styles changes in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Progress value from `0` to `100`"}
       [:or :int :double]]],
     :defaults
     {:fill-direction :left-to-right,
      :label-position :bottom,
      :orientation :up,
      :size 200,
      :thickness 12,
      :transition-duration 0},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :pagination
    {:description
     "Mantine `Pagination` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 5\n     gesture(s), and 5 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped
     {"dotsIcon" "PaginationIcon",
      "firstIcon" "PaginationIcon",
      "lastIcon" "PaginationIcon",
      "nextIcon" "PaginationIcon",
      "previousIcon" "PaginationIcon"},
     :defaults
     {:boundaries 1,
      :gap 8,
      :hide-with-one-page false,
      :siblings 1,
      :size :md,
      :with-controls true,
      :with-edges false,
      :with-pages true},
     :mantine {:component "Pagination"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change :first-page :last-page :next-page :previous-page],
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:boundaries
       {:optional true,
        :doc "Number of elements visible on the left/right edges"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc "Key of `theme.colors`, active item color"}
       [:or :keyword :string]]
      [:default-value
       {:optional true,
        :doc
        "Active page for uncontrolled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Disables all controls, applies disabled styles"}
       :boolean]
      [:gap
       {:optional true,
        :doc "Key of `theme.spacing`, gap between controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:hide-with-one-page
       {:optional true,
        :doc
        "If set, the pagination is hidden when only one page is available (`total={1}`)"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:siblings
       {:optional true,
        :doc
        "Number of siblings displayed on the left/right side of the selected page"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "`height` and `min-width` of controls"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:total
       {:optional true,
        :doc "Total number of pages, must be an integer"}
       [:or :int :double]]
      [:value
       {:optional true,
        :doc
        "Active page for controlled component, must be an integer in [0, total] interval"}
       [:or :int :double]]
      [:with-controls
       {:optional true,
        :doc "If set, next/previous controls are displayed"}
       :boolean]
      [:with-edges
       {:optional true,
        :doc "If set, first/last controls are displayed"}
       :boolean]
      [:with-pages
       {:optional true,
        :doc "If set to `false`, pages controls are hidden"}
       :boolean]]},
    :color-input
    {:description
     "A swatch-picker input — Mantine `ColorInput` (ADR-graph-ui-v0-013-01\n     Sec16), the theme editor's field. :value is a CSS colour string (hex,\n     as the theme tokens already are — ADR-graph-ui-v0-009-01). Fires\n     :on-gesture's :submit key on change, $value = the picked colour — the\n     same input->command shape :input/:select already use.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :avatar
    {:description
     "Mantine `Avatar` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Avatar"},
     :props
     [:map
      [:allowed-initials-colors
       {:optional true,
        :doc
        "A list of colors that is used for autogenerated initials. By default, all default Mantine colors can be used except gray and dark."}
       [:vector :any]]
      [:alt
       {:optional true,
        :doc
        "Image `alt` attribute, also used as `title` attribute for placeholder"}
       :string]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or
        [:enum
         :dark
         :gray
         :red
         :pink
         :grape
         :violet
         :indigo
         :blue
         :cyan
         :green
         :lime
         :yellow
         :orange
         :teal
         :initials]
        :string]]
      [:gradient
       {:optional true,
        :doc "Gradient configuration for `variant=\"gradient\"`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:name
       {:optional true,
        :doc
        "Name of the user. When `src` is not set, used to display initials and to generate color when `color=\"initials\"` is set."}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc
        "Width and height of the avatar, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:src
       {:optional true,
        :doc
        "Image url, if the image cannot be loaded or `src={null}`, then placeholder is displayed instead"}
       :string]],
     :defaults {:color :gray, :radius "1000px", :size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :graph
    {:description
     "A SUBGRAPH, DRAWN. One node at the centre, what it connects to around it,\n     and the edges between them.\n\n     :subgraph IS THE BOUND PROP and its shape is :knowledge-graph/subgraph-of's\n     result VERBATIM. That is deliberate: the widget invents no structure of its\n     own, so what is on the screen is what the store answered, and a question\n     about the picture is answerable by running the query.\n\n     IT IS AN EGO GRAPH AND NOT `THE GRAPH`. SPEC-graph-ui-v0-002-01 AC-2 says\n     the UI must not load the whole graph to become usable, and ikc1 is the\n     evidence: it held every frame WITH ITS CONTENT in the browser and froze for\n     a minute before a keystroke. The bound query is bounded at both ends —\n     :depth limits the walk and :max-nodes caps the answer — so a description\n     cannot ask for the corpus. :truncated? in the bound value says the cap was\n     reached, and the widget says so on the screen rather than drawing a lie.\n\n     NO GRAPH LIBRARY, AND THAT IS A DECISION. The layouts are computed in the\n     browser from the node and edge lists — a few hundred lines, no dependency.\n     ikc1 needed d3-force and React Flow for the same picture; a declaration\n     that named a library would put a second vocabulary beside this one, and the\n     bundle would carry it for every island that never draws a graph. Above about\n     2,000 nodes this stops being the right answer (M8 names canvas or WebGL\n     there), which is what :max-nodes exists to keep away from.\n\n     :layout FOLLOWS THE RELATION, which is M8's own rule:\n       :radial  rings by hop, the focus at the centre. The default, and the one\n                that reads best for `what does this connect to` — a ring IS the\n                distance, so nothing has to be inferred from a line's length.\n       :force   a spring relaxation. For a neighbourhood with its own clusters,\n                where a ring would put two unrelated groups side by side.\n       :tree    left to right by hop. For a relation that IS a hierarchy —\n                :child-of, and later :broader.\n\n     ONE GESTURE, :submit, and $value is the node's :id — the same contract\n     :tree and :list already carry, so opening a node is the command the\n     description already knows how to write. A hub node (a tag, a folder) has an\n     id that names no frame, and a description that opens pages should expect it:\n     the widget still reports it, because refusing to would make half the picture\n     dead to the touch.\n\n     :encoding NAMES A TABLE, NOT A COLOUR. Type to colour and shape, relation\n     to stroke, derived to dashed — declared as data in dsl/design/graph-\n     encoding.edn and read by the renderer, which invents nothing. A description\n     that wants a different encoding names a different table; it never states a\n     colour, for the reason ADR-graph-ui-v0-009-01 gives.\n\n     THE TUI DRAWS IT AS A LIST. A terminal has no plane to lay a graph out on,\n     so the TUI prints the focus and then one line per neighbour, `relation →\n     label`. That is real parity for the question the pane answers, not a\n     placeholder — the same choice :highlight-list made\n     (ADR-graph-ui-v0-007-01).",
     :status :in-progress,
     :props
     [:map
      [:subgraph
       {:optional true}
       [:maybe
        [:map
         [:focus {:optional true} [:maybe :string]]
         [:depth {:optional true} :int]
         [:relations {:optional true} [:vector :keyword]]
         [:nodes
          [:vector
           [:map
            [:id :string]
            [:label :string]
            [:frame-type {:optional true} [:maybe :keyword]]
            [:partition {:optional true} [:maybe :keyword]]
            [:hops :int]
            [:focus? {:optional true} :boolean]]]]
         [:edges
          [:vector
           [:map
            [:from :string]
            [:to :string]
            [:relation :keyword]
            [:derived? {:optional true} :boolean]
            [:inferred? {:optional true} :boolean]]]]
         [:count {:optional true} :int]
         [:edge-count {:optional true} :int]
         [:truncated? {:optional true} :boolean]
         [:omitted {:optional true} :int]]]]
      [:layout {:optional true} [:enum :radial :force :tree]]
      [:caption {:optional true} :boolean]
      [:legend {:optional true} :boolean]
      [:encoding {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:title {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults
     {:layout :radial,
      :caption true,
      :legend true,
      :encoding "design/graph-encoding.edn"},
     :children :none,
     :box-from :content},
    :text-input
    {:description
     "Mantine `TextInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "TextInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :highlight-list
    {:description
     "The document's highlights, listed beside it — ikc1's right gutter\n     (F-platform-v0-011-01, ADR-graph-ui-v0-017-01 §5). One row per highlight: a\n     dot in the highlight's own colour, the level badge when a level is set, the\n     marked text on ONE line (truncated, because a chunk-sized highlight is\n     paragraphs long and the gutter is a column), the note when there is one, and\n     an X that removes it, and — when the description wires a :link gesture — a\n     control that copies a wikilink to that mark, for pasting into a note.\n\n     THREE ACTS, AND NONE IS ANOTHER (2026-08-24). A row's click GOES to the\n     words. The link control COPIES a link. The X REMOVES it. George asked for\n     that split by name: \"without this click on bookmark to delete it, have some\n     more narrow way to delete it\".\n\n     NOT NAMED :highlight, which is taken — the generated Mantine `Highlight`\n     kind below marks substrings matching a search term and is unrelated. Two\n     things called highlight in one closed vocabulary would be a trap for every\n     later reader.\n\n     :items is the bound prop and its shape is :highlights/for-page's result\n     VERBATIM, whichever storage served it: a native page's highlights arrive as\n     block-relative and a vault page's as file-relative, and this widget cannot\n     tell, which is the point (ADR-ikc-v3-064-01 §3).\n\n     ORPHANED ROWS STAY LISTED, dimmed. A highlight whose text has been edited\n     away is a fact worth seeing — 'you marked this and it is gone' — and hiding\n     it would be the one behaviour that loses information silently\n     (CONCEPT-ikc-v3-008-01).\n\n     ONE GESTURE, :remove, $value = the row's :id — and since v2.1-SNAPSHOT a\n     second, :set-level (PLAN-ikc-v3-026-01 Phase D): when the description\n     wires it, each row carries a picker for the highlight's LAYER, 1 to 5\n     (RESEARCH-ikc-v3-021-01 D5), and firing it hands $value {:highlight-id\n     :level}. Creating a highlight is not a\n     gutter affordance: you make one by selecting text in the document, so there\n     is deliberately no empty-state gesture here and no :empty-reachable entry\n     below — a gutter with nothing in it is a document with nothing marked, and\n     the way out is in the document, not the gutter.\n\n     :title IS OPTIONAL AND MEANS A HEADER. Without one the column draws no\n     caption — which is what the reading area asks for, because the gutter sits\n     directly beside the text with each row level with the words it marks, and a\n     caption over that labels the self-evident. It captioned itself\n     unconditionally while it was a panel out at the pane's right edge; George\n     struck that panel through on 2026-08-16, saying the highlight in it\n     'belongs to the right gutter'. THE RIGHT GUTTER IS THIS, AND THERE IS ONLY\n     ONE — the per-row `2 hl` chip column that briefly sat between the text and\n     this one is gone (see the :outline kind).",
     :status :in-progress,
     :props
     [:map
      [:level-with-text {:optional true} :boolean]
      [:items
       {:optional true}
       [:vector
        [:map
         [:id :string]
         [:anchor-text :string]
         [:color :keyword]
         [:block-id {:optional true} :string]
         [:start {:optional true} :int]
         [:end {:optional true} :int]
         [:level {:optional true} :int]
         [:note {:optional true} :string]
         [:orphaned {:optional true} [:maybe :boolean]]
         [:relocated {:optional true} [:maybe :boolean]]
         [:created-at {:optional true} :string]
         [:created-by {:optional true} :string]]]]
      [:title {:optional true} :string]
      [:empty-label {:optional true} :string]
      [:chrome {:optional true} :boolean]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:chrome true},
     :children :none,
     :box-from :content},
    :container
    {:description
     "A centred, max-width content column — Mantine `Container`\n     (ADR-graph-ui-v0-013-01 Sec20). SPEC-graph-ui-v0-002-01's locked target\n     centres its reading pane in a `max-width: 900px` column; nothing else in\n     v2.0 can say that, so a reading UI otherwise runs its prose edge-to-edge\n     on a wide monitor — a legibility defect, not a cosmetic one, in the\n     island whose whole purpose is reading.\n\n     :size is Mantine's own max-width scale: :xs 540 / :sm 720 / :md 960 /\n     :lg 1140 / :xl 1320 pixels, read from the shipped styles.css rather than\n     recalled. (Corrected 2026-07-28: this rule first said :md 768 / :lg 992,\n     which are Mantine's BREAKPOINT values, not its container sizes. The error\n     put the reading column at 1140px — wider than the target instead of nearer\n     it.) :fluid takes the parent's full width and ignores :size.\n\n     OPEN SINCE ADR-graph-ui-v0-001-01. :size also accepts a NUMBER (pixels) or any\n     CSS length string, which is Mantine's own documented contract — the size\n     prop accepts any valid CSS value or a number. It was closed to five tokens\n     by 057-01 Sec0, and that clamp is what this declaration used to confess to:\n     'the enum cannot express 900 exactly, which is the standing trade'.\n\n     The trade was worse than lossy. CONCEPT-graph-ui-v0-009-01 defines measure\n     as Bringhurst does — the length of a line counted in CHARACTERS — and a\n     measure in pixels is not a measure: change the type size and the line\n     length moves while :md does not. So a reading column says {:size \"66ch\"}\n     and means it, instead of naming the nearest breakpoint token and hoping.\n     The tokens remain valid and remain the ordinary case for non-prose widths.\n\n     The renderer lays a :container out as a flex COLUMN, so that a child\n     carrying :flex 1 fills it. Mantine's Container is a plain block element,\n     and a :flex 1 child inside a block parent silently falls back to its own\n     content height (measured: a 180px reading pane inside a 986px column). Mantine's :strategy ('block' | 'grid') is deliberately NOT\n     adopted: no consumer needs grid-centring, and an unused prop is a\n     promise the renderer has to keep.",
     :children :any,
     :needs :inline,
     :self-flex :inline,
     :defaults {:size :lg},
     :box-to-children :flex-column,
     :status :in-progress,
     :box-from :parent,
     :props
     [:map
      [:size
       {:optional true}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:fluid {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]]},
    :indicator
    {:description
     "Mantine `Indicator` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 11 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Indicator"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:disabled
       {:optional true, :doc "If set, the indicator is hidden"}
       :boolean]
      [:inline
       {:optional true,
        :doc
        "Determines whether the indicator container should be an inline element"}
       :boolean]
      [:offset
       {:optional true,
        :doc
        "Indicator offset relative to the target element, usually used for elements with border-radius"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Indicator position relative to the target element"}
       [:enum
        :top-end
        :top-start
        :bottom-end
        :bottom-start
        :top-center
        :bottom-center
        :middle-center
        :middle-end
        :middle-start]]
      [:processing
       {:optional true,
        :doc "If set, the indicator has processing animation"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Indicator width and height"}
       [:or :string :int :double]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:z-index
       {:optional true, :doc "Indicator z-index"}
       [:or :string :int :double]]],
     :defaults
     {:inline false,
      :position :top-end,
      :processing false,
      :radius 100,
      :size 10,
      :z-index 200},
     :slots [:label],
     :children :slots,
     :box-from :content},
    :stack
    {:description
     "Vertical stack — Mantine `Stack`, the common default arrangement\n     (ADR-graph-ui-v0-013-01 Sec0). :gap/:align/:justify keep Mantine's names;\n     values closed (Sec0).",
     :status :in-progress,
     :props
     [:map
      [:gap {:optional true} [:enum :xs :sm :md :lg :xl]]
      [:align
       {:optional true}
       [:enum :start :center :end :stretch :baseline]]
      [:justify
       {:optional true}
       [:enum :start :end :center :between :around]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :flex-column},
    :outline
    {:description
     "ADR-graph-ui-v0-006-01: a flat, :order-sorted list of typed blocks, nested\n     VISUALLY by each item's :depth (never a real tree — the native\n     block-frame engine keeps every block a flat :child-of child of its\n     page). :items is optional: a bound :outline gets its list from a\n     source (:block-outline). Each item is {:block-id uuid-str :block-type\n     kw :content string :order number :depth int :checked? bool :collapsed?\n     bool}.\n\n     THERE IS NO :meta PROP. ADR-graph-ui-v0-013-01 Sec17 accepted one — a\n     trailing chip/badge gutter, third track in every row, captured from ikc1\n     by SPEC-graph-ui-v0-002-01 (`30px / 1fr / 132px`). Removed 2026-08-15,\n     George: \"What is this invented meta-gutter? The right gutter is the place\n     for meta information, no extra gutters.\" ikc3 has one margin beside the\n     document (F-platform-v0-011-01) that ikc1 did not, and meta about a block\n     belongs there; two gutters is two places to look for one kind of thing.\n     Nothing ever emitted :meta in production, so nothing is lost — the\n     reversal is recorded in that same ADR's Sec17. A deeper\n     item whose ancestor has :collapsed? true is hidden by the renderer, not\n     the source. Dispatches :on-gesture's named keys (ADR-graph-ui-v0-013 Sec7-8,\n     replacing v1.x's :actions): :indent/:outdent/:toggle-done/\n     :toggle-collapse/:delete/:insert-after/:update-text/:insert-first.\n     $value's meaning is still per gesture key (row actions: the acted-on\n     item's :block-id; :update-text: the edited text) but documented once, on\n     :on-gesture itself, not re-derived here.\n\n     :insert-first is the EMPTY state's gesture, and the only one that fires\n     when there are no items. Every other gesture acts on a row, so a page with\n     no blocks could not be given one: :insert-after needs a block to insert\n     after, and the empty state rendered as inert text. A note editor that\n     cannot accept its first character is not an editor, and the gap was\n     invisible until a wiped graph produced an empty page (2026-08-03). It\n     carries no $value — the target page is the session's selected one, which\n     the handler resolves, because the empty state has no row to name it.\n\n     :row-menu declares WHICH of the gestures above a row offers, in what order,\n     and how each is labelled. One list, rendered twice: as the hover strip on a\n     row and as the right-click context menu over it. Before this the strip was\n     four buttons hand-written in widgets.cljs, so adding an action cost three\n     edits in three languages — a command in this manifest, a gesture in the\n     description, and a button in ClojureScript. The gestures were declared; only\n     their PRESENTATION was not (2026-08-03).\n\n     Each entry is {:gesture <a key of this node's :on-gesture> :label <string>\n     :icon <string, optional> :tone <token, optional> :divider-before <bool,\n     optional>} — deliberately the same :label/:gesture/:tone shape v2.0's :menu\n     items use, so the two read alike. :row-menu is not a :menu widget, though:\n     a menu over a ROW must act on THAT row, and :menu's items have no notion of\n     which row they are over. The outline's gestures already carry the row id\n     through $value, so the same list renders as both the hover strip and the\n     right-click menu without any selected-block state to feed it. validate-dsl fails an entry naming a gesture the node does not\n     wire — a menu item that dispatches nothing looks identical to one that\n     works until it is clicked.\n\n     Omitting :row-menu means NO row affordances, which is a real choice for a\n     read-only outline rather than a reason to fall back to a built-in default:\n     a hidden default is how the hardcoded strip survived unnoticed.\n\n     :slash-menu declares the commands a row offers when its text begins with\n     '/' — the outliner idiom where typing turns a block into a to-do, a\n     separator, or a date without leaving the keyboard. Same shape as :row-menu\n     with one addition: :trigger is what you type after the slash, and what the\n     list filters on as you keep typing.\n\n     Each entry is {:trigger <string> :gesture <a key of :on-gesture>\n     :label <string> :icon <string, optional>}. validate-dsl fails an entry\n     naming a gesture the node does not wire, and fails two entries sharing a\n     :trigger — an ambiguous trigger picks one silently, and which one depends\n     on map ordering nobody declared.\n\n     The gesture's own template carries whatever the command needs (/todo and\n     /--- are both :ui/set-block-type with different literal :block-type args),\n     so a new slash command is usually a gesture plus a line here, and no\n     renderer change at all.\n\n     :completions declares what a TRIGGER CHARACTER inside a row offers. Same\n     idea as :slash-menu and a different shape, because the two answer different\n     questions. A slash menu is a CLOSED list of commands, declared here, and a\n     pick DISPATCHES one. A completion is an OPEN list of data — the tag\n     vocabulary is about 300 strings and grows as a person writes — so the list\n     cannot live in this file, and a pick DISPATCHES NOTHING. It splices text\n     into the buffer and the ordinary edit path carries it from there.\n\n     Each entry is {:trigger <one character> :items <a prop of this node>}. The\n     items arrive through an ordinary per-prop bind, so both bind runtimes fill\n     it generically and neither needs to know what a completion is. The trigger\n     matches at a WORD BOUNDARY before the caret, not at the start of the buffer:\n     a hashtag is written mid-sentence, and a slash command is not.\n\n     WHY A PICK DISPATCHES NOTHING, and it is the whole reason the two mechanisms\n     are separate. A `#` pick writes text. On a file-backed page the next scan\n     indexes it. On a native page the tags context's block-event subscriber\n     indexes it (ADR-ikc-v3-080-01 decision 3). Either way the tag reaches the\n     tree through the text, which is the one storage that cannot disagree with\n     what a person actually wrote.\n\n     validate-dsl fails an entry with no :trigger, two entries sharing one, and\n     an :items that does not name a prop this kind declares — a completion\n     pointing at nothing opens an empty popup and looks broken.\n\n     TUI renders read-only (gutters/numbering only, no dispatch).",
     :status :in-progress,
     :props
     [:map
      [:items {:optional true} [:vector :any]]
      [:highlights {:optional true} [:vector [:map-of :keyword :any]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]
      [:row-menu
       {:optional true}
       [:vector
        [:map
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:divider-before {:optional true} :boolean]]]]
      [:slash-menu
       {:optional true}
       [:vector
        [:map
         [:trigger :string]
         [:gesture :keyword]
         [:label :string]
         [:icon {:optional true} :string]]]]
      [:completions
       {:optional true}
       [:vector [:map [:trigger :string] [:items :keyword]]]]
      [:tag-suggestions {:optional true} [:vector :string]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :typography
    {:description
     "Mantine `Typography` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 0 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Typography"},
     :props [:map],
     :defaults {},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :angle-slider
    {:description
     "Mantine `AngleSlider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 4\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "AngleSlider"},
     :props
     [:map
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "Sets `data-disabled` attribute, disables interactions"}
       :boolean]
      [:marks
       {:optional true, :doc "Array of marks displayed on the slider"}
       [:vector :any]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:restrict-to-marks
       {:optional true,
        :doc
        "If set, the selection is allowed only from the given marks array"}
       :boolean]
      [:size
       {:optional true, :doc "Slider size in px"}
       [:or :int :double]]
      [:step
       {:optional true, :doc "Step between values"}
       [:or :int :double]]
      [:thumb-size
       {:optional true,
        :doc
        "Size of the thumb in px. Calculated based on the `size` value by default."}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]
      [:with-label
       {:optional true,
        :doc "If set, the label is displayed inside the slider"}
       :boolean]],
     :defaults {:restrict-to-marks false, :step 1, :with-label true},
     :gestures [:change :change-end :scrub-end :scrub-start],
     :children :none,
     :box-from :content},
    :dialog
    {:description
     "Mantine `Dialog` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 10 prop(s), 1 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped {"position" "AffixPosition"},
     :defaults
     {:size :md,
      :with-close-button true,
      :within-portal true,
      :z-index 200},
     :box-to-children :block-flow,
     :mantine {:component "Dialog"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close],
     :props
     [:map
      [:keep-mounted
       {:optional true,
        :doc
        "If set, dialog is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:opened {:optional true, :doc "Opened state"} :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS value to set `box-shadow`"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls `width` of the dialog"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-border
       {:optional true, :doc "Adds border to the root element"}
       :boolean]
      [:with-close-button
       {:optional true, :doc "If set, the close button is displayed"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether the component is rendered within `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Root element `z-index` property"}
       [:or :string :int :double]]]},
    :pills-input
    {:description
     "Mantine `PillsInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 13 prop(s), 5 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "PillsInput"},
     :props
     [:map
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]],
     :defaults
     {:left-section-pointer-events "none",
      :pointer false,
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :slots [:description :error :label :left-section :right-section],
     :children :slots,
     :box-from :content},
    :combobox
    {:description
     "Mantine `Combobox` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 1 named\n     child slot(s), 7 gesture(s), and 6 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"dropdownPadding" "Padding<string | number>",
      "middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "store" "ComboboxStore",
      "width" "PopoverWidth"},
     :defaults
     {:reset-selection-on-option-hover false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :floating-strategy :absolute,
      :arrow-offset 5,
      :size :sm,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "Combobox"},
     :status :generated,
     :box-from :content,
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :option-submit
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true,
        :doc "Determines whether the `Combobox` value can be changed"}
       :boolean]
      [:reset-selection-on-option-hover
       {:optional true,
        :doc
        "Determines whether selection should be reset when option is hovered"}
       :boolean]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true,
        :doc "Controls items `font-size` and `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :image
    {:description
     "Mantine `Image` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 4 prop(s), 1\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped {"src" "any"},
     :defaults {:fit :cover, :radius 0},
     :mantine {:component "Image"},
     :status :generated,
     :box-from :content,
     :gestures [:error],
     :props
     [:map
      [:fallback-src
       {:optional true,
        :doc
        "Image url used as a fallback if the image cannot be loaded"}
       :string]
      [:fit
       {:optional true, :doc "Controls `object-fit` style"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :fill
        :none
        :contain
        :cover
        :scale-down]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :autocomplete
    {:description
     "Mantine `Autocomplete` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 27 prop(s), 5 named\n     child slot(s), 5 gesture(s), and 3 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped
     {"data" "ComboboxStringData",
      "filter" "OptionsFilter",
      "renderOption" "RenderAutocompleteOption"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :clearable false,
      :right-section-pointer-events "none",
      :size :sm,
      :auto-select-on-blur false,
      :open-on-focus true,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "Autocomplete"},
     :status :generated,
     :box-from :content,
     :gestures
     [:change :clear :dropdown-close :dropdown-open :option-submit],
     :props
     [:map
      [:auto-select-on-blur
       {:optional true,
        :doc
        "If set, the highlighted option is selected when the input loses focus"}
       :boolean]
      [:clearable
       {:optional true,
        :doc
        "If set, the clear button is displayed when the component has a value"}
       :boolean]
      [:default-dropdown-opened
       {:optional true,
        :doc "Uncontrolled dropdown initial opened state"}
       :boolean]
      [:default-value
       {:optional true,
        :doc "Default value for uncontrolled component"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:dropdown-opened
       {:optional true, :doc "Controlled dropdown opened state"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:limit
       {:optional true,
        :doc
        "Maximum number of options displayed at a time, `Infinity` by default"}
       [:or :int :double]]
      [:max-dropdown-height
       {:optional true,
        :doc
        "`max-height` of the dropdown, only applicable when `withScrollArea` prop is `true`, `250` by default"}
       [:or :string :int :double]]
      [:open-on-focus
       {:optional true,
        :doc
        "If set, the dropdown opens when the input receives focus"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:select-first-option-on-change
       {:optional true,
        :doc
        "If set, the first option is selected when value changes, `false` by default"}
       :boolean]
      [:select-first-option-on-dropdown-open
       {:optional true,
        :doc
        "If set, the first option is selected when dropdown opens, `false` by default"}
       :boolean]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]
      [:with-scroll-area
       {:optional true,
        :doc
        "Determines whether the options should be wrapped with `ScrollArea.AutoSize`, `true` by default"}
       :boolean]]},
    :hover-card
    {:description
     "Mantine `HoverCard` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 32 prop(s), 1 named\n     child slot(s), 6 gesture(s), and 4 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"middlewares" "PopoverMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "width" "PopoverWidth"},
     :defaults
     {:trap-focus false,
      :return-focus false,
      :arrow-radius 0,
      :with-arrow false,
      :with-roles true,
      :floating-strategy :absolute,
      :close-on-click-outside true,
      :arrow-offset 5,
      :within-portal true,
      :hide-detached true,
      :z-index 300,
      :close-on-escape true,
      :position :bottom,
      :arrow-size 7,
      :with-overlay false},
     :box-to-children :block-flow,
     :mantine {:component "HoverCard"},
     :status :generated,
     :box-from :viewport,
     :gestures
     [:close
      :dismiss
      :enter-transition-end
      :exit-transition-end
      :open
      :position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:click-outside-events
       {:optional true, :doc "Events that trigger outside clicks"}
       [:vector :string]]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:close-on-click-outside
       {:optional true,
        :doc
        "Determines whether dropdown should be closed on outside clicks"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "Determines whether dropdown should be closed when `Escape` key is pressed"}
       :boolean]
      [:default-opened
       {:optional true,
        :doc "Initial opened state for uncontrolled component"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, popover dropdown will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:hide-detached
       {:optional true,
        :doc
        "If set, the dropdown is hidden when the element is hidden with styles or not visible on the screen"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id base to create accessibility connections"}
       :string]
      [:initially-opened
       {:optional true, :doc "Initial opened state"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the dropdown is not unmounted from the DOM when hidden. `display: none` styles are added instead."}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:position
       {:optional true,
        :doc "Dropdown position relative to the target element"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:prevent-position-change-when-visible
       {:optional true,
        :doc
        "Prevents popover from flipping/shifting when it the dropdown is visible"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "Determines whether focus should be automatically returned to control when dropdown closes"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any other valid CSS `box-shadow` value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:trap-focus
       {:optional true,
        :doc
        "Determines whether focus should be trapped within dropdown"}
       :boolean]
      [:variant {:optional true} :string]
      [:with-arrow
       {:optional true,
        :doc "Determines whether component should have an arrow"}
       :boolean]
      [:with-overlay
       {:optional true,
        :doc
        "Determines whether the overlay should be displayed when the dropdown is opened"}
       :boolean]
      [:with-roles
       {:optional true,
        :doc
        "Determines whether dropdown and target elements should have accessible roles"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether dropdown should be rendered within the `Portal`"}
       :boolean]
      [:z-index
       {:optional true, :doc "Dropdown `z-index`"}
       [:or :string :int :double]]]},
    :anchor
    {:description
     "Mantine `Anchor` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :status :generated,
     :mantine {:component "Anchor"},
     :props
     [:map
      [:color {:optional true} [:or :keyword :string]]
      [:gradient
       {:optional true,
        :doc
        "Gradient configuration, ignored when `variant` is not `gradient`"}
       [:map
        [:from :string]
        [:to :string]
        [:deg {:optional true} :int :double]]]
      [:inherit
       {:optional true,
        :doc
        "Determines whether font properties should be inherited from the parent"}
       :boolean]
      [:inline
       {:optional true, :doc "Sets `line-height` to 1 for centering"}
       :boolean]
      [:line-clamp
       {:optional true,
        :doc "Number of lines after which Text will be truncated"}
       [:or :int :double]]
      [:size
       {:optional true, :doc "Controls `font-size` and `line-height`"}
       [:or [:enum :xs :sm :md :lg :xl] :string]]
      [:truncate
       {:optional true,
        :doc
        "Side on which Text must be truncated, if `true`, text is truncated from the start"}
       [:enum :end :start]]
      [:underline
       {:optional true,
        :doc
        "Defines when `text-decoration: underline` styles are applied."}
       [:enum :always :hover :not-hover :never]]],
     :defaults {:inherit false, :inline false, :size :md},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :stepper
    {:description
     "Mantine `Stepper` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :defaults
     {:allow-next-steps-select true,
      :icon-position :left,
      :orientation :horizontal,
      :radius :xl,
      :wrap true},
     :box-to-children :block-flow,
     :mantine {:component "Stepper"},
     :status :generated,
     :box-from :content,
     :gestures [:step-click],
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active step"}
       [:or :int :double]]
      [:allow-next-steps-select
       {:optional true, :doc "If set, next steps can be selected"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls colors of active and progress steps"}
       [:or :keyword :string]]
      [:completed-icon
       {:optional true,
        :doc
        "Step icon displayed when step is completed, check icon by default"}
       :boolean]
      [:content-padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `padding-top` of the content"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:icon
       {:optional true,
        :doc "Step icon, default value is `step index + 1`"}
       :boolean]
      [:icon-position
       {:optional true, :doc "Icon position relative to the step body"}
       [:enum :left :right]]
      [:icon-size
       {:optional true,
        :doc
        "Controls size of the step icon, by default icon size is inferred from `size` prop"}
       [:or :string :int :double]]
      [:orientation
       {:optional true, :doc "Stepper orientation"}
       [:enum :horizontal :vertical]]
      [:progress-icon
       {:optional true,
        :doc
        "Step icon displayed when step is in progress, default value is `step index + 1`"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set steps border-radius"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls size of various Stepper elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:wrap
       {:optional true,
        :doc
        "Determines whether steps should wrap to the next line if no space is available"}
       :boolean]]},
    :input
    {:description
     "A single-line text input. The renderer maintains the edit buffer and,\n     on Enter, dispatches :on-gesture's :submit key (ADR-graph-ui-v0-013-01\n     Sec7-8, replacing v1.x's :on-submit). :leading-icon (ADR-graph-ui-v0-013 Sec17): an\n     optional :icon name shown at the input's leading edge — Mantine's\n     `leftSection`, the search field's magnifying glass. :state: a\n     validation/enablement hint — :invalid highlights the field, :disabled\n     greys it out and blocks edits. :variant (ADR-graph-ui-v0-013-01 Sec21):\n     Mantine's own InputVariant enum verbatim ('default' | 'filled' |\n     'unstyled'). :unstyled drops the field chrome, so an editable page title\n     paired with the universal :size :h1 reads as a HEADING rather than as a\n     form control — the locked target's 27px editable h1, expressed entirely\n     in Mantine's vocabulary rather than an ikc3 invention.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:leading-icon {:optional true} :keyword]
      [:variant {:optional true} [:enum :default :filled :unstyled]]
      [:multiline {:optional true} :boolean]
      [:reset-key {:optional true} [:maybe :string]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :dock
    {:description
     "THE ARRANGEMENT OF PANES, and the only kind that does not draw one —\n     ADR-graph-ui-v0-026-01. dockview owns level 5 of\n     CONCEPT-graph-ui-v0-014-01: it arranges PANES, and levels 4 and below\n     arrange what is inside one. That boundary is why ADR-013's single layout\n     model became one model PER SURFACE.\n\n     IT HOLDS NO GEOMETRY, and that is the decision rather than an omission.\n     Sizes, positions, split ratios and tab order are a VALUE the person owns —\n     api.toJSON() — stored on their session frame (ADR-graph-ui-v0-025-01 Sec4),\n     so an arrangement travels to the phone in their pocket. A description that\n     stated geometry would be a second authority over the same fact, and the\n     one-authority rule refuses that. This kind is the level-2 DOOR to a level-5\n     authority and nothing more.\n\n     EACH CHILD IS ONE PANE. The child's :title is the tab label and its\n     :import-id is the panel id, so a pane keeps its identity across a reload —\n     the same convention :tab-set already uses for its child boxes. A child\n     needs no other prop to be a pane.\n\n     ONLY A PERSON'S MOVE IS A COMMAND. dockview's onWillMutateLayout reports\n     :origin user or api. An api change is our own render, and echoing it back\n     as a person's choice is the defect class CONCEPT-ikc-v3-012-01 records.\n\n     :split-pane STAYS FROZEN (ADR-graph-ui-v0-025-01 Sec5). It holds exactly\n     two panes and cannot be the class for four.",
     :status :in-progress,
     :props
     [:map
      [:fallback {:optional true} [:enum :stack :first]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {:fallback :stack},
     :children :any,
     :box-from :parent,
     :needs :both,
     :box-to-children :definite},
    :timeline
    {:description
     "Mantine `Timeline` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), 1 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :status :generated,
     :mantine {:component "Timeline"},
     :props
     [:map
      [:active
       {:optional true, :doc "Index of the active element"}
       [:or :int :double]]
      [:align
       {:optional true,
        :doc "Position of content relative to the bullet"}
       [:enum :left :right]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:bullet-size
       {:optional true, :doc "Size of the bullet"}
       [:or :string :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to control active item colors"}
       [:or :keyword :string]]
      [:line-width
       {:optional true, :doc "Control width of the line"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:reverse-active
       {:optional true,
        :doc
        "If set, the active items direction is reversed without reversing items order"}
       :boolean]],
     :defaults
     {:align :left,
      :bullet-size 20,
      :radius :xl,
      :reverse-active false},
     :children :any,
     :box-from :content,
     :box-to-children :block-flow},
    :password-input
    {:description
     "Mantine `PasswordInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 15 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"visibilityToggleIcon" "FC<{ reveal: boolean; }>"},
     :slots [:description :error :label :left-section :right-section],
     :defaults
     {:left-section-pointer-events "none",
      :required false,
      :right-section-pointer-events "none",
      :size :sm,
      :with-asterisk false,
      :with-error-styles true},
     :mantine {:component "PasswordInput"},
     :status :generated,
     :box-from :content,
     :gestures [:visibility-change],
     :props
     [:map
      [:default-visible
       {:optional true,
        :doc "If set, the input value is visible by default"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:visible
       {:optional true,
        :doc "If set, the input value is visible visible"}
       :boolean]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :progress
    {:description
     "Mantine `Progress` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "Progress"},
     :props
     [:map
      [:animated
       {:optional true,
        :doc
        "If set, the sections stripes are animated, `striped` prop is ignored"}
       :boolean]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS value"}
       [:or :keyword :string]]
      [:orientation
       {:optional true, :doc "Controls orientation"}
       [:enum :horizontal :vertical]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls track height"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:striped
       {:optional true, :doc "If set, the section has stripes"}
       :boolean]
      [:transition-duration
       {:optional true,
        :doc
        "Controls sections width transition duration, value is specified in ms"}
       [:or :int :double]]
      [:value
       {:optional true, :doc "Value of the progress"}
       [:or :int :double]]],
     :defaults
     {:animated false,
      :orientation :horizontal,
      :size :md,
      :striped false,
      :transition-duration 100},
     :children :none,
     :box-from :content},
    :badge
    {:description
     "A static label pill — Mantine `Badge` (ADR-graph-ui-v0-013-01 Sec13). Also\n     covers the 'status LED' row: :label absent + :circle true + a small\n     implicit size IS a state-coloured dot, deliberately not a seventh\n     kind. Non-interactive — no :on-gesture.",
     :status :in-progress,
     :props
     [:map
      [:label {:optional true} :string]
      [:circle {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :table-of-contents
    {:description
     "Mantine `TableOfContents` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 8 prop(s), and 1\n     prop(s) whose type carries no data contract (see :unmapped). RENDERED\n     GENERICALLY: graph-ui.web.mantine-generic drives the component named above\n     straight from this declaration — the props here are the legal ones, the\n     gestures here are the wired ones, and nothing else reaches the DOM.\n     Generic is not finished: this kind has no data binding, no edit buffer and\n     no selection state of its own. A kind that needs one of those graduates to\n     a hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.",
     :status :generated,
     :mantine {:component "TableOfContents"},
     :props
     [:map
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color value"}
       [:or :keyword :string]]
      [:depth-offset
       {:optional true,
        :doc
        "Controls padding on the left side of control, multiplied by (`depth` - `minDepthToOffset`), `20px` by default"}
       [:or :string :int :double]]
      [:initial-data
       {:optional true,
        :doc
        "Data used to render content until actual values are retrieved from the DOM"}
       [:vector :any]]
      [:min-depth-to-offset
       {:optional true,
        :doc
        "Minimum `depth` value that requires offset, `1` by default"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true,
        :doc "Controls font-size and padding of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:size :md},
     :unmapped {"scrollSpyOptions" "UseScrollSpyOptions"},
     :children :none,
     :box-from :content},
    :breadcrumbs
    {:description
     "Mantine `Breadcrumbs` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 1 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. TAKES CHILDREN: Mantine declares `children`, so a\n     child that names no slot is ordinary body content.",
     :children :any,
     :slots [:separator],
     :defaults {:separator-margin :xs},
     :box-to-children :block-flow,
     :mantine {:component "Breadcrumbs"},
     :status :generated,
     :box-from :content,
     :props
     [:map
      [:separator-margin
       {:optional true,
        :doc "Controls spacing between separator and breadcrumb"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]]},
    :pin-input
    {:description
     "Mantine `PinInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 22 prop(s), 2\n     gesture(s), and 1 prop(s) whose type carries no data contract (see\n     :unmapped). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :children :none,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :defaults
     {:mask false,
      :one-time-code true,
      :placeholder "○",
      :type :alphanumeric,
      :size :sm,
      :manage-focus true,
      :gap :md,
      :length 4,
      :auto-focus false},
     :mantine {:component "PinInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change :complete],
     :props
     [:map
      [:aria-label
       {:optional true, :doc "`aria-label` attribute"}
       :string]
      [:auto-focus
       {:optional true,
        :doc
        "If set, the first input is focused when component is mounted"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true, :doc "Adds disabled attribute to all inputs"}
       :boolean]
      [:error
       {:optional true,
        :doc
        "Sets `aria-invalid` attribute and applies error styles to all inputs"}
       :boolean]
      [:form
       {:optional true, :doc "Hidden input `form` attribute"}
       :string]
      [:gap
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set `gap` between inputs, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:id
       {:optional true,
        :doc "Base id used to generate unique ids for inputs"}
       :string]
      [:input-mode
       {:optional true,
        :doc
        "`inputmode` attribute, inferred from the `type` prop if not specified"}
       [:enum :search :text :none :tel :email :url :numeric :decimal]]
      [:input-type
       {:optional true,
        :doc
        "Inputs `type` attribute, inferred from the `type` prop if not specified"}
       [:or
        [:enum
         :number
         :button
         :search
         :time
         :image
         :text
         :hidden
         :color
         :radio
         :checkbox
         :tel
         :password
         :date
         :datetime-local
         :email
         :file
         :month
         :range
         :reset
         :submit
         :url
         :week]
        :string]]
      [:length
       {:optional true, :doc "Number of inputs"}
       [:or :int :double]]
      [:manage-focus
       {:optional true,
        :doc
        "Determines whether focus should be moved automatically to the next input once filled"}
       :boolean]
      [:mask
       {:optional true, :doc "Changes input type to `\"password\"`"}
       :boolean]
      [:name
       {:optional true, :doc "Hidden input `name` attribute"}
       :string]
      [:one-time-code
       {:optional true,
        :doc
        "Determines whether `autocomplete=\"one-time-code\"` attribute should be set on all inputs"}
       :boolean]
      [:placeholder
       {:optional true, :doc "Inputs placeholder"}
       :string]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:read-only
       {:optional true, :doc "If set, the user cannot edit the value"}
       :boolean]
      [:size
       {:optional true, :doc "Controls inputs `width` and `height`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:type
       {:optional true, :doc "Determines which values can be entered"}
       [:or [:enum :number :alphanumeric] :string]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]]},
    :code-view
    {:description
     "A whole source FILE, shown the way an editor shows one: syntax colour, line\n     numbers, code folding, and the corpus ids and handler symbols inside the\n     text rendered as links that navigate to the frames they name. Read-only.\n     :value is the file body and :language the grammar to colour it with, both\n     normally bound to a source rather than written in the description. The TUI\n     renders it as plain monospaced text, as it does every code widget here.\n\n     Distinct from :code-block, which is a snippet inside a document and needs\n     only colour.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:language {:optional true} :keyword]
      [:line-numbers {:optional true} :boolean]
      [:folding {:optional true} :boolean]
      [:links
       {:optional true}
       [:vector [:map [:text :string] [:frame-id :string]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {:line-numbers true, :folding true},
     :children :none,
     :box-from :parent,
     :needs :block,
     :self-flex :block},
    :coach-mark
    {:description
     "A GUIDE'S POINTER (PLAN-ikc-v3-028-01 Phase D). The CARD draws where the\n     description puts it, in flow — the Guide pane — with :title, :says,\n     `index / count`, and the buttons: `Previous` and `Next` fire :previous and :next with $value = the\n     step's number to show; `Do it for me` fires :submit; `Resume` (drawn when\n     :pinned?) fires :resume; `Start again` (drawn when :done-all?) fires\n     :restart. :dim? draws a translucent overlay over the rest of the island, so\n     the eye goes to the target. :has-do? false, or :done? true, disables `Do it\n     for me` — the step is done by hand, and :says names the key, or it is done\n     already and the header says so.\n\n     WHAT FLOATS is the target's ring and a small badge with the step's number,\n     at the corner of the widget whose root carries data-import-id = :target\n     (the renderer stamps every root). A card floated beside a column of\n     controls covered one of them every time (2026-09-08), so the card does not\n     float. With no such element on the screen there is no badge and the card\n     still says the step — never nothing. The mark is STATELESS: everything it\n     shows is bound from :guide-current, and every button is one declared\n     command.",
     :status :in-progress,
     :props
     [:map
      [:target {:optional true} :string]
      [:step {:optional true} :string]
      [:title {:optional true} :string]
      [:says {:optional true} :string]
      [:index {:optional true} :int]
      [:count {:optional true} :int]
      [:has-do? {:optional true} :boolean]
      [:done? {:optional true} :boolean]
      [:pinned? {:optional true} :boolean]
      [:done-all? {:optional true} :boolean]
      [:dim? {:optional true} :boolean]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]],
     :defaults {:dim? false},
     :children :none,
     :box-from :content},
    :json-input
    {:description
     "Mantine `JsonInput` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 20 prop(s), 6 named\n     child slot(s), 1 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :slots
     [:description
      :error
      :label
      :left-section
      :right-section
      :validation-error],
     :defaults
     {:autosize false,
      :left-section-pointer-events "none",
      :format-on-blur false,
      :right-section-pointer-events "none",
      :resize :none,
      :size :sm,
      :pointer false,
      :with-asterisk false,
      :with-error-styles true,
      :required false},
     :mantine {:component "JsonInput"},
     :status :generated,
     :box-from :content,
     :gestures [:change],
     :props
     [:map
      [:autosize
       {:optional true,
        :doc
        "If set, enables textarea height growing with its content"}
       :boolean]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       :string]
      [:disabled
       {:optional true,
        :doc "Sets `disabled` attribute on the `input` element"}
       :boolean]
      [:format-on-blur
       {:optional true,
        :doc
        "Determines whether the value should be formatted on blur"}
       :boolean]
      [:input-size
       {:optional true,
        :doc "`size` attribute passed down to the input element"}
       :string]
      [:input-wrapper-order
       {:optional true, :doc "Controls order of the elements"}
       [:vector :any]]
      [:left-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `leftSection` element"}
       :string]
      [:left-section-width
       {:optional true,
        :doc
        "Left section width, used to set `width` of the section and input `padding-left`, by default equals to the input height"}
       [:or :string :int :double]]
      [:max-rows
       {:optional true,
        :doc
        "Maximum rows for autosize textarea to grow, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:min-rows
       {:optional true,
        :doc
        "Minimum rows of autosize textarea, ignored if `autosize` prop is not set"}
       [:or :int :double]]
      [:pointer
       {:optional true,
        :doc
        "Determines whether the input should have `cursor: pointer` style"}
       :boolean]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:required
       {:optional true,
        :doc
        "Adds required attribute to the input and a red asterisk on the right side of label"}
       :boolean]
      [:resize
       {:optional true, :doc "Controls `resize` CSS property"}
       [:enum
        "-moz-initial"
        :inherit
        :initial
        :revert
        :revert-layer
        :unset
        :inline
        :none
        :block
        :horizontal
        :vertical
        :both]]
      [:right-section-pointer-events
       {:optional true,
        :doc
        "Sets `pointer-events` styles on the `rightSection` element"}
       :string]
      [:right-section-width
       {:optional true,
        :doc
        "Right section width, used to set `width` of the section and input `padding-right`, by default equals to the input height"}
       [:or :string :int :double]]
      [:size
       {:optional true,
        :doc "Controls input `height` and horizontal `padding`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       :string]
      [:with-asterisk
       {:optional true,
        :doc
        "If set, the required asterisk is displayed next to the label. Overrides `required` prop. Does not add required attribute to the input."}
       :boolean]
      [:with-error-styles
       {:optional true,
        :doc
        "Determines whether the input should have red border and red text color when the `error` prop is set"}
       :boolean]]},
    :menu
    {:description
     "A vertical menu of actions — the actionable sibling of :list. :items is\n     a vector of {:label <string> :gesture <keyword> :tone <token,\n     optional> :disabled <bool, optional>} maps (ADR-graph-ui-v0-013-01 Sec9,\n     replacing v1.x's per-item :command/:with): :gesture names a key in\n     this SAME node's :on-gesture map, where the actual command template\n     lives, authored once alongside every other gesture the node carries.\n     Clicking an item dispatches its named :on-gesture entry — $session-id\n     substituted, plus whatever :with that entry's template carries.\n     Distinct from :list (plain display) and :button (one action): :menu is\n     a grouped set of commands. Web-only interactive; the TUI renders the\n     item labels as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:items
       {:optional true}
       [:vector
        [:map
         {:closed true}
         [:label {:optional true} :string]
         [:gesture {:optional true} :keyword]
         [:tone
          {:optional true}
          [:enum :default :muted :accent :success :warning :danger]]
         [:disabled {:optional true} :boolean]]]]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :tooltip
    {:description
     "Mantine `Tooltip` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 26 prop(s), 2 named\n     child slot(s), 1 gesture(s), and 5 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :unmapped
     {"events" "{ hover: boolean; focus: boolean; touch: boolean; }",
      "middlewares" "TooltipMiddlewares",
      "offset" "number | FloatingAxesOffsets",
      "positionDependencies" "any[]",
      "target" "string | HTMLElement | RefObject<HTMLElement>"},
     :slots [:label],
     :defaults
     {:arrow-offset 5,
      :arrow-radius 0,
      :arrow-size 4,
      :close-delay 0,
      :floating-strategy :absolute,
      :with-arrow false},
     :box-to-children :block-flow,
     :mantine {:component "Tooltip"},
     :status :generated,
     :box-from :viewport,
     :gestures [:position-change],
     :props
     [:map
      [:arrow-offset
       {:optional true, :doc "Arrow offset in px"}
       [:or :int :double]]
      [:arrow-position
       {:optional true, :doc "Arrow position relative to the tooltip"}
       [:enum :center :side]]
      [:arrow-radius
       {:optional true, :doc "Arrow `border-radius` in px"}
       [:or :int :double]]
      [:arrow-size
       {:optional true, :doc "Arrow size in px"}
       [:or :int :double]]
      [:auto-contrast
       {:optional true,
        :doc
        "If set, adjusts text color based on background color for `filled` variant"}
       :boolean]
      [:close-delay
       {:optional true, :doc "Close delay in ms"}
       [:or :int :double]]
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls tooltip background, by default set based on current color scheme"}
       [:or :keyword :string]]
      [:default-opened
       {:optional true,
        :doc "Uncontrolled tooltip initial opened state"}
       :boolean]
      [:disabled
       {:optional true,
        :doc "If set, tooltip element will not be rendered"}
       :boolean]
      [:floating-strategy
       {:optional true,
        :doc
        "Changes floating ui [position strategy](https://floating-ui.com/docs/usefloating#strategy)"}
       [:enum :absolute :fixed]]
      [:inline
       {:optional true,
        :doc "Must be set if the tooltip target is an inline element"}
       :boolean]
      [:keep-mounted
       {:optional true,
        :doc
        "If set, the tooltip is not unmounted from the DOM when hidden, `display: none` styles are applied instead"}
       :boolean]
      [:multiline
       {:optional true,
        :doc
        "Determines whether content should be wrapped on to the next line, `false` by default"}
       :boolean]
      [:open-delay
       {:optional true, :doc "Open delay in ms"}
       [:or :int :double]]
      [:opened
       {:optional true, :doc "Controlled opened state"}
       :boolean]
      [:position
       {:optional true,
        :doc
        "Tooltip position relative to target element (`Tooltip` component) or mouse (`Tooltip.Floating` component)"}
       [:enum
        :top
        :right
        :bottom
        :left
        :top-start
        :top-end
        :right-start
        :right-end
        :bottom-start
        :bottom-end
        :left-start
        :left-end]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set border-radius, numbers are converted to rem@default `theme.defaultRadius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:ref-prop
       {:optional true,
        :doc
        "Key of the prop that can be used to access element ref, `ref` by default"}
       :string]
      [:with-arrow
       {:optional true, :doc "If set, the tooltip has an arrow"}
       :boolean]
      [:within-portal
       {:optional true,
        :doc
        "Determines whether tooltip should be rendered within `Portal`, `true` by default"}
       :boolean]
      [:z-index
       {:optional true, :doc "Tooltip z-index, `300` by default"}
       [:or :string :int :double]]]},
    :blockquote
    {:description
     "Mantine `Blockquote` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 3 prop(s), 2 named\n     child slot(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives\n     the component named above straight from this declaration — the props here\n     are the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF. CHILDREN FILL SLOTS ONLY: Mantine declares no\n     `children` for this component, so a child is admitted solely to fill one\n     of the named slots above, saying which with :section. A child that names\n     no slot is not body content here — there is no body to put it in.",
     :status :generated,
     :mantine {:component "Blockquote"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any valid CSS color"}
       [:or :keyword :string]]
      [:icon-size
       {:optional true,
        :doc
        "Controls icon `width` and `height`, numbers are converted to rem"}
       [:or :string :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]],
     :defaults {:icon-size 40},
     :slots [:cite :icon],
     :children :slots,
     :box-from :content},
    :modal-base
    {:description
     "Mantine `ModalBase` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 14 prop(s), 1 named\n     child slot(s), 3 gesture(s). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF. TAKES\n     CHILDREN: Mantine declares `children`, so a child that names no slot is\n     ordinary body content.",
     :children :any,
     :defaults
     {:trap-focus true,
      :keep-mounted false,
      :return-focus true,
      :close-on-click-outside true,
      :size :md,
      :within-portal true,
      :z-index 200,
      :close-on-escape true,
      :padding :md,
      :shadow :xl,
      :lock-scroll true},
     :box-to-children :block-flow,
     :mantine {:component "ModalBase"},
     :status :generated,
     :box-from :viewport,
     :gestures [:close :enter-transition-end :exit-transition-end],
     :props
     [:map
      [:close-on-click-outside
       {:optional true,
        :doc
        "If set, the modal/drawer is closed when user clicks on the overlay"}
       :boolean]
      [:close-on-escape
       {:optional true,
        :doc
        "If set, `onClose` is called when user presses the escape key"}
       :boolean]
      [:id
       {:optional true,
        :doc "Id used to connect modal/drawer with body and title"}
       :string]
      [:keep-mounted
       {:optional true,
        :doc
        "If set modal/drawer is not unmounted from the DOM when hidden. `display: none` styles are applied instead."}
       :boolean]
      [:lock-scroll
       {:optional true,
        :doc "If set, scroll is locked when `opened={true}`"}
       :boolean]
      [:opened {:optional true, :doc "Controls opened state"} :boolean]
      [:padding
       {:optional true,
        :doc
        "Key of `theme.spacing` or any valid CSS value to set content, header and footer padding"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:return-focus
       {:optional true,
        :doc
        "If set, focus is returned to the last active element when `onClose` is called"}
       :boolean]
      [:shadow
       {:optional true,
        :doc
        "Key of `theme.shadows` or any valid CSS box-shadow value"}
       [:or [:enum :xs :sm :md :lg :xl]]]
      [:size
       {:optional true, :doc "Controls width of the content area"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:trap-focus
       {:optional true,
        :doc "If set, focus is trapped within the modal/drawer"}
       :boolean]
      [:unstyled {:optional true} :boolean]
      [:within-portal
       {:optional true,
        :doc "If set, the component is rendered inside `Portal`"}
       :boolean]
      [:z-index
       {:optional true,
        :doc "`z-index` CSS property of the root element"}
       [:or :string :int :double]]]},
    :switch
    {:description
     "Mantine `Switch` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 7 prop(s), 5 named\n     child slot(s), 1 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"rootRef" "ForwardedRef<HTMLDivElement>"},
     :slots [:description :error :label :off-label :thumb-icon],
     :defaults
     {:label-position :right, :radius :xl, :with-thumb-indicator true},
     :mantine {:component "Switch"},
     :status :generated,
     :box-from :content,
     :gestures [:label],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color to set input color in checked state"}
       [:or :keyword :string]]
      [:id
       {:optional true,
        :doc
        "Id used to bind input and label, if not passed, unique id will be generated instead"}
       :string]
      [:label-position
       {:optional true,
        :doc "Position of the label relative to the input"}
       [:enum :left :right]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius,`"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:size
       {:optional true, :doc "Controls size of all elements"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:with-thumb-indicator
       {:optional true,
        :doc "If set, the indicator will be displayed inside thumb"}
       :boolean]]},
    :rating
    {:description
     "Mantine `Rating` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 9 prop(s), 2\n     gesture(s). RENDERED GENERICALLY: graph-ui.web.mantine-generic drives the\n     component named above straight from this declaration — the props here are\n     the legal ones, the gestures here are the wired ones, and nothing else\n     reaches the DOM. Generic is not finished: this kind has no data binding,\n     no edit buffer and no selection state of its own. A kind that needs one of\n     those graduates to a hand-written widget and an explicit case in\n     render.cljs — move it above the GENERATED marker and give it a description\n     that explains ITSELF.",
     :status :generated,
     :mantine {:component "Rating"},
     :props
     [:map
      [:color
       {:optional true,
        :doc "Key of `theme.colors` or any CSS color value"}
       [:or :keyword :string]]
      [:count
       {:optional true, :doc "Number of controls"}
       [:or :int :double]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:fractions
       {:optional true,
        :doc "Number of fractions each item can be divided into"}
       [:or :int :double]]
      [:highlight-selected-only
       {:optional true,
        :doc
        "If set, only the selected symbol changes to full symbol when selected"}
       :boolean]
      [:name
       {:optional true,
        :doc
        "`name` attribute passed down to all inputs. By default, `name` is generated randomly."}
       :string]
      [:read-only
       {:optional true,
        :doc "If set, the user cannot interact with the component"}
       :boolean]
      [:size
       {:optional true, :doc "Controls component size"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]],
     :defaults
     {:color :yellow,
      :count 5,
      :fractions 1,
      :highlight-selected-only false,
      :read-only false,
      :size :sm},
     :gestures [:change :hover],
     :children :none,
     :box-from :content},
    :select
    {:description
     "A single-line dropdown chooser (native <select> in the web renderer).\n     :options is the list of choices — a vector of {:label <string> :value\n     <string>} maps, bindable via :bind. :value names the initially-selected\n     option's :value. On change the renderer dispatches :on-gesture's\n     :submit key (ADR-graph-ui-v0-013-01 Sec7-8, replacing v1.x's :on-submit)\n     with $value = the chosen option's :value — mirroring :input's\n     Enter->command seam. :placeholder shows as a disabled leading option\n     when no :value matches. Web-only interactive; the TUI renders the\n     current value (or placeholder) as plain read-only text.",
     :status :in-progress,
     :props
     [:map
      [:options {:optional true} [:vector :any]]
      [:value {:optional true} :string]
      [:placeholder {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:state {:optional true} [:enum :default :invalid :disabled]]],
     :defaults {},
     :children :none,
     :box-from :content},
    :slider
    {:description
     "Mantine `Slider` — GENERATED from @mantine/core's own TypeScript\n     declarations (PLAN-graph-ui-v0-009-01), not hand-written, so this kind\n     says exactly what the library promises and no more. 19 prop(s), 1 named\n     child slot(s), 2 gesture(s), and 1 prop(s) whose type carries no data\n     contract (see :unmapped). RENDERED GENERICALLY:\n     graph-ui.web.mantine-generic drives the component named above straight\n     from this declaration — the props here are the legal ones, the gestures\n     here are the wired ones, and nothing else reaches the DOM. Generic is not\n     finished: this kind has no data binding, no edit buffer and no selection\n     state of its own. A kind that needs one of those graduates to a\n     hand-written widget and an explicit case in render.cljs — move it above\n     the GENERATED marker and give it a description that explains ITSELF.\n     CHILDREN FILL SLOTS ONLY: Mantine declares no `children` for this\n     component, so a child is admitted solely to fill one of the named slots\n     above, saying which with :section. A child that names no slot is not body\n     content here — there is no body to put it in.",
     :children :slots,
     :unmapped {"domain" "[number, number]"},
     :slots [:thumb-children],
     :defaults
     {:show-label-on-hover true,
      :min 0,
      :restrict-to-marks false,
      :radius :xl,
      :size :md,
      :max 100,
      :label-always-on false,
      :step 1,
      :inverted false},
     :mantine {:component "Slider"},
     :status :generated,
     :box-from :content,
     :gestures [:change :change-end],
     :props
     [:map
      [:color
       {:optional true,
        :doc
        "Key of `theme.colors` or any valid CSS color, controls color of track and thumb"}
       [:or :keyword :string]]
      [:default-value
       {:optional true, :doc "Uncontrolled component default value"}
       [:or :int :double]]
      [:disabled {:optional true, :doc "Disables slider"} :boolean]
      [:inverted
       {:optional true,
        :doc
        "Determines whether track value representation should be inverted"}
       :boolean]
      [:label-always-on
       {:optional true,
        :doc
        "Determines whether the label should be visible when the slider is not being dragged or hovered"}
       :boolean]
      [:marks
       {:optional true, :doc "Marks displayed on the track"}
       [:vector :any]]
      [:max
       {:optional true, :doc "Maximum possible value"}
       [:or :int :double]]
      [:min
       {:optional true, :doc "Minimal possible value"}
       [:or :int :double]]
      [:name
       {:optional true,
        :doc "Hidden input name, use with uncontrolled component"}
       :string]
      [:precision
       {:optional true,
        :doc "Number of significant digits after the decimal point"}
       [:or :int :double]]
      [:radius
       {:optional true,
        :doc
        "Key of `theme.radius` or any valid CSS value to set `border-radius`, numbers are converted to rem"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:restrict-to-marks
       {:optional true,
        :doc
        "Determines whether the selection should be only allowed from the given marks array"}
       :boolean]
      [:show-label-on-hover
       {:optional true,
        :doc
        "Determines whether the label should be displayed when the slider is hovered"}
       :boolean]
      [:size
       {:optional true, :doc "Controls size of the track"}
       [:or
        [:enum :xs :sm :md :lg :xl]
        [:re "^\\d+(\\.\\d+)?(ch|%)$"]]]
      [:step
       {:optional true,
        :doc
        "Number by which value will be incremented/decremented with thumb drag and arrows"}
       [:or :int :double]]
      [:thumb-label
       {:optional true, :doc "Thumb `aria-label`"}
       :string]
      [:thumb-size
       {:optional true,
        :doc
        "Thumb `width` and `height`, by default value is computed based on `size` prop"}
       [:or :string :int :double]]
      [:value
       {:optional true, :doc "Controlled component value"}
       [:or :int :double]]]},
    :text
    {:description
     "A run of text — the atomic leaf widget. :value is optional: a bound :text\n     (see :bind) gets its value from a data source. Type size, weight and\n     casing are NOT declared here: they are the :font-size/:font-weight/\n     :text-transform UNIVERSAL SLOTS as of ADR-graph-ui-v0-013-01 Sec19, because\n     they were never properties of text specifically (v1.x's own :size/:weight\n     stay on v1.x's :text forever, unchanged).\n     :empty-label (Sec23): what to show when the bound value resolves to an\n     empty string — the locked target's 'Add tags…' on a page with no tags.\n     Same slot name and same meaning :list/:tree/:outline already carry, so a\n     resolved-empty binding reads as EMPTY rather than as a broken pane. Not\n     :placeholder: that name already means 'hint text in an editable field'\n     on :input, and one name with two senses is how vocabulary rots.",
     :status :in-progress,
     :props
     [:map
      [:value {:optional true} :string]
      [:tone
       {:optional true}
       [:enum :default :muted :accent :success :warning :danger]]
      [:density {:optional true} [:enum :compact :cozy :roomy]]
      [:empty-label {:optional true} :string]],
     :defaults {},
     :children :none,
     :box-from :content}}}}}
)
